//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IClient {
    /**
     * Get Realtime Alarms
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    queryRealtimeAlarm(body: QueryEventAlarmDataIn | undefined): Observable<QueryAlarmDataOutPaginationDataOut>;
    /**
     * Get Alarm by Command or Event
     * @param body (optional) 
     * @return OK
     */
    getAlarm(body: AlarmCommandEvent | undefined): Observable<AlarmDataOut>;
    /**
     * Load on demand alarms from meter
     * @param meterNo (optional) The unique identifier (meter number) of the target meter.
     * @return OK
     */
    onDemandReadAlarms(meterNo: string | undefined): Observable<StringResponseCommandSuccess>;
    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreaByRegion(region: string): Observable<GuidDictionaryItem[]>;
    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreaByRegionForOptions(region: string): Observable<GuidDictionaryItem[]>;
    /**
     * Get all areas for dropdown elements.
     * @param regions (optional) 
     * @return OK
     */
    getAllAreaByRegionsForOptions(regions: string[] | undefined): Observable<GuidDictionaryItem[]>;
    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreasForOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * Save area (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveArea(body: AreaDataIn | undefined): Observable<string>;
    /**
     * Delete area
     * @param id (optional) 
     * @return OK
     */
    deleteArea(id: string | undefined): Observable<string>;
    /**
     * GetAll area
     * @param body (optional) 
     * @return OK
     */
    areaQuery(body: AreaGetAllDataIn | undefined): Observable<AreaDataOutPaginationDataOut>;
    /**
     * Get area with id.
     * @return OK
     */
    getArea(id: string): Observable<AreaDetailsDataOut>;
    /**
     * Get all asset types for dropdown elements.
     * @param applyLimiterConfiguration (optional) 
     * @return OK
     */
    getAllAssetTypesForOptions(applyLimiterConfiguration: boolean | undefined): Observable<GuidDictionaryItem[]>;
    /**
     * Get Asset Types
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    assetTypeQuery(body: AssetTypeGetAllDataIn | undefined): Observable<AssetTypeDataOutPaginationDataOut>;
    /**
     * Save Asset Type
     * @param body (optional) The request body containing all the necessary information about the asset type.
     * @return OK
     */
    saveAssetType(body: AssetTypeDataIn | undefined): Observable<string>;
    /**
     * Get Asset Type by Id
     * @param id Asset type Hes Id
     * @return OK
     */
    getAssetType(id: string): Observable<AssetTypeDataOut>;
    /**
     * Delete Asset Type by Id
     * @param id (optional) 
     * @return OK
     */
    deleteAssetType(id: string | undefined): Observable<string>;
    /**
     * Get region by area id
     * @param body (optional) 
     * @return OK
     */
    queryAuditLog(body: AuditLogQueryDataIn | undefined): Observable<AuditLogQueryDataOutPaginationDataOut>;
    /**
     * Download xlsx file with audit log info.
     * @param body (optional) 
     * @return OK
     */
    downloadAuditLogFile(body: DownloadAuditLogDataIn | undefined): Observable<FileResponse>;
    /**
     * Login on Identity
     * @return OK
     */
    identityLogin(): Observable<string>;
    /**
     * Login on Identity
     * @return OK
     */
    identityLoginDesktopApp(): Observable<string>;
    /**
     * Temporary endpoint to generate a login token until we integrate with Identity server
     * @param email (optional) 
     * @return OK
     */
    getToken(email: string | undefined): Observable<string>;
    /**
     * @return OK
     */
    loginGET(): Observable<void>;
    /**
     * @return OK
     */
    loginPOST(): Observable<void>;
    /**
     * Log Out
     * @return OK
     */
    logout(): Observable<void>;
    /**
     * GetAll on demand commands for alarm
     * @param body (optional) 
     * @return OK
     */
    onDemandAlarmsCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for load profile.
     * @param body (optional) 
     * @return OK
     */
    onDemandLoadProfileCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for event log.
     * @param body (optional) 
     * @return OK
     */
    onDemandEventLogCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for energy register.
     * @param body (optional) 
     * @return OK
     */
    onDemandEnergyRegisterCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for power demand.
     * @param body (optional) 
     * @return OK
     */
    onDemandPowerDemandCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    onDemandInstantaneousObjectCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    onDemandBillingDataCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * GetAll on demand commands for custom register.
     * @param body (optional) 
     * @return OK
     */
    onDemandCustomRegisterCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * Get last device configuration.
     * @param meterId (optional) 
     * @return OK
     */
    queryDeviceConfiguration(meterId: string | undefined): Observable<DeviceConfigurationInfoDataOut>;
    /**
     * GetAll commands across every command type (no type filter is applied), unlike the
    type-scoped on-demand endpoints above.
     * @param body (optional) 
     * @return OK
     */
    queryCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut>;
    /**
     * Cancel a single command that is currently in a pending state. Image update commands are aborted via the firmware update group service; other command types that do not support cancellation return an error.
     * @param commandId (optional) 
     * @return OK
     */
    cancelCommand(commandId: string | undefined): Observable<string>;
    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    setConnectedStateCommandQuery(body: CommandQueryDataIn | undefined): Observable<ConnectDisconnectDataOutPaginationDataOut>;
    /**
     * Retrieves a specific connect/disconnect command by its unique identifier.
     * @param id The unique identifier (GUID) of the connect/disconnect command.
     * @return OK
     */
    getConnectDisconnect(id: string): Observable<InfoConnectDisconnectDataOut>;
    /**
     * Get dashboard asset data.
     * @return OK
     */
    getAssets(): Observable<AssetValues[]>;
    /**
     * Get dashboard remote command statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getRemoteCommands(body: DashboardQueryDataIn | undefined): Observable<CommandValues[]>;
    /**
     * Get dashboard events statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getAlarms(body: DashboardQueryDataIn | undefined): Observable<EventValues[]>;
    /**
     * Get dashboard events statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getEvents(body: DashboardQueryDataIn | undefined): Observable<EventValues[]>;
    /**
     * Get meter online/offline availability split into fixed-size time intervals.
     * @param body (optional) Meter id, time range and interval size (in minutes) to split the range into.
     * @return OK
     */
    getMeterAvailabilityForInterval(body: MeterAvailabilityDataIn | undefined): Observable<MeterAvailabilityDataOut[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getMeterAvailabilityForIntervalInfo(body: MeterAvailabilityDataIn | undefined): Observable<MeterAvailabilityInfoDataOut>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getEnergyReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<EnergyReadDataOut[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getPowerDemandReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<PowerDemandReadDataOut[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getInstantaneousObjectReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<InstantaneousObjectReadDataOut[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCommunicationActivity(body: DashboardCommunicationActivityDataIn | undefined): Observable<CommunicationActivityDataOut[]>;
    /**
     * List the uploaded meter setup desktop app binaries
     * @return OK
     */
    listDesktopAppBinaries(): Observable<BinaryFileDataOut[]>;
    /**
     * Download the most recently uploaded meter setup desktop app binary
     * @return OK
     */
    downloadLatestDesktopAppBinary(): Observable<FileResponse>;
    /**
     * Download an uploaded meter setup desktop app binary
     * @param fileName (optional) 
     * @return OK
     */
    downloadDesktopAppBinary(fileName: string | undefined): Observable<FileResponse>;
    /**
     * Upload a desktop app binary
     * @param file (optional) 
     * @return OK
     */
    uploadBinary(file: FileParameter | undefined): Observable<string>;
    /**
     * Get all devices (with filters and pagination).
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    query(body: MeterGetAllDataIn | undefined): Observable<MeterDataOutPaginationDataOut>;
    /**
     * Add device
     * @param body (optional) Contains all meter info
     * @return OK
     */
    addDevice(body: CreateMeterDataIn | undefined): Observable<string>;
    /**
     * Save and edit (when the id parameter is sent, the user is updating, until it is not sent, a new user is adding).
     * @param body (optional) Contains all meter info
     * @return OK
     */
    editDevice(body: EditMeterDataIn | undefined): Observable<string>;
    /**
     * Delete device from list.
     * @param id (optional) 
     * @return OK
     */
    deleteDevice(id: string | undefined): Observable<string>;
    /**
     * Get device with id.
     * @return OK
     */
    getDevice(id: string): Observable<EditMeterDataIn>;
    /**
     * Download xlsx file with devices info.
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceFile(body: DownloadDeviceDataIn | undefined): Observable<FileResponse>;
    /**
     * Sync the meter clock with the system time.
     * @param meterId (optional) 
     * @return OK
     */
    syncClock(meterId: string | undefined): Observable<string>;
    /**
     * SetupDevice
     * @param meterId (optional) 
     * @param forceFullSetup (optional) 
     * @return OK
     */
    setupDevice(meterId: string | undefined, forceFullSetup: boolean | undefined): Observable<string>;
    /**
     * BulkDelete
     * @param body (optional) 
     * @return OK
     */
    bulkDelete(body: string[] | undefined): Observable<string>;
    /**
     * BulkSetup
     * @param forceFullSetup (optional) 
     * @param body (optional) 
     * @return OK
     */
    bulkSetup(forceFullSetup: boolean | undefined, body: string[] | undefined): Observable<string>;
    /**
     * For meter model get first meter that is online.
     * @param id (optional) 
     * @return OK
     */
    getMeterModelOnlineDevice(id: string | undefined): Observable<string>;
    /**
     * Get device with id.
     * @param meterNumber (optional) 
     * @return OK
     */
    getMeterModelHesId(meterNumber: string | undefined): Observable<string>;
    /**
     * Pings a meter causing an update in online status
     * @param meterNumber (optional) 
     * @return OK
     */
    pingMeter(meterNumber: string | undefined): Observable<string>;
    /**
     * @param meterNumber (optional) 
     * @return OK
     */
    updateMeterSimId(meterNumber: string | undefined): Observable<string>;
    /**
     * Wake a meter using SMS (Not finished)
     * @param meterNumber (optional) 
     * @return OK
     */
    smsWakeMeter(meterNumber: string | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setIpSecConnector(body: SetIpSecConnectorDataIn | undefined): Observable<boolean>;
    /**
     * Acquire IP address from GSm provider based on provider name and SimNumber
     * @param provider (optional) 
     * @param simNumber (optional) 
     * @return OK
     */
    getIpAddressFromGsmProvider(provider: GsmProviders | undefined, simNumber: string | undefined): Observable<string>;
    /**
     * @param meterHesId (optional) 
     * @return OK
     */
    getAllMeterModelForFwUpdateOptions(meterHesId: string | undefined): Observable<GuidDictionaryItem[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getParentsForOption(body: MeterParentGetDataIn | undefined): Observable<GuidParentMeterDataOutDictionaryItem[]>;
    /**
     * Get device with id.
     * @return OK
     */
    getParent(id: string): Observable<ParentMeterDataOut>;
    /**
     * @param meterNumber (optional) 
     * @return OK
     */
    runDiagnostics(meterNumber: string | undefined): Observable<string>;
    /**
     * Returns the status and steps of a single diagnostics command, or null when the id
    belongs to no diagnostics command.
     * @param commandId (optional) 
     * @return OK
     */
    getDiagnosticsStatus(commandId: string | undefined): Observable<DiagnosticsCommandStatusDataOut>;
    /**
     * Sets the connected state (connected or disconnected) for a specific meter based on the provided input.
     * @param body (optional) Object containing the meter number, desired connection state, and the reason for the change.
     * @return OK
     */
    setConnectedState(body: DisconnectControlDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * @param body (optional) 
     * @return OK
     */
    query2(body: EventQueryDataIn | undefined): Observable<EventDataOutPaginationDataOut>;
    /**
     * Get the event code mappings of a meter model.
     * @param meterModelId (optional) 
     * @return OK
     */
    getEventCodeMappings(meterModelId: string | undefined): Observable<EventCodeMappingDto[]>;
    /**
     * Download the event code mappings of a meter model in the layout the import reads.
     * @param meterModelId (optional) 
     * @return OK
     */
    downloadEventCodeMappings(meterModelId: string | undefined): Observable<FileResponse>;
    /**
     * Remove value to event mappings. The page collects what a user deleted and saves it in one call.
     * @param body (optional) 
     * @return OK
     */
    deleteEventCodeMappings(body: string[] | undefined): Observable<string>;
    /**
     * Get the event log names a meter model overrides, one per log. An empty entry keeps the default name.
     * @param meterModelId (optional) 
     * @return OK
     */
    getEventLogLabels(meterModelId: string | undefined): Observable<string[]>;
    /**
     * Save the event log names of a meter model, one per log. An empty entry restores the default name.
     * @param body (optional) 
     * @return OK
     */
    saveEventLogLabels(body: EventLogLabelsDataIn | undefined): Observable<string>;
    /**
     * Get the event log names of a meter's model, the same way getEventLogLabels returns them.
     * @param meterId (optional) 
     * @return OK
     */
    getMeterEventLogLabels(meterId: string | undefined): Observable<string[]>;
    /**
     * Get the event log names of the model of the meter an on demand event log read was for, the same way getEventLogLabels returns them.
     * @param commandId (optional) 
     * @return OK
     */
    getOnDemandEventLogLabels(commandId: string | undefined): Observable<string[]>;
    /**
     * Query firmware update groups for specific meters.
     * @param body (optional) 
     * @return OK
     */
    queryDeferredReminders(body: FirmwareUpdateGroupForMetersQuery | undefined): Observable<FirmwareUpdateGroupDataOut[]>;
    /**
     * Start firmware update for specific meters.
     * @param body (optional) 
     * @return OK
     */
    updateFirmwareImage(body: FirmwareUpdateStartDataIn | undefined): Observable<string>;
    /**
     * Start firmware update for meters selected by region, area and meter model.
     * @param body (optional) 
     * @return OK
     */
    updateFirmwareImageByLocation(body: FirmwareUpdateByLocationDataIn | undefined): Observable<string>;
    /**
     * Query firmware update groups.
     * @param body (optional) 
     * @return OK
     */
    queryFirmwareUpdateGroups(body: FirmwareUpdateGroupsQuery | undefined): Observable<FirmwareUpdateGroupSummaryDataOutPaginationDataOut>;
    /**
     * Query commands for a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    queryFirmwareUpdateGroupCommands(body: FirmwareUpdateGroupCommandsQuery | undefined): Observable<FirmwareUpdateCommandDataOutPaginationDataOut>;
    /**
     * Download all commands for a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    downloadFirmwareUpdateGroupCommands(body: FirmwareUpdateGroupCommandsQuery | undefined): Observable<FileResponse>;
    /**
     * Toggle scheduled firmware update group activation.
     * @param body (optional) 
     * @return OK
     */
    toggleFirmwareUpdateGroupActivation(body: string[] | undefined): Observable<string>;
    /**
     * Retry all failed commands in a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    retryFailedFirmwareUpdateGroupCommands(body: string[] | undefined): Observable<string>;
    /**
     * Retry selected firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    retryFirmwareUpdateCommands(body: string[] | undefined): Observable<string>;
    /**
     * Abort all active commands in a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    abortFirmwareUpdateGroupCommands(body: string[] | undefined): Observable<string>;
    /**
     * Abort selected firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    abortFirmwareUpdateCommands(body: string[] | undefined): Observable<string>;
    /**
     * Delete deferred firmware update group.
     * @param body (optional) 
     * @return OK
     */
    deleteDeferredReminderBatch(body: string[] | undefined): Observable<string>;
    /**
     * Delete selected scheduled firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    deleteFirmwareUpdateCommands(body: string[] | undefined): Observable<string>;
    /**
     * Delete deferred firmware update command.
     * @return OK
     */
    deleteDeferredReminder(id: string): Observable<string>;
    /**
     * Health check endpoint.
     * @return OK
     */
    hello(): Observable<void>;
    /**
     * Get Realtime Alarms
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    getPage(body: IndividualAlarmPageQueryDataIn | undefined): Observable<IndividualAlarmPageDataOutPaginationDataOut>;
    /**
     * Get Fraudulent Alarms (FrudAttempt or CurrentReversal)
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    getFraudulentMeters(body: FraudAlarmDataIn | undefined): Observable<FraudAlarmDataOutPaginationDataOut>;
    /**
     * Download xlsx file with Fraudulent Meters list.
     * @param body (optional) 
     * @return OK
     */
    downloadFraudulentMetersFile(body: DownloadFraudAlarmDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return Accepted
     */
    activateIpSecConnectorsJob(body: IpSecConnectorsDataIn | undefined): Observable<void>;
    /**
     * Get network outage state (admin only).
     * @return OK
     */
    getNetworkOutageState(): Observable<NetworkOutageState>;
    /**
     * @param body (optional) 
     * @return OK
     */
    queryLoadLimits(body: LoadLimitGetAllDataIn | undefined): Observable<LoadLimitDataOutPaginationDataOut>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addLoadLimit(body: CreateLoadLimitDataIn | undefined): Observable<string>;
    /**
     * @return OK
     */
    getLoadLimit(id: string): Observable<LoadLimitDto>;
    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLoadLimit(id: string | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    loadLimitStatus(body: LoadLimitStatus | undefined): Observable<string>;
    /**
     * @param meterId (optional) 
     * @return OK
     */
    getMeterGeoLocation(meterId: string | undefined): Observable<MeterGeoLocationQueryDataOut[]>;
    /**
     * @param meterId (optional) 
     * @return OK
     */
    setMeterGeoLocationViewed(meterId: string | undefined): Observable<boolean>;
    /**
     * Get all meter makes for dropdown elements.
     * @return OK
     */
    getAllMeterMakersForOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * Get all disconnect control mode for dropdown elements.
     * @return OK
     */
    getAllDisconnectControlModeForOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * @return OK
     */
    getAllMeterMakersForSetupOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * Save meter make (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveMeterMake(body: MeterMakeDataIn | undefined): Observable<string>;
    /**
     * Delete meter make
     * @param id (optional) 
     * @return OK
     */
    deleteMeterMake(id: string | undefined): Observable<string>;
    /**
     * GetAll meter make
     * @param body (optional) 
     * @return OK
     */
    meterMakeQuery(body: MeterMakeGetAllDataIn | undefined): Observable<MeterMakeDataOutPaginationDataOut>;
    /**
     * Get meter make with id.
     * @return OK
     */
    getMeterMake(id: string): Observable<MeterMakeDetailsDataOut>;
    /**
     * Get all meter models for dropdown elements.
     * @param meterMake (optional) 
     * @return OK
     */
    getAllMeterModelForOptions(meterMake: string | undefined): Observable<GuidDictionaryItem[]>;
    /**
     * Get all meter models for dropdown elements.
     * @param meterMakes (optional) 
     * @return OK
     */
    getAllMeterModelForMeterMakes(meterMakes: string[] | undefined): Observable<GuidDictionaryItem[]>;
    /**
     * Get all meter models for dropdown elements.
     * @param meterMakes (optional) 
     * @return OK
     */
    getAllMeterModelForMeterMakes2(meterMakes: string[] | undefined): Observable<MeterModelDetailsDataOut[]>;
    /**
     * Save meter model (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveMeterModel(body: MeterModelDataIn | undefined): Observable<string>;
    /**
     * Delete meter make
     * @param id (optional) 
     * @return OK
     */
    deleteMeterModel(id: string | undefined): Observable<string>;
    /**
     * GetAll meter make
     * @param body (optional) 
     * @return OK
     */
    meterModelQuery(body: MeterModelGetAllDataIn | undefined): Observable<MeterModelDataOutPaginationDataOut>;
    /**
     * Get meter make with id.
     * @return OK
     */
    getMeterModel(id: string): Observable<MeterModelDetailsDataOut>;
    /**
     * Query meter model versions for meter model.
     * @param body (optional) 
     * @return OK
     */
    queryMeterModelVersions(body: MeterModelVersionsQueryDataIn | undefined): Observable<MeterSetupVersionDtoPaginationDataOut>;
    /**
     * Add meter model versions for meter model.
     * @param body (optional) 
     * @return OK
     */
    addNewVersion(body: MeterModelVersionsNew | undefined): Observable<string>;
    /**
     * Get meter model associations with id.
     * @param meterModel (optional) 
     * @return OK
     */
    getMeterModelAssociations(meterModel: string | undefined): Observable<MeterSetupVersionDto>;
    /**
     * Get meter model associations with id.
     * @param versionId (optional) 
     * @return OK
     */
    getVersionAssociations(versionId: string | undefined): Observable<MeterSetupVersionDto>;
    /**
     * Download file meter model associations with id.
     * @param versionId (optional) 
     * @return OK
     */
    downloadFileMeterModelAssociations(versionId: string | undefined): Observable<FileResponse>;
    /**
     * Get Push Interval 1 Required Capture Objects.
     * @return OK
     */
    getConfigurationOptions(): Observable<SetupConfigurationOptionsDto>;
    /**
     * Get all acquisitions (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    queryAcquisitions(body: AcquisitionQuery | undefined): Observable<AcquisitionQueryDataOutPaginationDataOut>;
    /**
     * Get acquisition with id.
     * @return OK
     */
    getAcquisition(id: string): Observable<AcquisitionDataOut>;
    /**
     * Get all device connection times (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    queryDeviceConnection(body: DeviceConnectionQuery | undefined): Observable<DeviceConnectionQueryDataOutPaginationDataOut>;
    /**
     * Get device connection time with id.
     * @return OK
     */
    getDeviceConnection(id: string): Observable<DeviceConnectionDataOut>;
    /**
     * Retrieves a paginated list of meters with information about whether their time is properly synchronized or not.
     * @param body (optional) 
     * @return OK
     */
    queryMeterTimeSync(body: TimeSyncQuery | undefined): Observable<TimeSyncDataOutPaginationDataOut>;
    /**
     * Get all device connection times (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceConnectionListFile(body: DownloadDeviceConnectionDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAcquisitionFile(body: DownloadAcquisitionDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadTimeSyncFile(body: DownloadTimeSyncDataIn | undefined): Observable<FileResponse>;
    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandLoadProfile(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Runs an on-demand load profile read for the given meter, without requiring the caller
    to supply a date range, reading from its last recorded read meter time up to now.
     * @param meterHesId (optional) The HES id of the meter to read.
     * @return OK
     */
    runReadLoadProfile(meterHesId: string | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandEnergyRegisters(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandPowerDemand(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandInstantaneousObject(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Retrieves the billing data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandBilling(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Read custom DLMS register value from a meter
     * @param body (optional) 
     * @return OK
     */
    onDemandReadRegister(body: OnDemandReadRegisterIn | undefined): Observable<StringResponseCommandSuccess>;
    /**
     * @return OK
     */
    onDemandBillingRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandAlarmRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandLoadProfileRegisterRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandEnergyRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandInstantaneousRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandPowerDemandRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandClearCreditRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandClearTamperRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandConnectDisconnectRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandSequentialTokenRetry(commandId: string): Observable<string>;
    /**
     * @return OK
     */
    onDemandTokenLoadRetry(commandId: string): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    onDemandDataBulkRetry(body: string[] | undefined): Observable<string>;
    /**
     * @return OK
     */
    commandRetry(commandId: string): Observable<string>;
    /**
     * Retrieves the event log data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandEventLog(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandEnergyRegisters(body: OnDemandDetailsDataIn | undefined): Observable<EnergyBufferDataOutPaginationDataOut>;
    /**
     * Get Billing data registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandBillingDataRegisters(body: OnDemandDetailsDataIn | undefined): Observable<BillingDataBufferDataOutPaginationDataOut>;
    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandPowerDemandRegisters(body: OnDemandDetailsDataIn | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut>;
    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandLoadProfile(body: OnDemandDetailsDataIn | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut>;
    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandInstantaneousObject(body: OnDemandDetailsDataIn | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut>;
    /**
     * Download file with load profile registers for command.
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandLoadProfileRegisters(commandId: string | undefined): Observable<FileResponse>;
    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandEventLog(commandId: string | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadMeterEventLogs(body: MeterEventLogQueryDataIn | undefined): Observable<FileResponse>;
    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandEnergyRegisters(commandId: string | undefined): Observable<FileResponse>;
    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandPowerDemandRegisters(commandId: string | undefined): Observable<FileResponse>;
    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandInstantaneousObjectRegisters(commandId: string | undefined): Observable<FileResponse>;
    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandBillingDataRegisters(commandId: string | undefined): Observable<FileResponse>;
    /**
     * Fetch all reads from the database for a specific command.
     * @param body (optional) CommandId and page info
     * @return OK
     */
    getOnDemandRegisterReads(body: OnDemandDetailsDataIn | undefined): Observable<OnDemandAttributeDataOutPaginationDataOut>;
    /**
     * Lists all supported registers for on demand read
     * @param meterModelHesId (optional) 
     * @return OK
     */
    getOnDemandRegisterAttributes(meterModelHesId: string | undefined): Observable<AssociationDescriptionDto[]>;
    /**
     * Get Event Log Registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandEventLog(body: EventLogDetailsDataIn | undefined): Observable<EventLogEntryDataOutPaginationDataOut>;
    /**
     * Every event one meter logged, across all of its event log reads, each event once.
     * @param body (optional) 
     * @return OK
     */
    getMeterEventLogs(body: MeterEventLogQueryDataIn | undefined): Observable<MeterEventLogDataOutPaginationDataOut>;
    /**
     * @param body (optional) 
     * @return OK
     */
    simNetworkEvent(key: string, body: SimNetworkWebhook | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    query3(body: PendingMeterGetAllDataIn | undefined): Observable<PendingMeterDataOutPaginationDataOut>;
    /**
     * Delete device from list.
     * @param id (optional) 
     * @return OK
     */
    deleteDevice2(id: string | undefined): Observable<string>;
    /**
     * Download xlsx file with devices info.
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceFile2(body: DownloadPendingDeviceDataIn | undefined): Observable<FileResponse>;
    /**
     * Get all prepayments
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    queryPrepaymentReport(body: PrepaymentGetAllDataIn | undefined): Observable<PrepaymentDataOutPaginationDataOut>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadPrepaymentReportFile(body: DownloadPrepaymentDataIn | undefined): Observable<FileResponse>;
    /**
     * Get all regions.
     * @return OK
     */
    getAllRegions(): Observable<GuidDictionaryItem[]>;
    /**
     * Get all regions for dropdown elements.
     * @return OK
     */
    getAllRegionsForOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * Save region (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveRegion(body: RegionDataIn | undefined): Observable<string>;
    /**
     * Delete region
     * @param id (optional) 
     * @return OK
     */
    deleteRegion(id: string | undefined): Observable<string>;
    /**
     * GetAll region
     * @param body (optional) 
     * @return OK
     */
    regionQuery(body: RegionGetAllDataIn | undefined): Observable<RegionDetailsDataOutPaginationDataOut>;
    /**
     * Get region with id.
     * @return OK
     */
    getRegion(id: string): Observable<RegionDetailsDataOut>;
    /**
     * Get region by area id.
     * @return OK
     */
    getRegionByArea(id: string): Observable<RegionDetailsDataOut>;
    /**
     * Get all for dropdown
     * @return OK
     */
    getAllRolesForOptions(): Observable<RoleSimpleDataOut[]>;
    /**
     * Returns all permissions for the currently logged in user
     * @return OK
     */
    getMyPermissions(): Observable<string>;
    /**
     * GetAll user roles
     * @param body (optional) 
     * @return OK
     */
    roleQuery(body: RoleGetAllDataIn | undefined): Observable<RoleDataOutPaginationDataOut>;
    /**
     * Save role (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveRole(body: RoleDataIn | undefined): Observable<string>;
    /**
     * Delete role
     * @param id (optional) 
     * @return OK
     */
    deleteRole(id: string | undefined): Observable<string>;
    /**
     * Deactivate user
     * @param body (optional) 
     * @return OK
     */
    changeRoleStatus(body: RoleStatusUpdate | undefined): Observable<string>;
    /**
     * Get role
     * @return OK
     */
    getRole(id: string): Observable<RoleCrud>;
    /**
     * Get scheduled load profile events.
     * @param body (optional) 
     * @return OK
     */
    queryLastScheduledDevices(body: QueryScheduledDataReadDataIn | undefined): Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
    /**
     * Get meters with scheduled event logs.
     * @param body (optional) 
     * @return OK
     */
    queryScheduledEventLogDevices(body: QueryScheduledDataReadDataIn | undefined): Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getRawEnergyRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyBufferDataOutPaginationDataOut>;
    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedEnergyRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyBufferDataOutPaginationDataOut>;
    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getRawPowerDemandRegisters(body: LoadProfileCommandEvent | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut>;
    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedPowerDemandRegisters(body: LoadProfileCommandEvent | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut>;
    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getRawLoadProfile(body: LoadProfileCommandEvent | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut>;
    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedLoadProfile(body: LoadProfileCommandEvent | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut>;
    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getRawInstantaneousObject(body: LoadProfileCommandEvent | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut>;
    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getProcessedInstantaneousObject(body: LoadProfileCommandEvent | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut>;
    /**
     * Download file with energy registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawEnergyRegistersFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with energy registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedEnergyRegistersFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with power demand registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawPowerDemandFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with power demand registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedPowerDemandFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with load profile for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawLoadProfileFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with load profile for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedLoadProfileFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with instantaneous objects for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawInstantaneousObjectFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Download file with instantaneous objects for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedInstantaneousObjectFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * Get energy per phase registers.
     * @param body (optional) 
     * @return OK
     */
    getEnergyPerPhaseRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyPerPhaseDataOutPaginationDataOut>;
    /**
     * Get processed energy per phase registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedEnergyPerPhaseRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyPerPhaseDataOutPaginationDataOut>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadEnergyPerPhaseFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedEnergyPerPhaseFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyPerPhaseCombined(body: DownloadBulkDataIn | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkLoadProfileRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkLoadProfileCombined(body: DownloadBulkDataIn | undefined): Observable<string>;
    /**
     * @param path (optional) 
     * @return OK
     */
    downloadBulkFile(path: string | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyRegisterRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyRegisterCombined(body: DownloadBulkDataIn | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkPowerDemandRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkPowerDemandCombined(body: DownloadBulkDataIn | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkInstantaneousRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkInstantaneousCombined(body: DownloadBulkDataIn | undefined): Observable<string>;
    /**
     * Returns a paginated list of scheduler execution history entries filtered by status, date range, and search term.
    Each entry represents one scheduler run and includes the aggregated command status across all meters processed in that run.
     * @param body (optional) 
     * @return OK
     */
    jobStatusHistoryQuery(body: SchedulerStatusHistoryDataIn | undefined): Observable<SchedulerStatusHistoryDataOutPaginationDataOut>;
    /**
     * Downloads an Excel file containing scheduler execution history entries filtered by status, date range, and search term.
    Each row represents one scheduler run with its aggregated command status across all meters processed in that run.
    Requires HES.UO.Shared.Common.PermissionsEnum.systemmonitoring_jobstatushistory_download permission.
     * @param body (optional) 
     * @return OK
     */
    downloadJobStatusHistoryQuery(body: SchedulerStatusHistoryDataIn | undefined): Observable<FileResponse>;
    /**
     * Save reminder
     * @param body (optional) 
     * @return OK
     */
    saveScheduler(body: SchedulerDataIn | undefined): Observable<string>;
    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryReminders(body: SchedulerQuery | undefined): Observable<SchedulerQueryDataOutPaginationDataOut>;
    /**
     * Change reminder status
     * @param body (optional) 
     * @return OK
     */
    reminderStatus(body: SchedulerStatus | undefined): Observable<string>;
    /**
     * Delete reminder
     * @return OK
     */
    deleteReminder(id: string): Observable<string>;
    /**
     * Get reminder
     * @return OK
     */
    getReminder(id: string): Observable<SchedulerDto>;
    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryScheduleLogs(body: ScheduleLogsDataIn | undefined): Observable<ScheduleLogsDataOutPaginationDataOut>;
    /**
     * Downloads the schedule log commands as an Excel file for the specified schedule log ID.
     * @param dataIn (optional) 
     * @return OK
     */
    downloadScheduleLog(dataIn: string | undefined): Observable<FileResponse>;
    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryScheduleLogsCommands(body: ScheduleLogsCommandsQuery | undefined): Observable<ScheduleLogsCommandsDataOutPaginationDataOut>;
    /**
     * Downloads schedule log commands as an Excel file based on the provided query parameters.
     * @param body (optional) 
     * @return OK
     */
    downloadScheduleLogCommands(body: ScheduleLogsCommandsQuery | undefined): Observable<FileResponse>;
    /**
     * Get all service types for dropdown elements.
     * @return OK
     */
    getAllServiceTypesForOptions(): Observable<GuidDictionaryItem[]>;
    /**
     * Save service type (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveServiceType(body: ServiceTypeDataIn | undefined): Observable<string>;
    /**
     * Delete service type
     * @param id (optional) 
     * @return OK
     */
    deleteServiceType(id: string | undefined): Observable<string>;
    /**
     * GetAll service type
     * @param body (optional) 
     * @return OK
     */
    serviceTypeQuery(body: ServiceTypeGetAllDataIn | undefined): Observable<ServiceTypeDataOutPaginationDataOut>;
    /**
     * Get service type with id.
     * @return OK
     */
    getServiceType(id: string): Observable<ServiceTypeDetailsDataOut>;
    /**
     * Get network status.
     * @return OK
     */
    getIpSecStatus(): Observable<boolean>;
    /**
     * GetAll sequential token load commands.
     * @param body (optional) 
     * @return OK
     */
    sequentialTokenQuery(body: QuerySequentialTokenDataIn | undefined): Observable<QuerySequentialTokenDataOutPaginationDataOut>;
    /**
     * Executes a list of tokens sequentially on the specified meter.
     * @param body (optional) 
     * @return OK
     */
    executeTokensSequentially(body: RemoteTokenDataIn | undefined): Observable<RemoteTokenResponse>;
    /**
     * GetAll load token commands
     * @param body (optional) 
     * @return OK
     */
    loadTokenQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut>;
    /**
     * GetAll clear credit commands
     * @param body (optional) 
     * @return OK
     */
    clearCreditQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut>;
    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    clearTamperQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut>;
    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    queryTokens(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut>;
    /**
     * GetAll tokens for a specific meter, enriched with the recharge amount for credit tokens.
     * @param body (optional) 
     * @return OK
     */
    queryTokensDeviceDetails(body: QueryTokenDeviceDetailsDataIn | undefined): Observable<QueryTokenDeviceDetailsDataOutPaginationDataOut>;
    /**
     * GetAll clear tamper commands
     * @param commandId (optional) 
     * @return OK
     */
    getTokensByCommand(commandId: string | undefined): Observable<SequentalTokenDataOut[]>;
    /**
     * Returns command details and token statuses for a given sequential token load command.
     * @return OK
     */
    getSequentialToken(commandId: string): Observable<CommandTokenInfoDataOut>;
    /**
     * Loads a token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadCreditToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Loads a clear credit token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadClearCreditToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Loads a clear tamper token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadClearTamperToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess>;
    /**
     * Download file that is imported on sftp server
     * @param fileId (optional) 
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportFile(fileId: string | undefined, fileType: FileType | undefined): Observable<FileResponse>;
    /**
     * Download report file
     * @param fileId (optional) 
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportReport(fileId: string | undefined, fileType: FileType | undefined): Observable<FileResponse>;
    /**
     * Download template file for import
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportTemplate(fileType: FileType | undefined): Observable<FileResponse>;
    /**
     * Upload file on sftp server
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadImportFile(fileType: FileType | undefined, file: FileParameter | undefined): Observable<string>;
    /**
     * Upload firmware file to sftp server
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadFirmwareFile(fileType: FileType | undefined, file: FileParameter | undefined): Observable<string>;
    /**
     * Get all imported files
     * @param body (optional) 
     * @return OK
     */
    queryFile(body: BulkFileGetAllDataIn | undefined): Observable<BulkFileDataOutPaginationDataOut>;
    /**
     * Process imported file. If overrideExisting is true (default), existing meters will be updated.
    If false, meters that already exist in the database will be reported as errors.
     * @param overrideExisting (optional) 
     * @return OK
     */
    processFile(id: string, overrideExisting: boolean | undefined): Observable<string>;
    /**
     * @param path (optional) 
     * @return OK
     */
    downloadBulkFile2(path: string | undefined): Observable<FileResponse>;
    /**
     * GetAll users
     * @param body (optional) 
     * @return OK
     */
    userQuery(body: UserGetAllDataIn | undefined): Observable<UserDataOutPaginationDataOut>;
    /**
     * Save user (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveUser(body: UserDataIn | undefined): Observable<string>;
    /**
     * Edit user
     * @param body (optional) 
     * @return OK
     */
    editProfile(body: UserEditDataIn | undefined): Observable<string>;
    /**
     * Delete user
     * @param id (optional) 
     * @return OK
     */
    deleteUser(id: string | undefined): Observable<string>;
    /**
     * Deactivate user
     * @param body (optional) 
     * @return OK
     */
    changeUserStatus(body: UserStatusUpdate | undefined): Observable<string>;
    /**
     * Get user by id
     * @return OK
     */
    getUser(id: string): Observable<UserDataOut>;
    /**
     * Retrieves information about the currently logged-in user.
     * @return OK
     */
    getMyUser(): Observable<UserDataOut>;
    /**
     * Query utilities for UI
     * @param body (optional) 
     * @return OK
     */
    utilityQuery(body: UtilityGetAllDataIn | undefined): Observable<UtilityDtoPaginationDataOut>;
    /**
     * Save Utility
     * @param name (optional) 
     * @param acronym (optional) 
     * @param contactPersonEmail (optional) 
     * @param contactPersonFirstName (optional) 
     * @param contactPersonLastName (optional) 
     * @param contactPersonPhoneNumber (optional) 
     * @param address (optional) 
     * @param websiteAddress (optional) 
     * @param country (optional) 
     * @param timeZone (optional) 
     * @param file (optional) 
     * @return OK
     */
    addUtility(name: string | undefined, acronym: string | undefined, contactPersonEmail: string | undefined, contactPersonFirstName: string | undefined, contactPersonLastName: string | undefined, contactPersonPhoneNumber: string | undefined, address: string | undefined, websiteAddress: string | undefined, country: UtilityCountry | undefined, timeZone: number | undefined, file: FileParameter | null | undefined): Observable<string>;
    /**
     * Edit Utility (Add new or update)
     * @param id (optional) 
     * @param name (optional) 
     * @param acronym (optional) 
     * @param contactPerson (optional) 
     * @param address (optional) 
     * @param websiteAddress (optional) 
     * @param country (optional) 
     * @param timeZone (optional) 
     * @param file (optional) 
     * @return OK
     */
    editUtility(id: string | undefined, name: string | undefined, acronym: string | undefined, contactPerson: string | undefined, address: string | undefined, websiteAddress: string | undefined, country: UtilityCountry | undefined, timeZone: number | undefined, file: FileParameter | null | undefined): Observable<string>;
    /**
     * Edit Utility
     * @param body (optional) 
     * @return OK
     */
    updateUtilityStatus(body: UtilityStatusDataIn | undefined): Observable<string>;
    /**
     * Get Utility by id
     * @return OK
     */
    getUtility(id: string): Observable<UtilityDto>;
    /**
     * Get Utility logo
     * @return OK
     */
    getUtilityLogo(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class Client implements IClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get Realtime Alarms
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    queryRealtimeAlarm(body: QueryEventAlarmDataIn | undefined): Observable<QueryAlarmDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Alarm/queryRealtimeAlarm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryRealtimeAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryRealtimeAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryAlarmDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryAlarmDataOutPaginationDataOut>;
        }));
    }

    protected processQueryRealtimeAlarm(response: HttpResponseBase): Observable<QueryAlarmDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryAlarmDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Alarm by Command or Event
     * @param body (optional) 
     * @return OK
     */
    getAlarm(body: AlarmCommandEvent | undefined): Observable<AlarmDataOut> {
        let url_ = this.baseUrl + "/api/Alarm/getAlarm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDataOut>;
        }));
    }

    protected processGetAlarm(response: HttpResponseBase): Observable<AlarmDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Load on demand alarms from meter
     * @param meterNo (optional) The unique identifier (meter number) of the target meter.
     * @return OK
     */
    onDemandReadAlarms(meterNo: string | undefined): Observable<StringResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/AlarmCommand/onDemandReadAlarms?";
        if (meterNo === null)
            throw new Error("The parameter 'meterNo' cannot be null.");
        else if (meterNo !== undefined)
            url_ += "meterNo=" + encodeURIComponent("" + meterNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandReadAlarms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandReadAlarms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringResponseCommandSuccess>;
        }));
    }

    protected processOnDemandReadAlarms(response: HttpResponseBase): Observable<StringResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreaByRegion(region: string): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Area/getAllAreaByRegion/{region}";
        if (region === undefined || region === null)
            throw new Error("The parameter 'region' must be defined.");
        url_ = url_.replace("{region}", encodeURIComponent("" + region));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllAreaByRegion(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreaByRegionForOptions(region: string): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Area/getAllAreaByRegionForOptions/{region}";
        if (region === undefined || region === null)
            throw new Error("The parameter 'region' must be defined.");
        url_ = url_.replace("{region}", encodeURIComponent("" + region));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaByRegionForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaByRegionForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllAreaByRegionForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all areas for dropdown elements.
     * @param regions (optional) 
     * @return OK
     */
    getAllAreaByRegionsForOptions(regions: string[] | undefined): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Area/getAllAreaByRegionsForOptions?";
        if (regions === null)
            throw new Error("The parameter 'regions' cannot be null.");
        else if (regions !== undefined)
            regions && regions.forEach(item => { url_ += "regions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaByRegionsForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaByRegionsForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllAreaByRegionsForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all areas for dropdown elements.
     * @return OK
     */
    getAllAreasForOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Area/getAllAreasForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreasForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreasForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllAreasForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save area (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveArea(body: AreaDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Area/saveArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveArea(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete area
     * @param id (optional) 
     * @return OK
     */
    deleteArea(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Area/deleteArea?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteArea(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll area
     * @param body (optional) 
     * @return OK
     */
    areaQuery(body: AreaGetAllDataIn | undefined): Observable<AreaDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Area/areaQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreaQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreaQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDataOutPaginationDataOut>;
        }));
    }

    protected processAreaQuery(response: HttpResponseBase): Observable<AreaDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get area with id.
     * @return OK
     */
    getArea(id: string): Observable<AreaDetailsDataOut> {
        let url_ = this.baseUrl + "/api/Area/GetArea/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDetailsDataOut>;
        }));
    }

    protected processGetArea(response: HttpResponseBase): Observable<AreaDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all asset types for dropdown elements.
     * @param applyLimiterConfiguration (optional) 
     * @return OK
     */
    getAllAssetTypesForOptions(applyLimiterConfiguration: boolean | undefined): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/AssetType/getAllAssetTypesForOptions?";
        if (applyLimiterConfiguration === null)
            throw new Error("The parameter 'applyLimiterConfiguration' cannot be null.");
        else if (applyLimiterConfiguration !== undefined)
            url_ += "ApplyLimiterConfiguration=" + encodeURIComponent("" + applyLimiterConfiguration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssetTypesForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssetTypesForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllAssetTypesForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Asset Types
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    assetTypeQuery(body: AssetTypeGetAllDataIn | undefined): Observable<AssetTypeDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/AssetType/assetTypeQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetTypeQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetTypeQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetTypeDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetTypeDataOutPaginationDataOut>;
        }));
    }

    protected processAssetTypeQuery(response: HttpResponseBase): Observable<AssetTypeDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetTypeDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Asset Type
     * @param body (optional) The request body containing all the necessary information about the asset type.
     * @return OK
     */
    saveAssetType(body: AssetTypeDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetType/saveAssetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAssetType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAssetType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveAssetType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Asset Type by Id
     * @param id Asset type Hes Id
     * @return OK
     */
    getAssetType(id: string): Observable<AssetTypeDataOut> {
        let url_ = this.baseUrl + "/api/AssetType/GetAssetType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetTypeDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetTypeDataOut>;
        }));
    }

    protected processGetAssetType(response: HttpResponseBase): Observable<AssetTypeDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetTypeDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Asset Type by Id
     * @param id (optional) 
     * @return OK
     */
    deleteAssetType(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetType/deleteAssetType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssetType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteAssetType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get region by area id
     * @param body (optional) 
     * @return OK
     */
    queryAuditLog(body: AuditLogQueryDataIn | undefined): Observable<AuditLogQueryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/AuditLog/queryAuditLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryAuditLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogQueryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogQueryDataOutPaginationDataOut>;
        }));
    }

    protected processQueryAuditLog(response: HttpResponseBase): Observable<AuditLogQueryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogQueryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download xlsx file with audit log info.
     * @param body (optional) 
     * @return OK
     */
    downloadAuditLogFile(body: DownloadAuditLogDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/AuditLog/downloadAuditLogFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAuditLogFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAuditLogFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAuditLogFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Login on Identity
     * @return OK
     */
    identityLogin(): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/identityLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIdentityLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIdentityLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIdentityLogin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Login on Identity
     * @return OK
     */
    identityLoginDesktopApp(): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/identityLoginDesktopApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIdentityLoginDesktopApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIdentityLoginDesktopApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIdentityLoginDesktopApp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Temporary endpoint to generate a login token until we integrate with Identity server
     * @param email (optional) 
     * @return OK
     */
    getToken(email: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/getToken?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    loginGET(): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/callback/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    loginPOST(): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/callback/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Log Out
     * @return OK
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for alarm
     * @param body (optional) 
     * @return OK
     */
    onDemandAlarmsCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandAlarmsCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandAlarmsCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandAlarmsCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandAlarmsCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for load profile.
     * @param body (optional) 
     * @return OK
     */
    onDemandLoadProfileCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandLoadProfileCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandLoadProfileCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandLoadProfileCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandLoadProfileCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for event log.
     * @param body (optional) 
     * @return OK
     */
    onDemandEventLogCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandEventLogCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandEventLogCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandEventLogCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandEventLogCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for energy register.
     * @param body (optional) 
     * @return OK
     */
    onDemandEnergyRegisterCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandEnergyRegisterCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandEnergyRegisterCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandEnergyRegisterCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandEnergyRegisterCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for power demand.
     * @param body (optional) 
     * @return OK
     */
    onDemandPowerDemandCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandPowerDemandCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandPowerDemandCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandPowerDemandCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandPowerDemandCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    onDemandInstantaneousObjectCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandInstantaneousObjectCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandInstantaneousObjectCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandInstantaneousObjectCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandInstantaneousObjectCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    onDemandBillingDataCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandBillingDataCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandBillingDataCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandBillingDataCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandBillingDataCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll on demand commands for custom register.
     * @param body (optional) 
     * @return OK
     */
    onDemandCustomRegisterCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/onDemandCustomRegisterCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandCustomRegisterCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandCustomRegisterCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processOnDemandCustomRegisterCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get last device configuration.
     * @param meterId (optional) 
     * @return OK
     */
    queryDeviceConfiguration(meterId: string | undefined): Observable<DeviceConfigurationInfoDataOut> {
        let url_ = this.baseUrl + "/api/Command/queryDeviceConfiguration?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryDeviceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryDeviceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceConfigurationInfoDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceConfigurationInfoDataOut>;
        }));
    }

    protected processQueryDeviceConfiguration(response: HttpResponseBase): Observable<DeviceConfigurationInfoDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceConfigurationInfoDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll commands across every command type (no type filter is applied), unlike the
    type-scoped on-demand endpoints above.
     * @param body (optional) 
     * @return OK
     */
    queryCommands(body: CommandQueryDataIn | undefined): Observable<CommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Command/queryCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDataOutPaginationDataOut>;
        }));
    }

    protected processQueryCommands(response: HttpResponseBase): Observable<CommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a single command that is currently in a pending state. Image update commands are aborted via the firmware update group service; other command types that do not support cancellation return an error.
     * @param commandId (optional) 
     * @return OK
     */
    cancelCommand(commandId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Command/cancelCommand?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCancelCommand(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    setConnectedStateCommandQuery(body: CommandQueryDataIn | undefined): Observable<ConnectDisconnectDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ConnectDisconnect/SetConnectedStateCommandQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetConnectedStateCommandQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetConnectedStateCommandQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConnectDisconnectDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConnectDisconnectDataOutPaginationDataOut>;
        }));
    }

    protected processSetConnectedStateCommandQuery(response: HttpResponseBase): Observable<ConnectDisconnectDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectDisconnectDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a specific connect/disconnect command by its unique identifier.
     * @param id The unique identifier (GUID) of the connect/disconnect command.
     * @return OK
     */
    getConnectDisconnect(id: string): Observable<InfoConnectDisconnectDataOut> {
        let url_ = this.baseUrl + "/api/ConnectDisconnect/getConnectDisconnect/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoConnectDisconnectDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoConnectDisconnectDataOut>;
        }));
    }

    protected processGetConnectDisconnect(response: HttpResponseBase): Observable<InfoConnectDisconnectDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfoConnectDisconnectDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get dashboard asset data.
     * @return OK
     */
    getAssets(): Observable<AssetValues[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getAssets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetValues[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetValues[]>;
        }));
    }

    protected processGetAssets(response: HttpResponseBase): Observable<AssetValues[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetValues.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get dashboard remote command statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getRemoteCommands(body: DashboardQueryDataIn | undefined): Observable<CommandValues[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getRemoteCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemoteCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoteCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandValues[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandValues[]>;
        }));
    }

    protected processGetRemoteCommands(response: HttpResponseBase): Observable<CommandValues[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommandValues.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get dashboard events statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getAlarms(body: DashboardQueryDataIn | undefined): Observable<EventValues[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getAlarms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlarms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlarms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventValues[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventValues[]>;
        }));
    }

    protected processGetAlarms(response: HttpResponseBase): Observable<EventValues[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventValues.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get dashboard events statistics.
     * @param body (optional) Request body containing the region and date range for the query.
     * @return OK
     */
    getEvents(body: DashboardQueryDataIn | undefined): Observable<EventValues[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventValues[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventValues[]>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<EventValues[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventValues.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meter online/offline availability split into fixed-size time intervals.
     * @param body (optional) Meter id, time range and interval size (in minutes) to split the range into.
     * @return OK
     */
    getMeterAvailabilityForInterval(body: MeterAvailabilityDataIn | undefined): Observable<MeterAvailabilityDataOut[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getMeterAvailabilityForInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterAvailabilityForInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterAvailabilityForInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterAvailabilityDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterAvailabilityDataOut[]>;
        }));
    }

    protected processGetMeterAvailabilityForInterval(response: HttpResponseBase): Observable<MeterAvailabilityDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeterAvailabilityDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMeterAvailabilityForIntervalInfo(body: MeterAvailabilityDataIn | undefined): Observable<MeterAvailabilityInfoDataOut> {
        let url_ = this.baseUrl + "/api/Dashboard/getMeterAvailabilityForIntervalInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterAvailabilityForIntervalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterAvailabilityForIntervalInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterAvailabilityInfoDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterAvailabilityInfoDataOut>;
        }));
    }

    protected processGetMeterAvailabilityForIntervalInfo(response: HttpResponseBase): Observable<MeterAvailabilityInfoDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterAvailabilityInfoDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getEnergyReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<EnergyReadDataOut[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getEnergyReadForInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnergyReadForInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnergyReadForInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyReadDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyReadDataOut[]>;
        }));
    }

    protected processGetEnergyReadForInterval(response: HttpResponseBase): Observable<EnergyReadDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnergyReadDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPowerDemandReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<PowerDemandReadDataOut[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getPowerDemandReadForInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPowerDemandReadForInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPowerDemandReadForInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerDemandReadDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerDemandReadDataOut[]>;
        }));
    }

    protected processGetPowerDemandReadForInterval(response: HttpResponseBase): Observable<PowerDemandReadDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PowerDemandReadDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getInstantaneousObjectReadForInterval(body: MeterAvailabilityDataIn | undefined): Observable<InstantaneousObjectReadDataOut[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getInstantaneousObjectReadForInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstantaneousObjectReadForInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstantaneousObjectReadForInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstantaneousObjectReadDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstantaneousObjectReadDataOut[]>;
        }));
    }

    protected processGetInstantaneousObjectReadForInterval(response: HttpResponseBase): Observable<InstantaneousObjectReadDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstantaneousObjectReadDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCommunicationActivity(body: DashboardCommunicationActivityDataIn | undefined): Observable<CommunicationActivityDataOut[]> {
        let url_ = this.baseUrl + "/api/Dashboard/getCommunicationActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationActivityDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationActivityDataOut[]>;
        }));
    }

    protected processGetCommunicationActivity(response: HttpResponseBase): Observable<CommunicationActivityDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationActivityDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List the uploaded meter setup desktop app binaries
     * @return OK
     */
    listDesktopAppBinaries(): Observable<BinaryFileDataOut[]> {
        let url_ = this.baseUrl + "/api/DesktopAppBinary/listDesktopAppBinaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDesktopAppBinaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDesktopAppBinaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinaryFileDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinaryFileDataOut[]>;
        }));
    }

    protected processListDesktopAppBinaries(response: HttpResponseBase): Observable<BinaryFileDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BinaryFileDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download the most recently uploaded meter setup desktop app binary
     * @return OK
     */
    downloadLatestDesktopAppBinary(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DesktopAppBinary/downloadLatestDesktopAppBinary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLatestDesktopAppBinary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLatestDesktopAppBinary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLatestDesktopAppBinary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download an uploaded meter setup desktop app binary
     * @param fileName (optional) 
     * @return OK
     */
    downloadDesktopAppBinary(fileName: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DesktopAppBinary/downloadDesktopAppBinary?";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDesktopAppBinary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDesktopAppBinary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDesktopAppBinary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a desktop app binary
     * @param file (optional) 
     * @return OK
     */
    uploadBinary(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/webhooks/DesktopAppBinary/uploadBinary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBinary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBinary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadBinary(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all devices (with filters and pagination).
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    query(body: MeterGetAllDataIn | undefined): Observable<MeterDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Device/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterDataOutPaginationDataOut>;
        }));
    }

    protected processQuery(response: HttpResponseBase): Observable<MeterDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add device
     * @param body (optional) Contains all meter info
     * @return OK
     */
    addDevice(body: CreateMeterDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/addDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddDevice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save and edit (when the id parameter is sent, the user is updating, until it is not sent, a new user is adding).
     * @param body (optional) Contains all meter info
     * @return OK
     */
    editDevice(body: EditMeterDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/editDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditDevice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete device from list.
     * @param id (optional) 
     * @return OK
     */
    deleteDevice(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/deleteDevice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteDevice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get device with id.
     * @return OK
     */
    getDevice(id: string): Observable<EditMeterDataIn> {
        let url_ = this.baseUrl + "/api/Device/getDevice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditMeterDataIn>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditMeterDataIn>;
        }));
    }

    protected processGetDevice(response: HttpResponseBase): Observable<EditMeterDataIn> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMeterDataIn.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download xlsx file with devices info.
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceFile(body: DownloadDeviceDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Device/downloadDeviceFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDeviceFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDeviceFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDeviceFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sync the meter clock with the system time.
     * @param meterId (optional) 
     * @return OK
     */
    syncClock(meterId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/syncClock?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncClock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncClock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncClock(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * SetupDevice
     * @param meterId (optional) 
     * @param forceFullSetup (optional) 
     * @return OK
     */
    setupDevice(meterId: string | undefined, forceFullSetup: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/SetupDevice?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        if (forceFullSetup === null)
            throw new Error("The parameter 'forceFullSetup' cannot be null.");
        else if (forceFullSetup !== undefined)
            url_ += "forceFullSetup=" + encodeURIComponent("" + forceFullSetup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetupDevice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * BulkDelete
     * @param body (optional) 
     * @return OK
     */
    bulkDelete(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/bulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * BulkSetup
     * @param forceFullSetup (optional) 
     * @param body (optional) 
     * @return OK
     */
    bulkSetup(forceFullSetup: boolean | undefined, body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/bulkSetup?";
        if (forceFullSetup === null)
            throw new Error("The parameter 'forceFullSetup' cannot be null.");
        else if (forceFullSetup !== undefined)
            url_ += "forceFullSetup=" + encodeURIComponent("" + forceFullSetup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkSetup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * For meter model get first meter that is online.
     * @param id (optional) 
     * @return OK
     */
    getMeterModelOnlineDevice(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/getMeterModelOnlineDevice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterModelOnlineDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterModelOnlineDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMeterModelOnlineDevice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get device with id.
     * @param meterNumber (optional) 
     * @return OK
     */
    getMeterModelHesId(meterNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/GetMeterModelHesId?";
        if (meterNumber === null)
            throw new Error("The parameter 'meterNumber' cannot be null.");
        else if (meterNumber !== undefined)
            url_ += "meterNumber=" + encodeURIComponent("" + meterNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterModelHesId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterModelHesId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMeterModelHesId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pings a meter causing an update in online status
     * @param meterNumber (optional) 
     * @return OK
     */
    pingMeter(meterNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/PingMeter?";
        if (meterNumber === null)
            throw new Error("The parameter 'meterNumber' cannot be null.");
        else if (meterNumber !== undefined)
            url_ += "meterNumber=" + encodeURIComponent("" + meterNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPingMeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPingMeter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPingMeter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param meterNumber (optional) 
     * @return OK
     */
    updateMeterSimId(meterNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/UpdateMeterSimId?";
        if (meterNumber === null)
            throw new Error("The parameter 'meterNumber' cannot be null.");
        else if (meterNumber !== undefined)
            url_ += "meterNumber=" + encodeURIComponent("" + meterNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMeterSimId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMeterSimId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateMeterSimId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Wake a meter using SMS (Not finished)
     * @param meterNumber (optional) 
     * @return OK
     */
    smsWakeMeter(meterNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/SmsWakeMeter?";
        if (meterNumber === null)
            throw new Error("The parameter 'meterNumber' cannot be null.");
        else if (meterNumber !== undefined)
            url_ += "meterNumber=" + encodeURIComponent("" + meterNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsWakeMeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsWakeMeter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSmsWakeMeter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setIpSecConnector(body: SetIpSecConnectorDataIn | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Device/SetIpSecConnector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIpSecConnector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIpSecConnector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetIpSecConnector(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Acquire IP address from GSm provider based on provider name and SimNumber
     * @param provider (optional) 
     * @param simNumber (optional) 
     * @return OK
     */
    getIpAddressFromGsmProvider(provider: GsmProviders | undefined, simNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/getIpAddressFromGsmProvider?";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        if (simNumber === null)
            throw new Error("The parameter 'simNumber' cannot be null.");
        else if (simNumber !== undefined)
            url_ += "simNumber=" + encodeURIComponent("" + simNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIpAddressFromGsmProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIpAddressFromGsmProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetIpAddressFromGsmProvider(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param meterHesId (optional) 
     * @return OK
     */
    getAllMeterModelForFwUpdateOptions(meterHesId: string | undefined): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Device/getAllMeterModelForFwUpdateOptions?";
        if (meterHesId === null)
            throw new Error("The parameter 'meterHesId' cannot be null.");
        else if (meterHesId !== undefined)
            url_ += "meterHesId=" + encodeURIComponent("" + meterHesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterModelForFwUpdateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterModelForFwUpdateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllMeterModelForFwUpdateOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getParentsForOption(body: MeterParentGetDataIn | undefined): Observable<GuidParentMeterDataOutDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Device/getParentsForOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentsForOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentsForOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidParentMeterDataOutDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidParentMeterDataOutDictionaryItem[]>;
        }));
    }

    protected processGetParentsForOption(response: HttpResponseBase): Observable<GuidParentMeterDataOutDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidParentMeterDataOutDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get device with id.
     * @return OK
     */
    getParent(id: string): Observable<ParentMeterDataOut> {
        let url_ = this.baseUrl + "/api/Device/getParent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParentMeterDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParentMeterDataOut>;
        }));
    }

    protected processGetParent(response: HttpResponseBase): Observable<ParentMeterDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentMeterDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param meterNumber (optional) 
     * @return OK
     */
    runDiagnostics(meterNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/runDiagnostics?";
        if (meterNumber === null)
            throw new Error("The parameter 'meterNumber' cannot be null.");
        else if (meterNumber !== undefined)
            url_ += "meterNumber=" + encodeURIComponent("" + meterNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDiagnostics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDiagnostics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRunDiagnostics(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the status and steps of a single diagnostics command, or null when the id
    belongs to no diagnostics command.
     * @param commandId (optional) 
     * @return OK
     */
    getDiagnosticsStatus(commandId: string | undefined): Observable<DiagnosticsCommandStatusDataOut> {
        let url_ = this.baseUrl + "/api/Device/getDiagnosticsStatus?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosticsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosticsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagnosticsCommandStatusDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagnosticsCommandStatusDataOut>;
        }));
    }

    protected processGetDiagnosticsStatus(response: HttpResponseBase): Observable<DiagnosticsCommandStatusDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticsCommandStatusDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the connected state (connected or disconnected) for a specific meter based on the provided input.
     * @param body (optional) Object containing the meter number, desired connection state, and the reason for the change.
     * @return OK
     */
    setConnectedState(body: DisconnectControlDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/DisconnectCommand/setConnectedState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetConnectedState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetConnectedState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processSetConnectedState(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    query2(body: EventQueryDataIn | undefined): Observable<EventDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Event/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDataOutPaginationDataOut>;
        }));
    }

    protected processQuery2(response: HttpResponseBase): Observable<EventDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the event code mappings of a meter model.
     * @param meterModelId (optional) 
     * @return OK
     */
    getEventCodeMappings(meterModelId: string | undefined): Observable<EventCodeMappingDto[]> {
        let url_ = this.baseUrl + "/api/EventCode/getEventCodeMappings?";
        if (meterModelId === null)
            throw new Error("The parameter 'meterModelId' cannot be null.");
        else if (meterModelId !== undefined)
            url_ += "meterModelId=" + encodeURIComponent("" + meterModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventCodeMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventCodeMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventCodeMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventCodeMappingDto[]>;
        }));
    }

    protected processGetEventCodeMappings(response: HttpResponseBase): Observable<EventCodeMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventCodeMappingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download the event code mappings of a meter model in the layout the import reads.
     * @param meterModelId (optional) 
     * @return OK
     */
    downloadEventCodeMappings(meterModelId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/EventCode/downloadEventCodeMappings?";
        if (meterModelId === null)
            throw new Error("The parameter 'meterModelId' cannot be null.");
        else if (meterModelId !== undefined)
            url_ += "meterModelId=" + encodeURIComponent("" + meterModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEventCodeMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEventCodeMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEventCodeMappings(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove value to event mappings. The page collects what a user deleted and saves it in one call.
     * @param body (optional) 
     * @return OK
     */
    deleteEventCodeMappings(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/EventCode/deleteEventCodeMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEventCodeMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEventCodeMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteEventCodeMappings(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the event log names a meter model overrides, one per log. An empty entry keeps the default name.
     * @param meterModelId (optional) 
     * @return OK
     */
    getEventLogLabels(meterModelId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/EventCode/getEventLogLabels?";
        if (meterModelId === null)
            throw new Error("The parameter 'meterModelId' cannot be null.");
        else if (meterModelId !== undefined)
            url_ += "meterModelId=" + encodeURIComponent("" + meterModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventLogLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventLogLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEventLogLabels(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save the event log names of a meter model, one per log. An empty entry restores the default name.
     * @param body (optional) 
     * @return OK
     */
    saveEventLogLabels(body: EventLogLabelsDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/EventCode/saveEventLogLabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEventLogLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEventLogLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveEventLogLabels(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the event log names of a meter's model, the same way getEventLogLabels returns them.
     * @param meterId (optional) 
     * @return OK
     */
    getMeterEventLogLabels(meterId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/EventCode/getMeterEventLogLabels?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterEventLogLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterEventLogLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetMeterEventLogLabels(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the event log names of the model of the meter an on demand event log read was for, the same way getEventLogLabels returns them.
     * @param commandId (optional) 
     * @return OK
     */
    getOnDemandEventLogLabels(commandId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/EventCode/getOnDemandEventLogLabels?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandEventLogLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandEventLogLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetOnDemandEventLogLabels(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query firmware update groups for specific meters.
     * @param body (optional) 
     * @return OK
     */
    queryDeferredReminders(body: FirmwareUpdateGroupForMetersQuery | undefined): Observable<FirmwareUpdateGroupDataOut[]> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/queryDeferredReminders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryDeferredReminders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryDeferredReminders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareUpdateGroupDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareUpdateGroupDataOut[]>;
        }));
    }

    protected processQueryDeferredReminders(response: HttpResponseBase): Observable<FirmwareUpdateGroupDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareUpdateGroupDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start firmware update for specific meters.
     * @param body (optional) 
     * @return OK
     */
    updateFirmwareImage(body: FirmwareUpdateStartDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/updateFirmwareImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFirmwareImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirmwareImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateFirmwareImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start firmware update for meters selected by region, area and meter model.
     * @param body (optional) 
     * @return OK
     */
    updateFirmwareImageByLocation(body: FirmwareUpdateByLocationDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/updateFirmwareImageByLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFirmwareImageByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirmwareImageByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateFirmwareImageByLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query firmware update groups.
     * @param body (optional) 
     * @return OK
     */
    queryFirmwareUpdateGroups(body: FirmwareUpdateGroupsQuery | undefined): Observable<FirmwareUpdateGroupSummaryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/queryFirmwareUpdateGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFirmwareUpdateGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFirmwareUpdateGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareUpdateGroupSummaryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareUpdateGroupSummaryDataOutPaginationDataOut>;
        }));
    }

    protected processQueryFirmwareUpdateGroups(response: HttpResponseBase): Observable<FirmwareUpdateGroupSummaryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirmwareUpdateGroupSummaryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query commands for a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    queryFirmwareUpdateGroupCommands(body: FirmwareUpdateGroupCommandsQuery | undefined): Observable<FirmwareUpdateCommandDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/queryFirmwareUpdateGroupCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFirmwareUpdateGroupCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFirmwareUpdateGroupCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareUpdateCommandDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareUpdateCommandDataOutPaginationDataOut>;
        }));
    }

    protected processQueryFirmwareUpdateGroupCommands(response: HttpResponseBase): Observable<FirmwareUpdateCommandDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirmwareUpdateCommandDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download all commands for a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    downloadFirmwareUpdateGroupCommands(body: FirmwareUpdateGroupCommandsQuery | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/downloadFirmwareUpdateGroupCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFirmwareUpdateGroupCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFirmwareUpdateGroupCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFirmwareUpdateGroupCommands(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggle scheduled firmware update group activation.
     * @param body (optional) 
     * @return OK
     */
    toggleFirmwareUpdateGroupActivation(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/toggleFirmwareUpdateGroupActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleFirmwareUpdateGroupActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleFirmwareUpdateGroupActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processToggleFirmwareUpdateGroupActivation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retry all failed commands in a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    retryFailedFirmwareUpdateGroupCommands(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/retryFailedFirmwareUpdateGroupCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryFailedFirmwareUpdateGroupCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryFailedFirmwareUpdateGroupCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRetryFailedFirmwareUpdateGroupCommands(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retry selected firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    retryFirmwareUpdateCommands(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/retryFirmwareUpdateCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryFirmwareUpdateCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryFirmwareUpdateCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRetryFirmwareUpdateCommands(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Abort all active commands in a firmware update group.
     * @param body (optional) 
     * @return OK
     */
    abortFirmwareUpdateGroupCommands(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/abortFirmwareUpdateGroupCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortFirmwareUpdateGroupCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortFirmwareUpdateGroupCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAbortFirmwareUpdateGroupCommands(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Abort selected firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    abortFirmwareUpdateCommands(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/abortFirmwareUpdateCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortFirmwareUpdateCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortFirmwareUpdateCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAbortFirmwareUpdateCommands(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete deferred firmware update group.
     * @param body (optional) 
     * @return OK
     */
    deleteDeferredReminderBatch(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/deleteDeferredReminderBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeferredReminderBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeferredReminderBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteDeferredReminderBatch(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete selected scheduled firmware update commands.
     * @param body (optional) 
     * @return OK
     */
    deleteFirmwareUpdateCommands(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/deleteFirmwareUpdateCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFirmwareUpdateCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFirmwareUpdateCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteFirmwareUpdateCommands(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete deferred firmware update command.
     * @return OK
     */
    deleteDeferredReminder(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/FirmwareUpdateGroup/deleteDeferredReminder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeferredReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeferredReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteDeferredReminder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Health check endpoint.
     * @return OK
     */
    hello(): Observable<void> {
        let url_ = this.baseUrl + "/api/Hello";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHello(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHello(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHello(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Realtime Alarms
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    getPage(body: IndividualAlarmPageQueryDataIn | undefined): Observable<IndividualAlarmPageDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/IndividualAlarm/getPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndividualAlarmPageDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndividualAlarmPageDataOutPaginationDataOut>;
        }));
    }

    protected processGetPage(response: HttpResponseBase): Observable<IndividualAlarmPageDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndividualAlarmPageDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Fraudulent Alarms (FrudAttempt or CurrentReversal)
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    getFraudulentMeters(body: FraudAlarmDataIn | undefined): Observable<FraudAlarmDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/IndividualAlarm/getFraudulentMeters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFraudulentMeters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFraudulentMeters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FraudAlarmDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FraudAlarmDataOutPaginationDataOut>;
        }));
    }

    protected processGetFraudulentMeters(response: HttpResponseBase): Observable<FraudAlarmDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FraudAlarmDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download xlsx file with Fraudulent Meters list.
     * @param body (optional) 
     * @return OK
     */
    downloadFraudulentMetersFile(body: DownloadFraudAlarmDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/IndividualAlarm/downloadFraudulentMetersFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFraudulentMetersFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFraudulentMetersFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFraudulentMetersFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    activateIpSecConnectorsJob(body: IpSecConnectorsDataIn | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Jobs/activateIpSecConnectorsJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateIpSecConnectorsJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateIpSecConnectorsJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateIpSecConnectorsJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get network outage state (admin only).
     * @return OK
     */
    getNetworkOutageState(): Observable<NetworkOutageState> {
        let url_ = this.baseUrl + "/api/Jobs/getNetworkOutageState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetworkOutageState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetworkOutageState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NetworkOutageState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NetworkOutageState>;
        }));
    }

    protected processGetNetworkOutageState(response: HttpResponseBase): Observable<NetworkOutageState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NetworkOutageState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    queryLoadLimits(body: LoadLimitGetAllDataIn | undefined): Observable<LoadLimitDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/LoadLimit/queryLoadLimits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryLoadLimits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryLoadLimits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadLimitDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadLimitDataOutPaginationDataOut>;
        }));
    }

    protected processQueryLoadLimits(response: HttpResponseBase): Observable<LoadLimitDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadLimitDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addLoadLimit(body: CreateLoadLimitDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/LoadLimit/addLoadLimit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLoadLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLoadLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddLoadLimit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLoadLimit(id: string): Observable<LoadLimitDto> {
        let url_ = this.baseUrl + "/api/LoadLimit/getLoadLimit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadLimitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadLimitDto>;
        }));
    }

    protected processGetLoadLimit(response: HttpResponseBase): Observable<LoadLimitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadLimitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLoadLimit(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/LoadLimit/deleteLoadLimit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoadLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoadLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteLoadLimit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loadLimitStatus(body: LoadLimitStatus | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/LoadLimit/loadLimitStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadLimitStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadLimitStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoadLimitStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param meterId (optional) 
     * @return OK
     */
    getMeterGeoLocation(meterId: string | undefined): Observable<MeterGeoLocationQueryDataOut[]> {
        let url_ = this.baseUrl + "/api/MeterGeoLocation/GetMeterGeoLocation?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterGeoLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterGeoLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterGeoLocationQueryDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterGeoLocationQueryDataOut[]>;
        }));
    }

    protected processGetMeterGeoLocation(response: HttpResponseBase): Observable<MeterGeoLocationQueryDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeterGeoLocationQueryDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param meterId (optional) 
     * @return OK
     */
    setMeterGeoLocationViewed(meterId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/MeterGeoLocation/SetMeterGeoLocationViewed?";
        if (meterId === null)
            throw new Error("The parameter 'meterId' cannot be null.");
        else if (meterId !== undefined)
            url_ += "meterId=" + encodeURIComponent("" + meterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMeterGeoLocationViewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMeterGeoLocationViewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetMeterGeoLocationViewed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all meter makes for dropdown elements.
     * @return OK
     */
    getAllMeterMakersForOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/MeterMake/getAllMeterMakersForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterMakersForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterMakersForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllMeterMakersForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all disconnect control mode for dropdown elements.
     * @return OK
     */
    getAllDisconnectControlModeForOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/MeterMake/getAllDisconnectControlModeForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDisconnectControlModeForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDisconnectControlModeForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllDisconnectControlModeForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllMeterMakersForSetupOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/MeterMake/getAllMeterMakersForSetupOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterMakersForSetupOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterMakersForSetupOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllMeterMakersForSetupOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save meter make (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveMeterMake(body: MeterMakeDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MeterMake/saveMeterMake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMeterMake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMeterMake(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveMeterMake(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete meter make
     * @param id (optional) 
     * @return OK
     */
    deleteMeterMake(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MeterMake/deleteMeterMake?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMeterMake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMeterMake(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteMeterMake(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll meter make
     * @param body (optional) 
     * @return OK
     */
    meterMakeQuery(body: MeterMakeGetAllDataIn | undefined): Observable<MeterMakeDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterMake/meterMakeQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMeterMakeQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMeterMakeQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterMakeDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterMakeDataOutPaginationDataOut>;
        }));
    }

    protected processMeterMakeQuery(response: HttpResponseBase): Observable<MeterMakeDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterMakeDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meter make with id.
     * @return OK
     */
    getMeterMake(id: string): Observable<MeterMakeDetailsDataOut> {
        let url_ = this.baseUrl + "/api/MeterMake/GetMeterMake/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterMake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterMake(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterMakeDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterMakeDetailsDataOut>;
        }));
    }

    protected processGetMeterMake(response: HttpResponseBase): Observable<MeterMakeDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterMakeDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all meter models for dropdown elements.
     * @param meterMake (optional) 
     * @return OK
     */
    getAllMeterModelForOptions(meterMake: string | undefined): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/MeterModel/getAllMeterModelForOptions?";
        if (meterMake === null)
            throw new Error("The parameter 'meterMake' cannot be null.");
        else if (meterMake !== undefined)
            url_ += "meterMake=" + encodeURIComponent("" + meterMake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterModelForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterModelForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllMeterModelForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all meter models for dropdown elements.
     * @param meterMakes (optional) 
     * @return OK
     */
    getAllMeterModelForMeterMakes(meterMakes: string[] | undefined): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/MeterModel/getAllMeterModelForMeterMakes?";
        if (meterMakes === null)
            throw new Error("The parameter 'meterMakes' cannot be null.");
        else if (meterMakes !== undefined)
            meterMakes && meterMakes.forEach(item => { url_ += "meterMakes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterModelForMeterMakes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterModelForMeterMakes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllMeterModelForMeterMakes(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all meter models for dropdown elements.
     * @param meterMakes (optional) 
     * @return OK
     */
    getAllMeterModelForMeterMakes2(meterMakes: string[] | undefined): Observable<MeterModelDetailsDataOut[]> {
        let url_ = this.baseUrl + "/api/MeterModel/v2/getAllMeterModelForMeterMakes?";
        if (meterMakes === null)
            throw new Error("The parameter 'meterMakes' cannot be null.");
        else if (meterMakes !== undefined)
            meterMakes && meterMakes.forEach(item => { url_ += "meterMakes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeterModelForMeterMakes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeterModelForMeterMakes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterModelDetailsDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterModelDetailsDataOut[]>;
        }));
    }

    protected processGetAllMeterModelForMeterMakes2(response: HttpResponseBase): Observable<MeterModelDetailsDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeterModelDetailsDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save meter model (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveMeterModel(body: MeterModelDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MeterModel/saveMeterModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMeterModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMeterModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveMeterModel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete meter make
     * @param id (optional) 
     * @return OK
     */
    deleteMeterModel(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MeterModel/deleteMeterModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMeterModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMeterModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteMeterModel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll meter make
     * @param body (optional) 
     * @return OK
     */
    meterModelQuery(body: MeterModelGetAllDataIn | undefined): Observable<MeterModelDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterModel/meterModelQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMeterModelQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMeterModelQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterModelDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterModelDataOutPaginationDataOut>;
        }));
    }

    protected processMeterModelQuery(response: HttpResponseBase): Observable<MeterModelDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterModelDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meter make with id.
     * @return OK
     */
    getMeterModel(id: string): Observable<MeterModelDetailsDataOut> {
        let url_ = this.baseUrl + "/api/MeterModel/getMeterModel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterModelDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterModelDetailsDataOut>;
        }));
    }

    protected processGetMeterModel(response: HttpResponseBase): Observable<MeterModelDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterModelDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query meter model versions for meter model.
     * @param body (optional) 
     * @return OK
     */
    queryMeterModelVersions(body: MeterModelVersionsQueryDataIn | undefined): Observable<MeterSetupVersionDtoPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/queryMeterModelVersions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryMeterModelVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryMeterModelVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterSetupVersionDtoPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterSetupVersionDtoPaginationDataOut>;
        }));
    }

    protected processQueryMeterModelVersions(response: HttpResponseBase): Observable<MeterSetupVersionDtoPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterSetupVersionDtoPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add meter model versions for meter model.
     * @param body (optional) 
     * @return OK
     */
    addNewVersion(body: MeterModelVersionsNew | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/addNewVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddNewVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meter model associations with id.
     * @param meterModel (optional) 
     * @return OK
     */
    getMeterModelAssociations(meterModel: string | undefined): Observable<MeterSetupVersionDto> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/getMeterModelAssociations?";
        if (meterModel === null)
            throw new Error("The parameter 'meterModel' cannot be null.");
        else if (meterModel !== undefined)
            url_ += "meterModel=" + encodeURIComponent("" + meterModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterModelAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterModelAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterSetupVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterSetupVersionDto>;
        }));
    }

    protected processGetMeterModelAssociations(response: HttpResponseBase): Observable<MeterSetupVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterSetupVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meter model associations with id.
     * @param versionId (optional) 
     * @return OK
     */
    getVersionAssociations(versionId: string | undefined): Observable<MeterSetupVersionDto> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/getVersionAssociations?";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterSetupVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterSetupVersionDto>;
        }));
    }

    protected processGetVersionAssociations(response: HttpResponseBase): Observable<MeterSetupVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterSetupVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file meter model associations with id.
     * @param versionId (optional) 
     * @return OK
     */
    downloadFileMeterModelAssociations(versionId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/downloadFileMeterModelAssociations?";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileMeterModelAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileMeterModelAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFileMeterModelAssociations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Push Interval 1 Required Capture Objects.
     * @return OK
     */
    getConfigurationOptions(): Observable<SetupConfigurationOptionsDto> {
        let url_ = this.baseUrl + "/api/MeterModelVersion/getConfigurationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetupConfigurationOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetupConfigurationOptionsDto>;
        }));
    }

    protected processGetConfigurationOptions(response: HttpResponseBase): Observable<SetupConfigurationOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetupConfigurationOptionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all acquisitions (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    queryAcquisitions(body: AcquisitionQuery | undefined): Observable<AcquisitionQueryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/queryAcquisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryAcquisitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryAcquisitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcquisitionQueryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcquisitionQueryDataOutPaginationDataOut>;
        }));
    }

    protected processQueryAcquisitions(response: HttpResponseBase): Observable<AcquisitionQueryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcquisitionQueryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get acquisition with id.
     * @return OK
     */
    getAcquisition(id: string): Observable<AcquisitionDataOut> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/getAcquisition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcquisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcquisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcquisitionDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcquisitionDataOut>;
        }));
    }

    protected processGetAcquisition(response: HttpResponseBase): Observable<AcquisitionDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcquisitionDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all device connection times (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    queryDeviceConnection(body: DeviceConnectionQuery | undefined): Observable<DeviceConnectionQueryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/queryDeviceConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryDeviceConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryDeviceConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceConnectionQueryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceConnectionQueryDataOutPaginationDataOut>;
        }));
    }

    protected processQueryDeviceConnection(response: HttpResponseBase): Observable<DeviceConnectionQueryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceConnectionQueryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get device connection time with id.
     * @return OK
     */
    getDeviceConnection(id: string): Observable<DeviceConnectionDataOut> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/getDeviceConnection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceConnectionDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceConnectionDataOut>;
        }));
    }

    protected processGetDeviceConnection(response: HttpResponseBase): Observable<DeviceConnectionDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceConnectionDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of meters with information about whether their time is properly synchronized or not.
     * @param body (optional) 
     * @return OK
     */
    queryMeterTimeSync(body: TimeSyncQuery | undefined): Observable<TimeSyncDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/queryMeterTimeSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryMeterTimeSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryMeterTimeSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSyncDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSyncDataOutPaginationDataOut>;
        }));
    }

    protected processQueryMeterTimeSync(response: HttpResponseBase): Observable<TimeSyncDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSyncDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all device connection times (with filters and pagination).
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceConnectionListFile(body: DownloadDeviceConnectionDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/downloadDeviceConnectionListFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDeviceConnectionListFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDeviceConnectionListFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDeviceConnectionListFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAcquisitionFile(body: DownloadAcquisitionDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/downloadAcquisitionFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAcquisitionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAcquisitionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAcquisitionFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadTimeSyncFile(body: DownloadTimeSyncDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MeterSnapshot/downloadTimeSyncFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTimeSyncFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTimeSyncFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTimeSyncFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandLoadProfile(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandLoadProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandLoadProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandLoadProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandLoadProfile(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Runs an on-demand load profile read for the given meter, without requiring the caller
    to supply a date range, reading from its last recorded read meter time up to now.
     * @param meterHesId (optional) The HES id of the meter to read.
     * @return OK
     */
    runReadLoadProfile(meterHesId: string | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/RunReadLoadProfile?";
        if (meterHesId === null)
            throw new Error("The parameter 'meterHesId' cannot be null.");
        else if (meterHesId !== undefined)
            url_ += "meterHesId=" + encodeURIComponent("" + meterHesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunReadLoadProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunReadLoadProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processRunReadLoadProfile(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandEnergyRegisters(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandEnergyRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandEnergyRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandEnergyRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandEnergyRegisters(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandPowerDemand(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandPowerDemand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandPowerDemand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandPowerDemand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandPowerDemand(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the load profile data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandInstantaneousObject(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandInstantaneousObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandInstantaneousObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandInstantaneousObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandInstantaneousObject(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the billing data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandBilling(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandBilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandBilling(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read custom DLMS register value from a meter
     * @param body (optional) 
     * @return OK
     */
    onDemandReadRegister(body: OnDemandReadRegisterIn | undefined): Observable<StringResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandReadRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandReadRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandReadRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringResponseCommandSuccess>;
        }));
    }

    protected processOnDemandReadRegister(response: HttpResponseBase): Observable<StringResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandBillingRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandBillingRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandBillingRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandBillingRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandBillingRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandAlarmRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandAlarmRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandAlarmRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandAlarmRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandAlarmRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandLoadProfileRegisterRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandLoadProfileRegisterRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandLoadProfileRegisterRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandLoadProfileRegisterRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandLoadProfileRegisterRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandEnergyRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandEnergyRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandEnergyRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandEnergyRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandEnergyRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandInstantaneousRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandInstantaneousRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandInstantaneousRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandInstantaneousRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandInstantaneousRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandPowerDemandRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandPowerDemandRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandPowerDemandRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandPowerDemandRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandPowerDemandRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandClearCreditRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandClearCreditRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandClearCreditRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandClearCreditRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandClearCreditRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandClearTamperRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandClearTamperRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandClearTamperRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandClearTamperRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandClearTamperRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandConnectDisconnectRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandConnectDisconnectRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandConnectDisconnectRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandConnectDisconnectRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandConnectDisconnectRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandSequentialTokenRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandSequentialTokenRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandSequentialTokenRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandSequentialTokenRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandSequentialTokenRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onDemandTokenLoadRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandTokenLoadRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandTokenLoadRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandTokenLoadRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandTokenLoadRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onDemandDataBulkRetry(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandDataBulkRetry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandDataBulkRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandDataBulkRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnDemandDataBulkRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    commandRetry(commandId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/CommandRetry/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommandRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommandRetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommandRetry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the event log data from the specified meter for the given date range.
     * @param body (optional) An HES.UO.DigitalTwin.Services.UOServices.Models.OnDemand.DataIn.OnDemandDataIn object containing the meter number, start date, and end date for the data retrieval.
     * @return OK
     */
    onDemandEventLog(body: OnDemandDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/OnDemandCommand/OnDemandEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDemandEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDemandEventLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processOnDemandEventLog(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandEnergyRegisters(body: OnDemandDetailsDataIn | undefined): Observable<EnergyBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandEnergyRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandEnergyRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandEnergyRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandEnergyRegisters(response: HttpResponseBase): Observable<EnergyBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnergyBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Billing data registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandBillingDataRegisters(body: OnDemandDetailsDataIn | undefined): Observable<BillingDataBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandBillingDataRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandBillingDataRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandBillingDataRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDataBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDataBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandBillingDataRegisters(response: HttpResponseBase): Observable<BillingDataBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDataBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandPowerDemandRegisters(body: OnDemandDetailsDataIn | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandPowerDemandRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandPowerDemandRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandPowerDemandRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandPowerDemandRegisters(response: HttpResponseBase): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerDemandBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandLoadProfile(body: OnDemandDetailsDataIn | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandLoadProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandLoadProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandLoadProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandLoadProfile(response: HttpResponseBase): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadProfileBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandInstantaneousObject(body: OnDemandDetailsDataIn | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandInstantaneousObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandInstantaneousObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandInstantaneousObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandInstantaneousObject(response: HttpResponseBase): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstantaneousBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with load profile registers for command.
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandLoadProfileRegisters(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandLoadProfileRegisters?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandLoadProfileRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandLoadProfileRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandLoadProfileRegisters(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandEventLog(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandEventLog?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandEventLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandEventLog(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadMeterEventLogs(body: MeterEventLogQueryDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadMeterEventLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMeterEventLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMeterEventLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMeterEventLogs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandEnergyRegisters(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandEnergyRegisters?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandEnergyRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandEnergyRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandEnergyRegisters(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandPowerDemandRegisters(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandPowerDemandRegisters?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandPowerDemandRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandPowerDemandRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandPowerDemandRegisters(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandInstantaneousObjectRegisters(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandInstantaneousObjectRegisters?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandInstantaneousObjectRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandInstantaneousObjectRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandInstantaneousObjectRegisters(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param commandId (optional) 
     * @return OK
     */
    downloadOnDemandBillingDataRegisters(commandId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OnDemandReads/downloadOnDemandBillingDataRegisters?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOnDemandBillingDataRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOnDemandBillingDataRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOnDemandBillingDataRegisters(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fetch all reads from the database for a specific command.
     * @param body (optional) CommandId and page info
     * @return OK
     */
    getOnDemandRegisterReads(body: OnDemandDetailsDataIn | undefined): Observable<OnDemandAttributeDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/GetOnDemandRegisterReads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandRegisterReads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandRegisterReads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnDemandAttributeDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnDemandAttributeDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandRegisterReads(response: HttpResponseBase): Observable<OnDemandAttributeDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnDemandAttributeDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lists all supported registers for on demand read
     * @param meterModelHesId (optional) 
     * @return OK
     */
    getOnDemandRegisterAttributes(meterModelHesId: string | undefined): Observable<AssociationDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/OnDemandReads/GetOnDemandRegisterAttributes?";
        if (meterModelHesId === null)
            throw new Error("The parameter 'meterModelHesId' cannot be null.");
        else if (meterModelHesId !== undefined)
            url_ += "meterModelHesId=" + encodeURIComponent("" + meterModelHesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandRegisterAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandRegisterAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssociationDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssociationDescriptionDto[]>;
        }));
    }

    protected processGetOnDemandRegisterAttributes(response: HttpResponseBase): Observable<AssociationDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssociationDescriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Event Log Registers.
     * @param body (optional) 
     * @return OK
     */
    getOnDemandEventLog(body: EventLogDetailsDataIn | undefined): Observable<EventLogEntryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getOnDemandEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandEventLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventLogEntryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventLogEntryDataOutPaginationDataOut>;
        }));
    }

    protected processGetOnDemandEventLog(response: HttpResponseBase): Observable<EventLogEntryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventLogEntryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Every event one meter logged, across all of its event log reads, each event once.
     * @param body (optional) 
     * @return OK
     */
    getMeterEventLogs(body: MeterEventLogQueryDataIn | undefined): Observable<MeterEventLogDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/OnDemandReads/getMeterEventLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterEventLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterEventLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterEventLogDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterEventLogDataOutPaginationDataOut>;
        }));
    }

    protected processGetMeterEventLogs(response: HttpResponseBase): Observable<MeterEventLogDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeterEventLogDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    simNetworkEvent(key: string, body: SimNetworkWebhook | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/webhooks/Onomondo/simNetworkEvent/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimNetworkEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimNetworkEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSimNetworkEvent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    query3(body: PendingMeterGetAllDataIn | undefined): Observable<PendingMeterDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/PendingMeter/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingMeterDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingMeterDataOutPaginationDataOut>;
        }));
    }

    protected processQuery3(response: HttpResponseBase): Observable<PendingMeterDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingMeterDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete device from list.
     * @param id (optional) 
     * @return OK
     */
    deleteDevice2(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/PendingMeter/deleteDevice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDevice2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDevice2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteDevice2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download xlsx file with devices info.
     * @param body (optional) 
     * @return OK
     */
    downloadDeviceFile2(body: DownloadPendingDeviceDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PendingMeter/downloadDeviceFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDeviceFile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDeviceFile2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDeviceFile2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all prepayments
     * @param body (optional) Request body containing filter, sorting and pagination options.
     * @return OK
     */
    queryPrepaymentReport(body: PrepaymentGetAllDataIn | undefined): Observable<PrepaymentDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Prepayment/queryPrepaymentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryPrepaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryPrepaymentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrepaymentDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrepaymentDataOutPaginationDataOut>;
        }));
    }

    protected processQueryPrepaymentReport(response: HttpResponseBase): Observable<PrepaymentDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrepaymentDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadPrepaymentReportFile(body: DownloadPrepaymentDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Prepayment/downloadPrepaymentReportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPrepaymentReportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPrepaymentReportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPrepaymentReportFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all regions.
     * @return OK
     */
    getAllRegions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Region/getAllRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllRegions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all regions for dropdown elements.
     * @return OK
     */
    getAllRegionsForOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/Region/getAllRegionsForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegionsForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegionsForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllRegionsForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save region (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveRegion(body: RegionDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Region/saveRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveRegion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete region
     * @param id (optional) 
     * @return OK
     */
    deleteRegion(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Region/deleteRegion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteRegion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll region
     * @param body (optional) 
     * @return OK
     */
    regionQuery(body: RegionGetAllDataIn | undefined): Observable<RegionDetailsDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Region/regionQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDetailsDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDetailsDataOutPaginationDataOut>;
        }));
    }

    protected processRegionQuery(response: HttpResponseBase): Observable<RegionDetailsDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDetailsDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get region with id.
     * @return OK
     */
    getRegion(id: string): Observable<RegionDetailsDataOut> {
        let url_ = this.baseUrl + "/api/Region/GetRegion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDetailsDataOut>;
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<RegionDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get region by area id.
     * @return OK
     */
    getRegionByArea(id: string): Observable<RegionDetailsDataOut> {
        let url_ = this.baseUrl + "/api/Region/GetRegionByArea/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionByArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionByArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDetailsDataOut>;
        }));
    }

    protected processGetRegionByArea(response: HttpResponseBase): Observable<RegionDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all for dropdown
     * @return OK
     */
    getAllRolesForOptions(): Observable<RoleSimpleDataOut[]> {
        let url_ = this.baseUrl + "/api/Role/getAllRolesForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRolesForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRolesForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleSimpleDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleSimpleDataOut[]>;
        }));
    }

    protected processGetAllRolesForOptions(response: HttpResponseBase): Observable<RoleSimpleDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleSimpleDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all permissions for the currently logged in user
     * @return OK
     */
    getMyPermissions(): Observable<string> {
        let url_ = this.baseUrl + "/api/Role/getMyPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMyPermissions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll user roles
     * @param body (optional) 
     * @return OK
     */
    roleQuery(body: RoleGetAllDataIn | undefined): Observable<RoleDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Role/roleQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDataOutPaginationDataOut>;
        }));
    }

    protected processRoleQuery(response: HttpResponseBase): Observable<RoleDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save role (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveRole(body: RoleDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Role/saveRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete role
     * @param id (optional) 
     * @return OK
     */
    deleteRole(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Role/deleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate user
     * @param body (optional) 
     * @return OK
     */
    changeRoleStatus(body: RoleStatusUpdate | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Role/changeRoleStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRoleStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRoleStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangeRoleStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get role
     * @return OK
     */
    getRole(id: string): Observable<RoleCrud> {
        let url_ = this.baseUrl + "/api/Role/getRole/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleCrud>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleCrud>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<RoleCrud> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleCrud.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get scheduled load profile events.
     * @param body (optional) 
     * @return OK
     */
    queryLastScheduledDevices(body: QueryScheduledDataReadDataIn | undefined): Observable<QueryScheduledDataReadDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/queryLastScheduledDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryLastScheduledDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryLastScheduledDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
        }));
    }

    protected processQueryLastScheduledDevices(response: HttpResponseBase): Observable<QueryScheduledDataReadDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryScheduledDataReadDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meters with scheduled event logs.
     * @param body (optional) 
     * @return OK
     */
    queryScheduledEventLogDevices(body: QueryScheduledDataReadDataIn | undefined): Observable<QueryScheduledDataReadDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/queryScheduledEventLogDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryScheduledEventLogDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryScheduledEventLogDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryScheduledDataReadDataOutPaginationDataOut>;
        }));
    }

    protected processQueryScheduledEventLogDevices(response: HttpResponseBase): Observable<QueryScheduledDataReadDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryScheduledDataReadDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getRawEnergyRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getRawEnergyRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawEnergyRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawEnergyRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetRawEnergyRegisters(response: HttpResponseBase): Observable<EnergyBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnergyBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get energy registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedEnergyRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getProcessedEnergyRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedEnergyRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedEnergyRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetProcessedEnergyRegisters(response: HttpResponseBase): Observable<EnergyBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnergyBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getRawPowerDemandRegisters(body: LoadProfileCommandEvent | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getRawPowerDemandRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawPowerDemandRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawPowerDemandRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetRawPowerDemandRegisters(response: HttpResponseBase): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerDemandBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get power demand registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedPowerDemandRegisters(body: LoadProfileCommandEvent | undefined): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getProcessedPowerDemandRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedPowerDemandRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedPowerDemandRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerDemandBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetProcessedPowerDemandRegisters(response: HttpResponseBase): Observable<PowerDemandBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerDemandBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getRawLoadProfile(body: LoadProfileCommandEvent | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getRawLoadProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawLoadProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawLoadProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetRawLoadProfile(response: HttpResponseBase): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadProfileBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get load profile registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedLoadProfile(body: LoadProfileCommandEvent | undefined): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getProcessedLoadProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedLoadProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedLoadProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadProfileBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetProcessedLoadProfile(response: HttpResponseBase): Observable<LoadProfileBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadProfileBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getRawInstantaneousObject(body: LoadProfileCommandEvent | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getRawInstantaneousObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawInstantaneousObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawInstantaneousObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetRawInstantaneousObject(response: HttpResponseBase): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstantaneousBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get instantaneous object.
     * @param body (optional) 
     * @return OK
     */
    getProcessedInstantaneousObject(body: LoadProfileCommandEvent | undefined): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getProcessedInstantaneousObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedInstantaneousObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedInstantaneousObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstantaneousBufferDataOutPaginationDataOut>;
        }));
    }

    protected processGetProcessedInstantaneousObject(response: HttpResponseBase): Observable<InstantaneousBufferDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstantaneousBufferDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with energy registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawEnergyRegistersFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadRawEnergyRegistersFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadRawEnergyRegistersFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadRawEnergyRegistersFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadRawEnergyRegistersFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with energy registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedEnergyRegistersFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadProcessedEnergyRegistersFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessedEnergyRegistersFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessedEnergyRegistersFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessedEnergyRegistersFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with power demand registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawPowerDemandFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadRawPowerDemandFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadRawPowerDemandFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadRawPowerDemandFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadRawPowerDemandFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with power demand registers for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedPowerDemandFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadProcessedPowerDemandFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessedPowerDemandFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessedPowerDemandFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessedPowerDemandFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with load profile for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawLoadProfileFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadRawLoadProfileFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadRawLoadProfileFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadRawLoadProfileFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadRawLoadProfileFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with load profile for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedLoadProfileFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadProcessedLoadProfileFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessedLoadProfileFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessedLoadProfileFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessedLoadProfileFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with instantaneous objects for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadRawInstantaneousObjectFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadRawInstantaneousObjectFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadRawInstantaneousObjectFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadRawInstantaneousObjectFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadRawInstantaneousObjectFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file with instantaneous objects for command or event.
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedInstantaneousObjectFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadProcessedInstantaneousObjectFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessedInstantaneousObjectFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessedInstantaneousObjectFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessedInstantaneousObjectFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get energy per phase registers.
     * @param body (optional) 
     * @return OK
     */
    getEnergyPerPhaseRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyPerPhaseDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getEnergyPerPhaseRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnergyPerPhaseRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnergyPerPhaseRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyPerPhaseDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyPerPhaseDataOutPaginationDataOut>;
        }));
    }

    protected processGetEnergyPerPhaseRegisters(response: HttpResponseBase): Observable<EnergyPerPhaseDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnergyPerPhaseDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get processed energy per phase registers.
     * @param body (optional) 
     * @return OK
     */
    getProcessedEnergyPerPhaseRegisters(body: LoadProfileCommandEvent | undefined): Observable<EnergyPerPhaseDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ScheduledReads/getProcessedEnergyPerPhaseRegisters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedEnergyPerPhaseRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedEnergyPerPhaseRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnergyPerPhaseDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnergyPerPhaseDataOutPaginationDataOut>;
        }));
    }

    protected processGetProcessedEnergyPerPhaseRegisters(response: HttpResponseBase): Observable<EnergyPerPhaseDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnergyPerPhaseDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadEnergyPerPhaseFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadEnergyPerPhaseFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEnergyPerPhaseFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEnergyPerPhaseFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEnergyPerPhaseFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadProcessedEnergyPerPhaseFile(body: DownloadLoadProfileDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadProcessedEnergyPerPhaseFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProcessedEnergyPerPhaseFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProcessedEnergyPerPhaseFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProcessedEnergyPerPhaseFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyPerPhaseCombined(body: DownloadBulkDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkEnergyPerPhaseCombined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkEnergyPerPhaseCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkEnergyPerPhaseCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadBulkEnergyPerPhaseCombined(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkLoadProfileRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkLoadProfileRaw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkLoadProfileRaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkLoadProfileRaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkLoadProfileRaw(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkLoadProfileCombined(body: DownloadBulkDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkLoadProfileCombined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkLoadProfileCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkLoadProfileCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadBulkLoadProfileCombined(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path (optional) 
     * @return OK
     */
    downloadBulkFile(path: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkFile?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyRegisterRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkEnergyRegisterRaw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkEnergyRegisterRaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkEnergyRegisterRaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkEnergyRegisterRaw(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkEnergyRegisterCombined(body: DownloadBulkDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkEnergyRegisterCombined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkEnergyRegisterCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkEnergyRegisterCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadBulkEnergyRegisterCombined(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkPowerDemandRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkPowerDemandRaw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkPowerDemandRaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkPowerDemandRaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkPowerDemandRaw(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkPowerDemandCombined(body: DownloadBulkDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkPowerDemandCombined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkPowerDemandCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkPowerDemandCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadBulkPowerDemandCombined(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkInstantaneousRaw(body: DownloadBulkDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkInstantaneousRaw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkInstantaneousRaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkInstantaneousRaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkInstantaneousRaw(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBulkInstantaneousCombined(body: DownloadBulkDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledReads/downloadBulkInstantaneousCombined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkInstantaneousCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkInstantaneousCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadBulkInstantaneousCombined(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a paginated list of scheduler execution history entries filtered by status, date range, and search term.
    Each entry represents one scheduler run and includes the aggregated command status across all meters processed in that run.
     * @param body (optional) 
     * @return OK
     */
    jobStatusHistoryQuery(body: SchedulerStatusHistoryDataIn | undefined): Observable<SchedulerStatusHistoryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Scheduler/jobStatusHistoryQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJobStatusHistoryQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJobStatusHistoryQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerStatusHistoryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerStatusHistoryDataOutPaginationDataOut>;
        }));
    }

    protected processJobStatusHistoryQuery(response: HttpResponseBase): Observable<SchedulerStatusHistoryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulerStatusHistoryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads an Excel file containing scheduler execution history entries filtered by status, date range, and search term.
    Each row represents one scheduler run with its aggregated command status across all meters processed in that run.
    Requires HES.UO.Shared.Common.PermissionsEnum.systemmonitoring_jobstatushistory_download permission.
     * @param body (optional) 
     * @return OK
     */
    downloadJobStatusHistoryQuery(body: SchedulerStatusHistoryDataIn | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Scheduler/downloadJobStatusHistoryQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadJobStatusHistoryQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadJobStatusHistoryQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadJobStatusHistoryQuery(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save reminder
     * @param body (optional) 
     * @return OK
     */
    saveScheduler(body: SchedulerDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Scheduler/saveScheduler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveScheduler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveScheduler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveScheduler(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryReminders(body: SchedulerQuery | undefined): Observable<SchedulerQueryDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Scheduler/queryReminders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryReminders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryReminders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerQueryDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerQueryDataOutPaginationDataOut>;
        }));
    }

    protected processQueryReminders(response: HttpResponseBase): Observable<SchedulerQueryDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulerQueryDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change reminder status
     * @param body (optional) 
     * @return OK
     */
    reminderStatus(body: SchedulerStatus | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Scheduler/reminderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReminderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReminderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReminderStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete reminder
     * @return OK
     */
    deleteReminder(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Scheduler/deleteReminder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteReminder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get reminder
     * @return OK
     */
    getReminder(id: string): Observable<SchedulerDto> {
        let url_ = this.baseUrl + "/api/Scheduler/getReminder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerDto>;
        }));
    }

    protected processGetReminder(response: HttpResponseBase): Observable<SchedulerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryScheduleLogs(body: ScheduleLogsDataIn | undefined): Observable<ScheduleLogsDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Scheduler/queryScheduleLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryScheduleLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryScheduleLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleLogsDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleLogsDataOutPaginationDataOut>;
        }));
    }

    protected processQueryScheduleLogs(response: HttpResponseBase): Observable<ScheduleLogsDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleLogsDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads the schedule log commands as an Excel file for the specified schedule log ID.
     * @param dataIn (optional) 
     * @return OK
     */
    downloadScheduleLog(dataIn: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Scheduler/downloadScheduleLog?";
        if (dataIn === null)
            throw new Error("The parameter 'dataIn' cannot be null.");
        else if (dataIn !== undefined)
            url_ += "dataIn=" + encodeURIComponent("" + dataIn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadScheduleLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadScheduleLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadScheduleLog(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query reminders
     * @param body (optional) 
     * @return OK
     */
    queryScheduleLogsCommands(body: ScheduleLogsCommandsQuery | undefined): Observable<ScheduleLogsCommandsDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Scheduler/queryScheduleLogsCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryScheduleLogsCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryScheduleLogsCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleLogsCommandsDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleLogsCommandsDataOutPaginationDataOut>;
        }));
    }

    protected processQueryScheduleLogsCommands(response: HttpResponseBase): Observable<ScheduleLogsCommandsDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleLogsCommandsDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads schedule log commands as an Excel file based on the provided query parameters.
     * @param body (optional) 
     * @return OK
     */
    downloadScheduleLogCommands(body: ScheduleLogsCommandsQuery | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Scheduler/downloadScheduleLogCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadScheduleLogCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadScheduleLogCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadScheduleLogCommands(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all service types for dropdown elements.
     * @return OK
     */
    getAllServiceTypesForOptions(): Observable<GuidDictionaryItem[]> {
        let url_ = this.baseUrl + "/api/ServiceType/getAllServiceTypesForOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceTypesForOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceTypesForOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidDictionaryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidDictionaryItem[]>;
        }));
    }

    protected processGetAllServiceTypesForOptions(response: HttpResponseBase): Observable<GuidDictionaryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidDictionaryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save service type (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveServiceType(body: ServiceTypeDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ServiceType/saveServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveServiceType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete service type
     * @param id (optional) 
     * @return OK
     */
    deleteServiceType(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ServiceType/deleteServiceType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteServiceType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll service type
     * @param body (optional) 
     * @return OK
     */
    serviceTypeQuery(body: ServiceTypeGetAllDataIn | undefined): Observable<ServiceTypeDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/ServiceType/serviceTypeQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTypeQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTypeQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTypeDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTypeDataOutPaginationDataOut>;
        }));
    }

    protected processServiceTypeQuery(response: HttpResponseBase): Observable<ServiceTypeDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTypeDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get service type with id.
     * @return OK
     */
    getServiceType(id: string): Observable<ServiceTypeDetailsDataOut> {
        let url_ = this.baseUrl + "/api/ServiceType/getServiceType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTypeDetailsDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTypeDetailsDataOut>;
        }));
    }

    protected processGetServiceType(response: HttpResponseBase): Observable<ServiceTypeDetailsDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTypeDetailsDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get network status.
     * @return OK
     */
    getIpSecStatus(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SystemStatus/getIpSecStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIpSecStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIpSecStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIpSecStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll sequential token load commands.
     * @param body (optional) 
     * @return OK
     */
    sequentialTokenQuery(body: QuerySequentialTokenDataIn | undefined): Observable<QuerySequentialTokenDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/sequentialTokenQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSequentialTokenQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSequentialTokenQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuerySequentialTokenDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuerySequentialTokenDataOutPaginationDataOut>;
        }));
    }

    protected processSequentialTokenQuery(response: HttpResponseBase): Observable<QuerySequentialTokenDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuerySequentialTokenDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes a list of tokens sequentially on the specified meter.
     * @param body (optional) 
     * @return OK
     */
    executeTokensSequentially(body: RemoteTokenDataIn | undefined): Observable<RemoteTokenResponse> {
        let url_ = this.baseUrl + "/api/Token/executeTokensSequentially";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteTokensSequentially(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteTokensSequentially(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteTokenResponse>;
        }));
    }

    protected processExecuteTokensSequentially(response: HttpResponseBase): Observable<RemoteTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoteTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll load token commands
     * @param body (optional) 
     * @return OK
     */
    loadTokenQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/loadTokenQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadTokenQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadTokenQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryTokenDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryTokenDataOutPaginationDataOut>;
        }));
    }

    protected processLoadTokenQuery(response: HttpResponseBase): Observable<QueryTokenDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryTokenDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll clear credit commands
     * @param body (optional) 
     * @return OK
     */
    clearCreditQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/clearCreditQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCreditQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCreditQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryTokenDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryTokenDataOutPaginationDataOut>;
        }));
    }

    protected processClearCreditQuery(response: HttpResponseBase): Observable<QueryTokenDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryTokenDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    clearTamperQuery(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/clearTamperQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearTamperQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearTamperQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryTokenDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryTokenDataOutPaginationDataOut>;
        }));
    }

    protected processClearTamperQuery(response: HttpResponseBase): Observable<QueryTokenDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryTokenDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll clear tamper commands
     * @param body (optional) 
     * @return OK
     */
    queryTokens(body: QueryTokenDataIn | undefined): Observable<QueryTokenDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/queryTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryTokenDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryTokenDataOutPaginationDataOut>;
        }));
    }

    protected processQueryTokens(response: HttpResponseBase): Observable<QueryTokenDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryTokenDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll tokens for a specific meter, enriched with the recharge amount for credit tokens.
     * @param body (optional) 
     * @return OK
     */
    queryTokensDeviceDetails(body: QueryTokenDeviceDetailsDataIn | undefined): Observable<QueryTokenDeviceDetailsDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Token/queryTokensDeviceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryTokensDeviceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryTokensDeviceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryTokenDeviceDetailsDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryTokenDeviceDetailsDataOutPaginationDataOut>;
        }));
    }

    protected processQueryTokensDeviceDetails(response: HttpResponseBase): Observable<QueryTokenDeviceDetailsDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryTokenDeviceDetailsDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll clear tamper commands
     * @param commandId (optional) 
     * @return OK
     */
    getTokensByCommand(commandId: string | undefined): Observable<SequentalTokenDataOut[]> {
        let url_ = this.baseUrl + "/api/Token/getTokensByCommand?";
        if (commandId === null)
            throw new Error("The parameter 'commandId' cannot be null.");
        else if (commandId !== undefined)
            url_ += "commandId=" + encodeURIComponent("" + commandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokensByCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokensByCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SequentalTokenDataOut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SequentalTokenDataOut[]>;
        }));
    }

    protected processGetTokensByCommand(response: HttpResponseBase): Observable<SequentalTokenDataOut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SequentalTokenDataOut.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns command details and token statuses for a given sequential token load command.
     * @return OK
     */
    getSequentialToken(commandId: string): Observable<CommandTokenInfoDataOut> {
        let url_ = this.baseUrl + "/api/Token/getSequentialToken/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSequentialToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSequentialToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandTokenInfoDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandTokenInfoDataOut>;
        }));
    }

    protected processGetSequentialToken(response: HttpResponseBase): Observable<CommandTokenInfoDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandTokenInfoDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Loads a token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadCreditToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/TokenCommand/loadCreditToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadCreditToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadCreditToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processLoadCreditToken(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Loads a clear credit token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadClearCreditToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/TokenCommand/loadClearCreditToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadClearCreditToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadClearCreditToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processLoadClearCreditToken(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Loads a clear tamper token into the specified meter to reset tamper conditions remotely.
     * @param body (optional) An object containing the meter number and the clear tamper token.
     * @return OK
     */
    loadClearTamperToken(body: LoadTokenDataIn | undefined): Observable<BooleanResponseCommandSuccess> {
        let url_ = this.baseUrl + "/api/commands/TokenCommand/loadClearTamperToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadClearTamperToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadClearTamperToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseCommandSuccess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseCommandSuccess>;
        }));
    }

    protected processLoadClearTamperToken(response: HttpResponseBase): Observable<BooleanResponseCommandSuccess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseCommandSuccess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file that is imported on sftp server
     * @param fileId (optional) 
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportFile(fileId: string | undefined, fileType: FileType | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Upload/downloadImportFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download report file
     * @param fileId (optional) 
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportReport(fileId: string | undefined, fileType: FileType | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Upload/downloadImportReport?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download template file for import
     * @param fileType (optional) 
     * @return OK
     */
    downloadImportTemplate(fileType: FileType | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Upload/downloadImportTemplate?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload file on sftp server
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadImportFile(fileType: FileType | undefined, file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Upload/uploadImportFile?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImportFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(result204);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload firmware file to sftp server
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadFirmwareFile(fileType: FileType | undefined, file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Upload/uploadFirmwareFile?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFirmwareFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFirmwareFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFirmwareFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(result204);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all imported files
     * @param body (optional) 
     * @return OK
     */
    queryFile(body: BulkFileGetAllDataIn | undefined): Observable<BulkFileDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Upload/queryFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkFileDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkFileDataOutPaginationDataOut>;
        }));
    }

    protected processQueryFile(response: HttpResponseBase): Observable<BulkFileDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkFileDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Process imported file. If overrideExisting is true (default), existing meters will be updated.
    If false, meters that already exist in the database will be reported as errors.
     * @param overrideExisting (optional) 
     * @return OK
     */
    processFile(id: string, overrideExisting: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Upload/processFile/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (overrideExisting === null)
            throw new Error("The parameter 'overrideExisting' cannot be null.");
        else if (overrideExisting !== undefined)
            url_ += "overrideExisting=" + encodeURIComponent("" + overrideExisting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processProcessFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return _observableOf(result202);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path (optional) 
     * @return OK
     */
    downloadBulkFile2(path: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Upload/downloadBulkFile?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkFile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkFile2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkFile2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll users
     * @param body (optional) 
     * @return OK
     */
    userQuery(body: UserGetAllDataIn | undefined): Observable<UserDataOutPaginationDataOut> {
        let url_ = this.baseUrl + "/api/User/userQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataOutPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataOutPaginationDataOut>;
        }));
    }

    protected processUserQuery(response: HttpResponseBase): Observable<UserDataOutPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataOutPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save user (Add new or update)
     * @param body (optional) 
     * @return OK
     */
    saveUser(body: UserDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/saveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit user
     * @param body (optional) 
     * @return OK
     */
    editProfile(body: UserEditDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/editProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete user
     * @param id (optional) 
     * @return OK
     */
    deleteUser(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/deleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate user
     * @param body (optional) 
     * @return OK
     */
    changeUserStatus(body: UserStatusUpdate | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/changeUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangeUserStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user by id
     * @return OK
     */
    getUser(id: string): Observable<UserDataOut> {
        let url_ = this.baseUrl + "/api/User/getUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataOut>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves information about the currently logged-in user.
     * @return OK
     */
    getMyUser(): Observable<UserDataOut> {
        let url_ = this.baseUrl + "/api/User/getMyUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataOut>;
        }));
    }

    protected processGetMyUser(response: HttpResponseBase): Observable<UserDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query utilities for UI
     * @param body (optional) 
     * @return OK
     */
    utilityQuery(body: UtilityGetAllDataIn | undefined): Observable<UtilityDtoPaginationDataOut> {
        let url_ = this.baseUrl + "/api/Utility/utilityQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUtilityQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUtilityQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityDtoPaginationDataOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityDtoPaginationDataOut>;
        }));
    }

    protected processUtilityQuery(response: HttpResponseBase): Observable<UtilityDtoPaginationDataOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UtilityDtoPaginationDataOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Utility
     * @param name (optional) 
     * @param acronym (optional) 
     * @param contactPersonEmail (optional) 
     * @param contactPersonFirstName (optional) 
     * @param contactPersonLastName (optional) 
     * @param contactPersonPhoneNumber (optional) 
     * @param address (optional) 
     * @param websiteAddress (optional) 
     * @param country (optional) 
     * @param timeZone (optional) 
     * @param file (optional) 
     * @return OK
     */
    addUtility(name: string | undefined, acronym: string | undefined, contactPersonEmail: string | undefined, contactPersonFirstName: string | undefined, contactPersonLastName: string | undefined, contactPersonPhoneNumber: string | undefined, address: string | undefined, websiteAddress: string | undefined, country: UtilityCountry | undefined, timeZone: number | undefined, file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Utility/addUtility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (acronym === null || acronym === undefined)
            throw new Error("The parameter 'acronym' cannot be null.");
        else
            content_.append("Acronym", acronym.toString());
        if (contactPersonEmail === null || contactPersonEmail === undefined)
            throw new Error("The parameter 'contactPersonEmail' cannot be null.");
        else
            content_.append("ContactPersonEmail", contactPersonEmail.toString());
        if (contactPersonFirstName === null || contactPersonFirstName === undefined)
            throw new Error("The parameter 'contactPersonFirstName' cannot be null.");
        else
            content_.append("ContactPersonFirstName", contactPersonFirstName.toString());
        if (contactPersonLastName === null || contactPersonLastName === undefined)
            throw new Error("The parameter 'contactPersonLastName' cannot be null.");
        else
            content_.append("ContactPersonLastName", contactPersonLastName.toString());
        if (contactPersonPhoneNumber === null || contactPersonPhoneNumber === undefined)
            throw new Error("The parameter 'contactPersonPhoneNumber' cannot be null.");
        else
            content_.append("ContactPersonPhoneNumber", contactPersonPhoneNumber.toString());
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (websiteAddress === null || websiteAddress === undefined)
            throw new Error("The parameter 'websiteAddress' cannot be null.");
        else
            content_.append("WebsiteAddress", websiteAddress.toString());
        if (country === null || country === undefined)
            throw new Error("The parameter 'country' cannot be null.");
        else
            content_.append("Country", country.toString());
        if (timeZone === null || timeZone === undefined)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else
            content_.append("TimeZone", timeZone.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddUtility(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit Utility (Add new or update)
     * @param id (optional) 
     * @param name (optional) 
     * @param acronym (optional) 
     * @param contactPerson (optional) 
     * @param address (optional) 
     * @param websiteAddress (optional) 
     * @param country (optional) 
     * @param timeZone (optional) 
     * @param file (optional) 
     * @return OK
     */
    editUtility(id: string | undefined, name: string | undefined, acronym: string | undefined, contactPerson: string | undefined, address: string | undefined, websiteAddress: string | undefined, country: UtilityCountry | undefined, timeZone: number | undefined, file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Utility/editUtility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (acronym === null || acronym === undefined)
            throw new Error("The parameter 'acronym' cannot be null.");
        else
            content_.append("Acronym", acronym.toString());
        if (contactPerson === null || contactPerson === undefined)
            throw new Error("The parameter 'contactPerson' cannot be null.");
        else
            content_.append("ContactPerson", contactPerson.toString());
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (websiteAddress === null || websiteAddress === undefined)
            throw new Error("The parameter 'websiteAddress' cannot be null.");
        else
            content_.append("WebsiteAddress", websiteAddress.toString());
        if (country === null || country === undefined)
            throw new Error("The parameter 'country' cannot be null.");
        else
            content_.append("Country", country.toString());
        if (timeZone === null || timeZone === undefined)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else
            content_.append("TimeZone", timeZone.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditUtility(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit Utility
     * @param body (optional) 
     * @return OK
     */
    updateUtilityStatus(body: UtilityStatusDataIn | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Utility/updateUtilityStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateUtilityStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Utility by id
     * @return OK
     */
    getUtility(id: string): Observable<UtilityDto> {
        let url_ = this.baseUrl + "/api/Utility/getUtility/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityDto>;
        }));
    }

    protected processGetUtility(response: HttpResponseBase): Observable<UtilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UtilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Utility logo
     * @return OK
     */
    getUtilityLogo(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Utility/getUtilityLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUtilityLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AcquisitionDataOut implements IAcquisitionDataOut {
    id!: string;
    meterNumber!: string | undefined;
    meterIP!: string | undefined;
    meterPort!: number;
    sessionStatus!: boolean;
    meterType!: MeterType;
    lastReadTime?: Date | undefined;
    sessionAlive!: number;
    sessionIndle!: number;

    constructor(data?: IAcquisitionDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.meterIP = _data["meterIP"];
            this.meterPort = _data["meterPort"];
            this.sessionStatus = _data["sessionStatus"];
            this.meterType = _data["meterType"];
            this.lastReadTime = _data["lastReadTime"] ? new Date(_data["lastReadTime"].toString()) : <any>undefined;
            this.sessionAlive = _data["sessionAlive"];
            this.sessionIndle = _data["sessionIndle"];
        }
    }

    static fromJS(data: any): AcquisitionDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AcquisitionDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["meterIP"] = this.meterIP;
        data["meterPort"] = this.meterPort;
        data["sessionStatus"] = this.sessionStatus;
        data["meterType"] = this.meterType;
        data["lastReadTime"] = this.lastReadTime ? this.lastReadTime.toISOString() : <any>undefined;
        data["sessionAlive"] = this.sessionAlive;
        data["sessionIndle"] = this.sessionIndle;
        return data;
    }
}

export interface IAcquisitionDataOut {
    id: string;
    meterNumber: string | undefined;
    meterIP: string | undefined;
    meterPort: number;
    sessionStatus: boolean;
    meterType: MeterType;
    lastReadTime?: Date | undefined;
    sessionAlive: number;
    sessionIndle: number;
}

export class AcquisitionQuery implements IAcquisitionQuery {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sessionStatus?: MeterStatus;

    constructor(data?: IAcquisitionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sessionStatus = _data["sessionStatus"];
        }
    }

    static fromJS(data: any): AcquisitionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AcquisitionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sessionStatus"] = this.sessionStatus;
        return data;
    }
}

export interface IAcquisitionQuery {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sessionStatus?: MeterStatus;
}

export class AcquisitionQueryDataOut implements IAcquisitionQueryDataOut {
    id!: string;
    meterNumber!: string | undefined;
    meterIP!: string | undefined;
    sessionStatus!: boolean;
    lastReadTime?: Date | undefined;

    constructor(data?: IAcquisitionQueryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.meterIP = _data["meterIP"];
            this.sessionStatus = _data["sessionStatus"];
            this.lastReadTime = _data["lastReadTime"] ? new Date(_data["lastReadTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AcquisitionQueryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AcquisitionQueryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["meterIP"] = this.meterIP;
        data["sessionStatus"] = this.sessionStatus;
        data["lastReadTime"] = this.lastReadTime ? this.lastReadTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAcquisitionQueryDataOut {
    id: string;
    meterNumber: string | undefined;
    meterIP: string | undefined;
    sessionStatus: boolean;
    lastReadTime?: Date | undefined;
}

export class AcquisitionQueryDataOutPaginationDataOut implements IAcquisitionQueryDataOutPaginationDataOut {
    count!: number;
    data!: AcquisitionQueryDataOut[] | undefined;

    constructor(data?: IAcquisitionQueryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AcquisitionQueryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcquisitionQueryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AcquisitionQueryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAcquisitionQueryDataOutPaginationDataOut {
    count: number;
    data: AcquisitionQueryDataOut[] | undefined;
}

export class AlarmCommandEvent implements IAlarmCommandEvent {
    event?: string | undefined;
    command?: string | undefined;

    constructor(data?: IAlarmCommandEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.command = _data["command"];
        }
    }

    static fromJS(data: any): AlarmCommandEvent {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCommandEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["command"] = this.command;
        return data;
    }
}

export interface IAlarmCommandEvent {
    event?: string | undefined;
    command?: string | undefined;
}

export class AlarmDataOut implements IAlarmDataOut {
    assetType!: string;
    assetTypeName!: string | undefined;
    serviceName!: string | undefined;
    meterNumber!: string | undefined;
    meterMakeName?: string | undefined;
    readOnMeterTime!: Date;
    ingestionTime?: Date | undefined;
    startTime?: Date | undefined;
    activeAlarms!: string[] | undefined;

    constructor(data?: IAlarmDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.assetTypeName = _data["assetTypeName"];
            this.serviceName = _data["serviceName"];
            this.meterNumber = _data["meterNumber"];
            this.meterMakeName = _data["meterMakeName"];
            this.readOnMeterTime = _data["readOnMeterTime"] ? new Date(_data["readOnMeterTime"].toString()) : <any>undefined;
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["activeAlarms"])) {
                this.activeAlarms = [] as any;
                for (let item of _data["activeAlarms"])
                    this.activeAlarms!.push(item);
            }
        }
    }

    static fromJS(data: any): AlarmDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["assetTypeName"] = this.assetTypeName;
        data["serviceName"] = this.serviceName;
        data["meterNumber"] = this.meterNumber;
        data["meterMakeName"] = this.meterMakeName;
        data["readOnMeterTime"] = this.readOnMeterTime ? this.readOnMeterTime.toISOString() : <any>undefined;
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        if (Array.isArray(this.activeAlarms)) {
            data["activeAlarms"] = [];
            for (let item of this.activeAlarms)
                data["activeAlarms"].push(item);
        }
        return data;
    }
}

export interface IAlarmDataOut {
    assetType: string;
    assetTypeName: string | undefined;
    serviceName: string | undefined;
    meterNumber: string | undefined;
    meterMakeName?: string | undefined;
    readOnMeterTime: Date;
    ingestionTime?: Date | undefined;
    startTime?: Date | undefined;
    activeAlarms: string[] | undefined;
}

export enum AlarmType {
    Unknown = "Unknown",
    ClockInvalid = "ClockInvalid",
    BatteryReplace = "BatteryReplace",
    ProgramMemoryError = "ProgramMemoryError",
    RamError = "RamError",
    NvMemoryError = "NvMemoryError",
    MeasurementSystemError = "MeasurementSystemError",
    WatchdogError = "WatchdogError",
    FraudAttempt = "FraudAttempt",
    TotalPowerFailure = "TotalPowerFailure",
    PowerResume = "PowerResume",
    VoltageMissingPhaseL1 = "VoltageMissingPhaseL1",
    VoltageMissingPhaseL2 = "VoltageMissingPhaseL2",
    VoltageMissingPhaseL3 = "VoltageMissingPhaseL3",
    VoltageNormalPhaseL1 = "VoltageNormalPhaseL1",
    VoltageNormalPhaseL2 = "VoltageNormalPhaseL2",
    VoltageNormalPhaseL3 = "VoltageNormalPhaseL3",
    MissingNeutral = "MissingNeutral",
    PhaseAsymmetry = "PhaseAsymmetry",
    CurrentReversal = "CurrentReversal",
    WrongPhaseSequence = "WrongPhaseSequence",
    UnexpectedConsumption = "UnexpectedConsumption",
    KeyExchanged = "KeyExchanged",
    BadVoltageQualityL1 = "BadVoltageQualityL1",
    BadVoltageQualityL2 = "BadVoltageQualityL2",
    BadVoltageQualityL3 = "BadVoltageQualityL3",
    ExternalAlert = "ExternalAlert",
    LocalCommunicationAttempt = "LocalCommunicationAttempt",
    DisconnectReconnectFailure = "DisconnectReconnectFailure",
}

export class AreaDataIn implements IAreaDataIn {
    id?: string | undefined;
    name!: string | undefined;
    regionId!: string;
    code!: string | undefined;

    constructor(data?: IAreaDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.regionId = _data["regionId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AreaDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        data["code"] = this.code;
        return data;
    }
}

export interface IAreaDataIn {
    id?: string | undefined;
    name: string | undefined;
    regionId: string;
    code: string | undefined;
}

export class AreaDataOut implements IAreaDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;
    regionName!: string | undefined;
    regionId?: string | undefined;

    constructor(data?: IAreaDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.regionName = _data["regionName"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): AreaDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["regionName"] = this.regionName;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IAreaDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
    regionName: string | undefined;
    regionId?: string | undefined;
}

export class AreaDataOutPaginationDataOut implements IAreaDataOutPaginationDataOut {
    count!: number;
    data!: AreaDataOut[] | undefined;

    constructor(data?: IAreaDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AreaDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AreaDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAreaDataOutPaginationDataOut {
    count: number;
    data: AreaDataOut[] | undefined;
}

export class AreaDetailsDataOut implements IAreaDetailsDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;
    regionName!: string | undefined;
    regionId?: string | undefined;

    constructor(data?: IAreaDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.regionName = _data["regionName"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): AreaDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["regionName"] = this.regionName;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IAreaDetailsDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
    regionName: string | undefined;
    regionId?: string | undefined;
}

export class AreaGetAllDataIn implements IAreaGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IAreaGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): AreaGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new AreaGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IAreaGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export enum AssetType {
    Customer = "Customer",
    Feeder = "Feeder",
    Incomer = "Incomer",
    DistributionTransformer = "DistributionTransformer",
}

export class AssetTypeDataIn implements IAssetTypeDataIn {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;
    assetType!: AssetType;
    applyLimiterConfiguration!: boolean;

    constructor(data?: IAssetTypeDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.assetType = _data["assetType"];
            this.applyLimiterConfiguration = _data["applyLimiterConfiguration"];
        }
    }

    static fromJS(data: any): AssetTypeDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["assetType"] = this.assetType;
        data["applyLimiterConfiguration"] = this.applyLimiterConfiguration;
        return data;
    }
}

export interface IAssetTypeDataIn {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
    assetType: AssetType;
    applyLimiterConfiguration: boolean;
}

export class AssetTypeDataOut implements IAssetTypeDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;
    assetType!: AssetType;
    applyLimiterConfiguration!: boolean;
    isUsedInLimiter!: boolean;

    constructor(data?: IAssetTypeDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.assetType = _data["assetType"];
            this.applyLimiterConfiguration = _data["applyLimiterConfiguration"];
            this.isUsedInLimiter = _data["isUsedInLimiter"];
        }
    }

    static fromJS(data: any): AssetTypeDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["assetType"] = this.assetType;
        data["applyLimiterConfiguration"] = this.applyLimiterConfiguration;
        data["isUsedInLimiter"] = this.isUsedInLimiter;
        return data;
    }
}

export interface IAssetTypeDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
    assetType: AssetType;
    applyLimiterConfiguration: boolean;
    isUsedInLimiter: boolean;
}

export class AssetTypeDataOutPaginationDataOut implements IAssetTypeDataOutPaginationDataOut {
    count!: number;
    data!: AssetTypeDataOut[] | undefined;

    constructor(data?: IAssetTypeDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssetTypeDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetTypeDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAssetTypeDataOutPaginationDataOut {
    count: number;
    data: AssetTypeDataOut[] | undefined;
}

export class AssetTypeGetAllDataIn implements IAssetTypeGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IAssetTypeGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): AssetTypeGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IAssetTypeGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class AssetValues implements IAssetValues {
    assetTypeName!: string | undefined;
    on!: number;
    off!: number;

    constructor(data?: IAssetValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetTypeName = _data["assetTypeName"];
            this.on = _data["on"];
            this.off = _data["off"];
        }
    }

    static fromJS(data: any): AssetValues {
        data = typeof data === 'object' ? data : {};
        let result = new AssetValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetTypeName"] = this.assetTypeName;
        data["on"] = this.on;
        data["off"] = this.off;
        return data;
    }
}

export interface IAssetValues {
    assetTypeName: string | undefined;
    on: number;
    off: number;
}

export class AssociationDescriptionDto implements IAssociationDescriptionDto {
    name!: string;
    attributes!: DlmsAttributes;
    obis!: string;
    attributeType!: DlmsDataType;
    attributeNo!: number;
    objectType!: DlmsObjectType;
    parameter?: number | undefined;
    inUse!: boolean;
    isConfigurable!: boolean;
    configuredInSetup!: boolean;
    isMethod!: boolean;

    constructor(data?: IAssociationDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributes = _data["attributes"];
            this.obis = _data["obis"];
            this.attributeType = _data["attributeType"];
            this.attributeNo = _data["attributeNo"];
            this.objectType = _data["objectType"];
            this.parameter = _data["parameter"];
            this.inUse = _data["inUse"];
            this.isConfigurable = _data["isConfigurable"];
            this.configuredInSetup = _data["configuredInSetup"];
            this.isMethod = _data["isMethod"];
        }
    }

    static fromJS(data: any): AssociationDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociationDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributes"] = this.attributes;
        data["obis"] = this.obis;
        data["attributeType"] = this.attributeType;
        data["attributeNo"] = this.attributeNo;
        data["objectType"] = this.objectType;
        data["parameter"] = this.parameter;
        data["inUse"] = this.inUse;
        data["isConfigurable"] = this.isConfigurable;
        data["configuredInSetup"] = this.configuredInSetup;
        data["isMethod"] = this.isMethod;
        return data;
    }
}

export interface IAssociationDescriptionDto {
    name: string;
    attributes: DlmsAttributes;
    obis: string;
    attributeType: DlmsDataType;
    attributeNo: number;
    objectType: DlmsObjectType;
    parameter?: number | undefined;
    inUse: boolean;
    isConfigurable: boolean;
    configuredInSetup: boolean;
    isMethod: boolean;
}

export class AuditLogQueryDataIn implements IAuditLogQueryDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IAuditLogQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditLogQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditLogQueryDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class AuditLogQueryDataOut implements IAuditLogQueryDataOut {
    hesTime!: Date;
    userId?: string | undefined;
    user?: string | undefined;
    userEmail?: string | undefined;
    controller!: string | undefined;
    method!: string | undefined;
    meterId?: string | undefined;
    meterNumber?: string | undefined;
    readonly ipAddress!: string | undefined;

    constructor(data?: IAuditLogQueryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hesTime = _data["hesTime"] ? new Date(_data["hesTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"];
            this.userEmail = _data["userEmail"];
            this.controller = _data["controller"];
            this.method = _data["method"];
            this.meterId = _data["meterId"];
            this.meterNumber = _data["meterNumber"];
            (<any>this).ipAddress = _data["IpAddress"];
        }
    }

    static fromJS(data: any): AuditLogQueryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogQueryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hesTime"] = this.hesTime ? this.hesTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user;
        data["userEmail"] = this.userEmail;
        data["controller"] = this.controller;
        data["method"] = this.method;
        data["meterId"] = this.meterId;
        data["meterNumber"] = this.meterNumber;
        data["IpAddress"] = this.ipAddress;
        return data;
    }
}

export interface IAuditLogQueryDataOut {
    hesTime: Date;
    userId?: string | undefined;
    user?: string | undefined;
    userEmail?: string | undefined;
    controller: string | undefined;
    method: string | undefined;
    meterId?: string | undefined;
    meterNumber?: string | undefined;
    ipAddress: string | undefined;
}

export class AuditLogQueryDataOutPaginationDataOut implements IAuditLogQueryDataOutPaginationDataOut {
    count!: number;
    data!: AuditLogQueryDataOut[] | undefined;

    constructor(data?: IAuditLogQueryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuditLogQueryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogQueryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogQueryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAuditLogQueryDataOutPaginationDataOut {
    count: number;
    data: AuditLogQueryDataOut[] | undefined;
}

/** Billing data buffer response */
export class BillingDataBufferDataOut implements IBillingDataBufferDataOut {
    /** Sample time utc */
    ingestionTime!: Date;
    /** Meter time included time zone */
    meterTime!: Date;
    /** Meter number */
    meterNumber!: string | undefined;
    /** Active energy import */
    activeEnergyImport?: number | undefined;
    /** Active energy export */
    activeEnergyExport?: number | undefined;
    /** Reactive energy import */
    reactiveEnergyImport?: number | undefined;
    /** Reactive energy export */
    reactiveEnergyExport?: number | undefined;
    /** Apparent energy import */
    apparentEnergyImport?: number | undefined;
    /** Apparent energy export */
    apparentEnergyExport?: number | undefined;
    /** Power factor */
    powerFactorL1?: number | undefined;
    powerFactorL2?: number | undefined;
    powerFactorL3?: number | undefined;

    constructor(data?: IBillingDataBufferDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.activeEnergyImport = _data["activeEnergyImport"];
            this.activeEnergyExport = _data["activeEnergyExport"];
            this.reactiveEnergyImport = _data["reactiveEnergyImport"];
            this.reactiveEnergyExport = _data["reactiveEnergyExport"];
            this.apparentEnergyImport = _data["apparentEnergyImport"];
            this.apparentEnergyExport = _data["apparentEnergyExport"];
            this.powerFactorL1 = _data["powerFactorL1"];
            this.powerFactorL2 = _data["powerFactorL2"];
            this.powerFactorL3 = _data["powerFactorL3"];
        }
    }

    static fromJS(data: any): BillingDataBufferDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDataBufferDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["activeEnergyImport"] = this.activeEnergyImport;
        data["activeEnergyExport"] = this.activeEnergyExport;
        data["reactiveEnergyImport"] = this.reactiveEnergyImport;
        data["reactiveEnergyExport"] = this.reactiveEnergyExport;
        data["apparentEnergyImport"] = this.apparentEnergyImport;
        data["apparentEnergyExport"] = this.apparentEnergyExport;
        data["powerFactorL1"] = this.powerFactorL1;
        data["powerFactorL2"] = this.powerFactorL2;
        data["powerFactorL3"] = this.powerFactorL3;
        return data;
    }
}

/** Billing data buffer response */
export interface IBillingDataBufferDataOut {
    /** Sample time utc */
    ingestionTime: Date;
    /** Meter time included time zone */
    meterTime: Date;
    /** Meter number */
    meterNumber: string | undefined;
    /** Active energy import */
    activeEnergyImport?: number | undefined;
    /** Active energy export */
    activeEnergyExport?: number | undefined;
    /** Reactive energy import */
    reactiveEnergyImport?: number | undefined;
    /** Reactive energy export */
    reactiveEnergyExport?: number | undefined;
    /** Apparent energy import */
    apparentEnergyImport?: number | undefined;
    /** Apparent energy export */
    apparentEnergyExport?: number | undefined;
    /** Power factor */
    powerFactorL1?: number | undefined;
    powerFactorL2?: number | undefined;
    powerFactorL3?: number | undefined;
}

export class BillingDataBufferDataOutPaginationDataOut implements IBillingDataBufferDataOutPaginationDataOut {
    count!: number;
    data!: BillingDataBufferDataOut[] | undefined;

    constructor(data?: IBillingDataBufferDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BillingDataBufferDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDataBufferDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDataBufferDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IBillingDataBufferDataOutPaginationDataOut {
    count: number;
    data: BillingDataBufferDataOut[] | undefined;
}

export class BinaryFileDataOut implements IBinaryFileDataOut {
    fileName!: string | undefined;
    size!: number;
    lastModified?: Date | undefined;

    constructor(data?: IBinaryFileDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.size = _data["size"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BinaryFileDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new BinaryFileDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBinaryFileDataOut {
    fileName: string | undefined;
    size: number;
    lastModified?: Date | undefined;
}

export class BooleanResponseCommandSuccess implements IBooleanResponseCommandSuccess {
    message!: boolean;
    commandId!: string;

    constructor(data?: IBooleanResponseCommandSuccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.commandId = _data["commandId"];
        }
    }

    static fromJS(data: any): BooleanResponseCommandSuccess {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanResponseCommandSuccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["commandId"] = this.commandId;
        return data;
    }
}

export interface IBooleanResponseCommandSuccess {
    message: boolean;
    commandId: string;
}

export class BulkFileDataOut implements IBulkFileDataOut {
    id!: string;
    path!: string | undefined;
    dateTime?: Date | undefined;
    status!: FileStatus;
    processedRows?: number | undefined;
    totalRows?: number | undefined;

    constructor(data?: IBulkFileDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.processedRows = _data["processedRows"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): BulkFileDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new BulkFileDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["processedRows"] = this.processedRows;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface IBulkFileDataOut {
    id: string;
    path: string | undefined;
    dateTime?: Date | undefined;
    status: FileStatus;
    processedRows?: number | undefined;
    totalRows?: number | undefined;
}

export class BulkFileDataOutPaginationDataOut implements IBulkFileDataOutPaginationDataOut {
    count!: number;
    data!: BulkFileDataOut[] | undefined;

    constructor(data?: IBulkFileDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BulkFileDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkFileDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new BulkFileDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IBulkFileDataOutPaginationDataOut {
    count: number;
    data: BulkFileDataOut[] | undefined;
}

export class BulkFileGetAllDataIn implements IBulkFileGetAllDataIn {
    pageInfo!: PageInfo;
    sorting?: SortingType;
    fileType!: FileType;

    constructor(data?: IBulkFileGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.sorting = _data["sorting"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): BulkFileGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new BulkFileGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["sorting"] = this.sorting;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IBulkFileGetAllDataIn {
    pageInfo: PageInfo;
    sorting?: SortingType;
    fileType: FileType;
}

export enum ClockSetType {
    Unknown = "Unknown",
    Utc = "Utc",
    Local = "Local",
}

export enum CommandAction {
    Connect = "Connect",
    Disconnect = "Disconnect",
}

export class CommandDataOut implements ICommandDataOut {
    assetType?: string | undefined;
    serviceName!: string | undefined;
    errorMessage?: string | undefined;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    status!: CommandStatus;
    source!: CommandSource;
    type!: CommandMessageType;
    action?: CommandAction;
    id!: string;
    failCount!: number;
    maxRetryCount!: number;
    token?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: ICommandDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.errorMessage = _data["errorMessage"];
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.source = _data["source"];
            this.type = _data["type"];
            this.action = _data["action"];
            this.id = _data["id"];
            this.failCount = _data["failCount"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.token = _data["token"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): CommandDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new CommandDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["errorMessage"] = this.errorMessage;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["source"] = this.source;
        data["type"] = this.type;
        data["action"] = this.action;
        data["id"] = this.id;
        data["failCount"] = this.failCount;
        data["maxRetryCount"] = this.maxRetryCount;
        data["token"] = this.token;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface ICommandDataOut {
    assetType?: string | undefined;
    serviceName: string | undefined;
    errorMessage?: string | undefined;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    status: CommandStatus;
    source: CommandSource;
    type: CommandMessageType;
    action?: CommandAction;
    id: string;
    failCount: number;
    maxRetryCount: number;
    token?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
}

export class CommandDataOutPaginationDataOut implements ICommandDataOutPaginationDataOut {
    count!: number;
    data!: CommandDataOut[] | undefined;

    constructor(data?: ICommandDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommandDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new CommandDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICommandDataOutPaginationDataOut {
    count: number;
    data: CommandDataOut[] | undefined;
}

export enum CommandMessageType {
    None = "None",
    DeviceAdded = "DeviceAdded",
    DeviceRemoved = "DeviceRemoved",
    MeterModelAdded = "MeterModelAdded",
    MeterModelRemoved = "MeterModelRemoved",
    MeterModelSetupAdded = "MeterModelSetupAdded",
    BulkMeterModelSetupAdded = "BulkMeterModelSetupAdded",
    SetConnectedState = "SetConnectedState",
    LoadPrepaidCreditToken = "LoadPrepaidCreditToken",
    LoadClearCreditToken = "LoadClearCreditToken",
    LoadClearTamperToken = "LoadClearTamperToken",
    LoadClearTamperTokenFromExternal = "LoadClearTamperTokenFromExternal",
    LoadClearCreditTokenFromExternal = "LoadClearCreditTokenFromExternal",
    LoadPrepaidCreditTokenFromExternal = "LoadPrepaidCreditTokenFromExternal",
    ReadCreditTokenFromExternal = "ReadCreditTokenFromExternal",
    BulkRemoteTokenExecution = "BulkRemoteTokenExecution",
    ReadCreditBalanceAmount = "ReadCreditBalanceAmount",
    LimitReconfiguration = "LimitReconfiguration",
    LoadKeyChangeTokenFromExternal = "LoadKeyChangeTokenFromExternal",
    LoadKeyChangeToken = "LoadKeyChangeToken",
    LoadProfileReadBuffer = "LoadProfileReadBuffer",
    AlarmsRead = "AlarmsRead",
    ReconfigurationScheduled = "ReconfigurationScheduled",
    LoadProfileOnDemand = "LoadProfileOnDemand",
    EnergyRegisterOnDemand = "EnergyRegisterOnDemand",
    PowerDemandRegisterOnDemand = "PowerDemandRegisterOnDemand",
    InstantaneousOnDemand = "InstantaneousOnDemand",
    BillingDataOnDemand = "BillingDataOnDemand",
    OnDemandAlarms = "OnDemandAlarms",
    OnDemandClockSync = "OnDemandClockSync",
    OnDemandInitSetup = "OnDemandInitSetup",
    MeterModelReconfiguration = "MeterModelReconfiguration",
    OnDemandGenericAttributeRead = "OnDemandGenericAttributeRead",
    PingDevice = "PingDevice",
    ImageUpdate = "ImageUpdate",
    LowLevelPasswordChange = "LowLevelPasswordChange",
    OnDemandEventLogRead = "OnDemandEventLogRead",
    Diagnostics = "Diagnostics",
    DiagnosticsPing = "DiagnosticsPing",
    ReadsOnDemand = "ReadsOnDemand",
    DesktopMeterModelAdded = "DesktopMeterModelAdded",
    DesktopDeviceAdded = "DesktopDeviceAdded",
}

export class CommandQueryDataIn implements ICommandQueryDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    meterId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: CommandStatus;
    type?: CommandMessageType;

    constructor(data?: ICommandQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.meterId = _data["meterId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CommandQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new CommandQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["meterId"] = this.meterId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface ICommandQueryDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    meterId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: CommandStatus;
    type?: CommandMessageType;
}

export enum CommandSource {
    User = "User",
    Scheduler = "Scheduler",
    External = "External",
    Event = "Event",
}

export enum CommandStatus {
    Pending = "Pending",
    Success = "Success",
    Failed = "Failed",
    InProgress = "InProgress",
    Finalize = "Finalize",
    Canceled = "Canceled",
    ErrorOccured = "ErrorOccured",
    Scheduled = "Scheduled",
}

export class CommandTokenInfoDataOut implements ICommandTokenInfoDataOut {
    commandId!: string;
    assetType?: string | undefined;
    serviceName!: string | undefined;
    meterNo!: string | undefined;
    source!: CommandSource;
    startTime?: Date | undefined;
    commandStatus!: CommandStatus;
    failCount!: number;
    maxRetryCount!: number;
    sequentialTokens!: SequentalTokenDataOut[] | undefined;

    constructor(data?: ICommandTokenInfoDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandId = _data["commandId"];
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.meterNo = _data["meterNo"];
            this.source = _data["source"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.commandStatus = _data["commandStatus"];
            this.failCount = _data["failCount"];
            this.maxRetryCount = _data["maxRetryCount"];
            if (Array.isArray(_data["sequentialTokens"])) {
                this.sequentialTokens = [] as any;
                for (let item of _data["sequentialTokens"])
                    this.sequentialTokens!.push(SequentalTokenDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandTokenInfoDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new CommandTokenInfoDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["meterNo"] = this.meterNo;
        data["source"] = this.source;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["commandStatus"] = this.commandStatus;
        data["failCount"] = this.failCount;
        data["maxRetryCount"] = this.maxRetryCount;
        if (Array.isArray(this.sequentialTokens)) {
            data["sequentialTokens"] = [];
            for (let item of this.sequentialTokens)
                data["sequentialTokens"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICommandTokenInfoDataOut {
    commandId: string;
    assetType?: string | undefined;
    serviceName: string | undefined;
    meterNo: string | undefined;
    source: CommandSource;
    startTime?: Date | undefined;
    commandStatus: CommandStatus;
    failCount: number;
    maxRetryCount: number;
    sequentialTokens: SequentalTokenDataOut[] | undefined;
}

export class CommandValues implements ICommandValues {
    commandType!: CommandMessageType;
    success!: number;
    failed!: number;
    pending!: number;

    constructor(data?: ICommandValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandType = _data["commandType"];
            this.success = _data["success"];
            this.failed = _data["failed"];
            this.pending = _data["pending"];
        }
    }

    static fromJS(data: any): CommandValues {
        data = typeof data === 'object' ? data : {};
        let result = new CommandValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandType"] = this.commandType;
        data["success"] = this.success;
        data["failed"] = this.failed;
        data["pending"] = this.pending;
        return data;
    }
}

export interface ICommandValues {
    commandType: CommandMessageType;
    success: number;
    failed: number;
    pending: number;
}

export class CommunicationActivityDataOut implements ICommunicationActivityDataOut {
    bucketTime!: Date;
    online!: number;
    offline!: number;

    constructor(data?: ICommunicationActivityDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bucketTime = _data["bucketTime"] ? new Date(_data["bucketTime"].toString()) : <any>undefined;
            this.online = _data["online"];
            this.offline = _data["offline"];
        }
    }

    static fromJS(data: any): CommunicationActivityDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationActivityDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bucketTime"] = this.bucketTime ? this.bucketTime.toISOString() : <any>undefined;
        data["online"] = this.online;
        data["offline"] = this.offline;
        return data;
    }
}

export interface ICommunicationActivityDataOut {
    bucketTime: Date;
    online: number;
    offline: number;
}

export enum ConfigurationProgressStatus {
    PendingDevice = "PendingDevice",
    ConfiguredDevice = "ConfiguredDevice",
    UnconfiguredDevice = "UnconfiguredDevice",
}

export enum ConfigurationStatus {
    Initializing = "Initializing",
    Reconfiguring = "Reconfiguring",
    Configured = "Configured",
    InitialConfigurationFailed = "InitialConfigurationFailed",
    ReconfigurationFailed = "ReconfigurationFailed",
    FirmwareUpdateStarted = "FirmwareUpdateStarted",
}

export class ConnectDisconnectDataOut implements IConnectDisconnectDataOut {
    assetType?: string | undefined;
    serviceName!: string | undefined;
    meterNo!: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    status!: CommandStatus;
    action!: ConnectionStatus;
    id!: string;
    commandId!: string;

    constructor(data?: IConnectDisconnectDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.meterNo = _data["meterNo"];
            this.errorMessage = _data["errorMessage"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.action = _data["action"];
            this.id = _data["id"];
            this.commandId = _data["commandId"];
        }
    }

    static fromJS(data: any): ConnectDisconnectDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectDisconnectDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["meterNo"] = this.meterNo;
        data["errorMessage"] = this.errorMessage;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["action"] = this.action;
        data["id"] = this.id;
        data["commandId"] = this.commandId;
        return data;
    }
}

export interface IConnectDisconnectDataOut {
    assetType?: string | undefined;
    serviceName: string | undefined;
    meterNo: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    status: CommandStatus;
    action: ConnectionStatus;
    id: string;
    commandId: string;
}

export class ConnectDisconnectDataOutPaginationDataOut implements IConnectDisconnectDataOutPaginationDataOut {
    count!: number;
    data!: ConnectDisconnectDataOut[] | undefined;

    constructor(data?: IConnectDisconnectDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConnectDisconnectDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConnectDisconnectDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectDisconnectDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IConnectDisconnectDataOutPaginationDataOut {
    count: number;
    data: ConnectDisconnectDataOut[] | undefined;
}

export enum ConnectionStatus {
    Connect = "Connect",
    Disconnect = "Disconnect",
}

export class CreateLoadLimitDataIn implements ICreateLoadLimitDataIn {
    id?: string | undefined;
    target!: MeterTargetType;
    meterNumber?: string | undefined;
    limitType!: LimitType;
    value!: number;
    waitTime?: number | undefined;
    regions?: string[] | undefined;
    assetTypeId?: string | undefined;
    serviceTypeId?: string | undefined;
    meterPhase?: MeterPhase;

    constructor(data?: ICreateLoadLimitDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.target = _data["target"];
            this.meterNumber = _data["meterNumber"];
            this.limitType = _data["limitType"];
            this.value = _data["value"];
            this.waitTime = _data["waitTime"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            this.assetTypeId = _data["assetTypeId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.meterPhase = _data["meterPhase"];
        }
    }

    static fromJS(data: any): CreateLoadLimitDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLoadLimitDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["target"] = this.target;
        data["meterNumber"] = this.meterNumber;
        data["limitType"] = this.limitType;
        data["value"] = this.value;
        data["waitTime"] = this.waitTime;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        data["assetTypeId"] = this.assetTypeId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["meterPhase"] = this.meterPhase;
        return data;
    }
}

export interface ICreateLoadLimitDataIn {
    id?: string | undefined;
    target: MeterTargetType;
    meterNumber?: string | undefined;
    limitType: LimitType;
    value: number;
    waitTime?: number | undefined;
    regions?: string[] | undefined;
    assetTypeId?: string | undefined;
    serviceTypeId?: string | undefined;
    meterPhase?: MeterPhase;
}

export class CreateMeterDataIn implements ICreateMeterDataIn {
    id!: string;
    /** Enum type field indicates the type of asset to which the meter is connected. */
    assetType!: string;
    /** String type field indicates the name of asset to which the meter is connected. */
    serviceName!: string | undefined;
    /** Null or string type field indicates the serial number of asset to which the meter is connected. */
    serviceNumber?: string | undefined;
    /** Double type field indicates the latitude of asset to which the meter is connected. */
    serviceLatitude?: number | undefined;
    /** Double type field indicates the longitude of asset to which the meter is connected. */
    serviceLongitude?: number | undefined;
    /** Null or string type field indicates the service type of asset to which the meter is connected. */
    serviceType?: string | undefined;
    /** Guid type field indicates the model of device. */
    meterModel!: string;
    /** The Guid type field indicates the area where the device is located. */
    area!: string;
    /** String type field indicates the physical address of device. */
    address!: string | undefined;
    /** String type field indicates the unique number of device. */
    meterNumber!: string | undefined;
    /** The Guid type field indicates the manufacturer of device. */
    meterMake!: string;
    meterType!: MeterType;
    /** String type field indicates serial number of SIM card in device. */
    cellularSimSerialNumber!: string | undefined;
    /** String type field indicates ip address of meter in our network. */
    meterIp!: string | undefined;
    /** Integer type field indicates port of meter on MeterIp. */
    meterPort!: number;
    /** Integer type field indicates period (in minutes)  during which data is collected by the meter. */
    dataCollectionInterval!: number;
    /** Integer type field indicates time zone (in minutes ) of meter. */
    meterTimeZone!: number;
    /** The DateTime type field indicates time when device was installed on the asset. */
    meterInstallationDate!: Date;
    /** The DateTime type field indicates time when device was created by the manufacturer. */
    meterManufactureDate?: Date | undefined;
    /** String type field indicates password of device. */
    password?: string | undefined;
    newPassword?: string | undefined;
    blockCipherKey?: string | undefined;
    authenticationKey?: string | undefined;
    clockTolerance?: number | undefined;
    gsmProvider!: GsmProviders;
    clockType?: ClockSetType;
    currentTransformerRatio?: RatioDataIn;
    voltageTransformerRatio?: RatioDataIn;
    loadLimitId?: string | undefined;
    parent?: string | undefined;

    constructor(data?: ICreateMeterDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.serviceNumber = _data["serviceNumber"];
            this.serviceLatitude = _data["serviceLatitude"];
            this.serviceLongitude = _data["serviceLongitude"];
            this.serviceType = _data["serviceType"];
            this.meterModel = _data["meterModel"];
            this.area = _data["area"];
            this.address = _data["address"];
            this.meterNumber = _data["meterNumber"];
            this.meterMake = _data["meterMake"];
            this.meterType = _data["meterType"];
            this.cellularSimSerialNumber = _data["cellularSimSerialNumber"];
            this.meterIp = _data["meterIp"];
            this.meterPort = _data["meterPort"];
            this.dataCollectionInterval = _data["dataCollectionInterval"];
            this.meterTimeZone = _data["meterTimeZone"];
            this.meterInstallationDate = _data["meterInstallationDate"] ? new Date(_data["meterInstallationDate"].toString()) : <any>undefined;
            this.meterManufactureDate = _data["meterManufactureDate"] ? new Date(_data["meterManufactureDate"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.newPassword = _data["newPassword"];
            this.blockCipherKey = _data["blockCipherKey"];
            this.authenticationKey = _data["authenticationKey"];
            this.clockTolerance = _data["clockTolerance"];
            this.gsmProvider = _data["gsmProvider"];
            this.clockType = _data["clockType"];
            this.currentTransformerRatio = _data["currentTransformerRatio"] ? RatioDataIn.fromJS(_data["currentTransformerRatio"]) : <any>undefined;
            this.voltageTransformerRatio = _data["voltageTransformerRatio"] ? RatioDataIn.fromJS(_data["voltageTransformerRatio"]) : <any>undefined;
            this.loadLimitId = _data["loadLimitId"];
            this.parent = _data["parent"];
        }
    }

    static fromJS(data: any): CreateMeterDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeterDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["serviceNumber"] = this.serviceNumber;
        data["serviceLatitude"] = this.serviceLatitude;
        data["serviceLongitude"] = this.serviceLongitude;
        data["serviceType"] = this.serviceType;
        data["meterModel"] = this.meterModel;
        data["area"] = this.area;
        data["address"] = this.address;
        data["meterNumber"] = this.meterNumber;
        data["meterMake"] = this.meterMake;
        data["meterType"] = this.meterType;
        data["cellularSimSerialNumber"] = this.cellularSimSerialNumber;
        data["meterIp"] = this.meterIp;
        data["meterPort"] = this.meterPort;
        data["dataCollectionInterval"] = this.dataCollectionInterval;
        data["meterTimeZone"] = this.meterTimeZone;
        data["meterInstallationDate"] = this.meterInstallationDate ? this.meterInstallationDate.toISOString() : <any>undefined;
        data["meterManufactureDate"] = this.meterManufactureDate ? this.meterManufactureDate.toISOString() : <any>undefined;
        data["password"] = this.password;
        data["newPassword"] = this.newPassword;
        data["blockCipherKey"] = this.blockCipherKey;
        data["authenticationKey"] = this.authenticationKey;
        data["clockTolerance"] = this.clockTolerance;
        data["gsmProvider"] = this.gsmProvider;
        data["clockType"] = this.clockType;
        data["currentTransformerRatio"] = this.currentTransformerRatio ? this.currentTransformerRatio.toJSON() : <any>undefined;
        data["voltageTransformerRatio"] = this.voltageTransformerRatio ? this.voltageTransformerRatio.toJSON() : <any>undefined;
        data["loadLimitId"] = this.loadLimitId;
        data["parent"] = this.parent;
        return data;
    }
}

export interface ICreateMeterDataIn {
    id: string;
    /** Enum type field indicates the type of asset to which the meter is connected. */
    assetType: string;
    /** String type field indicates the name of asset to which the meter is connected. */
    serviceName: string | undefined;
    /** Null or string type field indicates the serial number of asset to which the meter is connected. */
    serviceNumber?: string | undefined;
    /** Double type field indicates the latitude of asset to which the meter is connected. */
    serviceLatitude?: number | undefined;
    /** Double type field indicates the longitude of asset to which the meter is connected. */
    serviceLongitude?: number | undefined;
    /** Null or string type field indicates the service type of asset to which the meter is connected. */
    serviceType?: string | undefined;
    /** Guid type field indicates the model of device. */
    meterModel: string;
    /** The Guid type field indicates the area where the device is located. */
    area: string;
    /** String type field indicates the physical address of device. */
    address: string | undefined;
    /** String type field indicates the unique number of device. */
    meterNumber: string | undefined;
    /** The Guid type field indicates the manufacturer of device. */
    meterMake: string;
    meterType: MeterType;
    /** String type field indicates serial number of SIM card in device. */
    cellularSimSerialNumber: string | undefined;
    /** String type field indicates ip address of meter in our network. */
    meterIp: string | undefined;
    /** Integer type field indicates port of meter on MeterIp. */
    meterPort: number;
    /** Integer type field indicates period (in minutes)  during which data is collected by the meter. */
    dataCollectionInterval: number;
    /** Integer type field indicates time zone (in minutes ) of meter. */
    meterTimeZone: number;
    /** The DateTime type field indicates time when device was installed on the asset. */
    meterInstallationDate: Date;
    /** The DateTime type field indicates time when device was created by the manufacturer. */
    meterManufactureDate?: Date | undefined;
    /** String type field indicates password of device. */
    password?: string | undefined;
    newPassword?: string | undefined;
    blockCipherKey?: string | undefined;
    authenticationKey?: string | undefined;
    clockTolerance?: number | undefined;
    gsmProvider: GsmProviders;
    clockType?: ClockSetType;
    currentTransformerRatio?: RatioDataIn;
    voltageTransformerRatio?: RatioDataIn;
    loadLimitId?: string | undefined;
    parent?: string | undefined;
}

export class DashboardCommunicationActivityDataIn implements IDashboardCommunicationActivityDataIn {
    region?: string | undefined;
    area?: string | undefined;
    startDate!: Date;
    endDate?: Date | undefined;
    assetType?: string | undefined;
    intervalMinutes?: number | undefined;

    constructor(data?: IDashboardCommunicationActivityDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.area = _data["area"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.assetType = _data["assetType"];
            this.intervalMinutes = _data["intervalMinutes"];
        }
    }

    static fromJS(data: any): DashboardCommunicationActivityDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCommunicationActivityDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["area"] = this.area;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["assetType"] = this.assetType;
        data["intervalMinutes"] = this.intervalMinutes;
        return data;
    }
}

export interface IDashboardCommunicationActivityDataIn {
    region?: string | undefined;
    area?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    assetType?: string | undefined;
    intervalMinutes?: number | undefined;
}

export class DashboardQueryDataIn implements IDashboardQueryDataIn {
    region?: string | undefined;
    area?: string | undefined;
    startDate!: Date;
    assetType?: string | undefined;

    constructor(data?: IDashboardQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.area = _data["area"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.assetType = _data["assetType"];
        }
    }

    static fromJS(data: any): DashboardQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["area"] = this.area;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["assetType"] = this.assetType;
        return data;
    }
}

export interface IDashboardQueryDataIn {
    region?: string | undefined;
    area?: string | undefined;
    startDate: Date;
    assetType?: string | undefined;
}

export class DeviceConfigurationDataOut implements IDeviceConfigurationDataOut {
    stepName!: string | undefined;
    status!: string | undefined;
    groupName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: number | undefined;
    value?: string | undefined;
    percentCompleted?: number | undefined;

    constructor(data?: IDeviceConfigurationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepName = _data["stepName"];
            this.status = _data["status"];
            this.groupName = _data["groupName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            this.value = _data["value"];
            this.percentCompleted = _data["percentCompleted"];
        }
    }

    static fromJS(data: any): DeviceConfigurationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigurationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepName"] = this.stepName;
        data["status"] = this.status;
        data["groupName"] = this.groupName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        data["value"] = this.value;
        data["percentCompleted"] = this.percentCompleted;
        return data;
    }
}

export interface IDeviceConfigurationDataOut {
    stepName: string | undefined;
    status: string | undefined;
    groupName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: number | undefined;
    value?: string | undefined;
    percentCompleted?: number | undefined;
}

export class DeviceConfigurationInfoDataOut implements IDeviceConfigurationInfoDataOut {
    deviceConfigurationSteps!: DeviceConfigurationDataOut[] | undefined;
    canRunPartialSetup!: boolean;

    constructor(data?: IDeviceConfigurationInfoDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deviceConfigurationSteps"])) {
                this.deviceConfigurationSteps = [] as any;
                for (let item of _data["deviceConfigurationSteps"])
                    this.deviceConfigurationSteps!.push(DeviceConfigurationDataOut.fromJS(item));
            }
            this.canRunPartialSetup = _data["canRunPartialSetup"];
        }
    }

    static fromJS(data: any): DeviceConfigurationInfoDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigurationInfoDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deviceConfigurationSteps)) {
            data["deviceConfigurationSteps"] = [];
            for (let item of this.deviceConfigurationSteps)
                data["deviceConfigurationSteps"].push(item ? item.toJSON() : <any>undefined);
        }
        data["canRunPartialSetup"] = this.canRunPartialSetup;
        return data;
    }
}

export interface IDeviceConfigurationInfoDataOut {
    deviceConfigurationSteps: DeviceConfigurationDataOut[] | undefined;
    canRunPartialSetup: boolean;
}

export class DeviceConnectionDataOut implements IDeviceConnectionDataOut {
    id!: string;
    meterNumber!: string | undefined;
    sessionStatus!: boolean;
    meterMake!: string | undefined;
    dateInstalled?: Date | undefined;
    latestConnection?: Date | undefined;
    simCardNumber!: string | undefined;

    constructor(data?: IDeviceConnectionDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.sessionStatus = _data["sessionStatus"];
            this.meterMake = _data["meterMake"];
            this.dateInstalled = _data["dateInstalled"] ? new Date(_data["dateInstalled"].toString()) : <any>undefined;
            this.latestConnection = _data["latestConnection"] ? new Date(_data["latestConnection"].toString()) : <any>undefined;
            this.simCardNumber = _data["simCardNumber"];
        }
    }

    static fromJS(data: any): DeviceConnectionDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConnectionDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["sessionStatus"] = this.sessionStatus;
        data["meterMake"] = this.meterMake;
        data["dateInstalled"] = this.dateInstalled ? this.dateInstalled.toISOString() : <any>undefined;
        data["latestConnection"] = this.latestConnection ? this.latestConnection.toISOString() : <any>undefined;
        data["simCardNumber"] = this.simCardNumber;
        return data;
    }
}

export interface IDeviceConnectionDataOut {
    id: string;
    meterNumber: string | undefined;
    sessionStatus: boolean;
    meterMake: string | undefined;
    dateInstalled?: Date | undefined;
    latestConnection?: Date | undefined;
    simCardNumber: string | undefined;
}

export class DeviceConnectionQuery implements IDeviceConnectionQuery {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;

    constructor(data?: IDeviceConnectionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceConnectionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConnectionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceConnectionQuery {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
}

export class DeviceConnectionQueryDataOut implements IDeviceConnectionQueryDataOut {
    id!: string;
    meterNumber!: string | undefined;
    meterMake!: string | undefined;
    sessionStatus!: boolean;
    installationDate?: Date | undefined;
    latestConnection?: Date | undefined;

    constructor(data?: IDeviceConnectionQueryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.meterMake = _data["meterMake"];
            this.sessionStatus = _data["sessionStatus"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.latestConnection = _data["latestConnection"] ? new Date(_data["latestConnection"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceConnectionQueryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConnectionQueryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["meterMake"] = this.meterMake;
        data["sessionStatus"] = this.sessionStatus;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["latestConnection"] = this.latestConnection ? this.latestConnection.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceConnectionQueryDataOut {
    id: string;
    meterNumber: string | undefined;
    meterMake: string | undefined;
    sessionStatus: boolean;
    installationDate?: Date | undefined;
    latestConnection?: Date | undefined;
}

export class DeviceConnectionQueryDataOutPaginationDataOut implements IDeviceConnectionQueryDataOutPaginationDataOut {
    count!: number;
    data!: DeviceConnectionQueryDataOut[] | undefined;

    constructor(data?: IDeviceConnectionQueryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DeviceConnectionQueryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceConnectionQueryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConnectionQueryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDeviceConnectionQueryDataOutPaginationDataOut {
    count: number;
    data: DeviceConnectionQueryDataOut[] | undefined;
}

export class DiagnosticsCommandStatusDataOut implements IDiagnosticsCommandStatusDataOut {
    id!: string;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    status!: CommandStatus;
    error?: ResponseError;
    steps!: DiagnosticsStepResult[] | undefined;

    constructor(data?: IDiagnosticsCommandStatusDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.error = _data["error"] ? ResponseError.fromJS(_data["error"]) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(DiagnosticsStepResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagnosticsCommandStatusDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsCommandStatusDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDiagnosticsCommandStatusDataOut {
    id: string;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    status: CommandStatus;
    error?: ResponseError;
    steps: DiagnosticsStepResult[] | undefined;
}

export enum DiagnosticsStep {
    TargetMeterPing = "TargetMeterPing",
    ParentMeterPing = "ParentMeterPing",
    GrandparentMeterPing = "GrandparentMeterPing",
    NeighbourSweepPing = "NeighbourSweepPing",
    TelemetryHistory = "TelemetryHistory",
}

export class DiagnosticsStepResult implements IDiagnosticsStepResult {
    step!: DiagnosticsStep;
    meterNumber!: string | undefined;
    status!: CommandStatus;
    error?: ResponseError;
    executedTime!: Date;
    endpoint!: string | undefined;
    lastCommunicationTime?: Date | undefined;
    assetType?: string | undefined;
    assetName?: string | undefined;
    scannedCount?: number | undefined;
    failedCount?: number | undefined;
    expectedReadCount?: number | undefined;
    actualReadCount?: number | undefined;

    constructor(data?: IDiagnosticsStepResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.meterNumber = _data["meterNumber"];
            this.status = _data["status"];
            this.error = _data["error"] ? ResponseError.fromJS(_data["error"]) : <any>undefined;
            this.executedTime = _data["executedTime"] ? new Date(_data["executedTime"].toString()) : <any>undefined;
            this.endpoint = _data["endpoint"];
            this.lastCommunicationTime = _data["lastCommunicationTime"] ? new Date(_data["lastCommunicationTime"].toString()) : <any>undefined;
            this.assetType = _data["assetType"];
            this.assetName = _data["assetName"];
            this.scannedCount = _data["scannedCount"];
            this.failedCount = _data["failedCount"];
            this.expectedReadCount = _data["expectedReadCount"];
            this.actualReadCount = _data["actualReadCount"];
        }
    }

    static fromJS(data: any): DiagnosticsStepResult {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsStepResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["meterNumber"] = this.meterNumber;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["executedTime"] = this.executedTime ? this.executedTime.toISOString() : <any>undefined;
        data["endpoint"] = this.endpoint;
        data["lastCommunicationTime"] = this.lastCommunicationTime ? this.lastCommunicationTime.toISOString() : <any>undefined;
        data["assetType"] = this.assetType;
        data["assetName"] = this.assetName;
        data["scannedCount"] = this.scannedCount;
        data["failedCount"] = this.failedCount;
        data["expectedReadCount"] = this.expectedReadCount;
        data["actualReadCount"] = this.actualReadCount;
        return data;
    }
}

export interface IDiagnosticsStepResult {
    step: DiagnosticsStep;
    meterNumber: string | undefined;
    status: CommandStatus;
    error?: ResponseError;
    executedTime: Date;
    endpoint: string | undefined;
    lastCommunicationTime?: Date | undefined;
    assetType?: string | undefined;
    assetName?: string | undefined;
    scannedCount?: number | undefined;
    failedCount?: number | undefined;
    expectedReadCount?: number | undefined;
    actualReadCount?: number | undefined;
}

/** Input model for setting the connection state of a meter. Contains the meter identifier, desired connection state, and reason for the change. */
export class DisconnectControlDataIn implements IDisconnectControlDataIn {
    /** The unique identifier (meter number) of the target meter. */
    meterNo!: string | undefined;
    /** The desired connection state.
True to connect the meter, false to disconnect it. */
    setConnected!: boolean;
    /** The reason for changing the meter's connection state. */
    reason!: string | undefined;

    constructor(data?: IDisconnectControlDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNo = _data["meterNo"];
            this.setConnected = _data["setConnected"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DisconnectControlDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectControlDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNo"] = this.meterNo;
        data["setConnected"] = this.setConnected;
        data["reason"] = this.reason;
        return data;
    }
}

/** Input model for setting the connection state of a meter. Contains the meter identifier, desired connection state, and reason for the change. */
export interface IDisconnectControlDataIn {
    /** The unique identifier (meter number) of the target meter. */
    meterNo: string | undefined;
    /** The desired connection state.
True to connect the meter, false to disconnect it. */
    setConnected: boolean;
    /** The reason for changing the meter's connection state. */
    reason: string | undefined;
}

export enum DlmsAttributes {
    Unspecified = "Unspecified",
    Clock_Time = "Clock_Time",
    Clock_TimeZone = "Clock_TimeZone",
    Clock_ClockStatus = "Clock_ClockStatus",
    Clock_DaylightSavingBegin = "Clock_DaylightSavingBegin",
    Clock_DaylightSavingEnd = "Clock_DaylightSavingEnd",
    Clock_DaylightSavingDeviation = "Clock_DaylightSavingDeviation",
    Clock_DaylightSavingEnabled = "Clock_DaylightSavingEnabled",
    Clock_ClockBase = "Clock_ClockBase",
    DisconnectControl_OutputState = "DisconnectControl_OutputState",
    DisconnectControl_State = "DisconnectControl_State",
    DisconnectControl_Mode = "DisconnectControl_Mode",
    DisconnectControl_MethodRemoteDisconnect = "DisconnectControl_MethodRemoteDisconnect",
    DisconnectControl_MethodRemoteReconnect = "DisconnectControl_MethodRemoteReconnect",
    Data_LogicalDeviceName = "Data_LogicalDeviceName",
    Data_ActiveFirmwareIdentifier = "Data_ActiveFirmwareIdentifier",
    Data_ManufacturingNumber = "Data_ManufacturingNumber",
    Data_AlarmRegister1 = "Data_AlarmRegister1",
    Data_AlarmRegister2 = "Data_AlarmRegister2",
    Data_AlarmDescriptor1 = "Data_AlarmDescriptor1",
    Data_AlarmDescriptor2 = "Data_AlarmDescriptor2",
    Data_ManufacturingNumber_ObisCode = "Data_ManufacturingNumber_ObisCode",
    Data_FunctionalFirmwareVersion = "Data_FunctionalFirmwareVersion",
    Data_ModuleFirmwareVersion = "Data_ModuleFirmwareVersion",
    Data_TransformerRatioCurrentNumerator = "Data_TransformerRatioCurrentNumerator",
    Data_TransformerRatioCurrentDenominator = "Data_TransformerRatioCurrentDenominator",
    Data_TransformerRatioVoltageNumerator = "Data_TransformerRatioVoltageNumerator",
    Data_TransformerRatioVoltageDenominator = "Data_TransformerRatioVoltageDenominator",
    Data_GlobalOperatingStatus = "Data_GlobalOperatingStatus",
    Data_SelfCheckStatus = "Data_SelfCheckStatus",
    Data_PowerQualityStatus = "Data_PowerQualityStatus",
    Data_TamperIndicateStatus = "Data_TamperIndicateStatus",
    Data_AlarmFilter1 = "Data_AlarmFilter1",
    Data_AlarmFilter2 = "Data_AlarmFilter2",
    Data_DateOfLastFwActivation = "Data_DateOfLastFwActivation",
    Data_NoOfConfigProgramChanges = "Data_NoOfConfigProgramChanges",
    Data_NoOfPowerFailuresInAllThreePhases = "Data_NoOfPowerFailuresInAllThreePhases",
    Data_NoOfPowerFailuresInPhaseL1 = "Data_NoOfPowerFailuresInPhaseL1",
    Data_NoOfPowerFailuresInPhaseL2 = "Data_NoOfPowerFailuresInPhaseL2",
    Data_NoOfPowerFailuresInPhaseL3 = "Data_NoOfPowerFailuresInPhaseL3",
    Data_NoOfPowerFailuresInAnyPhase = "Data_NoOfPowerFailuresInAnyPhase",
    Data_MeterOpenEventCounter = "Data_MeterOpenEventCounter",
    Data_MeterOpenEventTimeOfCurrentEvent = "Data_MeterOpenEventTimeOfCurrentEvent",
    Data_TerminalCoverOpenEventCounter = "Data_TerminalCoverOpenEventCounter",
    Data_TerminalCoverOpenEventTimeOfCurrentEvent = "Data_TerminalCoverOpenEventTimeOfCurrentEvent",
    Data_LoadProfilePeriod1StatusValue = "Data_LoadProfilePeriod1StatusValue",
    Data_LoadProfilePeriod2StatusValue = "Data_LoadProfilePeriod2StatusValue",
    Data_LoadProfilePeriod3StatusValue = "Data_LoadProfilePeriod3StatusValue",
    Data_EventCode1Value = "Data_EventCode1Value",
    Data_EventCode2Value = "Data_EventCode2Value",
    Data_EventCode3Value = "Data_EventCode3Value",
    Data_EventCode4Value = "Data_EventCode4Value",
    Data_EventCode5Value = "Data_EventCode5Value",
    Data_EventCode6Value = "Data_EventCode6Value",
    Data_InvocationCounterValue = "Data_InvocationCounterValue",
    Register_ActiveEnergyImportValue = "Register_ActiveEnergyImportValue",
    Register_ActiveEnergyImportScalerAndUnit = "Register_ActiveEnergyImportScalerAndUnit",
    Register_ReactiveEnergyImportValue = "Register_ReactiveEnergyImportValue",
    Register_ReactiveEnergyImportScalerAndUnit = "Register_ReactiveEnergyImportScalerAndUnit",
    Register_ApparentEnergyImportValue = "Register_ApparentEnergyImportValue",
    Register_ApparentEnergyImportScalerAndUnit = "Register_ApparentEnergyImportScalerAndUnit",
    Register_NominalVoltageValue = "Register_NominalVoltageValue",
    Register_NominalVoltageScalerAndUnit = "Register_NominalVoltageScalerAndUnit",
    Register_NominalCurrentValue = "Register_NominalCurrentValue",
    Register_NominalCurrentScalerAndUnit = "Register_NominalCurrentScalerAndUnit",
    Register_NominalFrequencyValue = "Register_NominalFrequencyValue",
    Register_NominalFrequencyScalerAndUnit = "Register_NominalFrequencyScalerAndUnit",
    Register_MaximumCurrentValue = "Register_MaximumCurrentValue",
    Register_MaximumCurrentScalerAndUnit = "Register_MaximumCurrentScalerAndUnit",
    Register_CurrentL1Value = "Register_CurrentL1Value",
    Register_CurrentL1ScalerAndUnit = "Register_CurrentL1ScalerAndUnit",
    Register_CurrentL2Value = "Register_CurrentL2Value",
    Register_CurrentL2ScalerAndUnit = "Register_CurrentL2ScalerAndUnit",
    Register_CurrentL3Value = "Register_CurrentL3Value",
    Register_CurrentL3ScalerAndUnit = "Register_CurrentL3ScalerAndUnit",
    Register_VoltageL1Value = "Register_VoltageL1Value",
    Register_VoltageL1ScalerAndUnit = "Register_VoltageL1ScalerAndUnit",
    Register_VoltageL2Value = "Register_VoltageL2Value",
    Register_VoltageL2ScalerAndUnit = "Register_VoltageL2ScalerAndUnit",
    Register_VoltageL3Value = "Register_VoltageL3Value",
    Register_VoltageL3ScalerAndUnit = "Register_VoltageL3ScalerAndUnit",
    Register_PowerFactorL1Value = "Register_PowerFactorL1Value",
    Register_PowerFactorL1ScalerAndUnit = "Register_PowerFactorL1ScalerAndUnit",
    Register_PowerFactorL2Value = "Register_PowerFactorL2Value",
    Register_PowerFactorL2ScalerAndUnit = "Register_PowerFactorL2ScalerAndUnit",
    Register_PowerFactorL3Value = "Register_PowerFactorL3Value",
    Register_PowerFactorL3ScalerAndUnit = "Register_PowerFactorL3ScalerAndUnit",
    Register_ActivePowerSumValue = "Register_ActivePowerSumValue",
    Register_ActivePowerSumScalerAndUnit = "Register_ActivePowerSumScalerAndUnit",
    Register_ActiveEnergyExportValue = "Register_ActiveEnergyExportValue",
    Register_ActiveEnergyExportScalerAndUnit = "Register_ActiveEnergyExportScalerAndUnit",
    Register_ReactiveEnergyExportValue = "Register_ReactiveEnergyExportValue",
    Register_ReactiveEnergyExportScalerAndUnit = "Register_ReactiveEnergyExportScalerAndUnit",
    Register_ApparentEnergyExportValue = "Register_ApparentEnergyExportValue",
    Register_ApparentEnergyExportScalerAndUnit = "Register_ApparentEnergyExportScalerAndUnit",
    Register_SupplyFrequencyValue = "Register_SupplyFrequencyValue",
    Register_SupplyFrequencyScalerAndUnit = "Register_SupplyFrequencyScalerAndUnit",
    Register_PowerFactorValue = "Register_PowerFactorValue",
    Register_PowerFactorScalerAndUnit = "Register_PowerFactorScalerAndUnit",
    Register_AverageCurrentL1Value = "Register_AverageCurrentL1Value",
    Register_AverageCurrentL1ScalerAndUnit = "Register_AverageCurrentL1ScalerAndUnit",
    Register_AverageCurrentL2Value = "Register_AverageCurrentL2Value",
    Register_AverageCurrentL2ScalerAndUnit = "Register_AverageCurrentL2ScalerAndUnit",
    Register_AverageCurrentL3Value = "Register_AverageCurrentL3Value",
    Register_AverageCurrentL3ScalerAndUnit = "Register_AverageCurrentL3ScalerAndUnit",
    Register_AverageVoltageL1Value = "Register_AverageVoltageL1Value",
    Register_AverageVoltageL1ScalerAndUnit = "Register_AverageVoltageL1ScalerAndUnit",
    Register_AverageVoltageL2Value = "Register_AverageVoltageL2Value",
    Register_AverageVoltageL2ScalerAndUnit = "Register_AverageVoltageL2ScalerAndUnit",
    Register_AverageVoltageL3Value = "Register_AverageVoltageL3Value",
    Register_AverageVoltageL3ScalerAndUnit = "Register_AverageVoltageL3ScalerAndUnit",
    Register_AmbientTemperatureValue = "Register_AmbientTemperatureValue",
    Register_AmbientTemperatureScalerAndUnit = "Register_AmbientTemperatureScalerAndUnit",
    Register_VoltageAngleL1toL2Value = "Register_VoltageAngleL1toL2Value",
    Register_VoltageAngleL1toL2ScalerAndUnit = "Register_VoltageAngleL1toL2ScalerAndUnit",
    Register_VoltageAngleL1toL3Value = "Register_VoltageAngleL1toL3Value",
    Register_VoltageAngleL1toL3ScalerAndUnit = "Register_VoltageAngleL1toL3ScalerAndUnit",
    Register_VoltageAngleL2toL3Value = "Register_VoltageAngleL2toL3Value",
    Register_VoltageAngleL2toL3ScalerAndUnit = "Register_VoltageAngleL2toL3ScalerAndUnit",
    Register_CombinedReverseActivePowerSumValue = "Register_CombinedReverseActivePowerSumValue",
    Register_CombinedReverseActivePowerSumScalerAndUnit = "Register_CombinedReverseActivePowerSumScalerAndUnit",
    Register_TotalAbsoluteActiveEnergyValue = "Register_TotalAbsoluteActiveEnergyValue",
    Register_TotalAbsoluteActiveEnergyScalerAndUnit = "Register_TotalAbsoluteActiveEnergyScalerAndUnit",
    Register_ImportActivePowerL1Value = "Register_ImportActivePowerL1Value",
    Register_ImportActivePowerL1ScalerAndUnit = "Register_ImportActivePowerL1ScalerAndUnit",
    Register_ImportActivePowerL2Value = "Register_ImportActivePowerL2Value",
    Register_ImportActivePowerL2ScalerAndUnit = "Register_ImportActivePowerL2ScalerAndUnit",
    Register_ImportActivePowerL3Value = "Register_ImportActivePowerL3Value",
    Register_ImportActivePowerL3ScalerAndUnit = "Register_ImportActivePowerL3ScalerAndUnit",
    Register_ExportActivePowerL1Value = "Register_ExportActivePowerL1Value",
    Register_ExportActivePowerL1ScalerAndUnit = "Register_ExportActivePowerL1ScalerAndUnit",
    Register_ExportActivePowerL2Value = "Register_ExportActivePowerL2Value",
    Register_ExportActivePowerL2ScalerAndUnit = "Register_ExportActivePowerL2ScalerAndUnit",
    Register_ExportActivePowerL3Value = "Register_ExportActivePowerL3Value",
    Register_ExportActivePowerL3ScalerAndUnit = "Register_ExportActivePowerL3ScalerAndUnit",
    Register_VoltageHighThresholdValue = "Register_VoltageHighThresholdValue",
    Register_VoltageHighThresholdScalerAndUnit = "Register_VoltageHighThresholdScalerAndUnit",
    Register_VoltageLowThresholdValue = "Register_VoltageLowThresholdValue",
    Register_VoltageLowThresholdScalerAndUnit = "Register_VoltageLowThresholdScalerAndUnit",
    Register_BatteryVoltageValue = "Register_BatteryVoltageValue",
    Register_BatteryVoltageScalerAndUnit = "Register_BatteryVoltageScalerAndUnit",
    Register_L1ActiveEnergyImportValue = "Register_L1ActiveEnergyImportValue",
    Register_L1ActiveEnergyImportScalerAndUnit = "Register_L1ActiveEnergyImportScalerAndUnit",
    Register_L1ActiveEnergyExportValue = "Register_L1ActiveEnergyExportValue",
    Register_L1ActiveEnergyExportScalerAndUnit = "Register_L1ActiveEnergyExportScalerAndUnit",
    Register_L2ActiveEnergyImportValue = "Register_L2ActiveEnergyImportValue",
    Register_L2ActiveEnergyImportScalerAndUnit = "Register_L2ActiveEnergyImportScalerAndUnit",
    Register_L2ActiveEnergyExportValue = "Register_L2ActiveEnergyExportValue",
    Register_L2ActiveEnergyExportScalerAndUnit = "Register_L2ActiveEnergyExportScalerAndUnit",
    Register_L3ActiveEnergyImportValue = "Register_L3ActiveEnergyImportValue",
    Register_L3ActiveEnergyImportScalerAndUnit = "Register_L3ActiveEnergyImportScalerAndUnit",
    Register_L3ActiveEnergyExportValue = "Register_L3ActiveEnergyExportValue",
    Register_L3ActiveEnergyExportScalerAndUnit = "Register_L3ActiveEnergyExportScalerAndUnit",
    Register_NetTotalActiveEnergyValue = "Register_NetTotalActiveEnergyValue",
    Register_NetTotalActiveEnergyScalerAndUnit = "Register_NetTotalActiveEnergyScalerAndUnit",
    Register_TotalMagnitudeActivePowerValue = "Register_TotalMagnitudeActivePowerValue",
    Register_TotalMagnitudeActivePowerScalerAndUnit = "Register_TotalMagnitudeActivePowerScalerAndUnit",
    Register_TotalInstantaneousReactivePowerMagnitudeValue = "Register_TotalInstantaneousReactivePowerMagnitudeValue",
    Register_TotalInstantaneousReactivePowerMagnitudeScalerAndUnit = "Register_TotalInstantaneousReactivePowerMagnitudeScalerAndUnit",
    Register_RealtimeRateReactivePowerValue = "Register_RealtimeRateReactivePowerValue",
    Register_RealtimeRateReactivePowerScalerAndUnit = "Register_RealtimeRateReactivePowerScalerAndUnit",
    Register_InstantaneousApparentImportPowerValue = "Register_InstantaneousApparentImportPowerValue",
    Register_InstantaneousApparentImportPowerScalerAndUnit = "Register_InstantaneousApparentImportPowerScalerAndUnit",
    Register_InstantaneousApparentExportPowerValue = "Register_InstantaneousApparentExportPowerValue",
    Register_InstantaneousApparentExportPowerScalerAndUnit = "Register_InstantaneousApparentExportPowerScalerAndUnit",
    Register_L1ReactiveEnergyImportValue = "Register_L1ReactiveEnergyImportValue",
    Register_L1ReactiveEnergyImportScalerAndUnit = "Register_L1ReactiveEnergyImportScalerAndUnit",
    Register_L1ReactiveEnergyExportValue = "Register_L1ReactiveEnergyExportValue",
    Register_L1ReactiveEnergyExportScalerAndUnit = "Register_L1ReactiveEnergyExportScalerAndUnit",
    Register_L2ReactiveEnergyImportValue = "Register_L2ReactiveEnergyImportValue",
    Register_L2ReactiveEnergyImportScalerAndUnit = "Register_L2ReactiveEnergyImportScalerAndUnit",
    Register_L2ReactiveEnergyExportValue = "Register_L2ReactiveEnergyExportValue",
    Register_L2ReactiveEnergyExportScalerAndUnit = "Register_L2ReactiveEnergyExportScalerAndUnit",
    Register_L3ReactiveEnergyImportValue = "Register_L3ReactiveEnergyImportValue",
    Register_L3ReactiveEnergyImportScalerAndUnit = "Register_L3ReactiveEnergyImportScalerAndUnit",
    Register_L3ReactiveEnergyExportValue = "Register_L3ReactiveEnergyExportValue",
    Register_L3ReactiveEnergyExportScalerAndUnit = "Register_L3ReactiveEnergyExportScalerAndUnit",
    Register_L1ApparentEnergyImportValue = "Register_L1ApparentEnergyImportValue",
    Register_L1ApparentEnergyImportScalerAndUnit = "Register_L1ApparentEnergyImportScalerAndUnit",
    Register_L1ApparentEnergyExportValue = "Register_L1ApparentEnergyExportValue",
    Register_L1ApparentEnergyExportScalerAndUnit = "Register_L1ApparentEnergyExportScalerAndUnit",
    Register_L2ApparentEnergyImportValue = "Register_L2ApparentEnergyImportValue",
    Register_L2ApparentEnergyImportScalerAndUnit = "Register_L2ApparentEnergyImportScalerAndUnit",
    Register_L2ApparentEnergyExportValue = "Register_L2ApparentEnergyExportValue",
    Register_L2ApparentEnergyExportScalerAndUnit = "Register_L2ApparentEnergyExportScalerAndUnit",
    Register_L3ApparentEnergyImportValue = "Register_L3ApparentEnergyImportValue",
    Register_L3ApparentEnergyImportScalerAndUnit = "Register_L3ApparentEnergyImportScalerAndUnit",
    Register_L3ApparentEnergyExportValue = "Register_L3ApparentEnergyExportValue",
    Register_L3ApparentEnergyExportScalerAndUnit = "Register_L3ApparentEnergyExportScalerAndUnit",
    Register_ActiveEnergyImportRate1Value = "Register_ActiveEnergyImportRate1Value",
    Register_ActiveEnergyImportRate1ScalerAndUnit = "Register_ActiveEnergyImportRate1ScalerAndUnit",
    Register_ActiveEnergyImportRate2Value = "Register_ActiveEnergyImportRate2Value",
    Register_ActiveEnergyImportRate2ScalerAndUnit = "Register_ActiveEnergyImportRate2ScalerAndUnit",
    Register_ActiveEnergyImportRate3Value = "Register_ActiveEnergyImportRate3Value",
    Register_ActiveEnergyImportRate3ScalerAndUnit = "Register_ActiveEnergyImportRate3ScalerAndUnit",
    Register_ActiveEnergyImportRate4Value = "Register_ActiveEnergyImportRate4Value",
    Register_ActiveEnergyImportRate4ScalerAndUnit = "Register_ActiveEnergyImportRate4ScalerAndUnit",
    Register_ActiveEnergyExportRate1Value = "Register_ActiveEnergyExportRate1Value",
    Register_ActiveEnergyExportRate1ScalerAndUnit = "Register_ActiveEnergyExportRate1ScalerAndUnit",
    Register_ActiveEnergyExportRate2Value = "Register_ActiveEnergyExportRate2Value",
    Register_ActiveEnergyExportRate2ScalerAndUnit = "Register_ActiveEnergyExportRate2ScalerAndUnit",
    Register_ActiveEnergyExportRate3Value = "Register_ActiveEnergyExportRate3Value",
    Register_ActiveEnergyExportRate3ScalerAndUnit = "Register_ActiveEnergyExportRate3ScalerAndUnit",
    Register_ActiveEnergyExportRate4Value = "Register_ActiveEnergyExportRate4Value",
    Register_ActiveEnergyExportRate4ScalerAndUnit = "Register_ActiveEnergyExportRate4ScalerAndUnit",
    Register_ReactiveEnergyImportRate1Value = "Register_ReactiveEnergyImportRate1Value",
    Register_ReactiveEnergyImportRate1ScalerAndUnit = "Register_ReactiveEnergyImportRate1ScalerAndUnit",
    Register_ReactiveEnergyImportRate2Value = "Register_ReactiveEnergyImportRate2Value",
    Register_ReactiveEnergyImportRate2ScalerAndUnit = "Register_ReactiveEnergyImportRate2ScalerAndUnit",
    Register_ReactiveEnergyImportRate3Value = "Register_ReactiveEnergyImportRate3Value",
    Register_ReactiveEnergyImportRate3ScalerAndUnit = "Register_ReactiveEnergyImportRate3ScalerAndUnit",
    Register_ReactiveEnergyImportRate4Value = "Register_ReactiveEnergyImportRate4Value",
    Register_ReactiveEnergyImportRate4ScalerAndUnit = "Register_ReactiveEnergyImportRate4ScalerAndUnit",
    Register_ReactiveEnergyExportRate1Value = "Register_ReactiveEnergyExportRate1Value",
    Register_ReactiveEnergyExportRate1ScalerAndUnit = "Register_ReactiveEnergyExportRate1ScalerAndUnit",
    Register_ReactiveEnergyExportRate2Value = "Register_ReactiveEnergyExportRate2Value",
    Register_ReactiveEnergyExportRate2ScalerAndUnit = "Register_ReactiveEnergyExportRate2ScalerAndUnit",
    Register_ReactiveEnergyExportRate3Value = "Register_ReactiveEnergyExportRate3Value",
    Register_ReactiveEnergyExportRate3ScalerAndUnit = "Register_ReactiveEnergyExportRate3ScalerAndUnit",
    Register_ReactiveEnergyExportRate4Value = "Register_ReactiveEnergyExportRate4Value",
    Register_ReactiveEnergyExportRate4ScalerAndUnit = "Register_ReactiveEnergyExportRate4ScalerAndUnit",
    Register_ReactiveEnergyQ1Rate1Value = "Register_ReactiveEnergyQ1Rate1Value",
    Register_ReactiveEnergyQ1Rate1ScalerAndUnit = "Register_ReactiveEnergyQ1Rate1ScalerAndUnit",
    Register_ReactiveEnergyQ1Rate2Value = "Register_ReactiveEnergyQ1Rate2Value",
    Register_ReactiveEnergyQ1Rate2ScalerAndUnit = "Register_ReactiveEnergyQ1Rate2ScalerAndUnit",
    Register_ReactiveEnergyQ1Rate3Value = "Register_ReactiveEnergyQ1Rate3Value",
    Register_ReactiveEnergyQ1Rate3ScalerAndUnit = "Register_ReactiveEnergyQ1Rate3ScalerAndUnit",
    Register_ReactiveEnergyQ1Rate4Value = "Register_ReactiveEnergyQ1Rate4Value",
    Register_ReactiveEnergyQ1Rate4ScalerAndUnit = "Register_ReactiveEnergyQ1Rate4ScalerAndUnit",
    Register_ReactiveEnergyQ2Rate1Value = "Register_ReactiveEnergyQ2Rate1Value",
    Register_ReactiveEnergyQ2Rate1ScalerAndUnit = "Register_ReactiveEnergyQ2Rate1ScalerAndUnit",
    Register_ReactiveEnergyQ2Rate2Value = "Register_ReactiveEnergyQ2Rate2Value",
    Register_ReactiveEnergyQ2Rate2ScalerAndUnit = "Register_ReactiveEnergyQ2Rate2ScalerAndUnit",
    Register_ReactiveEnergyQ2Rate3Value = "Register_ReactiveEnergyQ2Rate3Value",
    Register_ReactiveEnergyQ2Rate3ScalerAndUnit = "Register_ReactiveEnergyQ2Rate3ScalerAndUnit",
    Register_ReactiveEnergyQ2Rate4Value = "Register_ReactiveEnergyQ2Rate4Value",
    Register_ReactiveEnergyQ2Rate4ScalerAndUnit = "Register_ReactiveEnergyQ2Rate4ScalerAndUnit",
    Register_ReactiveEnergyQ3Rate1Value = "Register_ReactiveEnergyQ3Rate1Value",
    Register_ReactiveEnergyQ3Rate1ScalerAndUnit = "Register_ReactiveEnergyQ3Rate1ScalerAndUnit",
    Register_ReactiveEnergyQ3Rate2Value = "Register_ReactiveEnergyQ3Rate2Value",
    Register_ReactiveEnergyQ3Rate2ScalerAndUnit = "Register_ReactiveEnergyQ3Rate2ScalerAndUnit",
    Register_ReactiveEnergyQ3Rate3Value = "Register_ReactiveEnergyQ3Rate3Value",
    Register_ReactiveEnergyQ3Rate3ScalerAndUnit = "Register_ReactiveEnergyQ3Rate3ScalerAndUnit",
    Register_ReactiveEnergyQ3Rate4Value = "Register_ReactiveEnergyQ3Rate4Value",
    Register_ReactiveEnergyQ3Rate4ScalerAndUnit = "Register_ReactiveEnergyQ3Rate4ScalerAndUnit",
    Register_ReactiveEnergyQ4Rate1Value = "Register_ReactiveEnergyQ4Rate1Value",
    Register_ReactiveEnergyQ4Rate1ScalerAndUnit = "Register_ReactiveEnergyQ4Rate1ScalerAndUnit",
    Register_ReactiveEnergyQ4Rate2Value = "Register_ReactiveEnergyQ4Rate2Value",
    Register_ReactiveEnergyQ4Rate2ScalerAndUnit = "Register_ReactiveEnergyQ4Rate2ScalerAndUnit",
    Register_ReactiveEnergyQ4Rate3Value = "Register_ReactiveEnergyQ4Rate3Value",
    Register_ReactiveEnergyQ4Rate3ScalerAndUnit = "Register_ReactiveEnergyQ4Rate3ScalerAndUnit",
    Register_ReactiveEnergyQ4Rate4Value = "Register_ReactiveEnergyQ4Rate4Value",
    Register_ReactiveEnergyQ4Rate4ScalerAndUnit = "Register_ReactiveEnergyQ4Rate4ScalerAndUnit",
    Register_ApparentEnergyImportRate1Value = "Register_ApparentEnergyImportRate1Value",
    Register_ApparentEnergyImportRate1ScalerAndUnit = "Register_ApparentEnergyImportRate1ScalerAndUnit",
    Register_ApparentEnergyImportRate2Value = "Register_ApparentEnergyImportRate2Value",
    Register_ApparentEnergyImportRate2ScalerAndUnit = "Register_ApparentEnergyImportRate2ScalerAndUnit",
    Register_ApparentEnergyImportRate3Value = "Register_ApparentEnergyImportRate3Value",
    Register_ApparentEnergyImportRate3ScalerAndUnit = "Register_ApparentEnergyImportRate3ScalerAndUnit",
    Register_ApparentEnergyImportRate4Value = "Register_ApparentEnergyImportRate4Value",
    Register_ApparentEnergyImportRate4ScalerAndUnit = "Register_ApparentEnergyImportRate4ScalerAndUnit",
    Register_ApparentEnergyExportRate1Value = "Register_ApparentEnergyExportRate1Value",
    Register_ApparentEnergyExportRate1ScalerAndUnit = "Register_ApparentEnergyExportRate1ScalerAndUnit",
    Register_ApparentEnergyExportRate2Value = "Register_ApparentEnergyExportRate2Value",
    Register_ApparentEnergyExportRate2ScalerAndUnit = "Register_ApparentEnergyExportRate2ScalerAndUnit",
    Register_ApparentEnergyExportRate3Value = "Register_ApparentEnergyExportRate3Value",
    Register_ApparentEnergyExportRate3ScalerAndUnit = "Register_ApparentEnergyExportRate3ScalerAndUnit",
    Register_ApparentEnergyExportRate4Value = "Register_ApparentEnergyExportRate4Value",
    Register_ApparentEnergyExportRate4ScalerAndUnit = "Register_ApparentEnergyExportRate4ScalerAndUnit",
    Register_ActiveEnergyCombinedTotalRate1Value = "Register_ActiveEnergyCombinedTotalRate1Value",
    Register_ActiveEnergyCombinedTotalRate1ScalerAndUnit = "Register_ActiveEnergyCombinedTotalRate1ScalerAndUnit",
    Register_ActiveEnergyCombinedTotalRate2Value = "Register_ActiveEnergyCombinedTotalRate2Value",
    Register_ActiveEnergyCombinedTotalRate2ScalerAndUnit = "Register_ActiveEnergyCombinedTotalRate2ScalerAndUnit",
    Register_ActiveEnergyCombinedTotalRate3Value = "Register_ActiveEnergyCombinedTotalRate3Value",
    Register_ActiveEnergyCombinedTotalRate3ScalerAndUnit = "Register_ActiveEnergyCombinedTotalRate3ScalerAndUnit",
    Register_ActiveEnergyCombinedTotalRate4Value = "Register_ActiveEnergyCombinedTotalRate4Value",
    Register_ActiveEnergyCombinedTotalRate4ScalerAndUnit = "Register_ActiveEnergyCombinedTotalRate4ScalerAndUnit",
    Register_ReactiveEnergyCombinedTotalQ1Value = "Register_ReactiveEnergyCombinedTotalQ1Value",
    Register_ReactiveActiveEnergyCombinedTotalQ1ScalerAndUnit = "Register_ReactiveActiveEnergyCombinedTotalQ1ScalerAndUnit",
    Register_ReactiveEnergyCombinedTotalQ2Value = "Register_ReactiveEnergyCombinedTotalQ2Value",
    Register_ReactiveActiveEnergyCombinedTotalQ2ScalerAndUnit = "Register_ReactiveActiveEnergyCombinedTotalQ2ScalerAndUnit",
    Register_ReactiveEnergyCombinedTotalQ3Value = "Register_ReactiveEnergyCombinedTotalQ3Value",
    Register_ReactiveActiveEnergyCombinedTotalQ3ScalerAndUnit = "Register_ReactiveActiveEnergyCombinedTotalQ3ScalerAndUnit",
    Register_ReactiveEnergyCombinedTotalQ4Value = "Register_ReactiveEnergyCombinedTotalQ4Value",
    Register_ReactiveActiveEnergyCombinedTotalQ4ScalerAndUnit = "Register_ReactiveActiveEnergyCombinedTotalQ4ScalerAndUnit",
    Register_RemainingCreditValue = "Register_RemainingCreditValue",
    Register_RemainingCreditScalerAndUnit = "Register_RemainingCreditScalerAndUnit",
    Register_RemainingCurrencyValue = "Register_RemainingCurrencyValue",
    Register_RemainingCurrencyScalerAndUnit = "Register_RemainingCurrencyScalerAndUnit",
    Register_AbsoluteActiveEnergyValue = "Register_AbsoluteActiveEnergyValue",
    Register_AbsoluteActiveEnergyScalerAndUnit = "Register_AbsoluteActiveEnergyScalerAndUnit",
    Register_TotalPurchaseValue = "Register_TotalPurchaseValue",
    Register_TotalPurchaseScalerAndUnit = "Register_TotalPurchaseScalerAndUnit",
    Register_LastPurchaseValue = "Register_LastPurchaseValue",
    Register_LastPurchaseScalerAndUnit = "Register_LastPurchaseScalerAndUnit",
    Register_InstantaneousCurrentTotalValue = "Register_InstantaneousCurrentTotalValue",
    Register_InstantaneousCurrentTotalScalerAndUnit = "Register_InstantaneousCurrentTotalScalerAndUnit",
    Register_MeasurementPeriod3ForInstantaneousValue = "Register_MeasurementPeriod3ForInstantaneousValue",
    Register_MeasurementPeriod3ForInstantaneousTotalScalerAndUnit = "Register_MeasurementPeriod3ForInstantaneousTotalScalerAndUnit",
    Register_InstantaneousActivePowerL1Value = "Register_InstantaneousActivePowerL1Value",
    Register_InstantaneousActivePowerL1ScalerAndUnit = "Register_InstantaneousActivePowerL1ScalerAndUnit",
    Register_InstantaneousActivePowerL2Value = "Register_InstantaneousActivePowerL2Value",
    Register_InstantaneousActivePowerL2ScalerAndUnit = "Register_InstantaneousActivePowerL2ScalerAndUnit",
    Register_InstantaneousActivePowerL3Value = "Register_InstantaneousActivePowerL3Value",
    Register_InstantaneousActivePowerL3ScalerAndUnit = "Register_InstantaneousActivePowerL3ScalerAndUnit",
    Register_InstantaneousReactiveImportPowerL1Value = "Register_InstantaneousReactiveImportPowerL1Value",
    Register_InstantaneousReactiveImportPowerL1ScalerAndUnit = "Register_InstantaneousReactiveImportPowerL1ScalerAndUnit",
    Register_InstantaneousReactiveImportPowerL2Value = "Register_InstantaneousReactiveImportPowerL2Value",
    Register_InstantaneousReactiveImportPowerL2ScalerAndUnit = "Register_InstantaneousReactiveImportPowerL2ScalerAndUnit",
    Register_InstantaneousReactiveImportPowerL3Value = "Register_InstantaneousReactiveImportPowerL3Value",
    Register_InstantaneousReactiveImportPowerL3ScalerAndUnit = "Register_InstantaneousReactiveImportPowerL3ScalerAndUnit",
    Register_InstantaneousReactiveExportPowerL1Value = "Register_InstantaneousReactiveExportPowerL1Value",
    Register_InstantaneousReactiveExportPowerL1ScalerAndUnit = "Register_InstantaneousReactiveExportPowerL1ScalerAndUnit",
    Register_InstantaneousReactiveExportPowerL2Value = "Register_InstantaneousReactiveExportPowerL2Value",
    Register_InstantaneousReactiveExportPowerL2ScalerAndUnit = "Register_InstantaneousReactiveExportPowerL2ScalerAndUnit",
    Register_InstantaneousReactiveExportPowerL3Value = "Register_InstantaneousReactiveExportPowerL3Value",
    Register_InstantaneousReactiveExportPowerL3ScalerAndUnit = "Register_InstantaneousReactiveExportPowerL3ScalerAndUnit",
    Register_L1ReactiveEnergy_Q1Value = "Register_L1ReactiveEnergy_Q1Value",
    Register_L1ReactiveEnergy_Q1ScalerAndUnit = "Register_L1ReactiveEnergy_Q1ScalerAndUnit",
    Register_L1ReactiveEnergy_Q2Value = "Register_L1ReactiveEnergy_Q2Value",
    Register_L1ReactiveEnergy_Q2ScalerAndUnit = "Register_L1ReactiveEnergy_Q2ScalerAndUnit",
    Register_L1ReactiveEnergy_Q3Value = "Register_L1ReactiveEnergy_Q3Value",
    Register_L1ReactiveEnergy_Q3ScalerAndUnit = "Register_L1ReactiveEnergy_Q3ScalerAndUnit",
    Register_L1ReactiveEnergy_Q4Value = "Register_L1ReactiveEnergy_Q4Value",
    Register_L1ReactiveEnergy_Q4ScalerAndUnit = "Register_L1ReactiveEnergy_Q4ScalerAndUnit",
    Register_L2ReactiveEnergy_Q1Value = "Register_L2ReactiveEnergy_Q1Value",
    Register_L2ReactiveEnergy_Q1ScalerAndUnit = "Register_L2ReactiveEnergy_Q1ScalerAndUnit",
    Register_L2ReactiveEnergy_Q2Value = "Register_L2ReactiveEnergy_Q2Value",
    Register_L2ReactiveEnergy_Q2ScalerAndUnit = "Register_L2ReactiveEnergy_Q2ScalerAndUnit",
    Register_L2ReactiveEnergy_Q3Value = "Register_L2ReactiveEnergy_Q3Value",
    Register_L2ReactiveEnergy_Q3ScalerAndUnit = "Register_L2ReactiveEnergy_Q3ScalerAndUnit",
    Register_L2ReactiveEnergy_Q4Value = "Register_L2ReactiveEnergy_Q4Value",
    Register_L2ReactiveEnergy_Q4ScalerAndUnit = "Register_L2ReactiveEnergy_Q4ScalerAndUnit",
    Register_L3ReactiveEnergy_Q1Value = "Register_L3ReactiveEnergy_Q1Value",
    Register_L3ReactiveEnergy_Q1ScalerAndUnit = "Register_L3ReactiveEnergy_Q1ScalerAndUnit",
    Register_L3ReactiveEnergy_Q2Value = "Register_L3ReactiveEnergy_Q2Value",
    Register_L3ReactiveEnergy_Q2ScalerAndUnit = "Register_L3ReactiveEnergy_Q2ScalerAndUnit",
    Register_L3ReactiveEnergy_Q3Value = "Register_L3ReactiveEnergy_Q3Value",
    Register_L3ReactiveEnergy_Q3ScalerAndUnit = "Register_L3ReactiveEnergy_Q3ScalerAndUnit",
    Register_L3ReactiveEnergy_Q4Value = "Register_L3ReactiveEnergy_Q4Value",
    Register_L3ReactiveEnergy_Q4ScalerAndUnit = "Register_L3ReactiveEnergy_Q4ScalerAndUnit",
    Register_OverloadPowerThresholdValue = "Register_OverloadPowerThresholdValue",
    Register_OverloadPowerThresholdScalerAndUnit = "Register_OverloadPowerThresholdScalerAndUnit",
    Register_OverloadPowerEnterDelayValue = "Register_OverloadPowerEnterDelayValue",
    Register_OverloadPowerEnterDelayScalerAndUnit = "Register_OverloadPowerEnterDelayScalerAndUnit",
    Register_PowerUnbalanceThresholdValue = "Register_PowerUnbalanceThresholdValue",
    Register_PowerUnbalanceThresholdScalerAndUnit = "Register_PowerUnbalanceThresholdScalerAndUnit",
    Register_PowerUnbalanceDelayValue = "Register_PowerUnbalanceDelayValue",
    Register_PowerUnbalanceDelayScalerAndUnit = "Register_PowerUnbalanceDelayScalerAndUnit",
    Register_OverCurrentProtection_ThresholdValue = "Register_OverCurrentProtection_ThresholdValue",
    Register_OverCurrentProtection_ThresholdScalerAndUnit = "Register_OverCurrentProtection_ThresholdScalerAndUnit",
    Register_OverCurrentProtection_DelayValue = "Register_OverCurrentProtection_DelayValue",
    Register_OverCurrentProtection_DelayScalerAndUnit = "Register_OverCurrentProtection_DelayScalerAndUnit",
    TokenGateway_Enter = "TokenGateway_Enter",
    TokenGateway_Token = "TokenGateway_Token",
    TokenGateway_Time = "TokenGateway_Time",
    TokenGateway_Description = "TokenGateway_Description",
    TokenGateway_DeliveryMethod = "TokenGateway_DeliveryMethod",
    TokenGateway_Status = "TokenGateway_Status",
    Account_AvailableCredit = "Account_AvailableCredit",
    Account_CurrencyName = "Account_CurrencyName",
    Account_PaymentMode = "Account_PaymentMode",
    Account_ActivateAccount = "Account_ActivateAccount",
    ConsumptionLimitter_MonitoredValue = "ConsumptionLimitter_MonitoredValue",
    ConsumptionLimitter_ActiveThreshold = "ConsumptionLimitter_ActiveThreshold",
    ConsumptionLimitter_NormalThreshold = "ConsumptionLimitter_NormalThreshold",
    ConsumptionLimitter_EmergencyThreshold = "ConsumptionLimitter_EmergencyThreshold",
    ConsumptionLimitter_DurationMinOver = "ConsumptionLimitter_DurationMinOver",
    ConsumptionLimitter_DurationMinUnder = "ConsumptionLimitter_DurationMinUnder",
    ConsumptionLimitter_EmergencyProfile = "ConsumptionLimitter_EmergencyProfile",
    ConsumptionLimitter_EmergencyProfileGroup = "ConsumptionLimitter_EmergencyProfileGroup",
    ConsumptionLimitter_EmergencyProfileActive = "ConsumptionLimitter_EmergencyProfileActive",
    ConsumptionLimitter_Actions = "ConsumptionLimitter_Actions",
    ScriptTable_DisconnectControl = "ScriptTable_DisconnectControl",
    ScriptTable_PushInterval1 = "ScriptTable_PushInterval1",
    ScriptTable_PushInterval2 = "ScriptTable_PushInterval2",
    ScriptTable_PushInterval3 = "ScriptTable_PushInterval3",
    ScriptTable_EndOfBillingPeriod = "ScriptTable_EndOfBillingPeriod",
    GprsSetup_Apn = "GprsSetup_Apn",
    PushSetup_Interval1_LogicalName = "PushSetup_Interval1_LogicalName",
    PushSetup_Interval1_ObjectList = "PushSetup_Interval1_ObjectList",
    PushSetup_Interval1_SendDestinationAndMethod = "PushSetup_Interval1_SendDestinationAndMethod",
    PushSetup_Interval1_RandomisationStartInterval = "PushSetup_Interval1_RandomisationStartInterval",
    PushSetup_Interval1_NumberOfRetries = "PushSetup_Interval1_NumberOfRetries",
    PushSetup_Interval1_RepetitionDelay = "PushSetup_Interval1_RepetitionDelay",
    PushSetup_Interval1_MethodTrigger = "PushSetup_Interval1_MethodTrigger",
    PushSetup_Interval2_LogicalName = "PushSetup_Interval2_LogicalName",
    PushSetup_Interval2_ObjectList = "PushSetup_Interval2_ObjectList",
    PushSetup_Interval2_SendDestinationAndMethod = "PushSetup_Interval2_SendDestinationAndMethod",
    PushSetup_Interval2_RandomisationStartInterval = "PushSetup_Interval2_RandomisationStartInterval",
    PushSetup_Interval2_NumberOfRetries = "PushSetup_Interval2_NumberOfRetries",
    PushSetup_Interval2_RepetitionDelay = "PushSetup_Interval2_RepetitionDelay",
    PushSetup_Interval2_MethodTrigger = "PushSetup_Interval2_MethodTrigger",
    PushSetup_Interval3_LogicalName = "PushSetup_Interval3_LogicalName",
    PushSetup_Interval3_ObjectList = "PushSetup_Interval3_ObjectList",
    PushSetup_Interval3_SendDestinationAndMethod = "PushSetup_Interval3_SendDestinationAndMethod",
    PushSetup_Interval3_RandomisationStartInterval = "PushSetup_Interval3_RandomisationStartInterval",
    PushSetup_Interval3_NumberOfRetries = "PushSetup_Interval3_NumberOfRetries",
    PushSetup_Interval3_RepetitionDelay = "PushSetup_Interval3_RepetitionDelay",
    PushSetup_Interval3_MethodTrigger = "PushSetup_Interval3_MethodTrigger",
    PushSetup_OnAlarm_LogicalName = "PushSetup_OnAlarm_LogicalName",
    PushSetup_OnAlarm_ObjectList = "PushSetup_OnAlarm_ObjectList",
    PushSetup_OnAlarm_SendDestinationAndMethod = "PushSetup_OnAlarm_SendDestinationAndMethod",
    PushSetup_OnAlarm_RandomisationStartInterval = "PushSetup_OnAlarm_RandomisationStartInterval",
    PushSetup_OnAlarm_NumberOfRetries = "PushSetup_OnAlarm_NumberOfRetries",
    PushSetup_OnAlarm_RepetitionDelay = "PushSetup_OnAlarm_RepetitionDelay",
    PushSetup_OnAlarm_MethodTrigger = "PushSetup_OnAlarm_MethodTrigger",
    PushSetup_OnConnect_LogicalName = "PushSetup_OnConnect_LogicalName",
    PushSetup_OnConnect_ObjectList = "PushSetup_OnConnect_ObjectList",
    PushSetup_OnConnect_SendDestinationAndMethod = "PushSetup_OnConnect_SendDestinationAndMethod",
    PushSetup_OnConnect_RandomisationStartInterval = "PushSetup_OnConnect_RandomisationStartInterval",
    PushSetup_OnConnect_NumberOfRetries = "PushSetup_OnConnect_NumberOfRetries",
    PushSetup_OnConnect_RepetitionDelay = "PushSetup_OnConnect_RepetitionDelay",
    PushSetup_OnConnect_MethodTrigger = "PushSetup_OnConnect_MethodTrigger",
    PushSetup_OnPowerDown_LogicalName = "PushSetup_OnPowerDown_LogicalName",
    PushSetup_OnPowerDown_ObjectList = "PushSetup_OnPowerDown_ObjectList",
    PushSetup_OnPowerDown_SendDestinationAndMethod = "PushSetup_OnPowerDown_SendDestinationAndMethod",
    PushSetup_OnPowerDown_RandomisationStartInterval = "PushSetup_OnPowerDown_RandomisationStartInterval",
    PushSetup_OnPowerDown_NumberOfRetries = "PushSetup_OnPowerDown_NumberOfRetries",
    PushSetup_OnPowerDown_RepetitionDelay = "PushSetup_OnPowerDown_RepetitionDelay",
    PushSetup_OnPowerDown_MethodTrigger = "PushSetup_OnPowerDown_MethodTrigger",
    PushSetup_OnInstallation_LogicalName = "PushSetup_OnInstallation_LogicalName",
    PushSetup_OnInstallation_ObjectList = "PushSetup_OnInstallation_ObjectList",
    PushSetup_OnInstallation_SendDestinationAndMethod = "PushSetup_OnInstallation_SendDestinationAndMethod",
    PushSetup_OnInstallation_RandomisationStartInterval = "PushSetup_OnInstallation_RandomisationStartInterval",
    PushSetup_OnInstallation_NumberOfRetries = "PushSetup_OnInstallation_NumberOfRetries",
    PushSetup_OnInstallation_RepetitionDelay = "PushSetup_OnInstallation_RepetitionDelay",
    PushSetup_OnInstallation_MethodTrigger = "PushSetup_OnInstallation_MethodTrigger",
    ProfileGeneric_LoadProfilePeriod1_LogicalName = "ProfileGeneric_LoadProfilePeriod1_LogicalName",
    ProfileGeneric_LoadProfilePeriod1_Buffer = "ProfileGeneric_LoadProfilePeriod1_Buffer",
    ProfileGeneric_LoadProfilePeriod1_CaptureObjects = "ProfileGeneric_LoadProfilePeriod1_CaptureObjects",
    ProfileGeneric_LoadProfilePeriod1_CapturePeriod = "ProfileGeneric_LoadProfilePeriod1_CapturePeriod",
    ProfileGeneric_LoadProfilePeriod1_SortMethod = "ProfileGeneric_LoadProfilePeriod1_SortMethod",
    ProfileGeneric_LoadProfilePeriod1_SortObject = "ProfileGeneric_LoadProfilePeriod1_SortObject",
    ProfileGeneric_LoadProfilePeriod1_EntriesInUse = "ProfileGeneric_LoadProfilePeriod1_EntriesInUse",
    ProfileGeneric_LoadProfilePeriod1_ProfileEntries = "ProfileGeneric_LoadProfilePeriod1_ProfileEntries",
    ProfileGeneric_LoadProfilePeriod2_LogicalName = "ProfileGeneric_LoadProfilePeriod2_LogicalName",
    ProfileGeneric_LoadProfilePeriod1_ResetBufferMethod = "ProfileGeneric_LoadProfilePeriod1_ResetBufferMethod",
    ProfileGeneric_LoadProfilePeriod2_Buffer = "ProfileGeneric_LoadProfilePeriod2_Buffer",
    ProfileGeneric_LoadProfilePeriod2_CaptureObjects = "ProfileGeneric_LoadProfilePeriod2_CaptureObjects",
    ProfileGeneric_LoadProfilePeriod2_CapturePeriod = "ProfileGeneric_LoadProfilePeriod2_CapturePeriod",
    ProfileGeneric_LoadProfilePeriod2_SortMethod = "ProfileGeneric_LoadProfilePeriod2_SortMethod",
    ProfileGeneric_LoadProfilePeriod2_SortObject = "ProfileGeneric_LoadProfilePeriod2_SortObject",
    ProfileGeneric_LoadProfilePeriod2_EntriesInUse = "ProfileGeneric_LoadProfilePeriod2_EntriesInUse",
    ProfileGeneric_LoadProfilePeriod2_ProfileEntries = "ProfileGeneric_LoadProfilePeriod2_ProfileEntries",
    ProfileGeneric_LoadProfilePeriod2_ResetBufferMethod = "ProfileGeneric_LoadProfilePeriod2_ResetBufferMethod",
    ProfileGeneric_LoadProfilePeriod3_LogicalName = "ProfileGeneric_LoadProfilePeriod3_LogicalName",
    ProfileGeneric_LoadProfilePeriod3_Buffer = "ProfileGeneric_LoadProfilePeriod3_Buffer",
    ProfileGeneric_LoadProfilePeriod3_CaptureObjects = "ProfileGeneric_LoadProfilePeriod3_CaptureObjects",
    ProfileGeneric_LoadProfilePeriod3_CapturePeriod = "ProfileGeneric_LoadProfilePeriod3_CapturePeriod",
    ProfileGeneric_LoadProfilePeriod3_SortMethod = "ProfileGeneric_LoadProfilePeriod3_SortMethod",
    ProfileGeneric_LoadProfilePeriod3_SortObject = "ProfileGeneric_LoadProfilePeriod3_SortObject",
    ProfileGeneric_LoadProfilePeriod3_EntriesInUse = "ProfileGeneric_LoadProfilePeriod3_EntriesInUse",
    ProfileGeneric_LoadProfilePeriod3_ProfileEntries = "ProfileGeneric_LoadProfilePeriod3_ProfileEntries",
    ProfileGeneric_LoadProfilePeriod3_ResetBufferMethod = "ProfileGeneric_LoadProfilePeriod3_ResetBufferMethod",
    ProfileGeneric_MonthlyBilling_CapturePeriod = "ProfileGeneric_MonthlyBilling_CapturePeriod",
    ProfileGeneric_DailyBilling_CapturePeriod = "ProfileGeneric_DailyBilling_CapturePeriod",
    ProfileGeneric_EventLog1_LogicalName = "ProfileGeneric_EventLog1_LogicalName",
    ProfileGeneric_EventLog1_Buffer = "ProfileGeneric_EventLog1_Buffer",
    ProfileGeneric_EventLog1_CaptureObjects = "ProfileGeneric_EventLog1_CaptureObjects",
    ProfileGeneric_EventLog1_CapturePeriod = "ProfileGeneric_EventLog1_CapturePeriod",
    ProfileGeneric_EventLog1_SortMethod = "ProfileGeneric_EventLog1_SortMethod",
    ProfileGeneric_EventLog1_SortObject = "ProfileGeneric_EventLog1_SortObject",
    ProfileGeneric_EventLog1_EntriesInUse = "ProfileGeneric_EventLog1_EntriesInUse",
    ProfileGeneric_EventLog1_ProfileEntries = "ProfileGeneric_EventLog1_ProfileEntries",
    ProfileGeneric_EventLog1_ResetBufferMethod = "ProfileGeneric_EventLog1_ResetBufferMethod",
    ProfileGeneric_EventLog2_LogicalName = "ProfileGeneric_EventLog2_LogicalName",
    ProfileGeneric_EventLog2_Buffer = "ProfileGeneric_EventLog2_Buffer",
    ProfileGeneric_EventLog2_CaptureObjects = "ProfileGeneric_EventLog2_CaptureObjects",
    ProfileGeneric_EventLog2_CapturePeriod = "ProfileGeneric_EventLog2_CapturePeriod",
    ProfileGeneric_EventLog2_SortMethod = "ProfileGeneric_EventLog2_SortMethod",
    ProfileGeneric_EventLog2_SortObject = "ProfileGeneric_EventLog2_SortObject",
    ProfileGeneric_EventLog2_EntriesInUse = "ProfileGeneric_EventLog2_EntriesInUse",
    ProfileGeneric_EventLog2_ProfileEntries = "ProfileGeneric_EventLog2_ProfileEntries",
    ProfileGeneric_EventLog2_ResetBufferMethod = "ProfileGeneric_EventLog2_ResetBufferMethod",
    ProfileGeneric_EventLog3_LogicalName = "ProfileGeneric_EventLog3_LogicalName",
    ProfileGeneric_EventLog3_Buffer = "ProfileGeneric_EventLog3_Buffer",
    ProfileGeneric_EventLog3_CaptureObjects = "ProfileGeneric_EventLog3_CaptureObjects",
    ProfileGeneric_EventLog3_CapturePeriod = "ProfileGeneric_EventLog3_CapturePeriod",
    ProfileGeneric_EventLog3_SortMethod = "ProfileGeneric_EventLog3_SortMethod",
    ProfileGeneric_EventLog3_SortObject = "ProfileGeneric_EventLog3_SortObject",
    ProfileGeneric_EventLog3_EntriesInUse = "ProfileGeneric_EventLog3_EntriesInUse",
    ProfileGeneric_EventLog3_ProfileEntries = "ProfileGeneric_EventLog3_ProfileEntries",
    ProfileGeneric_EventLog3_ResetBufferMethod = "ProfileGeneric_EventLog3_ResetBufferMethod",
    ProfileGeneric_EventLog4_LogicalName = "ProfileGeneric_EventLog4_LogicalName",
    ProfileGeneric_EventLog4_Buffer = "ProfileGeneric_EventLog4_Buffer",
    ProfileGeneric_EventLog4_CaptureObjects = "ProfileGeneric_EventLog4_CaptureObjects",
    ProfileGeneric_EventLog4_CapturePeriod = "ProfileGeneric_EventLog4_CapturePeriod",
    ProfileGeneric_EventLog4_SortMethod = "ProfileGeneric_EventLog4_SortMethod",
    ProfileGeneric_EventLog4_SortObject = "ProfileGeneric_EventLog4_SortObject",
    ProfileGeneric_EventLog4_EntriesInUse = "ProfileGeneric_EventLog4_EntriesInUse",
    ProfileGeneric_EventLog4_ProfileEntries = "ProfileGeneric_EventLog4_ProfileEntries",
    ProfileGeneric_EventLog4_ResetBufferMethod = "ProfileGeneric_EventLog4_ResetBufferMethod",
    ProfileGeneric_EventLog5_LogicalName = "ProfileGeneric_EventLog5_LogicalName",
    ProfileGeneric_EventLog5_Buffer = "ProfileGeneric_EventLog5_Buffer",
    ProfileGeneric_EventLog5_CaptureObjects = "ProfileGeneric_EventLog5_CaptureObjects",
    ProfileGeneric_EventLog5_CapturePeriod = "ProfileGeneric_EventLog5_CapturePeriod",
    ProfileGeneric_EventLog5_SortMethod = "ProfileGeneric_EventLog5_SortMethod",
    ProfileGeneric_EventLog5_SortObject = "ProfileGeneric_EventLog5_SortObject",
    ProfileGeneric_EventLog5_EntriesInUse = "ProfileGeneric_EventLog5_EntriesInUse",
    ProfileGeneric_EventLog5_ProfileEntries = "ProfileGeneric_EventLog5_ProfileEntries",
    ProfileGeneric_EventLog5_ResetBufferMethod = "ProfileGeneric_EventLog5_ResetBufferMethod",
    ProfileGeneric_EventLog6_LogicalName = "ProfileGeneric_EventLog6_LogicalName",
    ProfileGeneric_EventLog6_Buffer = "ProfileGeneric_EventLog6_Buffer",
    ProfileGeneric_EventLog6_CaptureObjects = "ProfileGeneric_EventLog6_CaptureObjects",
    ProfileGeneric_EventLog6_CapturePeriod = "ProfileGeneric_EventLog6_CapturePeriod",
    ProfileGeneric_EventLog6_SortMethod = "ProfileGeneric_EventLog6_SortMethod",
    ProfileGeneric_EventLog6_SortObject = "ProfileGeneric_EventLog6_SortObject",
    ProfileGeneric_EventLog6_EntriesInUse = "ProfileGeneric_EventLog6_EntriesInUse",
    ProfileGeneric_EventLog6_ProfileEntries = "ProfileGeneric_EventLog6_ProfileEntries",
    ProfileGeneric_EventLog6_ResetBufferMethod = "ProfileGeneric_EventLog6_ResetBufferMethod",
    ExtendedRegister_MaxDemandActivePowerImportValue = "ExtendedRegister_MaxDemandActivePowerImportValue",
    ExtendedRegister_MaxDemandActivePowerImportScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerImportScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerImportStatus = "ExtendedRegister_MaxDemandActivePowerImportStatus",
    ExtendedRegister_MaxDemandActivePowerImportCaptureTime = "ExtendedRegister_MaxDemandActivePowerImportCaptureTime",
    ExtendedRegister_MaxDemandActivePowerExportValue = "ExtendedRegister_MaxDemandActivePowerExportValue",
    ExtendedRegister_MaxDemandActivePowerExportScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerExportScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerExportStatus = "ExtendedRegister_MaxDemandActivePowerExportStatus",
    ExtendedRegister_MaxDemandActivePowerExportCaptureTime = "ExtendedRegister_MaxDemandActivePowerExportCaptureTime",
    ExtendedRegister_MaxDemandReactivePowerImportValue = "ExtendedRegister_MaxDemandReactivePowerImportValue",
    ExtendedRegister_MaxDemandReactivePowerImportScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerImportScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerImportStatus = "ExtendedRegister_MaxDemandReactivePowerImportStatus",
    ExtendedRegister_MaxDemandReactivePowerImportCaptureTime = "ExtendedRegister_MaxDemandReactivePowerImportCaptureTime",
    ExtendedRegister_MaxDemandReactivePowerExportValue = "ExtendedRegister_MaxDemandReactivePowerExportValue",
    ExtendedRegister_MaxDemandReactivePowerExportScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerExportScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerExportStatus = "ExtendedRegister_MaxDemandReactivePowerExportStatus",
    ExtendedRegister_MaxDemandReactivePowerExportCaptureTime = "ExtendedRegister_MaxDemandReactivePowerExportCaptureTime",
    ExtendedRegister_MaxDemandApparentPowerImportValue = "ExtendedRegister_MaxDemandApparentPowerImportValue",
    ExtendedRegister_MaxDemandApparentPowerImportScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerImportScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerImportStatus = "ExtendedRegister_MaxDemandApparentPowerImportStatus",
    ExtendedRegister_MaxDemandApparentPowerImportCaptureTime = "ExtendedRegister_MaxDemandApparentPowerImportCaptureTime",
    ExtendedRegister_MaxDemandApparentPowerExportValue = "ExtendedRegister_MaxDemandApparentPowerExportValue",
    ExtendedRegister_MaxDemandApparentPowerExportScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerExportScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerExportStatus = "ExtendedRegister_MaxDemandApparentPowerExportStatus",
    ExtendedRegister_MaxDemandApparentPowerExportCaptureTime = "ExtendedRegister_MaxDemandApparentPowerExportCaptureTime",
    ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportValue = "ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportValue",
    ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportStatus = "ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportStatus",
    ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportCaptureTime = "ExtendedRegister_MaxDemandActivePowerSumOfExportAndImportCaptureTime",
    ExtendedRegister_MaxDemandActivePowerImportRate1Value = "ExtendedRegister_MaxDemandActivePowerImportRate1Value",
    ExtendedRegister_MaxDemandActivePowerImportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerImportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerImportRate1Status = "ExtendedRegister_MaxDemandActivePowerImportRate1Status",
    ExtendedRegister_MaxDemandActivePowerImportRate1CaptureTime = "ExtendedRegister_MaxDemandActivePowerImportRate1CaptureTime",
    ExtendedRegister_MaxDemandActivePowerImportRate2Value = "ExtendedRegister_MaxDemandActivePowerImportRate2Value",
    ExtendedRegister_MaxDemandActivePowerImportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerImportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerImportRate2Status = "ExtendedRegister_MaxDemandActivePowerImportRate2Status",
    ExtendedRegister_MaxDemandActivePowerImportRate2CaptureTime = "ExtendedRegister_MaxDemandActivePowerImportRate2CaptureTime",
    ExtendedRegister_MaxDemandActivePowerImportRate3Value = "ExtendedRegister_MaxDemandActivePowerImportRate3Value",
    ExtendedRegister_MaxDemandActivePowerImportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerImportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerImportRate3Status = "ExtendedRegister_MaxDemandActivePowerImportRate3Status",
    ExtendedRegister_MaxDemandActivePowerImportRate3CaptureTime = "ExtendedRegister_MaxDemandActivePowerImportRate3CaptureTime",
    ExtendedRegister_MaxDemandActivePowerImportRate4Value = "ExtendedRegister_MaxDemandActivePowerImportRate4Value",
    ExtendedRegister_MaxDemandActivePowerImportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerImportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerImportRate4Status = "ExtendedRegister_MaxDemandActivePowerImportRate4Status",
    ExtendedRegister_MaxDemandActivePowerImportRate4CaptureTime = "ExtendedRegister_MaxDemandActivePowerImportRate4CaptureTime",
    ExtendedRegister_MaxDemandActivePowerExportRate1Value = "ExtendedRegister_MaxDemandActivePowerExportRate1Value",
    ExtendedRegister_MaxDemandActivePowerExportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerExportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerExportRate1Status = "ExtendedRegister_MaxDemandActivePowerExportRate1Status",
    ExtendedRegister_MaxDemandActivePowerExportRate1CaptureTime = "ExtendedRegister_MaxDemandActivePowerExportRate1CaptureTime",
    ExtendedRegister_MaxDemandActivePowerExportRate2Value = "ExtendedRegister_MaxDemandActivePowerExportRate2Value",
    ExtendedRegister_MaxDemandActivePowerExportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerExportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerExportRate2Status = "ExtendedRegister_MaxDemandActivePowerExportRate2Status",
    ExtendedRegister_MaxDemandActivePowerExportRate2CaptureTime = "ExtendedRegister_MaxDemandActivePowerExportRate2CaptureTime",
    ExtendedRegister_MaxDemandActivePowerExportRate3Value = "ExtendedRegister_MaxDemandActivePowerExportRate3Value",
    ExtendedRegister_MaxDemandActivePowerExportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerExportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerExportRate3Status = "ExtendedRegister_MaxDemandActivePowerExportRate3Status",
    ExtendedRegister_MaxDemandActivePowerExportRate3CaptureTime = "ExtendedRegister_MaxDemandActivePowerExportRate3CaptureTime",
    ExtendedRegister_MaxDemandActivePowerExportRate4Value = "ExtendedRegister_MaxDemandActivePowerExportRate4Value",
    ExtendedRegister_MaxDemandActivePowerExportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandActivePowerExportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandActivePowerExportRate4Status = "ExtendedRegister_MaxDemandActivePowerExportRate4Status",
    ExtendedRegister_MaxDemandActivePowerExportRate4CaptureTime = "ExtendedRegister_MaxDemandActivePowerExportRate4CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerImportRate1Value = "ExtendedRegister_MaxDemandReactivePowerImportRate1Value",
    ExtendedRegister_MaxDemandReactivePowerImportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerImportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerImportRate1Status = "ExtendedRegister_MaxDemandReactivePowerImportRate1Status",
    ExtendedRegister_MaxDemandReactivePowerImportRate1CaptureTime = "ExtendedRegister_MaxDemandReactivePowerImportRate1CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerImportRate2Value = "ExtendedRegister_MaxDemandReactivePowerImportRate2Value",
    ExtendedRegister_MaxDemandReactivePowerImportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerImportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerImportRate2Status = "ExtendedRegister_MaxDemandReactivePowerImportRate2Status",
    ExtendedRegister_MaxDemandReactivePowerImportRate2CaptureTime = "ExtendedRegister_MaxDemandReactivePowerImportRate2CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerImportRate3Value = "ExtendedRegister_MaxDemandReactivePowerImportRate3Value",
    ExtendedRegister_MaxDemandReactivePowerImportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerImportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerImportRate3Status = "ExtendedRegister_MaxDemandReactivePowerImportRate3Status",
    ExtendedRegister_MaxDemandReactivePowerImportRate3CaptureTime = "ExtendedRegister_MaxDemandReactivePowerImportRate3CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerImportRate4Value = "ExtendedRegister_MaxDemandReactivePowerImportRate4Value",
    ExtendedRegister_MaxDemandReactivePowerImportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerImportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerImportRate4Status = "ExtendedRegister_MaxDemandReactivePowerImportRate4Status",
    ExtendedRegister_MaxDemandReactivePowerImportRate4CaptureTime = "ExtendedRegister_MaxDemandReactivePowerImportRate4CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerExportRate1Value = "ExtendedRegister_MaxDemandReactivePowerExportRate1Value",
    ExtendedRegister_MaxDemandReactivePowerExportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerExportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerExportRate1Status = "ExtendedRegister_MaxDemandReactivePowerExportRate1Status",
    ExtendedRegister_MaxDemandReactivePowerExportRate1CaptureTime = "ExtendedRegister_MaxDemandReactivePowerExportRate1CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerExportRate2Value = "ExtendedRegister_MaxDemandReactivePowerExportRate2Value",
    ExtendedRegister_MaxDemandReactivePowerExportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerExportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerExportRate2Status = "ExtendedRegister_MaxDemandReactivePowerExportRate2Status",
    ExtendedRegister_MaxDemandReactivePowerExportRate2CaptureTime = "ExtendedRegister_MaxDemandReactivePowerExportRate2CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerExportRate3Value = "ExtendedRegister_MaxDemandReactivePowerExportRate3Value",
    ExtendedRegister_MaxDemandReactivePowerExportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerExportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerExportRate3Status = "ExtendedRegister_MaxDemandReactivePowerExportRate3Status",
    ExtendedRegister_MaxDemandReactivePowerExportRate3CaptureTime = "ExtendedRegister_MaxDemandReactivePowerExportRate3CaptureTime",
    ExtendedRegister_MaxDemandReactivePowerExportRate4Value = "ExtendedRegister_MaxDemandReactivePowerExportRate4Value",
    ExtendedRegister_MaxDemandReactivePowerExportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandReactivePowerExportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandReactivePowerExportRate4Status = "ExtendedRegister_MaxDemandReactivePowerExportRate4Status",
    ExtendedRegister_MaxDemandReactivePowerExportRate4CaptureTime = "ExtendedRegister_MaxDemandReactivePowerExportRate4CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerImportRate1Value = "ExtendedRegister_MaxDemandApparentPowerImportRate1Value",
    ExtendedRegister_MaxDemandApparentPowerImportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerImportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerImportRate1Status = "ExtendedRegister_MaxDemandApparentPowerImportRate1Status",
    ExtendedRegister_MaxDemandApparentPowerImportRate1CaptureTime = "ExtendedRegister_MaxDemandApparentPowerImportRate1CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerImportRate2Value = "ExtendedRegister_MaxDemandApparentPowerImportRate2Value",
    ExtendedRegister_MaxDemandApparentPowerImportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerImportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerImportRate2Status = "ExtendedRegister_MaxDemandApparentPowerImportRate2Status",
    ExtendedRegister_MaxDemandApparentPowerImportRate2CaptureTime = "ExtendedRegister_MaxDemandApparentPowerImportRate2CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerImportRate3Value = "ExtendedRegister_MaxDemandApparentPowerImportRate3Value",
    ExtendedRegister_MaxDemandApparentPowerImportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerImportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerImportRate3Status = "ExtendedRegister_MaxDemandApparentPowerImportRate3Status",
    ExtendedRegister_MaxDemandApparentPowerImportRate3CaptureTime = "ExtendedRegister_MaxDemandApparentPowerImportRate3CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerImportRate4Value = "ExtendedRegister_MaxDemandApparentPowerImportRate4Value",
    ExtendedRegister_MaxDemandApparentPowerImportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerImportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerImportRate4Status = "ExtendedRegister_MaxDemandApparentPowerImportRate4Status",
    ExtendedRegister_MaxDemandApparentPowerImportRate4CaptureTime = "ExtendedRegister_MaxDemandApparentPowerImportRate4CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerExportRate1Value = "ExtendedRegister_MaxDemandApparentPowerExportRate1Value",
    ExtendedRegister_MaxDemandApparentPowerExportRate1ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerExportRate1ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerExportRate1Status = "ExtendedRegister_MaxDemandApparentPowerExportRate1Status",
    ExtendedRegister_MaxDemandApparentPowerExportRate1CaptureTime = "ExtendedRegister_MaxDemandApparentPowerExportRate1CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerExportRate2Value = "ExtendedRegister_MaxDemandApparentPowerExportRate2Value",
    ExtendedRegister_MaxDemandApparentPowerExportRate2ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerExportRate2ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerExportRate2Status = "ExtendedRegister_MaxDemandApparentPowerExportRate2Status",
    ExtendedRegister_MaxDemandApparentPowerExportRate2CaptureTime = "ExtendedRegister_MaxDemandApparentPowerExportRate2CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerExportRate3Value = "ExtendedRegister_MaxDemandApparentPowerExportRate3Value",
    ExtendedRegister_MaxDemandApparentPowerExportRate3ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerExportRate3ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerExportRate3Status = "ExtendedRegister_MaxDemandApparentPowerExportRate3Status",
    ExtendedRegister_MaxDemandApparentPowerExportRate3CaptureTime = "ExtendedRegister_MaxDemandApparentPowerExportRate3CaptureTime",
    ExtendedRegister_MaxDemandApparentPowerExportRate4Value = "ExtendedRegister_MaxDemandApparentPowerExportRate4Value",
    ExtendedRegister_MaxDemandApparentPowerExportRate4ScalerAndUnit = "ExtendedRegister_MaxDemandApparentPowerExportRate4ScalerAndUnit",
    ExtendedRegister_MaxDemandApparentPowerExportRate4Status = "ExtendedRegister_MaxDemandApparentPowerExportRate4Status",
    ExtendedRegister_MaxDemandApparentPowerExportRate4CaptureTime = "ExtendedRegister_MaxDemandApparentPowerExportRate4CaptureTime",
    Ip4Setup_Address = "Ip4Setup_Address",
    TcpUdpSetup_Port = "TcpUdpSetup_Port",
    ActionSchedule_Push1_ExecutionTime = "ActionSchedule_Push1_ExecutionTime",
    ActionSchedule_Push1_Script = "ActionSchedule_Push1_Script",
    ActionSchedule_Push2_ExecutionTime = "ActionSchedule_Push2_ExecutionTime",
    ActionSchedule_Push2_Script = "ActionSchedule_Push2_Script",
    ActionSchedule_Push3_ExecutionTime = "ActionSchedule_Push3_ExecutionTime",
    ActionSchedule_Push3_Script = "ActionSchedule_Push3_Script",
    ActionSchedule_EndOfBillingPeriod1_ExecutionTime = "ActionSchedule_EndOfBillingPeriod1_ExecutionTime",
    ActionSchedule_EndOfBillingPeriod1_Script = "ActionSchedule_EndOfBillingPeriod1_Script",
    ActionSchedule_EndOfBillingPeriod2_ExecutionTime = "ActionSchedule_EndOfBillingPeriod2_ExecutionTime",
    ActionSchedule_EndOfBillingPeriod2_Script = "ActionSchedule_EndOfBillingPeriod2_Script",
    ImageTransfer_LogicalName = "ImageTransfer_LogicalName",
    ImageTransfer_BlockSize = "ImageTransfer_BlockSize",
    ImageTransfer_TransferedBlockStatus = "ImageTransfer_TransferedBlockStatus",
    ImageTransfer_FirstNotTransferedBlock = "ImageTransfer_FirstNotTransferedBlock",
    ImageTransfer_Enabled = "ImageTransfer_Enabled",
    ImageTransfer_Status = "ImageTransfer_Status",
    ImageTransfer_ActivateInfo = "ImageTransfer_ActivateInfo",
    ImageTransfer_TransferInitiate = "ImageTransfer_TransferInitiate",
    ImageTransfer_BlockTransfer = "ImageTransfer_BlockTransfer",
    ImageTransfer_Verify = "ImageTransfer_Verify",
    ImageTransfer_Activate = "ImageTransfer_Activate",
    SecuritySetup_ServerSystemTitle = "SecuritySetup_ServerSystemTitle",
    DemandRegister_ActiveEnergyImport_CurrentAverageValue = "DemandRegister_ActiveEnergyImport_CurrentAverageValue",
    DemandRegister_ActiveEnergyImport_LastAverageValue = "DemandRegister_ActiveEnergyImport_LastAverageValue",
    DemandRegister_ActiveEnergyImport_ScalerAndUnit = "DemandRegister_ActiveEnergyImport_ScalerAndUnit",
    DemandRegister_ActiveEnergyImport_Status = "DemandRegister_ActiveEnergyImport_Status",
    DemandRegister_ActiveEnergyImport_CaptureTime = "DemandRegister_ActiveEnergyImport_CaptureTime",
    DemandRegister_ActiveEnergyImport_StartTime = "DemandRegister_ActiveEnergyImport_StartTime",
    DemandRegister_ActiveEnergyImport_Period = "DemandRegister_ActiveEnergyImport_Period",
    DemandRegister_ActiveEnergyImport_NumberOfPeriods = "DemandRegister_ActiveEnergyImport_NumberOfPeriods",
    DemandRegister_ActiveEnergyExport_CurrentAverageValue = "DemandRegister_ActiveEnergyExport_CurrentAverageValue",
    DemandRegister_ActiveEnergyExport_LastAverageValue = "DemandRegister_ActiveEnergyExport_LastAverageValue",
    DemandRegister_ActiveEnergyExport_ScalerAndUnit = "DemandRegister_ActiveEnergyExport_ScalerAndUnit",
    DemandRegister_ActiveEnergyExport_Status = "DemandRegister_ActiveEnergyExport_Status",
    DemandRegister_ActiveEnergyExport_CaptureTime = "DemandRegister_ActiveEnergyExport_CaptureTime",
    DemandRegister_ActiveEnergyExport_StartTime = "DemandRegister_ActiveEnergyExport_StartTime",
    DemandRegister_ActiveEnergyExport_Period = "DemandRegister_ActiveEnergyExport_Period",
    DemandRegister_ActiveEnergyExport_NumberOfPeriods = "DemandRegister_ActiveEnergyExport_NumberOfPeriods",
    DemandRegister_ReactiveEnergyImport_CurrentAverageValue = "DemandRegister_ReactiveEnergyImport_CurrentAverageValue",
    DemandRegister_ReactiveEnergyImport_LastAverageValue = "DemandRegister_ReactiveEnergyImport_LastAverageValue",
    DemandRegister_ReactiveEnergyImport_ScalerAndUnit = "DemandRegister_ReactiveEnergyImport_ScalerAndUnit",
    DemandRegister_ReactiveEnergyImport_Status = "DemandRegister_ReactiveEnergyImport_Status",
    DemandRegister_ReactiveEnergyImport_CaptureTime = "DemandRegister_ReactiveEnergyImport_CaptureTime",
    DemandRegister_ReactiveEnergyImport_StartTime = "DemandRegister_ReactiveEnergyImport_StartTime",
    DemandRegister_ReactiveEnergyImport_Period = "DemandRegister_ReactiveEnergyImport_Period",
    DemandRegister_ReactiveEnergyImport_NumberOfPeriods = "DemandRegister_ReactiveEnergyImport_NumberOfPeriods",
    DemandRegister_ReactiveEnergyExport_CurrentAverageValue = "DemandRegister_ReactiveEnergyExport_CurrentAverageValue",
    DemandRegister_ReactiveEnergyExport_LastAverageValue = "DemandRegister_ReactiveEnergyExport_LastAverageValue",
    DemandRegister_ReactiveEnergyExport_ScalerAndUnit = "DemandRegister_ReactiveEnergyExport_ScalerAndUnit",
    DemandRegister_ReactiveEnergyExport_Status = "DemandRegister_ReactiveEnergyExport_Status",
    DemandRegister_ReactiveEnergyExport_CaptureTime = "DemandRegister_ReactiveEnergyExport_CaptureTime",
    DemandRegister_ReactiveEnergyExport_StartTime = "DemandRegister_ReactiveEnergyExport_StartTime",
    DemandRegister_ReactiveEnergyExport_Period = "DemandRegister_ReactiveEnergyExport_Period",
    DemandRegister_ReactiveEnergyExport_NumberOfPeriods = "DemandRegister_ReactiveEnergyExport_NumberOfPeriods",
    DemandRegister_ApparentEnergyImport_CurrentAverageValue = "DemandRegister_ApparentEnergyImport_CurrentAverageValue",
    DemandRegister_ApparentEnergyImport_LastAverageValue = "DemandRegister_ApparentEnergyImport_LastAverageValue",
    DemandRegister_ApparentEnergyImport_ScalerAndUnit = "DemandRegister_ApparentEnergyImport_ScalerAndUnit",
    DemandRegister_ApparentEnergyImport_Status = "DemandRegister_ApparentEnergyImport_Status",
    DemandRegister_ApparentEnergyImport_CaptureTime = "DemandRegister_ApparentEnergyImport_CaptureTime",
    DemandRegister_ApparentEnergyImport_StartTime = "DemandRegister_ApparentEnergyImport_StartTime",
    DemandRegister_ApparentEnergyImport_Period = "DemandRegister_ApparentEnergyImport_Period",
    DemandRegister_ApparentEnergyImport_NumberOfPeriods = "DemandRegister_ApparentEnergyImport_NumberOfPeriods",
    DemandRegister_ApparentEnergyExport_CurrentAverageValue = "DemandRegister_ApparentEnergyExport_CurrentAverageValue",
    DemandRegister_ApparentEnergyExport_LastAverageValue = "DemandRegister_ApparentEnergyExport_LastAverageValue",
    DemandRegister_ApparentEnergyExport_ScalerAndUnit = "DemandRegister_ApparentEnergyExport_ScalerAndUnit",
    DemandRegister_ApparentEnergyExport_Status = "DemandRegister_ApparentEnergyExport_Status",
    DemandRegister_ApparentEnergyExport_CaptureTime = "DemandRegister_ApparentEnergyExport_CaptureTime",
    DemandRegister_ApparentEnergyExport_StartTime = "DemandRegister_ApparentEnergyExport_StartTime",
    DemandRegister_ApparentEnergyExport_Period = "DemandRegister_ApparentEnergyExport_Period",
    DemandRegister_ApparentEnergyExport_NumberOfPeriods = "DemandRegister_ApparentEnergyExport_NumberOfPeriods",
    DemandRegister_SlidingAverageCurrentL1_CurrentAverageValue = "DemandRegister_SlidingAverageCurrentL1_CurrentAverageValue",
    DemandRegister_SlidingAverageCurrentL1_LastAverageValue = "DemandRegister_SlidingAverageCurrentL1_LastAverageValue",
    DemandRegister_SlidingAverageCurrentL1_ScalerAndUnit = "DemandRegister_SlidingAverageCurrentL1_ScalerAndUnit",
    DemandRegister_SlidingAverageCurrentL1_Status = "DemandRegister_SlidingAverageCurrentL1_Status",
    DemandRegister_SlidingAverageCurrentL1_CaptureTime = "DemandRegister_SlidingAverageCurrentL1_CaptureTime",
    DemandRegister_SlidingAverageCurrentL1_StartTime = "DemandRegister_SlidingAverageCurrentL1_StartTime",
    DemandRegister_SlidingAverageCurrentL1_Period = "DemandRegister_SlidingAverageCurrentL1_Period",
    DemandRegister_SlidingAverageCurrentL1_NumberOfPeriods = "DemandRegister_SlidingAverageCurrentL1_NumberOfPeriods",
    DemandRegister_SlidingAverageCurrentL2_CurrentAverageValue = "DemandRegister_SlidingAverageCurrentL2_CurrentAverageValue",
    DemandRegister_SlidingAverageCurrentL2_LastAverageValue = "DemandRegister_SlidingAverageCurrentL2_LastAverageValue",
    DemandRegister_SlidingAverageCurrentL2_ScalerAndUnit = "DemandRegister_SlidingAverageCurrentL2_ScalerAndUnit",
    DemandRegister_SlidingAverageCurrentL2_Status = "DemandRegister_SlidingAverageCurrentL2_Status",
    DemandRegister_SlidingAverageCurrentL2_CaptureTime = "DemandRegister_SlidingAverageCurrentL2_CaptureTime",
    DemandRegister_SlidingAverageCurrentL2_StartTime = "DemandRegister_SlidingAverageCurrentL2_StartTime",
    DemandRegister_SlidingAverageCurrentL2_Period = "DemandRegister_SlidingAverageCurrentL2_Period",
    DemandRegister_SlidingAverageCurrentL2_NumberOfPeriods = "DemandRegister_SlidingAverageCurrentL2_NumberOfPeriods",
    DemandRegister_SlidingAverageCurrentL3_CurrentAverageValue = "DemandRegister_SlidingAverageCurrentL3_CurrentAverageValue",
    DemandRegister_SlidingAverageCurrentL3_LastAverageValue = "DemandRegister_SlidingAverageCurrentL3_LastAverageValue",
    DemandRegister_SlidingAverageCurrentL3_ScalerAndUnit = "DemandRegister_SlidingAverageCurrentL3_ScalerAndUnit",
    DemandRegister_SlidingAverageCurrentL3_Status = "DemandRegister_SlidingAverageCurrentL3_Status",
    DemandRegister_SlidingAverageCurrentL3_CaptureTime = "DemandRegister_SlidingAverageCurrentL3_CaptureTime",
    DemandRegister_SlidingAverageCurrentL3_StartTime = "DemandRegister_SlidingAverageCurrentL3_StartTime",
    DemandRegister_SlidingAverageCurrentL3_Period = "DemandRegister_SlidingAverageCurrentL3_Period",
    DemandRegister_SlidingAverageCurrentL3_NumberOfPeriods = "DemandRegister_SlidingAverageCurrentL3_NumberOfPeriods",
    CurrentAssociationSecret = "CurrentAssociationSecret",
}

export enum DlmsDataType {
    None = "None",
    Array = "Array",
    Structure = "Structure",
    Boolean = "Boolean",
    BitString = "BitString",
    Int32 = "Int32",
    UInt32 = "UInt32",
    OctetString = "OctetString",
    String = "String",
    StringUTF8 = "StringUTF8",
    Bcd = "Bcd",
    Int8 = "Int8",
    Int16 = "Int16",
    UInt8 = "UInt8",
    UInt16 = "UInt16",
    CompactArray = "CompactArray",
    Int64 = "Int64",
    UInt64 = "UInt64",
    Enum = "Enum",
    Float32 = "Float32",
    Float64 = "Float64",
    DateTime = "DateTime",
    Date = "Date",
    Time = "Time",
    DeltaInt8 = "DeltaInt8",
    DeltaInt16 = "DeltaInt16",
    DeltaInt32 = "DeltaInt32",
    DeltaUInt8 = "DeltaUInt8",
    DeltaUInt16 = "DeltaUInt16",
    DeltaUInt32 = "DeltaUInt32",
}

export enum DlmsObjectType {
    None = "None",
    Data = "Data",
    SmtpSetup = "SmtpSetup",
    Register = "Register",
    ExtendedRegister = "ExtendedRegister",
    DemandRegister = "DemandRegister",
    RegisterActivation = "RegisterActivation",
    ProfileGeneric = "ProfileGeneric",
    Clock = "Clock",
    ScriptTable = "ScriptTable",
    Schedule = "Schedule",
    SpecialDaysTable = "SpecialDaysTable",
    AssociationShortName = "AssociationShortName",
    AssociationLogicalName = "AssociationLogicalName",
    SapAssignment = "SapAssignment",
    ImageTransfer = "ImageTransfer",
    IecLocalPortSetup = "IecLocalPortSetup",
    ActivityCalendar = "ActivityCalendar",
    RegisterMonitor = "RegisterMonitor",
    ActionSchedule = "ActionSchedule",
    IecHdlcSetup = "IecHdlcSetup",
    IecTwistedPairSetup = "IecTwistedPairSetup",
    MBusSlavePortSetup = "MBusSlavePortSetup",
    UtilityTables = "UtilityTables",
    ModemConfiguration = "ModemConfiguration",
    AutoAnswer = "AutoAnswer",
    AutoConnect = "AutoConnect",
    DataProtection = "DataProtection",
    PushSetup = "PushSetup",
    TcpUdpSetup = "TcpUdpSetup",
    Ip4Setup = "Ip4Setup",
    MacAddressSetup = "MacAddressSetup",
    PppSetup = "PppSetup",
    GprsSetup = "GprsSetup",
    GSMDiagnostic = "GSMDiagnostic",
    Ip6Setup = "Ip6Setup",
    SFSKPhyMacSetUp = "SFSKPhyMacSetUp",
    SFSKActiveInitiator = "SFSKActiveInitiator",
    SFSKMacSynchronizationTimeouts = "SFSKMacSynchronizationTimeouts",
    SFSKMacCounters = "SFSKMacCounters",
    Iec61334_4_32LlcSetup = "Iec61334_4_32LlcSetup",
    SFSKReportingSystemList = "SFSKReportingSystemList",
    Iec8802LlcType1Setup = "Iec8802LlcType1Setup",
    Iec8802LlcType2Setup = "Iec8802LlcType2Setup",
    Iec8802LlcType3Setup = "Iec8802LlcType3Setup",
    RegisterTable = "RegisterTable",
    CompactData = "CompactData",
    StatusMapping = "StatusMapping",
    SecuritySetup = "SecuritySetup",
    ParameterMonitor = "ParameterMonitor",
    Arbitrator = "Arbitrator",
    DisconnectControl = "DisconnectControl",
    Limiter = "Limiter",
    MBusClient = "MBusClient",
    WirelessModeQchannel = "WirelessModeQchannel",
    MBusMasterPortSetup = "MBusMasterPortSetup",
    MBusPortSetup = "MBusPortSetup",
    MBusDiagnostic = "MBusDiagnostic",
    LlcSscsSetup = "LlcSscsSetup",
    PrimeNbOfdmPlcPhysicalLayerCounters = "PrimeNbOfdmPlcPhysicalLayerCounters",
    PrimeNbOfdmPlcMacSetup = "PrimeNbOfdmPlcMacSetup",
    PrimeNbOfdmPlcMacFunctionalParameters = "PrimeNbOfdmPlcMacFunctionalParameters",
    PrimeNbOfdmPlcMacCounters = "PrimeNbOfdmPlcMacCounters",
    PrimeNbOfdmPlcMacNetworkAdministrationData = "PrimeNbOfdmPlcMacNetworkAdministrationData",
    PrimeNbOfdmPlcApplicationsIdentification = "PrimeNbOfdmPlcApplicationsIdentification",
    G3PlcMacLayerCounters = "G3PlcMacLayerCounters",
    G3PlcMacSetup = "G3PlcMacSetup",
    G3Plc6LoWPan = "G3Plc6LoWPan",
    NtpSetup = "NtpSetup",
    ZigBeeSasStartup = "ZigBeeSasStartup",
    ZigBeeSasJoin = "ZigBeeSasJoin",
    ZigBeeSasApsFragmentation = "ZigBeeSasApsFragmentation",
    ZigBeeNetworkControl = "ZigBeeNetworkControl",
    Account = "Account",
    Credit = "Credit",
    Charge = "Charge",
    TokenGateway = "TokenGateway",
    Token = "Token",
    FunctionControl = "FunctionControl",
    ArrayManager = "ArrayManager",
    CommunicationPortProtection = "CommunicationPortProtection",
    LteMonitoring = "LteMonitoring",
    CoAPSetup = "CoAPSetup",
    CoAPDiagnostic = "CoAPDiagnostic",
    G3PlcHybridRfMacLayerCounters = "G3PlcHybridRfMacLayerCounters",
    G3PlcHybridRfMacSetup = "G3PlcHybridRfMacSetup",
    G3PlcHybrid6LoWPANAdaptationLayerSetup = "G3PlcHybrid6LoWPANAdaptationLayerSetup",
    TariffPlan = "TariffPlan",
}

export class DownloadAcquisitionDataIn implements IDownloadAcquisitionDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    status?: MeterStatus;

    constructor(data?: IDownloadAcquisitionDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DownloadAcquisitionDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadAcquisitionDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IDownloadAcquisitionDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    status?: MeterStatus;
}

export class DownloadAuditLogDataIn implements IDownloadAuditLogDataIn {
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDownloadAuditLogDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadAuditLogDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadAuditLogDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadAuditLogDataIn {
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class DownloadBulkDataIn implements IDownloadBulkDataIn {
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    /** Optional status filter */
    meters!: string[] | undefined;

    constructor(data?: IDownloadBulkDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadBulkDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBulkDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item);
        }
        return data;
    }
}

export interface IDownloadBulkDataIn {
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    /** Optional status filter */
    meters: string[] | undefined;
}

export class DownloadDeviceConnectionDataIn implements IDownloadDeviceConnectionDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;

    constructor(data?: IDownloadDeviceConnectionDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadDeviceConnectionDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDeviceConnectionDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadDeviceConnectionDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
}

export class DownloadDeviceDataIn implements IDownloadDeviceDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: MeterStatus;
    simStatus?: MeterStatus;
    lastCommunication?: LastCommunicationPeriod;
    meterMakes!: string[] | undefined;
    assetTypes!: string[] | undefined;
    meterModels!: string[] | undefined;
    serviceTypes!: string[] | undefined;
    areas!: string[] | undefined;
    regions!: string[] | undefined;
    configurationProgressStatus!: ConfigurationProgressStatus[] | undefined;
    meters?: string[] | undefined;

    constructor(data?: IDownloadDeviceDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
            this.simStatus = _data["simStatus"];
            this.lastCommunication = _data["lastCommunication"];
            if (Array.isArray(_data["meterMakes"])) {
                this.meterMakes = [] as any;
                for (let item of _data["meterMakes"])
                    this.meterMakes!.push(item);
            }
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["meterModels"])) {
                this.meterModels = [] as any;
                for (let item of _data["meterModels"])
                    this.meterModels!.push(item);
            }
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["configurationProgressStatus"])) {
                this.configurationProgressStatus = [] as any;
                for (let item of _data["configurationProgressStatus"])
                    this.configurationProgressStatus!.push(item);
            }
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadDeviceDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDeviceDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        data["simStatus"] = this.simStatus;
        data["lastCommunication"] = this.lastCommunication;
        if (Array.isArray(this.meterMakes)) {
            data["meterMakes"] = [];
            for (let item of this.meterMakes)
                data["meterMakes"].push(item);
        }
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.meterModels)) {
            data["meterModels"] = [];
            for (let item of this.meterModels)
                data["meterModels"].push(item);
        }
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.configurationProgressStatus)) {
            data["configurationProgressStatus"] = [];
            for (let item of this.configurationProgressStatus)
                data["configurationProgressStatus"].push(item);
        }
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item);
        }
        return data;
    }
}

export interface IDownloadDeviceDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: MeterStatus;
    simStatus?: MeterStatus;
    lastCommunication?: LastCommunicationPeriod;
    meterMakes: string[] | undefined;
    assetTypes: string[] | undefined;
    meterModels: string[] | undefined;
    serviceTypes: string[] | undefined;
    areas: string[] | undefined;
    regions: string[] | undefined;
    configurationProgressStatus: ConfigurationProgressStatus[] | undefined;
    meters?: string[] | undefined;
}

export class DownloadFraudAlarmDataIn implements IDownloadFraudAlarmDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;

    constructor(data?: IDownloadFraudAlarmDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): DownloadFraudAlarmDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFraudAlarmDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IDownloadFraudAlarmDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
}

export class DownloadLoadProfileDataIn implements IDownloadLoadProfileDataIn {
    meterId!: string;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;

    constructor(data?: IDownloadLoadProfileDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterId = _data["meterId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadLoadProfileDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLoadProfileDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterId"] = this.meterId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadLoadProfileDataIn {
    meterId: string;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
}

export class DownloadPendingDeviceDataIn implements IDownloadPendingDeviceDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;

    constructor(data?: IDownloadPendingDeviceDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): DownloadPendingDeviceDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPendingDeviceDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IDownloadPendingDeviceDataIn {
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
}

export class DownloadPrepaymentDataIn implements IDownloadPrepaymentDataIn {
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDownloadPrepaymentDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadPrepaymentDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPrepaymentDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadPrepaymentDataIn {
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class DownloadTimeSyncDataIn implements IDownloadTimeSyncDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IDownloadTimeSyncDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): DownloadTimeSyncDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadTimeSyncDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IDownloadTimeSyncDataIn {
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
}

export class EditMeterDataIn implements IEditMeterDataIn {
    id!: string;
    /** Enum type field indicates the type of asset to which the meter is connected. */
    assetType!: string;
    assetTypeName!: string | undefined;
    /** String type field indicates the name of asset to which the meter is connected. */
    serviceName!: string | undefined;
    serviceId!: string;
    /** Null or string type field indicates the serial number of asset to which the meter is connected. */
    serviceNumber?: string | undefined;
    /** Double type field indicates the latitude of asset to which the meter is connected. */
    serviceLatitude?: number | undefined;
    /** Double type field indicates the longitude of asset to which the meter is connected. */
    serviceLongitude?: number | undefined;
    /** Null or string type field indicates the service type of asset to which the meter is connected. */
    serviceType?: string | undefined;
    serviceTypeName?: string | undefined;
    /** The string type field indicates the area where the device is located. */
    areaName?: string | undefined;
    areaId!: string;
    /** The string type field indicates the region where the device is located. */
    regionName?: string | undefined;
    regionId!: string;
    /** String type field indicates the physical address of device. */
    address!: string | undefined;
    /** String type field indicates the unique number of device. */
    meterNumber!: string | undefined;
    /** The Guid type field indicates the manufacturer of device. */
    meterMake!: string;
    meterMakeName?: string | undefined;
    meterType!: MeterType;
    /** String type field indicates the model of device. */
    meterModel!: string;
    meterModelName!: string | undefined;
    /** String type field indicates the previous model of device before a firmware update. */
    previousMeterModel?: string | undefined;
    previousMeterModelName?: string | undefined;
    /** String type field indicates the firmware version of device. */
    firmwareVersion!: string | undefined;
    /** String type field indicates serial number of SIM card in device. */
    cellularSimSerialNumber!: string | undefined;
    /** String type field indicates ip address of meter in our network. */
    meterIp!: string | undefined;
    /** Integer type field indicates port of meter on MeterIp. */
    meterPort!: number;
    /** Integer type field indicates period (in minutes)  during which data is collected by the meter. */
    dataCollectionInterval!: number;
    /** Integer type field indicates time zone (in minutes ) of meter. */
    meterTimeZone!: number;
    /** The DateTime type field indicates time when manufacture made the device. */
    meterManufactureDate?: Date | undefined;
    /** The DateTime type field indicates time when device was installed on the asset. */
    meterInstallationDate!: Date;
    /** The DateTime type field indicates time when device was created. */
    meterCreationDate?: Date | undefined;
    /** Timestamp of the device's last update. */
    lastUpdateTime?: Date | undefined;
    /** Timestamp of the device's last wake SMS message. */
    lastSmsWakeTime?: Date | undefined;
    /** String type field indicates password of device. */
    password?: string | undefined;
    /** String type field indicates new low level association password. */
    newPassword?: string | undefined;
    /** String type field, indicates the block cipher key used for encrypting data from the device. */
    blockCipherKey?: string | undefined;
    /** String type field, indicates the authentication key used to authenticate the device within the system. */
    authenticationKey?: string | undefined;
    clockTolerance?: number | undefined;
    /** Represents the action performed on the device, indicating whether the device is connected or disconnected. */
    status?: string | undefined;
    /** Represents whether the device is available, whether it is online or not, whether it has some other problem */
    connection?: string | undefined;
    /** Shows the current IpSec connector if any */
    ipSecConnector?: string | undefined;
    gsmProvider!: GsmProviders;
    currentTransformerRatio?: RatioDataIn;
    voltageTransformerRatio?: RatioDataIn;
    firmwareUpdateStatus?: FirmwareUpdateCommandStatusDataOut;
    enableMeterModelEdit!: boolean;
    currentVersion?: number | undefined;
    nextVersion?: number | undefined;
    /** Model and firmware of the next setup version to be applied, which can differ from the current MeterModelName/FirmwareVersion. */
    nextMeterModelName?: string | undefined;
    nextFirmwareVersion?: string | undefined;
    parentId?: string | undefined;
    parent?: ParentMeterDataOut;

    constructor(data?: IEditMeterDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType = _data["assetType"];
            this.assetTypeName = _data["assetTypeName"];
            this.serviceName = _data["serviceName"];
            this.serviceId = _data["serviceId"];
            this.serviceNumber = _data["serviceNumber"];
            this.serviceLatitude = _data["serviceLatitude"];
            this.serviceLongitude = _data["serviceLongitude"];
            this.serviceType = _data["serviceType"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.areaName = _data["areaName"];
            this.areaId = _data["areaId"];
            this.regionName = _data["regionName"];
            this.regionId = _data["regionId"];
            this.address = _data["address"];
            this.meterNumber = _data["meterNumber"];
            this.meterMake = _data["meterMake"];
            this.meterMakeName = _data["meterMakeName"];
            this.meterType = _data["meterType"];
            this.meterModel = _data["meterModel"];
            this.meterModelName = _data["meterModelName"];
            this.previousMeterModel = _data["previousMeterModel"];
            this.previousMeterModelName = _data["previousMeterModelName"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.cellularSimSerialNumber = _data["cellularSimSerialNumber"];
            this.meterIp = _data["meterIp"];
            this.meterPort = _data["meterPort"];
            this.dataCollectionInterval = _data["dataCollectionInterval"];
            this.meterTimeZone = _data["meterTimeZone"];
            this.meterManufactureDate = _data["meterManufactureDate"] ? new Date(_data["meterManufactureDate"].toString()) : <any>undefined;
            this.meterInstallationDate = _data["meterInstallationDate"] ? new Date(_data["meterInstallationDate"].toString()) : <any>undefined;
            this.meterCreationDate = _data["meterCreationDate"] ? new Date(_data["meterCreationDate"].toString()) : <any>undefined;
            this.lastUpdateTime = _data["lastUpdateTime"] ? new Date(_data["lastUpdateTime"].toString()) : <any>undefined;
            this.lastSmsWakeTime = _data["lastSmsWakeTime"] ? new Date(_data["lastSmsWakeTime"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.newPassword = _data["newPassword"];
            this.blockCipherKey = _data["blockCipherKey"];
            this.authenticationKey = _data["authenticationKey"];
            this.clockTolerance = _data["clockTolerance"];
            this.status = _data["status"];
            this.connection = _data["connection"];
            this.ipSecConnector = _data["ipSecConnector"];
            this.gsmProvider = _data["gsmProvider"];
            this.currentTransformerRatio = _data["currentTransformerRatio"] ? RatioDataIn.fromJS(_data["currentTransformerRatio"]) : <any>undefined;
            this.voltageTransformerRatio = _data["voltageTransformerRatio"] ? RatioDataIn.fromJS(_data["voltageTransformerRatio"]) : <any>undefined;
            this.firmwareUpdateStatus = _data["firmwareUpdateStatus"] ? FirmwareUpdateCommandStatusDataOut.fromJS(_data["firmwareUpdateStatus"]) : <any>undefined;
            this.enableMeterModelEdit = _data["enableMeterModelEdit"];
            this.currentVersion = _data["currentVersion"];
            this.nextVersion = _data["nextVersion"];
            this.nextMeterModelName = _data["nextMeterModelName"];
            this.nextFirmwareVersion = _data["nextFirmwareVersion"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? ParentMeterDataOut.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditMeterDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new EditMeterDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType"] = this.assetType;
        data["assetTypeName"] = this.assetTypeName;
        data["serviceName"] = this.serviceName;
        data["serviceId"] = this.serviceId;
        data["serviceNumber"] = this.serviceNumber;
        data["serviceLatitude"] = this.serviceLatitude;
        data["serviceLongitude"] = this.serviceLongitude;
        data["serviceType"] = this.serviceType;
        data["serviceTypeName"] = this.serviceTypeName;
        data["areaName"] = this.areaName;
        data["areaId"] = this.areaId;
        data["regionName"] = this.regionName;
        data["regionId"] = this.regionId;
        data["address"] = this.address;
        data["meterNumber"] = this.meterNumber;
        data["meterMake"] = this.meterMake;
        data["meterMakeName"] = this.meterMakeName;
        data["meterType"] = this.meterType;
        data["meterModel"] = this.meterModel;
        data["meterModelName"] = this.meterModelName;
        data["previousMeterModel"] = this.previousMeterModel;
        data["previousMeterModelName"] = this.previousMeterModelName;
        data["firmwareVersion"] = this.firmwareVersion;
        data["cellularSimSerialNumber"] = this.cellularSimSerialNumber;
        data["meterIp"] = this.meterIp;
        data["meterPort"] = this.meterPort;
        data["dataCollectionInterval"] = this.dataCollectionInterval;
        data["meterTimeZone"] = this.meterTimeZone;
        data["meterManufactureDate"] = this.meterManufactureDate ? this.meterManufactureDate.toISOString() : <any>undefined;
        data["meterInstallationDate"] = this.meterInstallationDate ? this.meterInstallationDate.toISOString() : <any>undefined;
        data["meterCreationDate"] = this.meterCreationDate ? this.meterCreationDate.toISOString() : <any>undefined;
        data["lastUpdateTime"] = this.lastUpdateTime ? this.lastUpdateTime.toISOString() : <any>undefined;
        data["lastSmsWakeTime"] = this.lastSmsWakeTime ? this.lastSmsWakeTime.toISOString() : <any>undefined;
        data["password"] = this.password;
        data["newPassword"] = this.newPassword;
        data["blockCipherKey"] = this.blockCipherKey;
        data["authenticationKey"] = this.authenticationKey;
        data["clockTolerance"] = this.clockTolerance;
        data["status"] = this.status;
        data["connection"] = this.connection;
        data["ipSecConnector"] = this.ipSecConnector;
        data["gsmProvider"] = this.gsmProvider;
        data["currentTransformerRatio"] = this.currentTransformerRatio ? this.currentTransformerRatio.toJSON() : <any>undefined;
        data["voltageTransformerRatio"] = this.voltageTransformerRatio ? this.voltageTransformerRatio.toJSON() : <any>undefined;
        data["firmwareUpdateStatus"] = this.firmwareUpdateStatus ? this.firmwareUpdateStatus.toJSON() : <any>undefined;
        data["enableMeterModelEdit"] = this.enableMeterModelEdit;
        data["currentVersion"] = this.currentVersion;
        data["nextVersion"] = this.nextVersion;
        data["nextMeterModelName"] = this.nextMeterModelName;
        data["nextFirmwareVersion"] = this.nextFirmwareVersion;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditMeterDataIn {
    id: string;
    /** Enum type field indicates the type of asset to which the meter is connected. */
    assetType: string;
    assetTypeName: string | undefined;
    /** String type field indicates the name of asset to which the meter is connected. */
    serviceName: string | undefined;
    serviceId: string;
    /** Null or string type field indicates the serial number of asset to which the meter is connected. */
    serviceNumber?: string | undefined;
    /** Double type field indicates the latitude of asset to which the meter is connected. */
    serviceLatitude?: number | undefined;
    /** Double type field indicates the longitude of asset to which the meter is connected. */
    serviceLongitude?: number | undefined;
    /** Null or string type field indicates the service type of asset to which the meter is connected. */
    serviceType?: string | undefined;
    serviceTypeName?: string | undefined;
    /** The string type field indicates the area where the device is located. */
    areaName?: string | undefined;
    areaId: string;
    /** The string type field indicates the region where the device is located. */
    regionName?: string | undefined;
    regionId: string;
    /** String type field indicates the physical address of device. */
    address: string | undefined;
    /** String type field indicates the unique number of device. */
    meterNumber: string | undefined;
    /** The Guid type field indicates the manufacturer of device. */
    meterMake: string;
    meterMakeName?: string | undefined;
    meterType: MeterType;
    /** String type field indicates the model of device. */
    meterModel: string;
    meterModelName: string | undefined;
    /** String type field indicates the previous model of device before a firmware update. */
    previousMeterModel?: string | undefined;
    previousMeterModelName?: string | undefined;
    /** String type field indicates the firmware version of device. */
    firmwareVersion: string | undefined;
    /** String type field indicates serial number of SIM card in device. */
    cellularSimSerialNumber: string | undefined;
    /** String type field indicates ip address of meter in our network. */
    meterIp: string | undefined;
    /** Integer type field indicates port of meter on MeterIp. */
    meterPort: number;
    /** Integer type field indicates period (in minutes)  during which data is collected by the meter. */
    dataCollectionInterval: number;
    /** Integer type field indicates time zone (in minutes ) of meter. */
    meterTimeZone: number;
    /** The DateTime type field indicates time when manufacture made the device. */
    meterManufactureDate?: Date | undefined;
    /** The DateTime type field indicates time when device was installed on the asset. */
    meterInstallationDate: Date;
    /** The DateTime type field indicates time when device was created. */
    meterCreationDate?: Date | undefined;
    /** Timestamp of the device's last update. */
    lastUpdateTime?: Date | undefined;
    /** Timestamp of the device's last wake SMS message. */
    lastSmsWakeTime?: Date | undefined;
    /** String type field indicates password of device. */
    password?: string | undefined;
    /** String type field indicates new low level association password. */
    newPassword?: string | undefined;
    /** String type field, indicates the block cipher key used for encrypting data from the device. */
    blockCipherKey?: string | undefined;
    /** String type field, indicates the authentication key used to authenticate the device within the system. */
    authenticationKey?: string | undefined;
    clockTolerance?: number | undefined;
    /** Represents the action performed on the device, indicating whether the device is connected or disconnected. */
    status?: string | undefined;
    /** Represents whether the device is available, whether it is online or not, whether it has some other problem */
    connection?: string | undefined;
    /** Shows the current IpSec connector if any */
    ipSecConnector?: string | undefined;
    gsmProvider: GsmProviders;
    currentTransformerRatio?: RatioDataIn;
    voltageTransformerRatio?: RatioDataIn;
    firmwareUpdateStatus?: FirmwareUpdateCommandStatusDataOut;
    enableMeterModelEdit: boolean;
    currentVersion?: number | undefined;
    nextVersion?: number | undefined;
    /** Model and firmware of the next setup version to be applied, which can differ from the current MeterModelName/FirmwareVersion. */
    nextMeterModelName?: string | undefined;
    nextFirmwareVersion?: string | undefined;
    parentId?: string | undefined;
    parent?: ParentMeterDataOut;
}

export class EnergyBufferDataOut implements IEnergyBufferDataOut {
    ingestionTime!: Date;
    meterTime!: Date;
    meterNumber!: string | undefined;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    absoluteActiveEnergy?: number | undefined;

    constructor(data?: IEnergyBufferDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.activeEnergyImport = _data["activeEnergyImport"];
            this.activeEnergyExport = _data["activeEnergyExport"];
            this.reactiveEnergyImport = _data["reactiveEnergyImport"];
            this.reactiveEnergyExport = _data["reactiveEnergyExport"];
            this.apparentEnergyImport = _data["apparentEnergyImport"];
            this.apparentEnergyExport = _data["apparentEnergyExport"];
            this.absoluteActiveEnergy = _data["absoluteActiveEnergy"];
        }
    }

    static fromJS(data: any): EnergyBufferDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyBufferDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["activeEnergyImport"] = this.activeEnergyImport;
        data["activeEnergyExport"] = this.activeEnergyExport;
        data["reactiveEnergyImport"] = this.reactiveEnergyImport;
        data["reactiveEnergyExport"] = this.reactiveEnergyExport;
        data["apparentEnergyImport"] = this.apparentEnergyImport;
        data["apparentEnergyExport"] = this.apparentEnergyExport;
        data["absoluteActiveEnergy"] = this.absoluteActiveEnergy;
        return data;
    }
}

export interface IEnergyBufferDataOut {
    ingestionTime: Date;
    meterTime: Date;
    meterNumber: string | undefined;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    absoluteActiveEnergy?: number | undefined;
}

export class EnergyBufferDataOutPaginationDataOut implements IEnergyBufferDataOutPaginationDataOut {
    count!: number;
    data!: EnergyBufferDataOut[] | undefined;

    constructor(data?: IEnergyBufferDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnergyBufferDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnergyBufferDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyBufferDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEnergyBufferDataOutPaginationDataOut {
    count: number;
    data: EnergyBufferDataOut[] | undefined;
}

export class EnergyPerPhaseDataOut implements IEnergyPerPhaseDataOut {
    ingestionTime!: Date;
    meterTime!: Date;
    meterNumber!: string | undefined;
    l1ActiveEnergyImport?: number | undefined;
    l1ActiveEnergyExport?: number | undefined;
    l2ActiveEnergyImport?: number | undefined;
    l2ActiveEnergyExport?: number | undefined;
    l3ActiveEnergyImport?: number | undefined;
    l3ActiveEnergyExport?: number | undefined;
    l1ReactiveEnergyImport?: number | undefined;
    l1ReactiveEnergyExport?: number | undefined;
    l2ReactiveEnergyImport?: number | undefined;
    l2ReactiveEnergyExport?: number | undefined;
    l3ReactiveEnergyImport?: number | undefined;
    l3ReactiveEnergyExport?: number | undefined;
    l1ApparentEnergyImport?: number | undefined;
    l1ApparentEnergyExport?: number | undefined;
    l2ApparentEnergyImport?: number | undefined;
    l2ApparentEnergyExport?: number | undefined;
    l3ApparentEnergyImport?: number | undefined;
    l3ApparentEnergyExport?: number | undefined;

    constructor(data?: IEnergyPerPhaseDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.l1ActiveEnergyImport = _data["l1ActiveEnergyImport"];
            this.l1ActiveEnergyExport = _data["l1ActiveEnergyExport"];
            this.l2ActiveEnergyImport = _data["l2ActiveEnergyImport"];
            this.l2ActiveEnergyExport = _data["l2ActiveEnergyExport"];
            this.l3ActiveEnergyImport = _data["l3ActiveEnergyImport"];
            this.l3ActiveEnergyExport = _data["l3ActiveEnergyExport"];
            this.l1ReactiveEnergyImport = _data["l1ReactiveEnergyImport"];
            this.l1ReactiveEnergyExport = _data["l1ReactiveEnergyExport"];
            this.l2ReactiveEnergyImport = _data["l2ReactiveEnergyImport"];
            this.l2ReactiveEnergyExport = _data["l2ReactiveEnergyExport"];
            this.l3ReactiveEnergyImport = _data["l3ReactiveEnergyImport"];
            this.l3ReactiveEnergyExport = _data["l3ReactiveEnergyExport"];
            this.l1ApparentEnergyImport = _data["l1ApparentEnergyImport"];
            this.l1ApparentEnergyExport = _data["l1ApparentEnergyExport"];
            this.l2ApparentEnergyImport = _data["l2ApparentEnergyImport"];
            this.l2ApparentEnergyExport = _data["l2ApparentEnergyExport"];
            this.l3ApparentEnergyImport = _data["l3ApparentEnergyImport"];
            this.l3ApparentEnergyExport = _data["l3ApparentEnergyExport"];
        }
    }

    static fromJS(data: any): EnergyPerPhaseDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyPerPhaseDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["l1ActiveEnergyImport"] = this.l1ActiveEnergyImport;
        data["l1ActiveEnergyExport"] = this.l1ActiveEnergyExport;
        data["l2ActiveEnergyImport"] = this.l2ActiveEnergyImport;
        data["l2ActiveEnergyExport"] = this.l2ActiveEnergyExport;
        data["l3ActiveEnergyImport"] = this.l3ActiveEnergyImport;
        data["l3ActiveEnergyExport"] = this.l3ActiveEnergyExport;
        data["l1ReactiveEnergyImport"] = this.l1ReactiveEnergyImport;
        data["l1ReactiveEnergyExport"] = this.l1ReactiveEnergyExport;
        data["l2ReactiveEnergyImport"] = this.l2ReactiveEnergyImport;
        data["l2ReactiveEnergyExport"] = this.l2ReactiveEnergyExport;
        data["l3ReactiveEnergyImport"] = this.l3ReactiveEnergyImport;
        data["l3ReactiveEnergyExport"] = this.l3ReactiveEnergyExport;
        data["l1ApparentEnergyImport"] = this.l1ApparentEnergyImport;
        data["l1ApparentEnergyExport"] = this.l1ApparentEnergyExport;
        data["l2ApparentEnergyImport"] = this.l2ApparentEnergyImport;
        data["l2ApparentEnergyExport"] = this.l2ApparentEnergyExport;
        data["l3ApparentEnergyImport"] = this.l3ApparentEnergyImport;
        data["l3ApparentEnergyExport"] = this.l3ApparentEnergyExport;
        return data;
    }
}

export interface IEnergyPerPhaseDataOut {
    ingestionTime: Date;
    meterTime: Date;
    meterNumber: string | undefined;
    l1ActiveEnergyImport?: number | undefined;
    l1ActiveEnergyExport?: number | undefined;
    l2ActiveEnergyImport?: number | undefined;
    l2ActiveEnergyExport?: number | undefined;
    l3ActiveEnergyImport?: number | undefined;
    l3ActiveEnergyExport?: number | undefined;
    l1ReactiveEnergyImport?: number | undefined;
    l1ReactiveEnergyExport?: number | undefined;
    l2ReactiveEnergyImport?: number | undefined;
    l2ReactiveEnergyExport?: number | undefined;
    l3ReactiveEnergyImport?: number | undefined;
    l3ReactiveEnergyExport?: number | undefined;
    l1ApparentEnergyImport?: number | undefined;
    l1ApparentEnergyExport?: number | undefined;
    l2ApparentEnergyImport?: number | undefined;
    l2ApparentEnergyExport?: number | undefined;
    l3ApparentEnergyImport?: number | undefined;
    l3ApparentEnergyExport?: number | undefined;
}

export class EnergyPerPhaseDataOutPaginationDataOut implements IEnergyPerPhaseDataOutPaginationDataOut {
    count!: number;
    data!: EnergyPerPhaseDataOut[] | undefined;

    constructor(data?: IEnergyPerPhaseDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnergyPerPhaseDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnergyPerPhaseDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyPerPhaseDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEnergyPerPhaseDataOutPaginationDataOut {
    count: number;
    data: EnergyPerPhaseDataOut[] | undefined;
}

export class EnergyReadDataOut implements IEnergyReadDataOut {
    meterTime!: Date;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    absoluteActiveEnergy?: number | undefined;

    constructor(data?: IEnergyReadDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.activeEnergyImport = _data["activeEnergyImport"];
            this.activeEnergyExport = _data["activeEnergyExport"];
            this.reactiveEnergyImport = _data["reactiveEnergyImport"];
            this.reactiveEnergyExport = _data["reactiveEnergyExport"];
            this.apparentEnergyImport = _data["apparentEnergyImport"];
            this.apparentEnergyExport = _data["apparentEnergyExport"];
            this.absoluteActiveEnergy = _data["absoluteActiveEnergy"];
        }
    }

    static fromJS(data: any): EnergyReadDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EnergyReadDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["activeEnergyImport"] = this.activeEnergyImport;
        data["activeEnergyExport"] = this.activeEnergyExport;
        data["reactiveEnergyImport"] = this.reactiveEnergyImport;
        data["reactiveEnergyExport"] = this.reactiveEnergyExport;
        data["apparentEnergyImport"] = this.apparentEnergyImport;
        data["apparentEnergyExport"] = this.apparentEnergyExport;
        data["absoluteActiveEnergy"] = this.absoluteActiveEnergy;
        return data;
    }
}

export interface IEnergyReadDataOut {
    meterTime: Date;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    absoluteActiveEnergy?: number | undefined;
}

/** The event a register reports when it carries a given value. */
export class EventCodeMappingDto implements IEventCodeMappingDto {
    id!: string;
    attribute!: DlmsAttributes;
    value!: number;
    eventCodeId!: string;
    eventCodeName!: string | undefined;
    eventCodeDescription?: string | undefined;

    constructor(data?: IEventCodeMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attribute = _data["attribute"];
            this.value = _data["value"];
            this.eventCodeId = _data["eventCodeId"];
            this.eventCodeName = _data["eventCodeName"];
            this.eventCodeDescription = _data["eventCodeDescription"];
        }
    }

    static fromJS(data: any): EventCodeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventCodeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attribute"] = this.attribute;
        data["value"] = this.value;
        data["eventCodeId"] = this.eventCodeId;
        data["eventCodeName"] = this.eventCodeName;
        data["eventCodeDescription"] = this.eventCodeDescription;
        return data;
    }
}

/** The event a register reports when it carries a given value. */
export interface IEventCodeMappingDto {
    id: string;
    attribute: DlmsAttributes;
    value: number;
    eventCodeId: string;
    eventCodeName: string | undefined;
    eventCodeDescription?: string | undefined;
}

export enum EventDataChannel {
    GeneralData = "GeneralData",
    OnConnect = "OnConnect",
    OnAlarm = "OnAlarm",
    OnPowerDown = "OnPowerDown",
    ScheduledLoadProfile1 = "ScheduledLoadProfile1",
    OnInstallation = "OnInstallation",
    ScheduledLoadProfile2 = "ScheduledLoadProfile2",
    ScheduledLoadProfile3 = "ScheduledLoadProfile3",
}

export class EventDataOut implements IEventDataOut {
    id!: string;
    meterNo!: string | undefined;
    assetType?: string | undefined;
    readOnMeterTime!: Date;
    ingestionTime!: Date;
    channelId?: EventDataChannel;

    constructor(data?: IEventDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNo = _data["meterNo"];
            this.assetType = _data["assetType"];
            this.readOnMeterTime = _data["readOnMeterTime"] ? new Date(_data["readOnMeterTime"].toString()) : <any>undefined;
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
        }
    }

    static fromJS(data: any): EventDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EventDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNo"] = this.meterNo;
        data["assetType"] = this.assetType;
        data["readOnMeterTime"] = this.readOnMeterTime ? this.readOnMeterTime.toISOString() : <any>undefined;
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        return data;
    }
}

export interface IEventDataOut {
    id: string;
    meterNo: string | undefined;
    assetType?: string | undefined;
    readOnMeterTime: Date;
    ingestionTime: Date;
    channelId?: EventDataChannel;
}

export class EventDataOutPaginationDataOut implements IEventDataOutPaginationDataOut {
    count!: number;
    data!: EventDataOut[] | undefined;

    constructor(data?: IEventDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EventDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EventDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEventDataOutPaginationDataOut {
    count: number;
    data: EventDataOut[] | undefined;
}

export class EventLogDetailsDataIn implements IEventLogDetailsDataIn {
    commandId!: string;
    pageInfo!: PageInfo;
    /** Event log to page, 1 to 6. The logs are filled independently, so only one is read at a time. */
    eventLogNumber!: number;

    constructor(data?: IEventLogDetailsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandId = _data["commandId"];
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.eventLogNumber = _data["eventLogNumber"];
        }
    }

    static fromJS(data: any): EventLogDetailsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new EventLogDetailsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["eventLogNumber"] = this.eventLogNumber;
        return data;
    }
}

export interface IEventLogDetailsDataIn {
    commandId: string;
    pageInfo: PageInfo;
    /** Event log to page, 1 to 6. The logs are filled independently, so only one is read at a time. */
    eventLogNumber: number;
}

/** One entry of one event log, with the event its value stands for on this meter model. */
export class EventLogEntryDataOut implements IEventLogEntryDataOut {
    ingestionTime!: Date;
    meterNumber!: string | undefined;
    /** Meter clock time the event was logged at */
    time!: Date;
    /** Value as read from the meter */
    eventCode!: number;
    /** Event the value is mapped to, empty when the value has no mapping yet */
    eventName?: string | undefined;

    constructor(data?: IEventLogEntryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.eventCode = _data["eventCode"];
            this.eventName = _data["eventName"];
        }
    }

    static fromJS(data: any): EventLogEntryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EventLogEntryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["eventCode"] = this.eventCode;
        data["eventName"] = this.eventName;
        return data;
    }
}

/** One entry of one event log, with the event its value stands for on this meter model. */
export interface IEventLogEntryDataOut {
    ingestionTime: Date;
    meterNumber: string | undefined;
    /** Meter clock time the event was logged at */
    time: Date;
    /** Value as read from the meter */
    eventCode: number;
    /** Event the value is mapped to, empty when the value has no mapping yet */
    eventName?: string | undefined;
}

export class EventLogEntryDataOutPaginationDataOut implements IEventLogEntryDataOutPaginationDataOut {
    count!: number;
    data!: EventLogEntryDataOut[] | undefined;

    constructor(data?: IEventLogEntryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EventLogEntryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventLogEntryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new EventLogEntryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEventLogEntryDataOutPaginationDataOut {
    count: number;
    data: EventLogEntryDataOut[] | undefined;
}

export class EventLogLabelsDataIn implements IEventLogLabelsDataIn {
    meterModelId!: string;
    /** One name per event log, by log number. An empty entry keeps the default name. */
    labels!: string[] | undefined;

    constructor(data?: IEventLogLabelsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterModelId = _data["meterModelId"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): EventLogLabelsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new EventLogLabelsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterModelId"] = this.meterModelId;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data;
    }
}

export interface IEventLogLabelsDataIn {
    meterModelId: string;
    /** One name per event log, by log number. An empty entry keeps the default name. */
    labels: string[] | undefined;
}

export class EventQueryDataIn implements IEventQueryDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes!: string[] | undefined;
    channelIds!: EventDataChannel[] | undefined;

    constructor(data?: IEventQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EventQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new EventQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        return data;
    }
}

export interface IEventQueryDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes: string[] | undefined;
    channelIds: EventDataChannel[] | undefined;
}

export class EventValues implements IEventValues {
    name!: string | undefined;
    count!: number;

    constructor(data?: IEventValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): EventValues {
        data = typeof data === 'object' ? data : {};
        let result = new EventValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface IEventValues {
    name: string | undefined;
    count: number;
}

export class ExternalTokenDataIn implements IExternalTokenDataIn {
    /** Allowed values: Credit, ClearCredit, ClearTamper, KeyChange */
    type!: ExternalTokenDataInType | undefined;
    value!: string | undefined;

    constructor(data?: IExternalTokenDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExternalTokenDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTokenDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IExternalTokenDataIn {
    /** Allowed values: Credit, ClearCredit, ClearTamper, KeyChange */
    type: ExternalTokenDataInType | undefined;
    value: string | undefined;
}

export enum FileStatus {
    NotProcessed = "NotProcessed",
    Processing = "Processing",
    Processed = "Processed",
    Failed = "Failed",
}

export enum FileType {
    DeviceImport = "DeviceImport",
    UserImport = "UserImport",
    VersionImport = "VersionImport",
    UtilityLogo = "UtilityLogo",
    FirmwareBinaryImport = "FirmwareBinaryImport",
    TokenImport = "TokenImport",
    EventCodeImport = "EventCodeImport",
}

export class FirmwareUpdateByLocationDataIn implements IFirmwareUpdateByLocationDataIn {
    regions!: string[] | undefined;
    areas!: string[] | undefined;
    meterModelId!: string;
    targetMeterModelId!: string;
    deferredTaskTime?: Date | undefined;
    maxRetryCount!: number;

    constructor(data?: IFirmwareUpdateByLocationDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            this.meterModelId = _data["meterModelId"];
            this.targetMeterModelId = _data["targetMeterModelId"];
            this.deferredTaskTime = _data["deferredTaskTime"] ? new Date(_data["deferredTaskTime"].toString()) : <any>undefined;
            this.maxRetryCount = _data["maxRetryCount"];
        }
    }

    static fromJS(data: any): FirmwareUpdateByLocationDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateByLocationDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        data["meterModelId"] = this.meterModelId;
        data["targetMeterModelId"] = this.targetMeterModelId;
        data["deferredTaskTime"] = this.deferredTaskTime ? this.deferredTaskTime.toISOString() : <any>undefined;
        data["maxRetryCount"] = this.maxRetryCount;
        return data;
    }
}

export interface IFirmwareUpdateByLocationDataIn {
    regions: string[] | undefined;
    areas: string[] | undefined;
    meterModelId: string;
    targetMeterModelId: string;
    deferredTaskTime?: Date | undefined;
    maxRetryCount: number;
}

export class FirmwareUpdateCommandDataOut implements IFirmwareUpdateCommandDataOut {
    id!: string;
    status!: CommandStatus;
    startTime!: Date;
    endTime?: Date | undefined;
    data?: FirmwareUpdateCommandStatusDataOut;
    meter!: FirmwareUpdateCommandMeterDataOut;

    constructor(data?: IFirmwareUpdateCommandDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.meter = new FirmwareUpdateCommandMeterDataOut();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.data = _data["data"] ? FirmwareUpdateCommandStatusDataOut.fromJS(_data["data"]) : <any>undefined;
            this.meter = _data["meter"] ? FirmwareUpdateCommandMeterDataOut.fromJS(_data["meter"]) : new FirmwareUpdateCommandMeterDataOut();
        }
    }

    static fromJS(data: any): FirmwareUpdateCommandDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateCommandDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["meter"] = this.meter ? this.meter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFirmwareUpdateCommandDataOut {
    id: string;
    status: CommandStatus;
    startTime: Date;
    endTime?: Date | undefined;
    data?: FirmwareUpdateCommandStatusDataOut;
    meter: FirmwareUpdateCommandMeterDataOut;
}

export class FirmwareUpdateCommandDataOutPaginationDataOut implements IFirmwareUpdateCommandDataOutPaginationDataOut {
    count!: number;
    data!: FirmwareUpdateCommandDataOut[] | undefined;

    constructor(data?: IFirmwareUpdateCommandDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FirmwareUpdateCommandDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FirmwareUpdateCommandDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateCommandDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IFirmwareUpdateCommandDataOutPaginationDataOut {
    count: number;
    data: FirmwareUpdateCommandDataOut[] | undefined;
}

export class FirmwareUpdateCommandMeterDataOut implements IFirmwareUpdateCommandMeterDataOut {
    meterId!: string;
    meterNumber!: string | undefined;
    meterType!: string | undefined;
    meterModel!: string | undefined;
    assetType!: string | undefined;
    meterMake!: string | undefined;
    assetName!: string | undefined;
    areaId!: string;
    areaName?: string | undefined;
    regionName?: string | undefined;

    constructor(data?: IFirmwareUpdateCommandMeterDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterId = _data["meterId"];
            this.meterNumber = _data["meterNumber"];
            this.meterType = _data["meterType"];
            this.meterModel = _data["meterModel"];
            this.assetType = _data["assetType"];
            this.meterMake = _data["meterMake"];
            this.assetName = _data["assetName"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.regionName = _data["regionName"];
        }
    }

    static fromJS(data: any): FirmwareUpdateCommandMeterDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateCommandMeterDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterId"] = this.meterId;
        data["meterNumber"] = this.meterNumber;
        data["meterType"] = this.meterType;
        data["meterModel"] = this.meterModel;
        data["assetType"] = this.assetType;
        data["meterMake"] = this.meterMake;
        data["assetName"] = this.assetName;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["regionName"] = this.regionName;
        return data;
    }
}

export interface IFirmwareUpdateCommandMeterDataOut {
    meterId: string;
    meterNumber: string | undefined;
    meterType: string | undefined;
    meterModel: string | undefined;
    assetType: string | undefined;
    meterMake: string | undefined;
    assetName: string | undefined;
    areaId: string;
    areaName?: string | undefined;
    regionName?: string | undefined;
}

export class FirmwareUpdateCommandStatusDataOut implements IFirmwareUpdateCommandStatusDataOut {
    error?: ResponseError;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    status!: CommandStatus;
    id!: string;
    meterId!: string;
    steps!: string[] | undefined;
    retryCount!: number;
    maxRetryCount!: number;
    currentStepPercentage?: number | undefined;
    firmwareIdentifier?: string | undefined;
    newMeterModelName?: string | undefined;

    constructor(data?: IFirmwareUpdateCommandStatusDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? ResponseError.fromJS(_data["error"]) : <any>undefined;
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.id = _data["id"];
            this.meterId = _data["meterId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(item);
            }
            this.retryCount = _data["retryCount"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.currentStepPercentage = _data["currentStepPercentage"];
            this.firmwareIdentifier = _data["firmwareIdentifier"];
            this.newMeterModelName = _data["newMeterModelName"];
        }
    }

    static fromJS(data: any): FirmwareUpdateCommandStatusDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateCommandStatusDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        data["meterId"] = this.meterId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        data["retryCount"] = this.retryCount;
        data["maxRetryCount"] = this.maxRetryCount;
        data["currentStepPercentage"] = this.currentStepPercentage;
        data["firmwareIdentifier"] = this.firmwareIdentifier;
        data["newMeterModelName"] = this.newMeterModelName;
        return data;
    }
}

export interface IFirmwareUpdateCommandStatusDataOut {
    error?: ResponseError;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    status: CommandStatus;
    id: string;
    meterId: string;
    steps: string[] | undefined;
    retryCount: number;
    maxRetryCount: number;
    currentStepPercentage?: number | undefined;
    firmwareIdentifier?: string | undefined;
    newMeterModelName?: string | undefined;
}

export class FirmwareUpdateGroupCommandsQuery implements IFirmwareUpdateGroupCommandsQuery {
    pageInfo!: PageInfo;
    firmwareUpdateGroupId!: string;
    assetTypeIds?: string[] | undefined;
    areas?: string[] | undefined;
    regions?: string[] | undefined;
    statuses?: CommandStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IFirmwareUpdateGroupCommandsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.firmwareUpdateGroupId = _data["firmwareUpdateGroupId"];
            if (Array.isArray(_data["assetTypeIds"])) {
                this.assetTypeIds = [] as any;
                for (let item of _data["assetTypeIds"])
                    this.assetTypeIds!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupCommandsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupCommandsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["firmwareUpdateGroupId"] = this.firmwareUpdateGroupId;
        if (Array.isArray(this.assetTypeIds)) {
            data["assetTypeIds"] = [];
            for (let item of this.assetTypeIds)
                data["assetTypeIds"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFirmwareUpdateGroupCommandsQuery {
    pageInfo: PageInfo;
    firmwareUpdateGroupId: string;
    assetTypeIds?: string[] | undefined;
    areas?: string[] | undefined;
    regions?: string[] | undefined;
    statuses?: CommandStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    search?: string | undefined;
    sorting?: SortingType;
}

export class FirmwareUpdateGroupDataOut implements IFirmwareUpdateGroupDataOut {
    id!: string;
    createdAt!: Date;
    scheduledTime!: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    commands!: FirmwareUpdateCommandDataOut[] | undefined;

    constructor(data?: IFirmwareUpdateGroupDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.scheduledTime = _data["scheduledTime"] ? new Date(_data["scheduledTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["commands"])) {
                this.commands = [] as any;
                for (let item of _data["commands"])
                    this.commands!.push(FirmwareUpdateCommandDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (Array.isArray(this.commands)) {
            data["commands"] = [];
            for (let item of this.commands)
                data["commands"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IFirmwareUpdateGroupDataOut {
    id: string;
    createdAt: Date;
    scheduledTime: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    commands: FirmwareUpdateCommandDataOut[] | undefined;
}

export class FirmwareUpdateGroupForMetersQuery implements IFirmwareUpdateGroupForMetersQuery {
    meterIds!: string[] | undefined;

    constructor(data?: IFirmwareUpdateGroupForMetersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["meterIds"])) {
                this.meterIds = [] as any;
                for (let item of _data["meterIds"])
                    this.meterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupForMetersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupForMetersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.meterIds)) {
            data["meterIds"] = [];
            for (let item of this.meterIds)
                data["meterIds"].push(item);
        }
        return data;
    }
}

export interface IFirmwareUpdateGroupForMetersQuery {
    meterIds: string[] | undefined;
}

export enum FirmwareUpdateGroupStatus {
    Scheduled = "Scheduled",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
    Deactivated = "Deactivated",
    Aborted = "Aborted",
}

export class FirmwareUpdateGroupSummaryDataOut implements IFirmwareUpdateGroupSummaryDataOut {
    id!: string;
    createdAt!: Date;
    scheduledTime!: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status!: FirmwareUpdateGroupStatus;
    firmwareVersion!: FirmwareUpdateGroupSummaryFirmwareVersionDataOut;
    pendingCommandsCount!: number;
    inProgressCommandsCount!: number;
    successfulCommandsCount!: number;
    failedCommandsCount!: number;
    abortedCommandsCount!: number;

    constructor(data?: IFirmwareUpdateGroupSummaryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firmwareVersion = new FirmwareUpdateGroupSummaryFirmwareVersionDataOut();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.scheduledTime = _data["scheduledTime"] ? new Date(_data["scheduledTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.firmwareVersion = _data["firmwareVersion"] ? FirmwareUpdateGroupSummaryFirmwareVersionDataOut.fromJS(_data["firmwareVersion"]) : new FirmwareUpdateGroupSummaryFirmwareVersionDataOut();
            this.pendingCommandsCount = _data["pendingCommandsCount"];
            this.inProgressCommandsCount = _data["inProgressCommandsCount"];
            this.successfulCommandsCount = _data["successfulCommandsCount"];
            this.failedCommandsCount = _data["failedCommandsCount"];
            this.abortedCommandsCount = _data["abortedCommandsCount"];
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupSummaryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupSummaryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["firmwareVersion"] = this.firmwareVersion ? this.firmwareVersion.toJSON() : <any>undefined;
        data["pendingCommandsCount"] = this.pendingCommandsCount;
        data["inProgressCommandsCount"] = this.inProgressCommandsCount;
        data["successfulCommandsCount"] = this.successfulCommandsCount;
        data["failedCommandsCount"] = this.failedCommandsCount;
        data["abortedCommandsCount"] = this.abortedCommandsCount;
        return data;
    }
}

export interface IFirmwareUpdateGroupSummaryDataOut {
    id: string;
    createdAt: Date;
    scheduledTime: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status: FirmwareUpdateGroupStatus;
    firmwareVersion: FirmwareUpdateGroupSummaryFirmwareVersionDataOut;
    pendingCommandsCount: number;
    inProgressCommandsCount: number;
    successfulCommandsCount: number;
    failedCommandsCount: number;
    abortedCommandsCount: number;
}

export class FirmwareUpdateGroupSummaryDataOutPaginationDataOut implements IFirmwareUpdateGroupSummaryDataOutPaginationDataOut {
    count!: number;
    data!: FirmwareUpdateGroupSummaryDataOut[] | undefined;

    constructor(data?: IFirmwareUpdateGroupSummaryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FirmwareUpdateGroupSummaryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupSummaryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupSummaryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IFirmwareUpdateGroupSummaryDataOutPaginationDataOut {
    count: number;
    data: FirmwareUpdateGroupSummaryDataOut[] | undefined;
}

export class FirmwareUpdateGroupSummaryFirmwareVersionDataOut implements IFirmwareUpdateGroupSummaryFirmwareVersionDataOut {
    meterMake!: string | undefined;
    meterModel!: string | undefined;
    firmwareFileName!: string | undefined;

    constructor(data?: IFirmwareUpdateGroupSummaryFirmwareVersionDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterMake = _data["meterMake"];
            this.meterModel = _data["meterModel"];
            this.firmwareFileName = _data["firmwareFileName"];
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupSummaryFirmwareVersionDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupSummaryFirmwareVersionDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterMake"] = this.meterMake;
        data["meterModel"] = this.meterModel;
        data["firmwareFileName"] = this.firmwareFileName;
        return data;
    }
}

export interface IFirmwareUpdateGroupSummaryFirmwareVersionDataOut {
    meterMake: string | undefined;
    meterModel: string | undefined;
    firmwareFileName: string | undefined;
}

export class FirmwareUpdateGroupsQuery implements IFirmwareUpdateGroupsQuery {
    pageInfo!: PageInfo;
    meterMakeIds?: string[] | undefined;
    meterModelIds?: string[] | undefined;
    scheduledStartTime?: Date | undefined;
    scheduledEndTime?: Date | undefined;
    statuses?: FirmwareUpdateGroupStatus[] | undefined;
    sorting?: SortingType;

    constructor(data?: IFirmwareUpdateGroupsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            if (Array.isArray(_data["meterMakeIds"])) {
                this.meterMakeIds = [] as any;
                for (let item of _data["meterMakeIds"])
                    this.meterMakeIds!.push(item);
            }
            if (Array.isArray(_data["meterModelIds"])) {
                this.meterModelIds = [] as any;
                for (let item of _data["meterModelIds"])
                    this.meterModelIds!.push(item);
            }
            this.scheduledStartTime = _data["scheduledStartTime"] ? new Date(_data["scheduledStartTime"].toString()) : <any>undefined;
            this.scheduledEndTime = _data["scheduledEndTime"] ? new Date(_data["scheduledEndTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FirmwareUpdateGroupsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateGroupsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.meterMakeIds)) {
            data["meterMakeIds"] = [];
            for (let item of this.meterMakeIds)
                data["meterMakeIds"].push(item);
        }
        if (Array.isArray(this.meterModelIds)) {
            data["meterModelIds"] = [];
            for (let item of this.meterModelIds)
                data["meterModelIds"].push(item);
        }
        data["scheduledStartTime"] = this.scheduledStartTime ? this.scheduledStartTime.toISOString() : <any>undefined;
        data["scheduledEndTime"] = this.scheduledEndTime ? this.scheduledEndTime.toISOString() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFirmwareUpdateGroupsQuery {
    pageInfo: PageInfo;
    meterMakeIds?: string[] | undefined;
    meterModelIds?: string[] | undefined;
    scheduledStartTime?: Date | undefined;
    scheduledEndTime?: Date | undefined;
    statuses?: FirmwareUpdateGroupStatus[] | undefined;
    sorting?: SortingType;
}

export class FirmwareUpdateStartDataIn implements IFirmwareUpdateStartDataIn {
    meterIds!: string[] | undefined;
    meterModelId!: string;
    deferredTaskTime?: Date | undefined;
    maxRetryCount!: number;

    constructor(data?: IFirmwareUpdateStartDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["meterIds"])) {
                this.meterIds = [] as any;
                for (let item of _data["meterIds"])
                    this.meterIds!.push(item);
            }
            this.meterModelId = _data["meterModelId"];
            this.deferredTaskTime = _data["deferredTaskTime"] ? new Date(_data["deferredTaskTime"].toString()) : <any>undefined;
            this.maxRetryCount = _data["maxRetryCount"];
        }
    }

    static fromJS(data: any): FirmwareUpdateStartDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareUpdateStartDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.meterIds)) {
            data["meterIds"] = [];
            for (let item of this.meterIds)
                data["meterIds"].push(item);
        }
        data["meterModelId"] = this.meterModelId;
        data["deferredTaskTime"] = this.deferredTaskTime ? this.deferredTaskTime.toISOString() : <any>undefined;
        data["maxRetryCount"] = this.maxRetryCount;
        return data;
    }
}

export interface IFirmwareUpdateStartDataIn {
    meterIds: string[] | undefined;
    meterModelId: string;
    deferredTaskTime?: Date | undefined;
    maxRetryCount: number;
}

export class FraudAlarmDataIn implements IFraudAlarmDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;

    constructor(data?: IFraudAlarmDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FraudAlarmDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new FraudAlarmDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFraudAlarmDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
}

export class FraudAlarmDataOut implements IFraudAlarmDataOut {
    meterNumber!: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    areaName!: string | undefined;
    areaId?: string | undefined;
    address!: string | undefined;
    alarmName!: string | undefined;
    alarmTimeDifference!: number;

    constructor(data?: IFraudAlarmDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.areaName = _data["areaName"];
            this.areaId = _data["areaId"];
            this.address = _data["address"];
            this.alarmName = _data["alarmName"];
            this.alarmTimeDifference = _data["alarmTimeDifference"];
        }
    }

    static fromJS(data: any): FraudAlarmDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FraudAlarmDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["areaName"] = this.areaName;
        data["areaId"] = this.areaId;
        data["address"] = this.address;
        data["alarmName"] = this.alarmName;
        data["alarmTimeDifference"] = this.alarmTimeDifference;
        return data;
    }
}

export interface IFraudAlarmDataOut {
    meterNumber: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    areaName: string | undefined;
    areaId?: string | undefined;
    address: string | undefined;
    alarmName: string | undefined;
    alarmTimeDifference: number;
}

export class FraudAlarmDataOutPaginationDataOut implements IFraudAlarmDataOutPaginationDataOut {
    count!: number;
    data!: FraudAlarmDataOut[] | undefined;

    constructor(data?: IFraudAlarmDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FraudAlarmDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FraudAlarmDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new FraudAlarmDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IFraudAlarmDataOutPaginationDataOut {
    count: number;
    data: FraudAlarmDataOut[] | undefined;
}

export enum GsmProviders {
    Onomondo = "Onomondo",
}

export class GuidDictionaryItem implements IGuidDictionaryItem {
    value!: string;
    name!: string | undefined;

    constructor(data?: IGuidDictionaryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GuidDictionaryItem {
        data = typeof data === 'object' ? data : {};
        let result = new GuidDictionaryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IGuidDictionaryItem {
    value: string;
    name: string | undefined;
}

export class GuidParentMeterDataOutDictionaryItem implements IGuidParentMeterDataOutDictionaryItem {
    key!: string;
    value?: ParentMeterDataOut;

    constructor(data?: IGuidParentMeterDataOutDictionaryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? ParentMeterDataOut.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GuidParentMeterDataOutDictionaryItem {
        data = typeof data === 'object' ? data : {};
        let result = new GuidParentMeterDataOutDictionaryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuidParentMeterDataOutDictionaryItem {
    key: string;
    value?: ParentMeterDataOut;
}

export class IndividualAlarmPageDataOut implements IIndividualAlarmPageDataOut {
    startEventId?: string | undefined;
    endEventId?: string | undefined;
    startCommandId?: string | undefined;
    endCommandId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    startSavedOnTime?: Date | undefined;
    endSavedOnTime?: Date | undefined;
    meterNumber!: string | undefined;
    assetType!: string | undefined;
    alarmType!: AlarmType;

    constructor(data?: IIndividualAlarmPageDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startEventId = _data["startEventId"];
            this.endEventId = _data["endEventId"];
            this.startCommandId = _data["startCommandId"];
            this.endCommandId = _data["endCommandId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.startSavedOnTime = _data["startSavedOnTime"] ? new Date(_data["startSavedOnTime"].toString()) : <any>undefined;
            this.endSavedOnTime = _data["endSavedOnTime"] ? new Date(_data["endSavedOnTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.assetType = _data["assetType"];
            this.alarmType = _data["alarmType"];
        }
    }

    static fromJS(data: any): IndividualAlarmPageDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualAlarmPageDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startEventId"] = this.startEventId;
        data["endEventId"] = this.endEventId;
        data["startCommandId"] = this.startCommandId;
        data["endCommandId"] = this.endCommandId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startSavedOnTime"] = this.startSavedOnTime ? this.startSavedOnTime.toISOString() : <any>undefined;
        data["endSavedOnTime"] = this.endSavedOnTime ? this.endSavedOnTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["assetType"] = this.assetType;
        data["alarmType"] = this.alarmType;
        return data;
    }
}

export interface IIndividualAlarmPageDataOut {
    startEventId?: string | undefined;
    endEventId?: string | undefined;
    startCommandId?: string | undefined;
    endCommandId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    startSavedOnTime?: Date | undefined;
    endSavedOnTime?: Date | undefined;
    meterNumber: string | undefined;
    assetType: string | undefined;
    alarmType: AlarmType;
}

export class IndividualAlarmPageDataOutPaginationDataOut implements IIndividualAlarmPageDataOutPaginationDataOut {
    count!: number;
    data!: IndividualAlarmPageDataOut[] | undefined;

    constructor(data?: IIndividualAlarmPageDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IndividualAlarmPageDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndividualAlarmPageDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualAlarmPageDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IIndividualAlarmPageDataOutPaginationDataOut {
    count: number;
    data: IndividualAlarmPageDataOut[] | undefined;
}

export class IndividualAlarmPageQueryDataIn implements IIndividualAlarmPageQueryDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes!: string[] | undefined;
    alarmTypes!: AlarmType[] | undefined;

    constructor(data?: IIndividualAlarmPageQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["alarmTypes"])) {
                this.alarmTypes = [] as any;
                for (let item of _data["alarmTypes"])
                    this.alarmTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): IndividualAlarmPageQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualAlarmPageQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.alarmTypes)) {
            data["alarmTypes"] = [];
            for (let item of this.alarmTypes)
                data["alarmTypes"].push(item);
        }
        return data;
    }
}

export interface IIndividualAlarmPageQueryDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes: string[] | undefined;
    alarmTypes: AlarmType[] | undefined;
}

export class InfoConnectDisconnectDataOut implements IInfoConnectDisconnectDataOut {
    assetType?: string | undefined;
    serviceName!: string | undefined;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status!: CommandStatus;
    action!: ConnectionStatus;
    reason?: string | undefined;
    id!: string;

    constructor(data?: IInfoConnectDisconnectDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.action = _data["action"];
            this.reason = _data["reason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InfoConnectDisconnectDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new InfoConnectDisconnectDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["action"] = this.action;
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    }
}

export interface IInfoConnectDisconnectDataOut {
    assetType?: string | undefined;
    serviceName: string | undefined;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status: CommandStatus;
    action: ConnectionStatus;
    reason?: string | undefined;
    id: string;
}

export class InstantaneousBufferDataOut implements IInstantaneousBufferDataOut {
    ingestionTime!: Date;
    meterTime!: Date;
    meterNumber!: string | undefined;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;
    averageCurrentL1?: number | undefined;
    averageCurrentL2?: number | undefined;
    averageCurrentL3?: number | undefined;
    averageVoltageL1?: number | undefined;
    averageVoltageL2?: number | undefined;
    averageVoltageL3?: number | undefined;

    constructor(data?: IInstantaneousBufferDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.instantaneousVoltageL1 = _data["instantaneousVoltageL1"];
            this.instantaneousVoltageL2 = _data["instantaneousVoltageL2"];
            this.instantaneousVoltageL3 = _data["instantaneousVoltageL3"];
            this.instantaneousCurrentL1 = _data["instantaneousCurrentL1"];
            this.instantaneousCurrentL2 = _data["instantaneousCurrentL2"];
            this.instantaneousCurrentL3 = _data["instantaneousCurrentL3"];
            this.instantaneousFrequency = _data["instantaneousFrequency"];
            this.instantaneousPowerFactorL1 = _data["instantaneousPowerFactorL1"];
            this.instantaneousPowerFactorL2 = _data["instantaneousPowerFactorL2"];
            this.instantaneousPowerFactorL3 = _data["instantaneousPowerFactorL3"];
            this.averageCurrentL1 = _data["averageCurrentL1"];
            this.averageCurrentL2 = _data["averageCurrentL2"];
            this.averageCurrentL3 = _data["averageCurrentL3"];
            this.averageVoltageL1 = _data["averageVoltageL1"];
            this.averageVoltageL2 = _data["averageVoltageL2"];
            this.averageVoltageL3 = _data["averageVoltageL3"];
        }
    }

    static fromJS(data: any): InstantaneousBufferDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new InstantaneousBufferDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["instantaneousVoltageL1"] = this.instantaneousVoltageL1;
        data["instantaneousVoltageL2"] = this.instantaneousVoltageL2;
        data["instantaneousVoltageL3"] = this.instantaneousVoltageL3;
        data["instantaneousCurrentL1"] = this.instantaneousCurrentL1;
        data["instantaneousCurrentL2"] = this.instantaneousCurrentL2;
        data["instantaneousCurrentL3"] = this.instantaneousCurrentL3;
        data["instantaneousFrequency"] = this.instantaneousFrequency;
        data["instantaneousPowerFactorL1"] = this.instantaneousPowerFactorL1;
        data["instantaneousPowerFactorL2"] = this.instantaneousPowerFactorL2;
        data["instantaneousPowerFactorL3"] = this.instantaneousPowerFactorL3;
        data["averageCurrentL1"] = this.averageCurrentL1;
        data["averageCurrentL2"] = this.averageCurrentL2;
        data["averageCurrentL3"] = this.averageCurrentL3;
        data["averageVoltageL1"] = this.averageVoltageL1;
        data["averageVoltageL2"] = this.averageVoltageL2;
        data["averageVoltageL3"] = this.averageVoltageL3;
        return data;
    }
}

export interface IInstantaneousBufferDataOut {
    ingestionTime: Date;
    meterTime: Date;
    meterNumber: string | undefined;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;
    averageCurrentL1?: number | undefined;
    averageCurrentL2?: number | undefined;
    averageCurrentL3?: number | undefined;
    averageVoltageL1?: number | undefined;
    averageVoltageL2?: number | undefined;
    averageVoltageL3?: number | undefined;
}

export class InstantaneousBufferDataOutPaginationDataOut implements IInstantaneousBufferDataOutPaginationDataOut {
    count!: number;
    data!: InstantaneousBufferDataOut[] | undefined;

    constructor(data?: IInstantaneousBufferDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InstantaneousBufferDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstantaneousBufferDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new InstantaneousBufferDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInstantaneousBufferDataOutPaginationDataOut {
    count: number;
    data: InstantaneousBufferDataOut[] | undefined;
}

export class InstantaneousObjectReadDataOut implements IInstantaneousObjectReadDataOut {
    meterTime!: Date;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;
    averageCurrentL1?: number | undefined;
    averageCurrentL2?: number | undefined;
    averageCurrentL3?: number | undefined;
    averageVoltageL1?: number | undefined;
    averageVoltageL2?: number | undefined;
    averageVoltageL3?: number | undefined;

    constructor(data?: IInstantaneousObjectReadDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.instantaneousVoltageL1 = _data["instantaneousVoltageL1"];
            this.instantaneousVoltageL2 = _data["instantaneousVoltageL2"];
            this.instantaneousVoltageL3 = _data["instantaneousVoltageL3"];
            this.instantaneousCurrentL1 = _data["instantaneousCurrentL1"];
            this.instantaneousCurrentL2 = _data["instantaneousCurrentL2"];
            this.instantaneousCurrentL3 = _data["instantaneousCurrentL3"];
            this.instantaneousFrequency = _data["instantaneousFrequency"];
            this.instantaneousPowerFactorL1 = _data["instantaneousPowerFactorL1"];
            this.instantaneousPowerFactorL2 = _data["instantaneousPowerFactorL2"];
            this.instantaneousPowerFactorL3 = _data["instantaneousPowerFactorL3"];
            this.averageCurrentL1 = _data["averageCurrentL1"];
            this.averageCurrentL2 = _data["averageCurrentL2"];
            this.averageCurrentL3 = _data["averageCurrentL3"];
            this.averageVoltageL1 = _data["averageVoltageL1"];
            this.averageVoltageL2 = _data["averageVoltageL2"];
            this.averageVoltageL3 = _data["averageVoltageL3"];
        }
    }

    static fromJS(data: any): InstantaneousObjectReadDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new InstantaneousObjectReadDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["instantaneousVoltageL1"] = this.instantaneousVoltageL1;
        data["instantaneousVoltageL2"] = this.instantaneousVoltageL2;
        data["instantaneousVoltageL3"] = this.instantaneousVoltageL3;
        data["instantaneousCurrentL1"] = this.instantaneousCurrentL1;
        data["instantaneousCurrentL2"] = this.instantaneousCurrentL2;
        data["instantaneousCurrentL3"] = this.instantaneousCurrentL3;
        data["instantaneousFrequency"] = this.instantaneousFrequency;
        data["instantaneousPowerFactorL1"] = this.instantaneousPowerFactorL1;
        data["instantaneousPowerFactorL2"] = this.instantaneousPowerFactorL2;
        data["instantaneousPowerFactorL3"] = this.instantaneousPowerFactorL3;
        data["averageCurrentL1"] = this.averageCurrentL1;
        data["averageCurrentL2"] = this.averageCurrentL2;
        data["averageCurrentL3"] = this.averageCurrentL3;
        data["averageVoltageL1"] = this.averageVoltageL1;
        data["averageVoltageL2"] = this.averageVoltageL2;
        data["averageVoltageL3"] = this.averageVoltageL3;
        return data;
    }
}

export interface IInstantaneousObjectReadDataOut {
    meterTime: Date;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;
    averageCurrentL1?: number | undefined;
    averageCurrentL2?: number | undefined;
    averageCurrentL3?: number | undefined;
    averageVoltageL1?: number | undefined;
    averageVoltageL2?: number | undefined;
    averageVoltageL3?: number | undefined;
}

export class IpSecConnectorsDataIn implements IIpSecConnectorsDataIn {
    utilityId!: string;

    constructor(data?: IIpSecConnectorsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilityId = _data["utilityId"];
        }
    }

    static fromJS(data: any): IpSecConnectorsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new IpSecConnectorsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilityId"] = this.utilityId;
        return data;
    }
}

export interface IIpSecConnectorsDataIn {
    utilityId: string;
}

export enum LastCommunicationPeriod {
    Within24Hours = "Within24Hours",
    Over24Hours = "Over24Hours",
}

export enum LimitType {
    Current = "Current",
    Demand = "Demand",
}

export class LoadLimitDataOut implements ILoadLimitDataOut {
    /** Unique identifier for the load limit. */
    id!: string;
    target!: MeterTargetType;
    /** Indicates whether the load limit is currently active. */
    isActive!: boolean;
    limitType!: LimitType;
    /** Numeric value of the load limit. */
    value!: number;
    /** The DateTime type field indicates time when load limit was created. */
    loadLimitCreationDate!: Date;
    /** List of region IDs that this load limit applies to, if any. */
    regions?: string[] | undefined;
    /** List of region names corresponding to the Regions IDs. */
    regionNames?: string[] | undefined;
    /** Meter number associated with the load limit (only for SingleMeter target). */
    meterNumber!: string | undefined;
    /** ID of the user who created the load limit. */
    createdById?: string | undefined;
    /** Name of the user who created the load limit. */
    createdBy?: string | undefined;
    assetTypeName!: string | undefined;
    assetTypeApplyLimiterConfiguration!: boolean;
    serviceTypeName?: string | undefined;
    meterPhase?: MeterPhase;

    constructor(data?: ILoadLimitDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.target = _data["target"];
            this.isActive = _data["isActive"];
            this.limitType = _data["limitType"];
            this.value = _data["value"];
            this.loadLimitCreationDate = _data["loadLimitCreationDate"] ? new Date(_data["loadLimitCreationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["regionNames"])) {
                this.regionNames = [] as any;
                for (let item of _data["regionNames"])
                    this.regionNames!.push(item);
            }
            this.meterNumber = _data["meterNumber"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.assetTypeName = _data["assetTypeName"];
            this.assetTypeApplyLimiterConfiguration = _data["assetTypeApplyLimiterConfiguration"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.meterPhase = _data["meterPhase"];
        }
    }

    static fromJS(data: any): LoadLimitDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new LoadLimitDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["target"] = this.target;
        data["isActive"] = this.isActive;
        data["limitType"] = this.limitType;
        data["value"] = this.value;
        data["loadLimitCreationDate"] = this.loadLimitCreationDate ? this.loadLimitCreationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.regionNames)) {
            data["regionNames"] = [];
            for (let item of this.regionNames)
                data["regionNames"].push(item);
        }
        data["meterNumber"] = this.meterNumber;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["assetTypeName"] = this.assetTypeName;
        data["assetTypeApplyLimiterConfiguration"] = this.assetTypeApplyLimiterConfiguration;
        data["serviceTypeName"] = this.serviceTypeName;
        data["meterPhase"] = this.meterPhase;
        return data;
    }
}

export interface ILoadLimitDataOut {
    /** Unique identifier for the load limit. */
    id: string;
    target: MeterTargetType;
    /** Indicates whether the load limit is currently active. */
    isActive: boolean;
    limitType: LimitType;
    /** Numeric value of the load limit. */
    value: number;
    /** The DateTime type field indicates time when load limit was created. */
    loadLimitCreationDate: Date;
    /** List of region IDs that this load limit applies to, if any. */
    regions?: string[] | undefined;
    /** List of region names corresponding to the Regions IDs. */
    regionNames?: string[] | undefined;
    /** Meter number associated with the load limit (only for SingleMeter target). */
    meterNumber: string | undefined;
    /** ID of the user who created the load limit. */
    createdById?: string | undefined;
    /** Name of the user who created the load limit. */
    createdBy?: string | undefined;
    assetTypeName: string | undefined;
    assetTypeApplyLimiterConfiguration: boolean;
    serviceTypeName?: string | undefined;
    meterPhase?: MeterPhase;
}

export class LoadLimitDataOutPaginationDataOut implements ILoadLimitDataOutPaginationDataOut {
    count!: number;
    data!: LoadLimitDataOut[] | undefined;

    constructor(data?: ILoadLimitDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LoadLimitDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadLimitDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new LoadLimitDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ILoadLimitDataOutPaginationDataOut {
    count: number;
    data: LoadLimitDataOut[] | undefined;
}

export class LoadLimitDto implements ILoadLimitDto {
    /** Unique identifier for the load limit. */
    id!: string;
    /** Meter number associated with the load limit (only for SingleMeter target). */
    meterNumber?: string | undefined;
    /** List of region IDs that this load limit applies to, if any. */
    regions?: string[] | undefined;
    /** List of region names corresponding to the Regions IDs. */
    regionNames?: string[] | undefined;
    limitType!: LimitType;
    /** Numeric value of the load limit. */
    value!: number;
    /** The ID of the asset type associated with this load limit. */
    assetType!: string;
    /** The name of the asset type associated with this load limit. */
    assetTypeName!: string | undefined;
    target!: MeterTargetType;
    /** The ID of the asset type associated with this load limit. */
    serviceType?: string | undefined;
    /** The name of the asset type associated with this load limit. */
    serviceTypeName?: string | undefined;
    /** Wait time in minutes before the power is cut */
    waitTime?: number | undefined;
    meterPhase?: MeterPhase;

    constructor(data?: ILoadLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["regionNames"])) {
                this.regionNames = [] as any;
                for (let item of _data["regionNames"])
                    this.regionNames!.push(item);
            }
            this.limitType = _data["limitType"];
            this.value = _data["value"];
            this.assetType = _data["assetType"];
            this.assetTypeName = _data["assetTypeName"];
            this.target = _data["target"];
            this.serviceType = _data["serviceType"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.waitTime = _data["waitTime"];
            this.meterPhase = _data["meterPhase"];
        }
    }

    static fromJS(data: any): LoadLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.regionNames)) {
            data["regionNames"] = [];
            for (let item of this.regionNames)
                data["regionNames"].push(item);
        }
        data["limitType"] = this.limitType;
        data["value"] = this.value;
        data["assetType"] = this.assetType;
        data["assetTypeName"] = this.assetTypeName;
        data["target"] = this.target;
        data["serviceType"] = this.serviceType;
        data["serviceTypeName"] = this.serviceTypeName;
        data["waitTime"] = this.waitTime;
        data["meterPhase"] = this.meterPhase;
        return data;
    }
}

export interface ILoadLimitDto {
    /** Unique identifier for the load limit. */
    id: string;
    /** Meter number associated with the load limit (only for SingleMeter target). */
    meterNumber?: string | undefined;
    /** List of region IDs that this load limit applies to, if any. */
    regions?: string[] | undefined;
    /** List of region names corresponding to the Regions IDs. */
    regionNames?: string[] | undefined;
    limitType: LimitType;
    /** Numeric value of the load limit. */
    value: number;
    /** The ID of the asset type associated with this load limit. */
    assetType: string;
    /** The name of the asset type associated with this load limit. */
    assetTypeName: string | undefined;
    target: MeterTargetType;
    /** The ID of the asset type associated with this load limit. */
    serviceType?: string | undefined;
    /** The name of the asset type associated with this load limit. */
    serviceTypeName?: string | undefined;
    /** Wait time in minutes before the power is cut */
    waitTime?: number | undefined;
    meterPhase?: MeterPhase;
}

export class LoadLimitGetAllDataIn implements ILoadLimitGetAllDataIn {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes!: string[] | undefined;
    regions!: string[] | undefined;
    target?: MeterTargetType;
    meterPhase?: MeterPhase;
    limitTypes!: LimitType[] | undefined;

    constructor(data?: ILoadLimitGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            this.target = _data["target"];
            this.meterPhase = _data["meterPhase"];
            if (Array.isArray(_data["limitTypes"])) {
                this.limitTypes = [] as any;
                for (let item of _data["limitTypes"])
                    this.limitTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadLimitGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new LoadLimitGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        data["target"] = this.target;
        data["meterPhase"] = this.meterPhase;
        if (Array.isArray(this.limitTypes)) {
            data["limitTypes"] = [];
            for (let item of this.limitTypes)
                data["limitTypes"].push(item);
        }
        return data;
    }
}

export interface ILoadLimitGetAllDataIn {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes: string[] | undefined;
    regions: string[] | undefined;
    target?: MeterTargetType;
    meterPhase?: MeterPhase;
    limitTypes: LimitType[] | undefined;
}

export class LoadLimitStatus implements ILoadLimitStatus {
    loadLimitId!: string;
    isActive!: boolean;

    constructor(data?: ILoadLimitStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadLimitId = _data["loadLimitId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LoadLimitStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LoadLimitStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadLimitId"] = this.loadLimitId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILoadLimitStatus {
    loadLimitId: string;
    isActive: boolean;
}

export class LoadProfileBufferDataOut implements ILoadProfileBufferDataOut {
    ingestionTime!: Date;
    meterTime!: Date;
    meterNumber!: string | undefined;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;

    constructor(data?: ILoadProfileBufferDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.activeEnergyImport = _data["activeEnergyImport"];
            this.activeEnergyExport = _data["activeEnergyExport"];
            this.reactiveEnergyImport = _data["reactiveEnergyImport"];
            this.reactiveEnergyExport = _data["reactiveEnergyExport"];
            this.apparentEnergyImport = _data["apparentEnergyImport"];
            this.apparentEnergyExport = _data["apparentEnergyExport"];
            this.instantaneousVoltageL1 = _data["instantaneousVoltageL1"];
            this.instantaneousVoltageL2 = _data["instantaneousVoltageL2"];
            this.instantaneousVoltageL3 = _data["instantaneousVoltageL3"];
            this.instantaneousCurrentL1 = _data["instantaneousCurrentL1"];
            this.instantaneousCurrentL2 = _data["instantaneousCurrentL2"];
            this.instantaneousCurrentL3 = _data["instantaneousCurrentL3"];
            this.instantaneousFrequency = _data["instantaneousFrequency"];
            this.instantaneousPowerFactorL1 = _data["instantaneousPowerFactorL1"];
            this.instantaneousPowerFactorL2 = _data["instantaneousPowerFactorL2"];
            this.instantaneousPowerFactorL3 = _data["instantaneousPowerFactorL3"];
        }
    }

    static fromJS(data: any): LoadProfileBufferDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new LoadProfileBufferDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["activeEnergyImport"] = this.activeEnergyImport;
        data["activeEnergyExport"] = this.activeEnergyExport;
        data["reactiveEnergyImport"] = this.reactiveEnergyImport;
        data["reactiveEnergyExport"] = this.reactiveEnergyExport;
        data["apparentEnergyImport"] = this.apparentEnergyImport;
        data["apparentEnergyExport"] = this.apparentEnergyExport;
        data["instantaneousVoltageL1"] = this.instantaneousVoltageL1;
        data["instantaneousVoltageL2"] = this.instantaneousVoltageL2;
        data["instantaneousVoltageL3"] = this.instantaneousVoltageL3;
        data["instantaneousCurrentL1"] = this.instantaneousCurrentL1;
        data["instantaneousCurrentL2"] = this.instantaneousCurrentL2;
        data["instantaneousCurrentL3"] = this.instantaneousCurrentL3;
        data["instantaneousFrequency"] = this.instantaneousFrequency;
        data["instantaneousPowerFactorL1"] = this.instantaneousPowerFactorL1;
        data["instantaneousPowerFactorL2"] = this.instantaneousPowerFactorL2;
        data["instantaneousPowerFactorL3"] = this.instantaneousPowerFactorL3;
        return data;
    }
}

export interface ILoadProfileBufferDataOut {
    ingestionTime: Date;
    meterTime: Date;
    meterNumber: string | undefined;
    activeEnergyImport?: number | undefined;
    activeEnergyExport?: number | undefined;
    reactiveEnergyImport?: number | undefined;
    reactiveEnergyExport?: number | undefined;
    apparentEnergyImport?: number | undefined;
    apparentEnergyExport?: number | undefined;
    instantaneousVoltageL1?: number | undefined;
    instantaneousVoltageL2?: number | undefined;
    instantaneousVoltageL3?: number | undefined;
    instantaneousCurrentL1?: number | undefined;
    instantaneousCurrentL2?: number | undefined;
    instantaneousCurrentL3?: number | undefined;
    instantaneousFrequency?: number | undefined;
    instantaneousPowerFactorL1?: number | undefined;
    instantaneousPowerFactorL2?: number | undefined;
    instantaneousPowerFactorL3?: number | undefined;
}

export class LoadProfileBufferDataOutPaginationDataOut implements ILoadProfileBufferDataOutPaginationDataOut {
    count!: number;
    data!: LoadProfileBufferDataOut[] | undefined;

    constructor(data?: ILoadProfileBufferDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LoadProfileBufferDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadProfileBufferDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new LoadProfileBufferDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ILoadProfileBufferDataOutPaginationDataOut {
    count: number;
    data: LoadProfileBufferDataOut[] | undefined;
}

export class LoadProfileCommandEvent implements ILoadProfileCommandEvent {
    meterId!: string;
    pageInfo!: PageInfo;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;

    constructor(data?: ILoadProfileCommandEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterId = _data["meterId"];
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LoadProfileCommandEvent {
        data = typeof data === 'object' ? data : {};
        let result = new LoadProfileCommandEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterId"] = this.meterId;
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILoadProfileCommandEvent {
    meterId: string;
    pageInfo: PageInfo;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
}

export class LoadTokenDataIn implements ILoadTokenDataIn {
    meterNo!: string | undefined;
    token!: string | undefined;

    constructor(data?: ILoadTokenDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNo = _data["meterNo"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoadTokenDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new LoadTokenDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNo"] = this.meterNo;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoadTokenDataIn {
    meterNo: string | undefined;
    token: string | undefined;
}

export enum MeterAutentification {
    None = "None",
    Low = "Low",
    High = "High",
    HighMD5 = "HighMD5",
    HighSHA1 = "HighSHA1",
    HighGMAC = "HighGMAC",
    HighSHA256 = "HighSHA256",
    HighECDSA = "HighECDSA",
}

export class MeterAvailabilityDataIn implements IMeterAvailabilityDataIn {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    meterId!: string;
    interval?: number | undefined;

    constructor(data?: IMeterAvailabilityDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.meterId = _data["meterId"];
            this.interval = _data["interval"];
        }
    }

    static fromJS(data: any): MeterAvailabilityDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterAvailabilityDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["meterId"] = this.meterId;
        data["interval"] = this.interval;
        return data;
    }
}

export interface IMeterAvailabilityDataIn {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    meterId: string;
    interval?: number | undefined;
}

export class MeterAvailabilityDataOut implements IMeterAvailabilityDataOut {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    online!: boolean;

    constructor(data?: IMeterAvailabilityDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.online = _data["online"];
        }
    }

    static fromJS(data: any): MeterAvailabilityDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterAvailabilityDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["online"] = this.online;
        return data;
    }
}

export interface IMeterAvailabilityDataOut {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    online: boolean;
}

export class MeterAvailabilityInfoDataOut implements IMeterAvailabilityInfoDataOut {
    onlinePercentage!: number;
    offlinePercentage!: number;
    onlineMinutes!: number;
    offlineMinutes!: number;
    lastSeen?: Date | undefined;

    constructor(data?: IMeterAvailabilityInfoDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onlinePercentage = _data["onlinePercentage"];
            this.offlinePercentage = _data["offlinePercentage"];
            this.onlineMinutes = _data["onlineMinutes"];
            this.offlineMinutes = _data["offlineMinutes"];
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterAvailabilityInfoDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterAvailabilityInfoDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlinePercentage"] = this.onlinePercentage;
        data["offlinePercentage"] = this.offlinePercentage;
        data["onlineMinutes"] = this.onlineMinutes;
        data["offlineMinutes"] = this.offlineMinutes;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMeterAvailabilityInfoDataOut {
    onlinePercentage: number;
    offlinePercentage: number;
    onlineMinutes: number;
    offlineMinutes: number;
    lastSeen?: Date | undefined;
}

export class MeterDataOut implements IMeterDataOut {
    id!: string;
    assetTypeId!: number;
    assetTypeName!: string | undefined;
    serviceName!: string | undefined;
    serviceNumber!: string | undefined;
    meterNo!: string | undefined;
    meterMake!: string | undefined;
    meterType!: MeterType;
    meterPhase!: MeterPhase;
    meterModel!: string | undefined;
    meterFirmware!: string | undefined;
    currentVersion?: number | undefined;
    nextVersion?: number | undefined;
    nextMeterModel?: string | undefined;
    nextMeterFirmware?: string | undefined;
    cellularSimSerialNumber!: string | undefined;
    meterIp!: string | undefined;
    meterPort!: number;
    dataCollectionIntervals!: number;
    meterTimeZone!: number;
    meterInstallationDate!: Date;
    meterManufactureDate?: Date | undefined;
    isConnected?: boolean | undefined;
    status?: boolean | undefined;
    configurationStatus!: ConfigurationStatus;
    lastOnlineTime?: Date | undefined;
    lastReadTime?: Date | undefined;
    lastEventTime?: Date | undefined;
    lastAlarmTime?: Date | undefined;
    ipSecConnector?: string | undefined;
    gsmProviderName!: GsmProviders;
    locationChanged?: boolean | undefined;
    communicationFailCount?: number | undefined;
    simRegistered!: boolean;
    firmwareUpdateStatus!: FirmwareUpdateCommandStatusDataOut;
    parent?: ParentMeterDataOut;

    constructor(data?: IMeterDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firmwareUpdateStatus = new FirmwareUpdateCommandStatusDataOut();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetTypeName = _data["assetTypeName"];
            this.serviceName = _data["serviceName"];
            this.serviceNumber = _data["serviceNumber"];
            this.meterNo = _data["meterNo"];
            this.meterMake = _data["meterMake"];
            this.meterType = _data["meterType"];
            this.meterPhase = _data["meterPhase"];
            this.meterModel = _data["meterModel"];
            this.meterFirmware = _data["meterFirmware"];
            this.currentVersion = _data["currentVersion"];
            this.nextVersion = _data["nextVersion"];
            this.nextMeterModel = _data["nextMeterModel"];
            this.nextMeterFirmware = _data["nextMeterFirmware"];
            this.cellularSimSerialNumber = _data["cellularSimSerialNumber"];
            this.meterIp = _data["meterIp"];
            this.meterPort = _data["meterPort"];
            this.dataCollectionIntervals = _data["dataCollectionIntervals"];
            this.meterTimeZone = _data["meterTimeZone"];
            this.meterInstallationDate = _data["meterInstallationDate"] ? new Date(_data["meterInstallationDate"].toString()) : <any>undefined;
            this.meterManufactureDate = _data["meterManufactureDate"] ? new Date(_data["meterManufactureDate"].toString()) : <any>undefined;
            this.isConnected = _data["isConnected"];
            this.status = _data["status"];
            this.configurationStatus = _data["configurationStatus"];
            this.lastOnlineTime = _data["lastOnlineTime"] ? new Date(_data["lastOnlineTime"].toString()) : <any>undefined;
            this.lastReadTime = _data["lastReadTime"] ? new Date(_data["lastReadTime"].toString()) : <any>undefined;
            this.lastEventTime = _data["lastEventTime"] ? new Date(_data["lastEventTime"].toString()) : <any>undefined;
            this.lastAlarmTime = _data["lastAlarmTime"] ? new Date(_data["lastAlarmTime"].toString()) : <any>undefined;
            this.ipSecConnector = _data["ipSecConnector"];
            this.gsmProviderName = _data["gsmProviderName"];
            this.locationChanged = _data["locationChanged"];
            this.communicationFailCount = _data["communicationFailCount"];
            this.simRegistered = _data["simRegistered"];
            this.firmwareUpdateStatus = _data["firmwareUpdateStatus"] ? FirmwareUpdateCommandStatusDataOut.fromJS(_data["firmwareUpdateStatus"]) : new FirmwareUpdateCommandStatusDataOut();
            this.parent = _data["parent"] ? ParentMeterDataOut.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetTypeId"] = this.assetTypeId;
        data["assetTypeName"] = this.assetTypeName;
        data["serviceName"] = this.serviceName;
        data["serviceNumber"] = this.serviceNumber;
        data["meterNo"] = this.meterNo;
        data["meterMake"] = this.meterMake;
        data["meterType"] = this.meterType;
        data["meterPhase"] = this.meterPhase;
        data["meterModel"] = this.meterModel;
        data["meterFirmware"] = this.meterFirmware;
        data["currentVersion"] = this.currentVersion;
        data["nextVersion"] = this.nextVersion;
        data["nextMeterModel"] = this.nextMeterModel;
        data["nextMeterFirmware"] = this.nextMeterFirmware;
        data["cellularSimSerialNumber"] = this.cellularSimSerialNumber;
        data["meterIp"] = this.meterIp;
        data["meterPort"] = this.meterPort;
        data["dataCollectionIntervals"] = this.dataCollectionIntervals;
        data["meterTimeZone"] = this.meterTimeZone;
        data["meterInstallationDate"] = this.meterInstallationDate ? this.meterInstallationDate.toISOString() : <any>undefined;
        data["meterManufactureDate"] = this.meterManufactureDate ? this.meterManufactureDate.toISOString() : <any>undefined;
        data["isConnected"] = this.isConnected;
        data["status"] = this.status;
        data["configurationStatus"] = this.configurationStatus;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["lastReadTime"] = this.lastReadTime ? this.lastReadTime.toISOString() : <any>undefined;
        data["lastEventTime"] = this.lastEventTime ? this.lastEventTime.toISOString() : <any>undefined;
        data["lastAlarmTime"] = this.lastAlarmTime ? this.lastAlarmTime.toISOString() : <any>undefined;
        data["ipSecConnector"] = this.ipSecConnector;
        data["gsmProviderName"] = this.gsmProviderName;
        data["locationChanged"] = this.locationChanged;
        data["communicationFailCount"] = this.communicationFailCount;
        data["simRegistered"] = this.simRegistered;
        data["firmwareUpdateStatus"] = this.firmwareUpdateStatus ? this.firmwareUpdateStatus.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeterDataOut {
    id: string;
    assetTypeId: number;
    assetTypeName: string | undefined;
    serviceName: string | undefined;
    serviceNumber: string | undefined;
    meterNo: string | undefined;
    meterMake: string | undefined;
    meterType: MeterType;
    meterPhase: MeterPhase;
    meterModel: string | undefined;
    meterFirmware: string | undefined;
    currentVersion?: number | undefined;
    nextVersion?: number | undefined;
    nextMeterModel?: string | undefined;
    nextMeterFirmware?: string | undefined;
    cellularSimSerialNumber: string | undefined;
    meterIp: string | undefined;
    meterPort: number;
    dataCollectionIntervals: number;
    meterTimeZone: number;
    meterInstallationDate: Date;
    meterManufactureDate?: Date | undefined;
    isConnected?: boolean | undefined;
    status?: boolean | undefined;
    configurationStatus: ConfigurationStatus;
    lastOnlineTime?: Date | undefined;
    lastReadTime?: Date | undefined;
    lastEventTime?: Date | undefined;
    lastAlarmTime?: Date | undefined;
    ipSecConnector?: string | undefined;
    gsmProviderName: GsmProviders;
    locationChanged?: boolean | undefined;
    communicationFailCount?: number | undefined;
    simRegistered: boolean;
    firmwareUpdateStatus: FirmwareUpdateCommandStatusDataOut;
    parent?: ParentMeterDataOut;
}

export class MeterDataOutPaginationDataOut implements IMeterDataOutPaginationDataOut {
    count!: number;
    data!: MeterDataOut[] | undefined;

    constructor(data?: IMeterDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeterDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterDataOutPaginationDataOut {
    count: number;
    data: MeterDataOut[] | undefined;
}

/** One event logged by a meter, named by the event code mapping of its meter model. */
export class MeterEventLogDataOut implements IMeterEventLogDataOut {
    /** Event log the entry belongs to, 1 to 6 */
    eventLogNumber!: number;
    /** Custom name of the log, from the meter model the entry was read under; null keeps the default name */
    eventLogLabel?: string | undefined;
    /** Value as read from the meter */
    eventCode!: number;
    /** Name of the mapped event, null when the value has no mapping */
    eventName?: string | undefined;
    description?: string | undefined;
    /** Meter clock time the event was logged at */
    eventTime!: Date;
    /** When the event first reached the system */
    ingestionTime!: Date;

    constructor(data?: IMeterEventLogDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventLogNumber = _data["eventLogNumber"];
            this.eventLogLabel = _data["eventLogLabel"];
            this.eventCode = _data["eventCode"];
            this.eventName = _data["eventName"];
            this.description = _data["description"];
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterEventLogDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterEventLogDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventLogNumber"] = this.eventLogNumber;
        data["eventLogLabel"] = this.eventLogLabel;
        data["eventCode"] = this.eventCode;
        data["eventName"] = this.eventName;
        data["description"] = this.description;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        return data;
    }
}

/** One event logged by a meter, named by the event code mapping of its meter model. */
export interface IMeterEventLogDataOut {
    /** Event log the entry belongs to, 1 to 6 */
    eventLogNumber: number;
    /** Custom name of the log, from the meter model the entry was read under; null keeps the default name */
    eventLogLabel?: string | undefined;
    /** Value as read from the meter */
    eventCode: number;
    /** Name of the mapped event, null when the value has no mapping */
    eventName?: string | undefined;
    description?: string | undefined;
    /** Meter clock time the event was logged at */
    eventTime: Date;
    /** When the event first reached the system */
    ingestionTime: Date;
}

export class MeterEventLogDataOutPaginationDataOut implements IMeterEventLogDataOutPaginationDataOut {
    count!: number;
    data!: MeterEventLogDataOut[] | undefined;

    constructor(data?: IMeterEventLogDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeterEventLogDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterEventLogDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterEventLogDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterEventLogDataOutPaginationDataOut {
    count: number;
    data: MeterEventLogDataOut[] | undefined;
}

/** Every event log entry read from one meter, across all of its event log reads. */
export class MeterEventLogQueryDataIn implements IMeterEventLogQueryDataIn {
    meterId!: string;
    pageInfo!: PageInfo;
    /** Range of meter clock time the events were logged at */
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    /** Event log numbers (1-6) to keep; every log when empty */
    eventLogNumbers?: number[] | undefined;
    /** Keeps the events whose name contains the text, or whose code is the number given */
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IMeterEventLogQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterId = _data["meterId"];
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["eventLogNumbers"])) {
                this.eventLogNumbers = [] as any;
                for (let item of _data["eventLogNumbers"])
                    this.eventLogNumbers!.push(item);
            }
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): MeterEventLogQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterEventLogQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterId"] = this.meterId;
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.eventLogNumbers)) {
            data["eventLogNumbers"] = [];
            for (let item of this.eventLogNumbers)
                data["eventLogNumbers"].push(item);
        }
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

/** Every event log entry read from one meter, across all of its event log reads. */
export interface IMeterEventLogQueryDataIn {
    meterId: string;
    pageInfo: PageInfo;
    /** Range of meter clock time the events were logged at */
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    /** Event log numbers (1-6) to keep; every log when empty */
    eventLogNumbers?: number[] | undefined;
    /** Keeps the events whose name contains the text, or whose code is the number given */
    search?: string | undefined;
    sorting?: SortingType;
}

export class MeterGeoLocationQueryDataOut implements IMeterGeoLocationQueryDataOut {
    latitude!: number;
    longitude!: number;
    accuracy!: number;
    address!: string | undefined;
    meterNo!: string | undefined;
    isViewed!: boolean;
    locationTime!: Date;

    constructor(data?: IMeterGeoLocationQueryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.accuracy = _data["accuracy"];
            this.address = _data["address"];
            this.meterNo = _data["meterNo"];
            this.isViewed = _data["isViewed"];
            this.locationTime = _data["locationTime"] ? new Date(_data["locationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterGeoLocationQueryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterGeoLocationQueryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["accuracy"] = this.accuracy;
        data["address"] = this.address;
        data["meterNo"] = this.meterNo;
        data["isViewed"] = this.isViewed;
        data["locationTime"] = this.locationTime ? this.locationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMeterGeoLocationQueryDataOut {
    latitude: number;
    longitude: number;
    accuracy: number;
    address: string | undefined;
    meterNo: string | undefined;
    isViewed: boolean;
    locationTime: Date;
}

export class MeterGetAllDataIn implements IMeterGetAllDataIn {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: MeterStatus;
    simStatus?: MeterStatus;
    lastCommunication?: LastCommunicationPeriod;
    /** List guids type field, represents a filter parameter by Meter manufacturer */
    meterMakes?: string[] | undefined;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes?: string[] | undefined;
    /** List enum values type field, represents a filter if meter is configured or not */
    configurationProgressStatus?: ConfigurationProgressStatus[] | undefined;
    /** List guids type field, represents a filter parameter by Meter model */
    meterModels?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Service type */
    serviceTypes?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Area */
    areas?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Region */
    regions?: string[] | undefined;

    constructor(data?: IMeterGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
            this.simStatus = _data["simStatus"];
            this.lastCommunication = _data["lastCommunication"];
            if (Array.isArray(_data["meterMakes"])) {
                this.meterMakes = [] as any;
                for (let item of _data["meterMakes"])
                    this.meterMakes!.push(item);
            }
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["configurationProgressStatus"])) {
                this.configurationProgressStatus = [] as any;
                for (let item of _data["configurationProgressStatus"])
                    this.configurationProgressStatus!.push(item);
            }
            if (Array.isArray(_data["meterModels"])) {
                this.meterModels = [] as any;
                for (let item of _data["meterModels"])
                    this.meterModels!.push(item);
            }
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
        }
    }

    static fromJS(data: any): MeterGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        data["simStatus"] = this.simStatus;
        data["lastCommunication"] = this.lastCommunication;
        if (Array.isArray(this.meterMakes)) {
            data["meterMakes"] = [];
            for (let item of this.meterMakes)
                data["meterMakes"].push(item);
        }
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.configurationProgressStatus)) {
            data["configurationProgressStatus"] = [];
            for (let item of this.configurationProgressStatus)
                data["configurationProgressStatus"].push(item);
        }
        if (Array.isArray(this.meterModels)) {
            data["meterModels"] = [];
            for (let item of this.meterModels)
                data["meterModels"].push(item);
        }
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        return data;
    }
}

export interface IMeterGetAllDataIn {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: MeterStatus;
    simStatus?: MeterStatus;
    lastCommunication?: LastCommunicationPeriod;
    /** List guids type field, represents a filter parameter by Meter manufacturer */
    meterMakes?: string[] | undefined;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes?: string[] | undefined;
    /** List enum values type field, represents a filter if meter is configured or not */
    configurationProgressStatus?: ConfigurationProgressStatus[] | undefined;
    /** List guids type field, represents a filter parameter by Meter model */
    meterModels?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Service type */
    serviceTypes?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Area */
    areas?: string[] | undefined;
    /** List guids type field, represents a filter parameter by Region */
    regions?: string[] | undefined;
}

export enum MeterInterface {
    HDLC = "HDLC",
    WRAPPER = "WRAPPER",
    PDU = "PDU",
    WirelessMBus = "WirelessMBus",
    HdlcWithModeE = "HdlcWithModeE",
    Plc = "Plc",
    PlcHdlc = "PlcHdlc",
    LPWAN = "LPWAN",
    WiSUN = "WiSUN",
    PlcPrime = "PlcPrime",
    WiredMBus = "WiredMBus",
    SMS = "SMS",
    PrimeDcWrapper = "PrimeDcWrapper",
    CoAP = "CoAP",
}

export class MeterMakeDataIn implements IMeterMakeDataIn {
    id?: string | undefined;
    name!: string | undefined;

    constructor(data?: IMeterMakeDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MeterMakeDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterMakeDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMeterMakeDataIn {
    id?: string | undefined;
    name: string | undefined;
}

export class MeterMakeDataOut implements IMeterMakeDataOut {
    id?: string | undefined;
    name!: string | undefined;
    lastUpdateTime?: Date | undefined;

    constructor(data?: IMeterMakeDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.lastUpdateTime = _data["lastUpdateTime"] ? new Date(_data["lastUpdateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterMakeDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterMakeDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["lastUpdateTime"] = this.lastUpdateTime ? this.lastUpdateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMeterMakeDataOut {
    id?: string | undefined;
    name: string | undefined;
    lastUpdateTime?: Date | undefined;
}

export class MeterMakeDataOutPaginationDataOut implements IMeterMakeDataOutPaginationDataOut {
    count!: number;
    data!: MeterMakeDataOut[] | undefined;

    constructor(data?: IMeterMakeDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeterMakeDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterMakeDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterMakeDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterMakeDataOutPaginationDataOut {
    count: number;
    data: MeterMakeDataOut[] | undefined;
}

export class MeterMakeDetailsDataOut implements IMeterMakeDetailsDataOut {
    id?: string | undefined;
    name!: string | undefined;

    constructor(data?: IMeterMakeDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MeterMakeDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterMakeDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMeterMakeDetailsDataOut {
    id?: string | undefined;
    name: string | undefined;
}

export class MeterMakeGetAllDataIn implements IMeterMakeGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IMeterMakeGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): MeterMakeGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterMakeGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IMeterMakeGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class MeterModelDataIn implements IMeterModelDataIn {
    id?: string | undefined;
    model!: string | undefined;
    firmwareVersion!: string | undefined;
    firmwareImage?: string | undefined;
    firmwareIdentifier?: string | undefined;
    code!: string | undefined;
    meterMake!: string;
    clientAddress!: number;
    interface!: MeterInterface;
    authorizationLevel!: MeterAutentification;
    security!: MeterSecurity;
    systemTitle?: string | undefined;
    editedByUserHesId?: string | undefined;
    smsWakeMessage?: string | undefined;
    smsWakeTimeout?: number | undefined;
    smsRetryTimeout?: number | undefined;
    meterPhase!: MeterPhase;
    disconnectControlMode!: string;
    blockRequestDelayMs?: number | undefined;

    constructor(data?: IMeterModelDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.model = _data["model"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.firmwareImage = _data["firmwareImage"];
            this.firmwareIdentifier = _data["firmwareIdentifier"];
            this.code = _data["code"];
            this.meterMake = _data["meterMake"];
            this.clientAddress = _data["clientAddress"];
            this.interface = _data["interface"];
            this.authorizationLevel = _data["authorizationLevel"];
            this.security = _data["security"];
            this.systemTitle = _data["systemTitle"];
            this.editedByUserHesId = _data["editedByUserHesId"];
            this.smsWakeMessage = _data["smsWakeMessage"];
            this.smsWakeTimeout = _data["smsWakeTimeout"];
            this.smsRetryTimeout = _data["smsRetryTimeout"];
            this.meterPhase = _data["meterPhase"];
            this.disconnectControlMode = _data["disconnectControlMode"];
            this.blockRequestDelayMs = _data["blockRequestDelayMs"];
        }
    }

    static fromJS(data: any): MeterModelDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["model"] = this.model;
        data["firmwareVersion"] = this.firmwareVersion;
        data["firmwareImage"] = this.firmwareImage;
        data["firmwareIdentifier"] = this.firmwareIdentifier;
        data["code"] = this.code;
        data["meterMake"] = this.meterMake;
        data["clientAddress"] = this.clientAddress;
        data["interface"] = this.interface;
        data["authorizationLevel"] = this.authorizationLevel;
        data["security"] = this.security;
        data["systemTitle"] = this.systemTitle;
        data["editedByUserHesId"] = this.editedByUserHesId;
        data["smsWakeMessage"] = this.smsWakeMessage;
        data["smsWakeTimeout"] = this.smsWakeTimeout;
        data["smsRetryTimeout"] = this.smsRetryTimeout;
        data["meterPhase"] = this.meterPhase;
        data["disconnectControlMode"] = this.disconnectControlMode;
        data["blockRequestDelayMs"] = this.blockRequestDelayMs;
        return data;
    }
}

export interface IMeterModelDataIn {
    id?: string | undefined;
    model: string | undefined;
    firmwareVersion: string | undefined;
    firmwareImage?: string | undefined;
    firmwareIdentifier?: string | undefined;
    code: string | undefined;
    meterMake: string;
    clientAddress: number;
    interface: MeterInterface;
    authorizationLevel: MeterAutentification;
    security: MeterSecurity;
    systemTitle?: string | undefined;
    editedByUserHesId?: string | undefined;
    smsWakeMessage?: string | undefined;
    smsWakeTimeout?: number | undefined;
    smsRetryTimeout?: number | undefined;
    meterPhase: MeterPhase;
    disconnectControlMode: string;
    blockRequestDelayMs?: number | undefined;
}

export class MeterModelDataOut implements IMeterModelDataOut {
    id?: string | undefined;
    model!: string | undefined;
    firmwareVersion!: string | undefined;
    meterMake!: string | undefined;
    code!: string | undefined;
    meterMakeId?: string | undefined;
    clientAddress!: number;
    interface!: MeterInterface;
    authorizationLevel!: MeterAutentification;
    security!: MeterSecurity;
    systemTitle?: string | undefined;
    smsWakeMessage?: string | undefined;
    smsWakeTimeout!: number;
    smsRetryTimeout!: number;
    lastUpdateTime?: Date | undefined;
    firmwareImage?: string | undefined;
    firmwareIdentifier?: string | undefined;
    meterPhase!: MeterPhase;
    creationDate!: Date;
    createdById?: string | undefined;
    createdBy?: string | undefined;
    updatedById?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IMeterModelDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.model = _data["model"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.meterMake = _data["meterMake"];
            this.code = _data["code"];
            this.meterMakeId = _data["meterMakeId"];
            this.clientAddress = _data["clientAddress"];
            this.interface = _data["interface"];
            this.authorizationLevel = _data["authorizationLevel"];
            this.security = _data["security"];
            this.systemTitle = _data["systemTitle"];
            this.smsWakeMessage = _data["smsWakeMessage"];
            this.smsWakeTimeout = _data["smsWakeTimeout"];
            this.smsRetryTimeout = _data["smsRetryTimeout"];
            this.lastUpdateTime = _data["lastUpdateTime"] ? new Date(_data["lastUpdateTime"].toString()) : <any>undefined;
            this.firmwareImage = _data["firmwareImage"];
            this.firmwareIdentifier = _data["firmwareIdentifier"];
            this.meterPhase = _data["meterPhase"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.updatedById = _data["updatedById"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MeterModelDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["model"] = this.model;
        data["firmwareVersion"] = this.firmwareVersion;
        data["meterMake"] = this.meterMake;
        data["code"] = this.code;
        data["meterMakeId"] = this.meterMakeId;
        data["clientAddress"] = this.clientAddress;
        data["interface"] = this.interface;
        data["authorizationLevel"] = this.authorizationLevel;
        data["security"] = this.security;
        data["systemTitle"] = this.systemTitle;
        data["smsWakeMessage"] = this.smsWakeMessage;
        data["smsWakeTimeout"] = this.smsWakeTimeout;
        data["smsRetryTimeout"] = this.smsRetryTimeout;
        data["lastUpdateTime"] = this.lastUpdateTime ? this.lastUpdateTime.toISOString() : <any>undefined;
        data["firmwareImage"] = this.firmwareImage;
        data["firmwareIdentifier"] = this.firmwareIdentifier;
        data["meterPhase"] = this.meterPhase;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["updatedById"] = this.updatedById;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMeterModelDataOut {
    id?: string | undefined;
    model: string | undefined;
    firmwareVersion: string | undefined;
    meterMake: string | undefined;
    code: string | undefined;
    meterMakeId?: string | undefined;
    clientAddress: number;
    interface: MeterInterface;
    authorizationLevel: MeterAutentification;
    security: MeterSecurity;
    systemTitle?: string | undefined;
    smsWakeMessage?: string | undefined;
    smsWakeTimeout: number;
    smsRetryTimeout: number;
    lastUpdateTime?: Date | undefined;
    firmwareImage?: string | undefined;
    firmwareIdentifier?: string | undefined;
    meterPhase: MeterPhase;
    creationDate: Date;
    createdById?: string | undefined;
    createdBy?: string | undefined;
    updatedById?: string | undefined;
    updatedBy?: string | undefined;
}

export class MeterModelDataOutPaginationDataOut implements IMeterModelDataOutPaginationDataOut {
    count!: number;
    data!: MeterModelDataOut[] | undefined;

    constructor(data?: IMeterModelDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeterModelDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterModelDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterModelDataOutPaginationDataOut {
    count: number;
    data: MeterModelDataOut[] | undefined;
}

export class MeterModelDetailsDataOut implements IMeterModelDetailsDataOut {
    id?: string | undefined;
    meterMake!: string | undefined;
    model!: string | undefined;
    firmwareVersion!: string | undefined;
    firmwareImage!: string | undefined;
    firmwareIdentifier!: string | undefined;
    code!: string | undefined;
    meterMakeId?: string | undefined;
    clientAddress!: number;
    interface!: MeterInterface;
    authorizationLevel!: MeterAutentification;
    security!: MeterSecurity;
    systemTitle!: string | undefined;
    smsWakeMessage!: string | undefined;
    smsWakeTimeout!: number;
    smsRetryTimeout!: number;
    versions!: MeterSetupVersionDto[] | undefined;
    meterPhase!: MeterPhase;
    blockRequestDelayMs!: number;
    dlmsDisconnectControlMode!: string;
    creationDate!: Date;

    constructor(data?: IMeterModelDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterMake = _data["meterMake"];
            this.model = _data["model"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.firmwareImage = _data["firmwareImage"];
            this.firmwareIdentifier = _data["firmwareIdentifier"];
            this.code = _data["code"];
            this.meterMakeId = _data["meterMakeId"];
            this.clientAddress = _data["clientAddress"];
            this.interface = _data["interface"];
            this.authorizationLevel = _data["authorizationLevel"];
            this.security = _data["security"];
            this.systemTitle = _data["systemTitle"];
            this.smsWakeMessage = _data["smsWakeMessage"];
            this.smsWakeTimeout = _data["smsWakeTimeout"];
            this.smsRetryTimeout = _data["smsRetryTimeout"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(MeterSetupVersionDto.fromJS(item));
            }
            this.meterPhase = _data["meterPhase"];
            this.blockRequestDelayMs = _data["blockRequestDelayMs"];
            this.dlmsDisconnectControlMode = _data["dlmsDisconnectControlMode"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterModelDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterMake"] = this.meterMake;
        data["model"] = this.model;
        data["firmwareVersion"] = this.firmwareVersion;
        data["firmwareImage"] = this.firmwareImage;
        data["firmwareIdentifier"] = this.firmwareIdentifier;
        data["code"] = this.code;
        data["meterMakeId"] = this.meterMakeId;
        data["clientAddress"] = this.clientAddress;
        data["interface"] = this.interface;
        data["authorizationLevel"] = this.authorizationLevel;
        data["security"] = this.security;
        data["systemTitle"] = this.systemTitle;
        data["smsWakeMessage"] = this.smsWakeMessage;
        data["smsWakeTimeout"] = this.smsWakeTimeout;
        data["smsRetryTimeout"] = this.smsRetryTimeout;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["meterPhase"] = this.meterPhase;
        data["blockRequestDelayMs"] = this.blockRequestDelayMs;
        data["dlmsDisconnectControlMode"] = this.dlmsDisconnectControlMode;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMeterModelDetailsDataOut {
    id?: string | undefined;
    meterMake: string | undefined;
    model: string | undefined;
    firmwareVersion: string | undefined;
    firmwareImage: string | undefined;
    firmwareIdentifier: string | undefined;
    code: string | undefined;
    meterMakeId?: string | undefined;
    clientAddress: number;
    interface: MeterInterface;
    authorizationLevel: MeterAutentification;
    security: MeterSecurity;
    systemTitle: string | undefined;
    smsWakeMessage: string | undefined;
    smsWakeTimeout: number;
    smsRetryTimeout: number;
    versions: MeterSetupVersionDto[] | undefined;
    meterPhase: MeterPhase;
    blockRequestDelayMs: number;
    dlmsDisconnectControlMode: string;
    creationDate: Date;
}

export class MeterModelGetAllDataIn implements IMeterModelGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IMeterModelGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): MeterModelGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IMeterModelGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class MeterModelSetupVersionDetailsDataIn implements IMeterModelSetupVersionDetailsDataIn {
    associations!: AssociationDescriptionDto[] | undefined;
    registers!: RegisterDescriptionDto[] | undefined;
    lP1CaptureObjectsConfiguration!: SetupConfigurationDataIn[] | undefined;
    lP2CaptureObjectsConfiguration!: SetupConfigurationDataIn[] | undefined;
    lP3CaptureObjectsConfiguration!: SetupConfigurationDataIn[] | undefined;
    scalers?: Scalers;

    constructor(data?: IMeterModelSetupVersionDetailsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associations"])) {
                this.associations = [] as any;
                for (let item of _data["associations"])
                    this.associations!.push(AssociationDescriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["registers"])) {
                this.registers = [] as any;
                for (let item of _data["registers"])
                    this.registers!.push(RegisterDescriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["lP1CaptureObjectsConfiguration"])) {
                this.lP1CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP1CaptureObjectsConfiguration"])
                    this.lP1CaptureObjectsConfiguration!.push(SetupConfigurationDataIn.fromJS(item));
            }
            if (Array.isArray(_data["lP2CaptureObjectsConfiguration"])) {
                this.lP2CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP2CaptureObjectsConfiguration"])
                    this.lP2CaptureObjectsConfiguration!.push(SetupConfigurationDataIn.fromJS(item));
            }
            if (Array.isArray(_data["lP3CaptureObjectsConfiguration"])) {
                this.lP3CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP3CaptureObjectsConfiguration"])
                    this.lP3CaptureObjectsConfiguration!.push(SetupConfigurationDataIn.fromJS(item));
            }
            this.scalers = _data["scalers"] ? Scalers.fromJS(_data["scalers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeterModelSetupVersionDetailsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelSetupVersionDetailsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associations)) {
            data["associations"] = [];
            for (let item of this.associations)
                data["associations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.registers)) {
            data["registers"] = [];
            for (let item of this.registers)
                data["registers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP1CaptureObjectsConfiguration)) {
            data["lP1CaptureObjectsConfiguration"] = [];
            for (let item of this.lP1CaptureObjectsConfiguration)
                data["lP1CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP2CaptureObjectsConfiguration)) {
            data["lP2CaptureObjectsConfiguration"] = [];
            for (let item of this.lP2CaptureObjectsConfiguration)
                data["lP2CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP3CaptureObjectsConfiguration)) {
            data["lP3CaptureObjectsConfiguration"] = [];
            for (let item of this.lP3CaptureObjectsConfiguration)
                data["lP3CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        data["scalers"] = this.scalers ? this.scalers.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeterModelSetupVersionDetailsDataIn {
    associations: AssociationDescriptionDto[] | undefined;
    registers: RegisterDescriptionDto[] | undefined;
    lP1CaptureObjectsConfiguration: SetupConfigurationDataIn[] | undefined;
    lP2CaptureObjectsConfiguration: SetupConfigurationDataIn[] | undefined;
    lP3CaptureObjectsConfiguration: SetupConfigurationDataIn[] | undefined;
    scalers?: Scalers;
}

export class MeterModelVersionsNew implements IMeterModelVersionsNew {
    meterModelId!: string;
    details!: MeterModelSetupVersionDetailsDataIn;

    constructor(data?: IMeterModelVersionsNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.details = new MeterModelSetupVersionDetailsDataIn();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterModelId = _data["meterModelId"];
            this.details = _data["details"] ? MeterModelSetupVersionDetailsDataIn.fromJS(_data["details"]) : new MeterModelSetupVersionDetailsDataIn();
        }
    }

    static fromJS(data: any): MeterModelVersionsNew {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelVersionsNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterModelId"] = this.meterModelId;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeterModelVersionsNew {
    meterModelId: string;
    details: MeterModelSetupVersionDetailsDataIn;
}

export class MeterModelVersionsQueryDataIn implements IMeterModelVersionsQueryDataIn {
    pageInfo!: PageInfo;
    meterModelId!: string;

    constructor(data?: IMeterModelVersionsQueryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.meterModelId = _data["meterModelId"];
        }
    }

    static fromJS(data: any): MeterModelVersionsQueryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterModelVersionsQueryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["meterModelId"] = this.meterModelId;
        return data;
    }
}

export interface IMeterModelVersionsQueryDataIn {
    pageInfo: PageInfo;
    meterModelId: string;
}

export class MeterParentGetDataIn implements IMeterParentGetDataIn {
    assetTypeId!: string;
    search!: string | undefined;
    readonly pageSize!: number;

    constructor(data?: IMeterParentGetDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetTypeId = _data["assetTypeId"];
            this.search = _data["search"];
            (<any>this).pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): MeterParentGetDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new MeterParentGetDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetTypeId"] = this.assetTypeId;
        data["search"] = this.search;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IMeterParentGetDataIn {
    assetTypeId: string;
    search: string | undefined;
    pageSize: number;
}

export enum MeterPhase {
    OnePhase = "OnePhase",
    ThreePhase = "ThreePhase",
}

export enum MeterSecurity {
    None = "None",
    Authentication = "Authentication",
    Encryption = "Encryption",
    AuthenticationEncryption = "AuthenticationEncryption",
}

export class MeterSetupVersionDto implements IMeterSetupVersionDto {
    id!: string;
    version!: number;
    createdAt!: Date;
    meterModelId!: number;
    approvedByUserHesId?: string | undefined;
    associations!: AssociationDescriptionDto[] | undefined;
    registers!: RegisterDescriptionDto[] | undefined;
    lP1CaptureObjectsConfiguration!: SetupConfigurationDto[] | undefined;
    lP2CaptureObjectsConfiguration!: SetupConfigurationDto[] | undefined;
    lP3CaptureObjectsConfiguration!: SetupConfigurationDto[] | undefined;

    constructor(data?: IMeterSetupVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.meterModelId = _data["meterModelId"];
            this.approvedByUserHesId = _data["approvedByUserHesId"];
            if (Array.isArray(_data["associations"])) {
                this.associations = [] as any;
                for (let item of _data["associations"])
                    this.associations!.push(AssociationDescriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["registers"])) {
                this.registers = [] as any;
                for (let item of _data["registers"])
                    this.registers!.push(RegisterDescriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["lP1CaptureObjectsConfiguration"])) {
                this.lP1CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP1CaptureObjectsConfiguration"])
                    this.lP1CaptureObjectsConfiguration!.push(SetupConfigurationDto.fromJS(item));
            }
            if (Array.isArray(_data["lP2CaptureObjectsConfiguration"])) {
                this.lP2CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP2CaptureObjectsConfiguration"])
                    this.lP2CaptureObjectsConfiguration!.push(SetupConfigurationDto.fromJS(item));
            }
            if (Array.isArray(_data["lP3CaptureObjectsConfiguration"])) {
                this.lP3CaptureObjectsConfiguration = [] as any;
                for (let item of _data["lP3CaptureObjectsConfiguration"])
                    this.lP3CaptureObjectsConfiguration!.push(SetupConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterSetupVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterSetupVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["meterModelId"] = this.meterModelId;
        data["approvedByUserHesId"] = this.approvedByUserHesId;
        if (Array.isArray(this.associations)) {
            data["associations"] = [];
            for (let item of this.associations)
                data["associations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.registers)) {
            data["registers"] = [];
            for (let item of this.registers)
                data["registers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP1CaptureObjectsConfiguration)) {
            data["lP1CaptureObjectsConfiguration"] = [];
            for (let item of this.lP1CaptureObjectsConfiguration)
                data["lP1CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP2CaptureObjectsConfiguration)) {
            data["lP2CaptureObjectsConfiguration"] = [];
            for (let item of this.lP2CaptureObjectsConfiguration)
                data["lP2CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lP3CaptureObjectsConfiguration)) {
            data["lP3CaptureObjectsConfiguration"] = [];
            for (let item of this.lP3CaptureObjectsConfiguration)
                data["lP3CaptureObjectsConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterSetupVersionDto {
    id: string;
    version: number;
    createdAt: Date;
    meterModelId: number;
    approvedByUserHesId?: string | undefined;
    associations: AssociationDescriptionDto[] | undefined;
    registers: RegisterDescriptionDto[] | undefined;
    lP1CaptureObjectsConfiguration: SetupConfigurationDto[] | undefined;
    lP2CaptureObjectsConfiguration: SetupConfigurationDto[] | undefined;
    lP3CaptureObjectsConfiguration: SetupConfigurationDto[] | undefined;
}

export class MeterSetupVersionDtoPaginationDataOut implements IMeterSetupVersionDtoPaginationDataOut {
    count!: number;
    data!: MeterSetupVersionDto[] | undefined;

    constructor(data?: IMeterSetupVersionDtoPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeterSetupVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterSetupVersionDtoPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new MeterSetupVersionDtoPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMeterSetupVersionDtoPaginationDataOut {
    count: number;
    data: MeterSetupVersionDto[] | undefined;
}

export enum MeterStatus {
    Online = "Online",
    Offline = "Offline",
}

export enum MeterTargetType {
    SingleMeter = "SingleMeter",
    MeterGroup = "MeterGroup",
}

export enum MeterType {
    Prepaid = "Prepaid",
    Postpaid = "Postpaid",
}

export class NetworkOutageState implements INetworkOutageState {
    isOfflineByUtility!: { [key: string]: boolean; } | undefined;
    isNotificationSent!: boolean;

    constructor(data?: INetworkOutageState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["isOfflineByUtility"]) {
                this.isOfflineByUtility = {} as any;
                for (let key in _data["isOfflineByUtility"]) {
                    if (_data["isOfflineByUtility"].hasOwnProperty(key))
                        (<any>this.isOfflineByUtility)![key] = _data["isOfflineByUtility"][key];
                }
            }
            this.isNotificationSent = _data["isNotificationSent"];
        }
    }

    static fromJS(data: any): NetworkOutageState {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkOutageState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.isOfflineByUtility) {
            data["isOfflineByUtility"] = {};
            for (let key in this.isOfflineByUtility) {
                if (this.isOfflineByUtility.hasOwnProperty(key))
                    (<any>data["isOfflineByUtility"])[key] = (<any>this.isOfflineByUtility)[key];
            }
        }
        data["isNotificationSent"] = this.isNotificationSent;
        return data;
    }
}

export interface INetworkOutageState {
    isOfflineByUtility: { [key: string]: boolean; } | undefined;
    isNotificationSent: boolean;
}

/** Billing data buffer response */
export class OnDemandAttributeDataOut implements IOnDemandAttributeDataOut {
    /** Sample time utc */
    ingestionTime!: Date;
    /** Meter time included time zone */
    meterTime!: Date;
    /** Meter number */
    meterNumber!: string | undefined;
    attributeName!: string | undefined;
    stringValue?: string | undefined;
    doubleValue?: number | undefined;
    unit!: string | undefined;
    errorMessage?: string | undefined;
    obis?: string | undefined;

    constructor(data?: IOnDemandAttributeDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.attributeName = _data["attributeName"];
            this.stringValue = _data["stringValue"];
            this.doubleValue = _data["doubleValue"];
            this.unit = _data["unit"];
            this.errorMessage = _data["errorMessage"];
            this.obis = _data["obis"];
        }
    }

    static fromJS(data: any): OnDemandAttributeDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandAttributeDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["attributeName"] = this.attributeName;
        data["stringValue"] = this.stringValue;
        data["doubleValue"] = this.doubleValue;
        data["unit"] = this.unit;
        data["errorMessage"] = this.errorMessage;
        data["obis"] = this.obis;
        return data;
    }
}

/** Billing data buffer response */
export interface IOnDemandAttributeDataOut {
    /** Sample time utc */
    ingestionTime: Date;
    /** Meter time included time zone */
    meterTime: Date;
    /** Meter number */
    meterNumber: string | undefined;
    attributeName: string | undefined;
    stringValue?: string | undefined;
    doubleValue?: number | undefined;
    unit: string | undefined;
    errorMessage?: string | undefined;
    obis?: string | undefined;
}

export class OnDemandAttributeDataOutPaginationDataOut implements IOnDemandAttributeDataOutPaginationDataOut {
    count!: number;
    data!: OnDemandAttributeDataOut[] | undefined;

    constructor(data?: IOnDemandAttributeDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OnDemandAttributeDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OnDemandAttributeDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandAttributeDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IOnDemandAttributeDataOutPaginationDataOut {
    count: number;
    data: OnDemandAttributeDataOut[] | undefined;
}

/** Load profile on demand */
export class OnDemandDataIn implements IOnDemandDataIn {
    /** Meter number */
    meterNo!: string | undefined;
    /** Start date of meter reading */
    readFromDate!: Date;
    /** End date of meter reading */
    readToDate!: Date;

    constructor(data?: IOnDemandDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNo = _data["meterNo"];
            this.readFromDate = _data["readFromDate"] ? new Date(_data["readFromDate"].toString()) : <any>undefined;
            this.readToDate = _data["readToDate"] ? new Date(_data["readToDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OnDemandDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNo"] = this.meterNo;
        data["readFromDate"] = this.readFromDate ? this.readFromDate.toISOString() : <any>undefined;
        data["readToDate"] = this.readToDate ? this.readToDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Load profile on demand */
export interface IOnDemandDataIn {
    /** Meter number */
    meterNo: string | undefined;
    /** Start date of meter reading */
    readFromDate: Date;
    /** End date of meter reading */
    readToDate: Date;
}

export class OnDemandDetailsDataIn implements IOnDemandDetailsDataIn {
    commandId!: string;
    pageInfo!: PageInfo;

    constructor(data?: IOnDemandDetailsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandId = _data["commandId"];
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
        }
    }

    static fromJS(data: any): OnDemandDetailsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandDetailsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOnDemandDetailsDataIn {
    commandId: string;
    pageInfo: PageInfo;
}

/** Load profile on demand */
export class OnDemandReadRegisterIn implements IOnDemandReadRegisterIn {
    /** Meter number */
    meterNo!: string | undefined;
    /** List of attributes to read */
    attributesList!: DlmsAttributes[] | undefined;

    constructor(data?: IOnDemandReadRegisterIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNo = _data["meterNo"];
            if (Array.isArray(_data["attributesList"])) {
                this.attributesList = [] as any;
                for (let item of _data["attributesList"])
                    this.attributesList!.push(item);
            }
        }
    }

    static fromJS(data: any): OnDemandReadRegisterIn {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandReadRegisterIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNo"] = this.meterNo;
        if (Array.isArray(this.attributesList)) {
            data["attributesList"] = [];
            for (let item of this.attributesList)
                data["attributesList"].push(item);
        }
        return data;
    }
}

/** Load profile on demand */
export interface IOnDemandReadRegisterIn {
    /** Meter number */
    meterNo: string | undefined;
    /** List of attributes to read */
    attributesList: DlmsAttributes[] | undefined;
}

export class PageInfo implements IPageInfo {
    pageSize!: number;
    page!: number;

    constructor(data?: IPageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageSize = 10;
            this.page = 1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : 10;
            this.page = _data["page"] !== undefined ? _data["page"] : 1;
        }
    }

    static fromJS(data: any): PageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["page"] = this.page;
        return data;
    }
}

export interface IPageInfo {
    pageSize: number;
    page: number;
}

export class ParentMeterDataOut implements IParentMeterDataOut {
    id!: string;
    meterNumber!: string | undefined;
    assetType!: AssetType;
    assetTypeName?: string | undefined;
    asset!: string | undefined;
    assetNumber?: string | undefined;

    constructor(data?: IParentMeterDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.assetType = _data["assetType"];
            this.assetTypeName = _data["assetTypeName"];
            this.asset = _data["asset"];
            this.assetNumber = _data["assetNumber"];
        }
    }

    static fromJS(data: any): ParentMeterDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ParentMeterDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["assetType"] = this.assetType;
        data["assetTypeName"] = this.assetTypeName;
        data["asset"] = this.asset;
        data["assetNumber"] = this.assetNumber;
        return data;
    }
}

export interface IParentMeterDataOut {
    id: string;
    meterNumber: string | undefined;
    assetType: AssetType;
    assetTypeName?: string | undefined;
    asset: string | undefined;
    assetNumber?: string | undefined;
}

export class PendingMeterDataOut implements IPendingMeterDataOut {
    id!: string;
    meterNumber!: string | undefined;
    meterFirmware!: string | undefined;
    meterIp!: string | undefined;
    meterPort!: number;
    firstContactDate!: Date;
    meterModel?: string | undefined;
    meterModelName?: string | undefined;
    meterMake?: string | undefined;
    meterMakeName?: string | undefined;

    constructor(data?: IPendingMeterDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.meterFirmware = _data["meterFirmware"];
            this.meterIp = _data["meterIp"];
            this.meterPort = _data["meterPort"];
            this.firstContactDate = _data["firstContactDate"] ? new Date(_data["firstContactDate"].toString()) : <any>undefined;
            this.meterModel = _data["meterModel"];
            this.meterModelName = _data["meterModelName"];
            this.meterMake = _data["meterMake"];
            this.meterMakeName = _data["meterMakeName"];
        }
    }

    static fromJS(data: any): PendingMeterDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PendingMeterDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["meterFirmware"] = this.meterFirmware;
        data["meterIp"] = this.meterIp;
        data["meterPort"] = this.meterPort;
        data["firstContactDate"] = this.firstContactDate ? this.firstContactDate.toISOString() : <any>undefined;
        data["meterModel"] = this.meterModel;
        data["meterModelName"] = this.meterModelName;
        data["meterMake"] = this.meterMake;
        data["meterMakeName"] = this.meterMakeName;
        return data;
    }
}

export interface IPendingMeterDataOut {
    id: string;
    meterNumber: string | undefined;
    meterFirmware: string | undefined;
    meterIp: string | undefined;
    meterPort: number;
    firstContactDate: Date;
    meterModel?: string | undefined;
    meterModelName?: string | undefined;
    meterMake?: string | undefined;
    meterMakeName?: string | undefined;
}

export class PendingMeterDataOutPaginationDataOut implements IPendingMeterDataOutPaginationDataOut {
    count!: number;
    data!: PendingMeterDataOut[] | undefined;

    constructor(data?: IPendingMeterDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PendingMeterDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendingMeterDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PendingMeterDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPendingMeterDataOutPaginationDataOut {
    count: number;
    data: PendingMeterDataOut[] | undefined;
}

export class PendingMeterGetAllDataIn implements IPendingMeterGetAllDataIn {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting?: SortingType;

    constructor(data?: IPendingMeterGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): PendingMeterGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new PendingMeterGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IPendingMeterGetAllDataIn {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting?: SortingType;
}

export enum PermissionsEnum {
    Device_view = "device_view",
    Device_add = "device_add",
    Device_modify = "device_modify",
    Device_delete = "device_delete",
    Device_configure = "device_configure",
    Device_bulk_download = "device_bulk_download",
    Device_bulk_upload = "device_bulk_upload",
    Device_bulk_delete = "device_bulk_delete",
    Device_bulk_configure = "device_bulk_configure",
    Device_firmware_update = "device_firmware_update",
    Device_parents_view = "device_parents_view",
    Alarms_realtime_view = "alarms_realtime_view",
    Alarms_ondemand_view = "alarms_ondemand_view",
    Alarms_ondemand_execute = "alarms_ondemand_execute",
    Alarms_events_view = "alarms_events_view",
    Ondemand_energyregister_view = "ondemand_energyregister_view",
    Ondemand_energyregister_download = "ondemand_energyregister_download",
    Ondemand_energyregister_execute = "ondemand_energyregister_execute",
    Ondemand_powerdemandregister_view = "ondemand_powerdemandregister_view",
    Ondemand_powerdemandregister_download = "ondemand_powerdemandregister_download",
    Ondemand_powerdemandregister_execute = "ondemand_powerdemandregister_execute",
    Ondemand_instantaneousobject_view = "ondemand_instantaneousobject_view",
    Ondemand_instantaneousobject_download = "ondemand_instantaneousobject_download",
    Ondemand_instantaneousobject_execute = "ondemand_instantaneousobject_execute",
    Ondemand_billingdata_view = "ondemand_billingdata_view",
    Ondemand_billingdata_download = "ondemand_billingdata_download",
    Ondemand_billingdata_execute = "ondemand_billingdata_execute",
    Ondemand_billingdata_bulk_download = "ondemand_billingdata_bulk_download",
    Ondemand_loadprofile_view = "ondemand_loadprofile_view",
    Ondemand_loadprofile_download = "ondemand_loadprofile_download",
    Ondemand_loadprofile_execute = "ondemand_loadprofile_execute",
    Ondemand_event_log_view = "ondemand_event_log_view",
    Ondemand_event_log_download = "ondemand_event_log_download",
    Ondemand_event_log_execute = "ondemand_event_log_execute",
    Ondemand_generic_register_view = "ondemand_generic_register_view",
    Ondemand_generic_register_execute = "ondemand_generic_register_execute",
    Ondemand_last_device_configuration_view = "ondemand_last_device_configuration_view",
    Remotecommands_connectdisconnect_view = "remotecommands_connectdisconnect_view",
    Remotecommands_connectdisconnect_execute = "remotecommands_connectdisconnect_execute",
    Remotecommands_tokenload_view = "remotecommands_tokenload_view",
    Remotecommands_tokenload_execute = "remotecommands_tokenload_execute",
    Remotecommands_clearcredit_view = "remotecommands_clearcredit_view",
    Remotecommands_clearcredit_execute = "remotecommands_clearcredit_execute",
    Remotecommands_cleartamper_view = "remotecommands_cleartamper_view",
    Remotecommands_cleartamper_execute = "remotecommands_cleartamper_execute",
    Remotecommands_sequentialtokenload_view = "remotecommands_sequentialtokenload_view",
    Remotecommands_sequentialtokenload_execute = "remotecommands_sequentialtokenload_execute",
    Settings_crud_region_view = "settings_crud_region_view",
    Settings_crud_region_modify = "settings_crud_region_modify",
    Settings_crud_region_delete = "settings_crud_region_delete",
    Settings_crud_area_view = "settings_crud_area_view",
    Settings_crud_area_modify = "settings_crud_area_modify",
    Settings_crud_area_delete = "settings_crud_area_delete",
    Settings_crud_servicetype_view = "settings_crud_servicetype_view",
    Settings_crud_servicetype_modify = "settings_crud_servicetype_modify",
    Settings_crud_servicetype_delete = "settings_crud_servicetype_delete",
    Settings_crud_metermake_view = "settings_crud_metermake_view",
    Settings_crud_metermake_modify = "settings_crud_metermake_modify",
    Settings_crud_metermake_delete = "settings_crud_metermake_delete",
    Settings_crud_metermodel_view = "settings_crud_metermodel_view",
    Settings_crud_metermodel_modify = "settings_crud_metermodel_modify",
    Settings_crud_metermodel_delete = "settings_crud_metermodel_delete",
    Settings_crud_assettype_view = "settings_crud_assettype_view",
    Settings_crud_assettype_modify = "settings_crud_assettype_modify",
    Settings_crud_assettype_delete = "settings_crud_assettype_delete",
    Settings_crud_association_view = "settings_crud_association_view",
    Settings_crud_association_modify = "settings_crud_association_modify",
    Settings_team_member_view = "settings_team_member_view",
    Settings_team_member_modify = "settings_team_member_modify",
    Settings_team_member_bulk_upload = "settings_team_member_bulk_upload",
    Settings_team_member_delete = "settings_team_member_delete",
    Settings_team_role_view = "settings_team_role_view",
    Settings_team_role_modify = "settings_team_role_modify",
    Settings_team_role_delete = "settings_team_role_delete",
    Scheduler_view = "scheduler_view",
    Scheduler_modify = "scheduler_modify",
    Scheduler_delete = "scheduler_delete",
    Scheduler_monitoring = "scheduler_monitoring",
    Scheduler_monitoring_download = "scheduler_monitoring_download",
    Auditlog_view = "auditlog_view",
    Personalize_view = "personalize_view",
    Personalize_modify = "personalize_modify",
    Systemmonitoring_acquisition_view = "systemmonitoring_acquisition_view",
    Systemmonitoring_deviceconnectiontime_view = "systemmonitoring_deviceconnectiontime_view",
    Systemmonitoring_jobstatushistory_view = "systemmonitoring_jobstatushistory_view",
    Systemmonitoring_jobstatushistory_download = "systemmonitoring_jobstatushistory_download",
    Systemmonitoring_acquisition_download = "systemmonitoring_acquisition_download",
    Systemmonitoring_deviceconnectiontime_download = "systemmonitoring_deviceconnectiontime_download",
    Scheduled_energyregister_view = "scheduled_energyregister_view",
    Scheduled_energyregister_download = "scheduled_energyregister_download",
    Scheduled_energyregister_bulk_download = "scheduled_energyregister_bulk_download",
    Scheduled_powerdemandregister_view = "scheduled_powerdemandregister_view",
    Scheduled_powerdemandregister_download = "scheduled_powerdemandregister_download",
    Scheduled_powerdemandregister_bulk_download = "scheduled_powerdemandregister_bulk_download",
    Scheduled_instantaneousobject_view = "scheduled_instantaneousobject_view",
    Scheduled_instantaneousobject_download = "scheduled_instantaneousobject_download",
    Scheduled_instantaneousobject_bulk_download = "scheduled_instantaneousobject_bulk_download",
    Scheduled_loadprofile_view = "scheduled_loadprofile_view",
    Scheduled_loadprofile_download = "scheduled_loadprofile_download",
    Scheduled_loadprofile_bulk_download = "scheduled_loadprofile_bulk_download",
    Scheduled_event_log_view = "scheduled_event_log_view",
    Scheduled_event_log_download = "scheduled_event_log_download",
    Report_meter_time_sync_view = "report_meter_time_sync_view",
    Report_meter_time_sync_execute = "report_meter_time_sync_execute",
    Report_fraudulent_meters_view = "report_fraudulent_meters_view",
    Report_prepayment_view = "report_prepayment_view",
    Report_fraudulent_meters_download = "report_fraudulent_meters_download",
    Report_prepayment_download = "report_prepayment_download",
    Report_meter_time_sync_download = "report_meter_time_sync_download",
    Report_energy_per_phase_view = "report_energy_per_phase_view",
    Report_energy_per_phase_download = "report_energy_per_phase_download",
    Report_energy_per_phase_bulk_download = "report_energy_per_phase_bulk_download",
    Desktop_app = "desktop_app",
    Desktop_meter_model_view = "desktop_meter_model_view",
    Desktop_meter_model_modify = "desktop_meter_model_modify",
    Desktop_meter_model_add = "desktop_meter_model_add",
    Desktop_meter_make_view = "desktop_meter_make_view",
    Desktop_meter_make_modify = "desktop_meter_make_modify",
    Desktop_meter_make_add = "desktop_meter_make_add",
    Desktop_device_view = "desktop_device_view",
    Desktop_device_download = "desktop_device_download",
    Desktop_meter_setup = "desktop_meter_setup",
    Desktop_bulk_device_view = "desktop_bulk_device_view",
    Desktop_bulk_device_execute = "desktop_bulk_device_execute",
    Desktop_register_view = "desktop_register_view",
    Desktop_firmware_update_execute = "desktop_firmware_update_execute",
    Desktop_load_limit = "desktop_load_limit",
    Desktop_parents_view = "desktop_parents_view",
    Tariff_view = "tariff_view",
    Tariff_add = "tariff_add",
    Tariff_modify = "tariff_modify",
    Tariff_delete = "tariff_delete",
    Loadlimit_view = "loadlimit_view",
    Loadlimit_add = "loadlimit_add",
    Loadlimit_modify = "loadlimit_modify",
    Loadlimit_delete = "loadlimit_delete",
    Gsmapi_ipsec = "gsmapi_ipsec",
}

export class PowerDemandBufferDataOut implements IPowerDemandBufferDataOut {
    ingestionTime!: Date;
    meterTime!: Date;
    meterNumber!: string | undefined;
    instantaneousActivePowerImport?: number | undefined;
    instantaneousActivePowerExport?: number | undefined;
    maxDemandActivePowerImport?: number | undefined;
    maxDemandActivePowerExport?: number | undefined;
    instantaneousReactivePowerImport?: number | undefined;
    instantaneousReactivePowerExport?: number | undefined;
    maxDemandReactivePowerImport?: number | undefined;
    maxDemandReactivePowerExport?: number | undefined;
    maxDemandApparentPowerImport?: number | undefined;
    maxDemandApparentPowerExport?: number | undefined;
    instantaneousApparentPowerImport?: number | undefined;
    instantaneousApparentPowerExport?: number | undefined;

    constructor(data?: IPowerDemandBufferDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.instantaneousActivePowerImport = _data["instantaneousActivePowerImport"];
            this.instantaneousActivePowerExport = _data["instantaneousActivePowerExport"];
            this.maxDemandActivePowerImport = _data["maxDemandActivePowerImport"];
            this.maxDemandActivePowerExport = _data["maxDemandActivePowerExport"];
            this.instantaneousReactivePowerImport = _data["instantaneousReactivePowerImport"];
            this.instantaneousReactivePowerExport = _data["instantaneousReactivePowerExport"];
            this.maxDemandReactivePowerImport = _data["maxDemandReactivePowerImport"];
            this.maxDemandReactivePowerExport = _data["maxDemandReactivePowerExport"];
            this.maxDemandApparentPowerImport = _data["maxDemandApparentPowerImport"];
            this.maxDemandApparentPowerExport = _data["maxDemandApparentPowerExport"];
            this.instantaneousApparentPowerImport = _data["instantaneousApparentPowerImport"];
            this.instantaneousApparentPowerExport = _data["instantaneousApparentPowerExport"];
        }
    }

    static fromJS(data: any): PowerDemandBufferDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PowerDemandBufferDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["instantaneousActivePowerImport"] = this.instantaneousActivePowerImport;
        data["instantaneousActivePowerExport"] = this.instantaneousActivePowerExport;
        data["maxDemandActivePowerImport"] = this.maxDemandActivePowerImport;
        data["maxDemandActivePowerExport"] = this.maxDemandActivePowerExport;
        data["instantaneousReactivePowerImport"] = this.instantaneousReactivePowerImport;
        data["instantaneousReactivePowerExport"] = this.instantaneousReactivePowerExport;
        data["maxDemandReactivePowerImport"] = this.maxDemandReactivePowerImport;
        data["maxDemandReactivePowerExport"] = this.maxDemandReactivePowerExport;
        data["maxDemandApparentPowerImport"] = this.maxDemandApparentPowerImport;
        data["maxDemandApparentPowerExport"] = this.maxDemandApparentPowerExport;
        data["instantaneousApparentPowerImport"] = this.instantaneousApparentPowerImport;
        data["instantaneousApparentPowerExport"] = this.instantaneousApparentPowerExport;
        return data;
    }
}

export interface IPowerDemandBufferDataOut {
    ingestionTime: Date;
    meterTime: Date;
    meterNumber: string | undefined;
    instantaneousActivePowerImport?: number | undefined;
    instantaneousActivePowerExport?: number | undefined;
    maxDemandActivePowerImport?: number | undefined;
    maxDemandActivePowerExport?: number | undefined;
    instantaneousReactivePowerImport?: number | undefined;
    instantaneousReactivePowerExport?: number | undefined;
    maxDemandReactivePowerImport?: number | undefined;
    maxDemandReactivePowerExport?: number | undefined;
    maxDemandApparentPowerImport?: number | undefined;
    maxDemandApparentPowerExport?: number | undefined;
    instantaneousApparentPowerImport?: number | undefined;
    instantaneousApparentPowerExport?: number | undefined;
}

export class PowerDemandBufferDataOutPaginationDataOut implements IPowerDemandBufferDataOutPaginationDataOut {
    count!: number;
    data!: PowerDemandBufferDataOut[] | undefined;

    constructor(data?: IPowerDemandBufferDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PowerDemandBufferDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PowerDemandBufferDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PowerDemandBufferDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPowerDemandBufferDataOutPaginationDataOut {
    count: number;
    data: PowerDemandBufferDataOut[] | undefined;
}

export class PowerDemandReadDataOut implements IPowerDemandReadDataOut {
    meterTime!: Date;
    instantaneousActivePowerImport?: number | undefined;
    instantaneousActivePowerExport?: number | undefined;
    maxDemandActivePowerImport?: number | undefined;
    maxDemandActivePowerExport?: number | undefined;
    instantaneousReactivePowerImport?: number | undefined;
    instantaneousReactivePowerExport?: number | undefined;
    maxDemandReactivePowerImport?: number | undefined;
    maxDemandReactivePowerExport?: number | undefined;
    maxDemandApparentPowerImport?: number | undefined;
    maxDemandApparentPowerExport?: number | undefined;
    instantaneousApparentPowerImport?: number | undefined;
    instantaneousApparentPowerExport?: number | undefined;

    constructor(data?: IPowerDemandReadDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterTime = _data["meterTime"] ? new Date(_data["meterTime"].toString()) : <any>undefined;
            this.instantaneousActivePowerImport = _data["instantaneousActivePowerImport"];
            this.instantaneousActivePowerExport = _data["instantaneousActivePowerExport"];
            this.maxDemandActivePowerImport = _data["maxDemandActivePowerImport"];
            this.maxDemandActivePowerExport = _data["maxDemandActivePowerExport"];
            this.instantaneousReactivePowerImport = _data["instantaneousReactivePowerImport"];
            this.instantaneousReactivePowerExport = _data["instantaneousReactivePowerExport"];
            this.maxDemandReactivePowerImport = _data["maxDemandReactivePowerImport"];
            this.maxDemandReactivePowerExport = _data["maxDemandReactivePowerExport"];
            this.maxDemandApparentPowerImport = _data["maxDemandApparentPowerImport"];
            this.maxDemandApparentPowerExport = _data["maxDemandApparentPowerExport"];
            this.instantaneousApparentPowerImport = _data["instantaneousApparentPowerImport"];
            this.instantaneousApparentPowerExport = _data["instantaneousApparentPowerExport"];
        }
    }

    static fromJS(data: any): PowerDemandReadDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PowerDemandReadDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterTime"] = this.meterTime ? this.meterTime.toISOString() : <any>undefined;
        data["instantaneousActivePowerImport"] = this.instantaneousActivePowerImport;
        data["instantaneousActivePowerExport"] = this.instantaneousActivePowerExport;
        data["maxDemandActivePowerImport"] = this.maxDemandActivePowerImport;
        data["maxDemandActivePowerExport"] = this.maxDemandActivePowerExport;
        data["instantaneousReactivePowerImport"] = this.instantaneousReactivePowerImport;
        data["instantaneousReactivePowerExport"] = this.instantaneousReactivePowerExport;
        data["maxDemandReactivePowerImport"] = this.maxDemandReactivePowerImport;
        data["maxDemandReactivePowerExport"] = this.maxDemandReactivePowerExport;
        data["maxDemandApparentPowerImport"] = this.maxDemandApparentPowerImport;
        data["maxDemandApparentPowerExport"] = this.maxDemandApparentPowerExport;
        data["instantaneousApparentPowerImport"] = this.instantaneousApparentPowerImport;
        data["instantaneousApparentPowerExport"] = this.instantaneousApparentPowerExport;
        return data;
    }
}

export interface IPowerDemandReadDataOut {
    meterTime: Date;
    instantaneousActivePowerImport?: number | undefined;
    instantaneousActivePowerExport?: number | undefined;
    maxDemandActivePowerImport?: number | undefined;
    maxDemandActivePowerExport?: number | undefined;
    instantaneousReactivePowerImport?: number | undefined;
    instantaneousReactivePowerExport?: number | undefined;
    maxDemandReactivePowerImport?: number | undefined;
    maxDemandReactivePowerExport?: number | undefined;
    maxDemandApparentPowerImport?: number | undefined;
    maxDemandApparentPowerExport?: number | undefined;
    instantaneousApparentPowerImport?: number | undefined;
    instantaneousApparentPowerExport?: number | undefined;
}

export class PrepaymentDataOut implements IPrepaymentDataOut {
    meterNumber!: string | undefined;
    meterType?: MeterType;
    rechargeAmount!: number;
    tokenNumber!: string | undefined;
    capturedTime!: Date;
    rechargeUnit!: string | undefined;

    constructor(data?: IPrepaymentDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.meterType = _data["meterType"];
            this.rechargeAmount = _data["rechargeAmount"];
            this.tokenNumber = _data["tokenNumber"];
            this.capturedTime = _data["capturedTime"] ? new Date(_data["capturedTime"].toString()) : <any>undefined;
            this.rechargeUnit = _data["rechargeUnit"];
        }
    }

    static fromJS(data: any): PrepaymentDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaymentDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["meterType"] = this.meterType;
        data["rechargeAmount"] = this.rechargeAmount;
        data["tokenNumber"] = this.tokenNumber;
        data["capturedTime"] = this.capturedTime ? this.capturedTime.toISOString() : <any>undefined;
        data["rechargeUnit"] = this.rechargeUnit;
        return data;
    }
}

export interface IPrepaymentDataOut {
    meterNumber: string | undefined;
    meterType?: MeterType;
    rechargeAmount: number;
    tokenNumber: string | undefined;
    capturedTime: Date;
    rechargeUnit: string | undefined;
}

export class PrepaymentDataOutPaginationDataOut implements IPrepaymentDataOutPaginationDataOut {
    count!: number;
    data!: PrepaymentDataOut[] | undefined;

    constructor(data?: IPrepaymentDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PrepaymentDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrepaymentDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaymentDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPrepaymentDataOutPaginationDataOut {
    count: number;
    data: PrepaymentDataOut[] | undefined;
}

export class PrepaymentGetAllDataIn implements IPrepaymentGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IPrepaymentGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrepaymentGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaymentGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPrepaymentGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class QueryAlarmDataOut implements IQueryAlarmDataOut {
    eventType?: EventDataChannel;
    alarmType?: string | undefined;
    readOnMeterTime!: Date;
    ingestionTime!: Date;
    meterNumber!: string | undefined;
    eventId?: string | undefined;
    commandId?: string | undefined;
    assetType!: string | undefined;
    activeAlarms!: string[] | undefined;

    constructor(data?: IQueryAlarmDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.alarmType = _data["alarmType"];
            this.readOnMeterTime = _data["readOnMeterTime"] ? new Date(_data["readOnMeterTime"].toString()) : <any>undefined;
            this.ingestionTime = _data["ingestionTime"] ? new Date(_data["ingestionTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.eventId = _data["eventId"];
            this.commandId = _data["commandId"];
            this.assetType = _data["assetType"];
            if (Array.isArray(_data["activeAlarms"])) {
                this.activeAlarms = [] as any;
                for (let item of _data["activeAlarms"])
                    this.activeAlarms!.push(item);
            }
        }
    }

    static fromJS(data: any): QueryAlarmDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryAlarmDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["alarmType"] = this.alarmType;
        data["readOnMeterTime"] = this.readOnMeterTime ? this.readOnMeterTime.toISOString() : <any>undefined;
        data["ingestionTime"] = this.ingestionTime ? this.ingestionTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["eventId"] = this.eventId;
        data["commandId"] = this.commandId;
        data["assetType"] = this.assetType;
        if (Array.isArray(this.activeAlarms)) {
            data["activeAlarms"] = [];
            for (let item of this.activeAlarms)
                data["activeAlarms"].push(item);
        }
        return data;
    }
}

export interface IQueryAlarmDataOut {
    eventType?: EventDataChannel;
    alarmType?: string | undefined;
    readOnMeterTime: Date;
    ingestionTime: Date;
    meterNumber: string | undefined;
    eventId?: string | undefined;
    commandId?: string | undefined;
    assetType: string | undefined;
    activeAlarms: string[] | undefined;
}

export class QueryAlarmDataOutPaginationDataOut implements IQueryAlarmDataOutPaginationDataOut {
    count!: number;
    data!: QueryAlarmDataOut[] | undefined;

    constructor(data?: IQueryAlarmDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QueryAlarmDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryAlarmDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryAlarmDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQueryAlarmDataOutPaginationDataOut {
    count: number;
    data: QueryAlarmDataOut[] | undefined;
}

export class QueryEventAlarmDataIn implements IQueryEventAlarmDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes!: string[] | undefined;

    constructor(data?: IQueryEventAlarmDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): QueryEventAlarmDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new QueryEventAlarmDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        return data;
    }
}

export interface IQueryEventAlarmDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    assetTypes: string[] | undefined;
}

export class QueryScheduledDataReadDataIn implements IQueryScheduledDataReadDataIn {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting!: SortingType;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes?: string[] | undefined;
    /** List of area GUIDs to filter meters by area. */
    areas?: string[] | undefined;
    /** List of region GUIDs to filter meters by region. Expanded to area IDs at the controller level. */
    regions?: string[] | undefined;

    constructor(data?: IQueryScheduledDataReadDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
        }
    }

    static fromJS(data: any): QueryScheduledDataReadDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new QueryScheduledDataReadDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        return data;
    }
}

export interface IQueryScheduledDataReadDataIn {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    startDate?: Date | undefined;
    /** Date Time type field, represents a field that performs a filter by meter installation date. */
    endDate?: Date | undefined;
    sorting: SortingType;
    /** List enum values type field, represents a filter parameter by asset type of asset to which the meter is connected */
    assetTypes?: string[] | undefined;
    /** List of area GUIDs to filter meters by area. */
    areas?: string[] | undefined;
    /** List of region GUIDs to filter meters by region. Expanded to area IDs at the controller level. */
    regions?: string[] | undefined;
}

export class QueryScheduledDataReadDataOut implements IQueryScheduledDataReadDataOut {
    readOnMeterTime?: Date | undefined;
    serviceName!: string | undefined;
    assetType!: string | undefined;
    meterNumber!: string | undefined;
    meterId!: string;
    area!: string | undefined;
    region!: string | undefined;

    constructor(data?: IQueryScheduledDataReadDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readOnMeterTime = _data["readOnMeterTime"] ? new Date(_data["readOnMeterTime"].toString()) : <any>undefined;
            this.serviceName = _data["serviceName"];
            this.assetType = _data["assetType"];
            this.meterNumber = _data["meterNumber"];
            this.meterId = _data["meterId"];
            this.area = _data["area"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): QueryScheduledDataReadDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryScheduledDataReadDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readOnMeterTime"] = this.readOnMeterTime ? this.readOnMeterTime.toISOString() : <any>undefined;
        data["serviceName"] = this.serviceName;
        data["assetType"] = this.assetType;
        data["meterNumber"] = this.meterNumber;
        data["meterId"] = this.meterId;
        data["area"] = this.area;
        data["region"] = this.region;
        return data;
    }
}

export interface IQueryScheduledDataReadDataOut {
    readOnMeterTime?: Date | undefined;
    serviceName: string | undefined;
    assetType: string | undefined;
    meterNumber: string | undefined;
    meterId: string;
    area: string | undefined;
    region: string | undefined;
}

export class QueryScheduledDataReadDataOutPaginationDataOut implements IQueryScheduledDataReadDataOutPaginationDataOut {
    count!: number;
    data!: QueryScheduledDataReadDataOut[] | undefined;

    constructor(data?: IQueryScheduledDataReadDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QueryScheduledDataReadDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryScheduledDataReadDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryScheduledDataReadDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQueryScheduledDataReadDataOutPaginationDataOut {
    count: number;
    data: QueryScheduledDataReadDataOut[] | undefined;
}

export class QuerySequentialTokenDataIn implements IQuerySequentialTokenDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: CommandStatus;

    constructor(data?: IQuerySequentialTokenDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): QuerySequentialTokenDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySequentialTokenDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        return data;
    }
}

export interface IQuerySequentialTokenDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: CommandStatus;
}

export class QuerySequentialTokenDataOut implements IQuerySequentialTokenDataOut {
    id!: string;
    assetType?: string | undefined;
    serviceName!: string | undefined;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    commandStatus!: CommandStatus;
    source!: CommandSource;
    failCount!: number;
    maxRetryCount!: number;
    errorMessage?: string | undefined;

    constructor(data?: IQuerySequentialTokenDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.commandStatus = _data["commandStatus"];
            this.source = _data["source"];
            this.failCount = _data["failCount"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): QuerySequentialTokenDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySequentialTokenDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["commandStatus"] = this.commandStatus;
        data["source"] = this.source;
        data["failCount"] = this.failCount;
        data["maxRetryCount"] = this.maxRetryCount;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IQuerySequentialTokenDataOut {
    id: string;
    assetType?: string | undefined;
    serviceName: string | undefined;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    commandStatus: CommandStatus;
    source: CommandSource;
    failCount: number;
    maxRetryCount: number;
    errorMessage?: string | undefined;
}

export class QuerySequentialTokenDataOutPaginationDataOut implements IQuerySequentialTokenDataOutPaginationDataOut {
    count!: number;
    data!: QuerySequentialTokenDataOut[] | undefined;

    constructor(data?: IQuerySequentialTokenDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuerySequentialTokenDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuerySequentialTokenDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySequentialTokenDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQuerySequentialTokenDataOutPaginationDataOut {
    count: number;
    data: QuerySequentialTokenDataOut[] | undefined;
}

export class QueryTokenDataIn implements IQueryTokenDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: TokenStatus;

    constructor(data?: IQueryTokenDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): QueryTokenDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        return data;
    }
}

export interface IQueryTokenDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: TokenStatus;
}

export class QueryTokenDataOut implements IQueryTokenDataOut {
    id!: string;
    commandId!: string;
    assetType?: string | undefined;
    serviceName!: string | undefined;
    errorMessage?: string | undefined;
    meterNo!: string | undefined;
    startTime?: Date | undefined;
    tokenStatus!: TokenStatus;
    commandStatus!: CommandStatus;
    source!: CommandSource;
    type!: CommandMessageType;
    failCount!: number;
    maxRetryCount!: number;
    token!: string | undefined;
    executionOrder?: number | undefined;

    constructor(data?: IQueryTokenDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commandId = _data["commandId"];
            this.assetType = _data["assetType"];
            this.serviceName = _data["serviceName"];
            this.errorMessage = _data["errorMessage"];
            this.meterNo = _data["meterNo"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.tokenStatus = _data["tokenStatus"];
            this.commandStatus = _data["commandStatus"];
            this.source = _data["source"];
            this.type = _data["type"];
            this.failCount = _data["failCount"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.token = _data["token"];
            this.executionOrder = _data["executionOrder"];
        }
    }

    static fromJS(data: any): QueryTokenDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commandId"] = this.commandId;
        data["assetType"] = this.assetType;
        data["serviceName"] = this.serviceName;
        data["errorMessage"] = this.errorMessage;
        data["meterNo"] = this.meterNo;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["tokenStatus"] = this.tokenStatus;
        data["commandStatus"] = this.commandStatus;
        data["source"] = this.source;
        data["type"] = this.type;
        data["failCount"] = this.failCount;
        data["maxRetryCount"] = this.maxRetryCount;
        data["token"] = this.token;
        data["executionOrder"] = this.executionOrder;
        return data;
    }
}

export interface IQueryTokenDataOut {
    id: string;
    commandId: string;
    assetType?: string | undefined;
    serviceName: string | undefined;
    errorMessage?: string | undefined;
    meterNo: string | undefined;
    startTime?: Date | undefined;
    tokenStatus: TokenStatus;
    commandStatus: CommandStatus;
    source: CommandSource;
    type: CommandMessageType;
    failCount: number;
    maxRetryCount: number;
    token: string | undefined;
    executionOrder?: number | undefined;
}

export class QueryTokenDataOutPaginationDataOut implements IQueryTokenDataOutPaginationDataOut {
    count!: number;
    data!: QueryTokenDataOut[] | undefined;

    constructor(data?: IQueryTokenDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QueryTokenDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryTokenDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQueryTokenDataOutPaginationDataOut {
    count: number;
    data: QueryTokenDataOut[] | undefined;
}

export class QueryTokenDeviceDetailsDataIn implements IQueryTokenDeviceDetailsDataIn {
    pageInfo!: PageInfo;
    meterId?: string | undefined;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: TokenStatus;
    type?: TokenType;

    constructor(data?: IQueryTokenDeviceDetailsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.meterId = _data["meterId"];
            this.search = _data["search"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): QueryTokenDeviceDetailsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDeviceDetailsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["meterId"] = this.meterId;
        data["search"] = this.search;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IQueryTokenDeviceDetailsDataIn {
    pageInfo: PageInfo;
    meterId?: string | undefined;
    search?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: SortingType;
    status?: TokenStatus;
    type?: TokenType;
}

export class QueryTokenDeviceDetailsDataOut implements IQueryTokenDeviceDetailsDataOut {
    id!: string;
    commandId!: string;
    source!: CommandSource;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    tokenStatus!: TokenStatus;
    type!: TokenType;
    token!: string | undefined;
    tokenAmount?: number | undefined;

    constructor(data?: IQueryTokenDeviceDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commandId = _data["commandId"];
            this.source = _data["source"];
            this.errorMessage = _data["errorMessage"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.tokenStatus = _data["tokenStatus"];
            this.type = _data["type"];
            this.token = _data["token"];
            this.tokenAmount = _data["tokenAmount"];
        }
    }

    static fromJS(data: any): QueryTokenDeviceDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDeviceDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commandId"] = this.commandId;
        data["source"] = this.source;
        data["errorMessage"] = this.errorMessage;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["tokenStatus"] = this.tokenStatus;
        data["type"] = this.type;
        data["token"] = this.token;
        data["tokenAmount"] = this.tokenAmount;
        return data;
    }
}

export interface IQueryTokenDeviceDetailsDataOut {
    id: string;
    commandId: string;
    source: CommandSource;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    tokenStatus: TokenStatus;
    type: TokenType;
    token: string | undefined;
    tokenAmount?: number | undefined;
}

export class QueryTokenDeviceDetailsDataOutPaginationDataOut implements IQueryTokenDeviceDetailsDataOutPaginationDataOut {
    count!: number;
    data!: QueryTokenDeviceDetailsDataOut[] | undefined;

    constructor(data?: IQueryTokenDeviceDetailsDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QueryTokenDeviceDetailsDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryTokenDeviceDetailsDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTokenDeviceDetailsDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQueryTokenDeviceDetailsDataOutPaginationDataOut {
    count: number;
    data: QueryTokenDeviceDetailsDataOut[] | undefined;
}

export class RatioDataIn implements IRatioDataIn {
    numerator!: number;
    denominator!: number;

    constructor(data?: IRatioDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numerator = _data["numerator"];
            this.denominator = _data["denominator"];
        }
    }

    static fromJS(data: any): RatioDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RatioDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numerator"] = this.numerator;
        data["denominator"] = this.denominator;
        return data;
    }
}

export interface IRatioDataIn {
    numerator: number;
    denominator: number;
}

export class RecommendedRegisterDto implements IRecommendedRegisterDto {
    attribute!: DlmsAttributes;
    name!: string | undefined;
    obis!: string | undefined;

    constructor(data?: IRecommendedRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["attribute"];
            this.name = _data["name"];
            this.obis = _data["obis"];
        }
    }

    static fromJS(data: any): RecommendedRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        data["name"] = this.name;
        data["obis"] = this.obis;
        return data;
    }
}

export interface IRecommendedRegisterDto {
    attribute: DlmsAttributes;
    name: string | undefined;
    obis: string | undefined;
}

export class RecommendedRegisterGroupDto implements IRecommendedRegisterGroupDto {
    /** Translation key the clients use as the group heading. */
    titleKey!: string | undefined;
    registers!: RecommendedRegisterDto[] | undefined;

    constructor(data?: IRecommendedRegisterGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleKey = _data["titleKey"];
            if (Array.isArray(_data["registers"])) {
                this.registers = [] as any;
                for (let item of _data["registers"])
                    this.registers!.push(RecommendedRegisterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecommendedRegisterGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedRegisterGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleKey"] = this.titleKey;
        if (Array.isArray(this.registers)) {
            data["registers"] = [];
            for (let item of this.registers)
                data["registers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRecommendedRegisterGroupDto {
    /** Translation key the clients use as the group heading. */
    titleKey: string | undefined;
    registers: RecommendedRegisterDto[] | undefined;
}

export class RegionDataIn implements IRegionDataIn {
    id?: string | undefined;
    name!: string;
    code!: string;

    constructor(data?: IRegionDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): RegionDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IRegionDataIn {
    id?: string | undefined;
    name: string;
    code: string;
}

export class RegionDetailsDataOut implements IRegionDetailsDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IRegionDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): RegionDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IRegionDetailsDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class RegionDetailsDataOutPaginationDataOut implements IRegionDetailsDataOutPaginationDataOut {
    count!: number;
    data!: RegionDetailsDataOut[] | undefined;

    constructor(data?: IRegionDetailsDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegionDetailsDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionDetailsDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDetailsDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRegionDetailsDataOutPaginationDataOut {
    count: number;
    data: RegionDetailsDataOut[] | undefined;
}

export class RegionGetAllDataIn implements IRegionGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IRegionGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): RegionGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RegionGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IRegionGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class RegisterDescriptionDto implements IRegisterDescriptionDto {
    name!: string;
    obis!: string;
    objectType!: DlmsObjectType;
    inUse?: boolean | undefined;

    constructor(data?: IRegisterDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.obis = _data["obis"];
            this.objectType = _data["objectType"];
            this.inUse = _data["inUse"];
        }
    }

    static fromJS(data: any): RegisterDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["obis"] = this.obis;
        data["objectType"] = this.objectType;
        data["inUse"] = this.inUse;
        return data;
    }
}

export interface IRegisterDescriptionDto {
    name: string;
    obis: string;
    objectType: DlmsObjectType;
    inUse?: boolean | undefined;
}

export class RemoteTokenDataIn implements IRemoteTokenDataIn {
    meterNumber!: string | undefined;
    webhookUrl?: string | undefined;
    tokens!: ExternalTokenDataIn[] | undefined;

    constructor(data?: IRemoteTokenDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.webhookUrl = _data["webhookUrl"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(ExternalTokenDataIn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteTokenDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteTokenDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["webhookUrl"] = this.webhookUrl;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRemoteTokenDataIn {
    meterNumber: string | undefined;
    webhookUrl?: string | undefined;
    tokens: ExternalTokenDataIn[] | undefined;
}

export class RemoteTokenResponse implements IRemoteTokenResponse {
    trackingId!: string;
    status!: CommandStatus;
    webhookUrl?: string | undefined;
    meterNumber!: string | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IRemoteTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingId = _data["trackingId"];
            this.status = _data["status"];
            this.webhookUrl = _data["webhookUrl"];
            this.meterNumber = _data["meterNumber"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): RemoteTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingId"] = this.trackingId;
        data["status"] = this.status;
        data["webhookUrl"] = this.webhookUrl;
        data["meterNumber"] = this.meterNumber;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IRemoteTokenResponse {
    trackingId: string;
    status: CommandStatus;
    webhookUrl?: string | undefined;
    meterNumber: string | undefined;
    errorMessage: string | undefined;
}

export class ResponseError implements IResponseError {
    errorCode!: ResponseErrorCode;
    message!: string | undefined;

    constructor(data?: IResponseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseError {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseError {
    errorCode: ResponseErrorCode;
    message: string | undefined;
}

export enum ResponseErrorCode {
    Exception = "Exception",
    Database_NotFound = "Database_NotFound",
    Database_BadData = "Database_BadData",
    Database_Unsupported = "Database_Unsupported",
    Meter_Problem = "Meter_Problem",
    Meter_Model_Problem = "Meter_Model_Problem",
    Meter_ConnectionConfigProblem = "Meter_ConnectionConfigProblem",
    Meter_NotAvailable = "Meter_NotAvailable",
    Meter_SetupProblem = "Meter_SetupProblem",
    Meter_MissingAssociation = "Meter_MissingAssociation",
    Meter_UnmatchedType = "Meter_UnmatchedType",
    Meter_OverflowError = "Meter_OverflowError",
    Meter_AccessDenied = "Meter_AccessDenied",
    Meter_UndefinedObject = "Meter_UndefinedObject",
    Storage_FileNotFound = "Storage_FileNotFound",
    ParsingProblem = "ParsingProblem",
    SwitchProblem = "SwitchProblem",
    DeserializeProblem = "DeserializeProblem",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    Forbidden = "Forbidden",
    ExternalServiceError = "ExternalServiceError",
    Token_Matching = "Token_Matching",
    OrleansGrainProblem = "OrleansGrainProblem",
    OrleansReminderProblem = "OrleansReminderProblem",
    IdentityError = "IdentityError",
    GsmApiError = "GsmApiError",
    GsmApiRateLimit = "GsmApiRateLimit",
    DesktopForbidden = "DesktopForbidden",
}

export class RoleCrud implements IRoleCrud {
    id!: string;
    name!: string | undefined;
    status!: UserStatus;
    createdTime!: Date;
    createdByUserEmail!: string | undefined;
    permissions!: PermissionsEnum[] | undefined;

    constructor(data?: IRoleCrud) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.createdByUserEmail = _data["createdByUserEmail"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleCrud {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCrud();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["createdByUserEmail"] = this.createdByUserEmail;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleCrud {
    id: string;
    name: string | undefined;
    status: UserStatus;
    createdTime: Date;
    createdByUserEmail: string | undefined;
    permissions: PermissionsEnum[] | undefined;
}

export class RoleDataIn implements IRoleDataIn {
    id?: string | undefined;
    name?: string | undefined;
    permissions?: PermissionsEnum[] | undefined;

    constructor(data?: IRoleDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleDataIn {
    id?: string | undefined;
    name?: string | undefined;
    permissions?: PermissionsEnum[] | undefined;
}

export class RoleDataOut implements IRoleDataOut {
    id!: string;
    name!: string | undefined;
    status!: UserStatus;
    createdTime!: Date;
    createdByUserEmail!: string | undefined;
    permissions!: PermissionsEnum[] | undefined;

    constructor(data?: IRoleDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.createdByUserEmail = _data["createdByUserEmail"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["createdByUserEmail"] = this.createdByUserEmail;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleDataOut {
    id: string;
    name: string | undefined;
    status: UserStatus;
    createdTime: Date;
    createdByUserEmail: string | undefined;
    permissions: PermissionsEnum[] | undefined;
}

export class RoleDataOutPaginationDataOut implements IRoleDataOutPaginationDataOut {
    count!: number;
    data!: RoleDataOut[] | undefined;

    constructor(data?: IRoleDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRoleDataOutPaginationDataOut {
    count: number;
    data: RoleDataOut[] | undefined;
}

export class RoleGetAllDataIn implements IRoleGetAllDataIn {
    userId?: number | undefined;
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IRoleGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): RoleGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IRoleGetAllDataIn {
    userId?: number | undefined;
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class RoleSimpleDataOut implements IRoleSimpleDataOut {
    id!: string;
    name!: string | undefined;
    status!: UserStatus;

    constructor(data?: IRoleSimpleDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoleSimpleDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new RoleSimpleDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IRoleSimpleDataOut {
    id: string;
    name: string | undefined;
    status: UserStatus;
}

export class RoleStatusUpdate implements IRoleStatusUpdate {
    roleId!: string;
    status!: UserStatus;

    constructor(data?: IRoleStatusUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoleStatusUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new RoleStatusUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["status"] = this.status;
        return data;
    }
}

export interface IRoleStatusUpdate {
    roleId: string;
    status: UserStatus;
}

export class Scaler implements IScaler {
    attribute!: DlmsAttributes;
    value!: number;

    constructor(data?: IScaler) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["attribute"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Scaler {
        data = typeof data === 'object' ? data : {};
        let result = new Scaler();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        data["value"] = this.value;
        return data;
    }
}

export interface IScaler {
    attribute: DlmsAttributes;
    value: number;
}

export class Scalers implements IScalers {
    scalerList!: Scaler[] | undefined;

    constructor(data?: IScalers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scalerList"])) {
                this.scalerList = [] as any;
                for (let item of _data["scalerList"])
                    this.scalerList!.push(Scaler.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Scalers {
        data = typeof data === 'object' ? data : {};
        let result = new Scalers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scalerList)) {
            data["scalerList"] = [];
            for (let item of this.scalerList)
                data["scalerList"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScalers {
    scalerList: Scaler[] | undefined;
}

export class ScheduleLogsCommandsDataOut implements IScheduleLogsCommandsDataOut {
    id!: string;
    schedulerStartTime?: Date | undefined;
    startTime?: Date | undefined;
    meterNumber!: string | undefined;
    endTime?: Date | undefined;
    status!: CommandStatus;
    errorMessage?: string | undefined;

    constructor(data?: IScheduleLogsCommandsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.schedulerStartTime = _data["schedulerStartTime"] ? new Date(_data["schedulerStartTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.meterNumber = _data["meterNumber"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ScheduleLogsCommandsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsCommandsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schedulerStartTime"] = this.schedulerStartTime ? this.schedulerStartTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["meterNumber"] = this.meterNumber;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IScheduleLogsCommandsDataOut {
    id: string;
    schedulerStartTime?: Date | undefined;
    startTime?: Date | undefined;
    meterNumber: string | undefined;
    endTime?: Date | undefined;
    status: CommandStatus;
    errorMessage?: string | undefined;
}

export class ScheduleLogsCommandsDataOutPaginationDataOut implements IScheduleLogsCommandsDataOutPaginationDataOut {
    count!: number;
    data!: ScheduleLogsCommandsDataOut[] | undefined;

    constructor(data?: IScheduleLogsCommandsDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ScheduleLogsCommandsDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleLogsCommandsDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsCommandsDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScheduleLogsCommandsDataOutPaginationDataOut {
    count: number;
    data: ScheduleLogsCommandsDataOut[] | undefined;
}

export class ScheduleLogsCommandsQuery implements IScheduleLogsCommandsQuery {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    commandStatus?: CommandStatus;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    schedulerId!: string;

    constructor(data?: IScheduleLogsCommandsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.commandStatus = _data["commandStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.schedulerId = _data["schedulerId"];
        }
    }

    static fromJS(data: any): ScheduleLogsCommandsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsCommandsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["commandStatus"] = this.commandStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["schedulerId"] = this.schedulerId;
        return data;
    }
}

export interface IScheduleLogsCommandsQuery {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    commandStatus?: CommandStatus;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    schedulerId: string;
}

export class ScheduleLogsDataIn implements IScheduleLogsDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    schedulerId!: string;

    constructor(data?: IScheduleLogsDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.schedulerId = _data["schedulerId"];
        }
    }

    static fromJS(data: any): ScheduleLogsDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["schedulerId"] = this.schedulerId;
        return data;
    }
}

export interface IScheduleLogsDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    schedulerId: string;
}

export class ScheduleLogsDataOut implements IScheduleLogsDataOut {
    id!: string;
    schedulerId!: string;
    scheduleName!: string | undefined;
    startTime?: Date | undefined;
    assetTypes?: string[] | undefined;
    assetTypeNames?: string[] | undefined;
    regions?: string[] | undefined;
    areas?: string[] | undefined;
    areaNames?: string[] | undefined;
    regionNames?: string[] | undefined;
    type!: SchedulerType;
    processed!: number;
    successfullyProcessed!: number;

    constructor(data?: IScheduleLogsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.schedulerId = _data["schedulerId"];
            this.scheduleName = _data["scheduleName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["assetTypeNames"])) {
                this.assetTypeNames = [] as any;
                for (let item of _data["assetTypeNames"])
                    this.assetTypeNames!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["areaNames"])) {
                this.areaNames = [] as any;
                for (let item of _data["areaNames"])
                    this.areaNames!.push(item);
            }
            if (Array.isArray(_data["regionNames"])) {
                this.regionNames = [] as any;
                for (let item of _data["regionNames"])
                    this.regionNames!.push(item);
            }
            this.type = _data["type"];
            this.processed = _data["processed"];
            this.successfullyProcessed = _data["successfullyProcessed"];
        }
    }

    static fromJS(data: any): ScheduleLogsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schedulerId"] = this.schedulerId;
        data["scheduleName"] = this.scheduleName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.assetTypeNames)) {
            data["assetTypeNames"] = [];
            for (let item of this.assetTypeNames)
                data["assetTypeNames"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.areaNames)) {
            data["areaNames"] = [];
            for (let item of this.areaNames)
                data["areaNames"].push(item);
        }
        if (Array.isArray(this.regionNames)) {
            data["regionNames"] = [];
            for (let item of this.regionNames)
                data["regionNames"].push(item);
        }
        data["type"] = this.type;
        data["processed"] = this.processed;
        data["successfullyProcessed"] = this.successfullyProcessed;
        return data;
    }
}

export interface IScheduleLogsDataOut {
    id: string;
    schedulerId: string;
    scheduleName: string | undefined;
    startTime?: Date | undefined;
    assetTypes?: string[] | undefined;
    assetTypeNames?: string[] | undefined;
    regions?: string[] | undefined;
    areas?: string[] | undefined;
    areaNames?: string[] | undefined;
    regionNames?: string[] | undefined;
    type: SchedulerType;
    processed: number;
    successfullyProcessed: number;
}

export class ScheduleLogsDataOutPaginationDataOut implements IScheduleLogsDataOutPaginationDataOut {
    count!: number;
    data!: ScheduleLogsDataOut[] | undefined;

    constructor(data?: IScheduleLogsDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ScheduleLogsDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleLogsDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleLogsDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScheduleLogsDataOutPaginationDataOut {
    count: number;
    data: ScheduleLogsDataOut[] | undefined;
}

export class SchedulerDataIn implements ISchedulerDataIn {
    id?: string | undefined;
    cron!: string;
    name!: string;
    type!: SchedulerType;
    regions!: string[] | undefined;
    areas!: string[] | undefined;
    assetTypes!: string[] | undefined;
    meterModels!: string[] | undefined;

    constructor(data?: ISchedulerDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cron = _data["cron"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(item);
            }
            if (Array.isArray(_data["meterModels"])) {
                this.meterModels = [] as any;
                for (let item of _data["meterModels"])
                    this.meterModels!.push(item);
            }
        }
    }

    static fromJS(data: any): SchedulerDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cron"] = this.cron;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item);
        }
        if (Array.isArray(this.meterModels)) {
            data["meterModels"] = [];
            for (let item of this.meterModels)
                data["meterModels"].push(item);
        }
        return data;
    }
}

export interface ISchedulerDataIn {
    id?: string | undefined;
    cron: string;
    name: string;
    type: SchedulerType;
    regions: string[] | undefined;
    areas: string[] | undefined;
    assetTypes: string[] | undefined;
    meterModels: string[] | undefined;
}

export class SchedulerDto implements ISchedulerDto {
    id?: string | undefined;
    cron!: string;
    name!: string;
    type!: SchedulerType;
    regions!: string[] | undefined;
    areas?: string[] | undefined;
    assetTypes!: AssetTypeDataOut[] | undefined;
    meterModels!: MeterModelDataOut[] | undefined;
    regionNames?: string[] | undefined;
    areaNames?: string[] | undefined;

    constructor(data?: ISchedulerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cron = _data["cron"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["assetTypes"])) {
                this.assetTypes = [] as any;
                for (let item of _data["assetTypes"])
                    this.assetTypes!.push(AssetTypeDataOut.fromJS(item));
            }
            if (Array.isArray(_data["meterModels"])) {
                this.meterModels = [] as any;
                for (let item of _data["meterModels"])
                    this.meterModels!.push(MeterModelDataOut.fromJS(item));
            }
            if (Array.isArray(_data["regionNames"])) {
                this.regionNames = [] as any;
                for (let item of _data["regionNames"])
                    this.regionNames!.push(item);
            }
            if (Array.isArray(_data["areaNames"])) {
                this.areaNames = [] as any;
                for (let item of _data["areaNames"])
                    this.areaNames!.push(item);
            }
        }
    }

    static fromJS(data: any): SchedulerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cron"] = this.cron;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.assetTypes)) {
            data["assetTypes"] = [];
            for (let item of this.assetTypes)
                data["assetTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.meterModels)) {
            data["meterModels"] = [];
            for (let item of this.meterModels)
                data["meterModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.regionNames)) {
            data["regionNames"] = [];
            for (let item of this.regionNames)
                data["regionNames"].push(item);
        }
        if (Array.isArray(this.areaNames)) {
            data["areaNames"] = [];
            for (let item of this.areaNames)
                data["areaNames"].push(item);
        }
        return data;
    }
}

export interface ISchedulerDto {
    id?: string | undefined;
    cron: string;
    name: string;
    type: SchedulerType;
    regions: string[] | undefined;
    areas?: string[] | undefined;
    assetTypes: AssetTypeDataOut[] | undefined;
    meterModels: MeterModelDataOut[] | undefined;
    regionNames?: string[] | undefined;
    areaNames?: string[] | undefined;
}

export class SchedulerQuery implements ISchedulerQuery {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: ISchedulerQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): SchedulerQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface ISchedulerQuery {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class SchedulerQueryDataOut implements ISchedulerQueryDataOut {
    id!: string;
    cron!: string | undefined;
    name!: string | undefined;
    lastExecutionTime?: Date | undefined;
    isActive!: boolean;
    type!: SchedulerType;

    constructor(data?: ISchedulerQueryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cron = _data["cron"];
            this.name = _data["name"];
            this.lastExecutionTime = _data["lastExecutionTime"] ? new Date(_data["lastExecutionTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SchedulerQueryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerQueryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cron"] = this.cron;
        data["name"] = this.name;
        data["lastExecutionTime"] = this.lastExecutionTime ? this.lastExecutionTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        return data;
    }
}

export interface ISchedulerQueryDataOut {
    id: string;
    cron: string | undefined;
    name: string | undefined;
    lastExecutionTime?: Date | undefined;
    isActive: boolean;
    type: SchedulerType;
}

export class SchedulerQueryDataOutPaginationDataOut implements ISchedulerQueryDataOutPaginationDataOut {
    count!: number;
    data!: SchedulerQueryDataOut[] | undefined;

    constructor(data?: ISchedulerQueryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SchedulerQueryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulerQueryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerQueryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISchedulerQueryDataOutPaginationDataOut {
    count: number;
    data: SchedulerQueryDataOut[] | undefined;
}

export class SchedulerStatus implements ISchedulerStatus {
    reminderId!: string;
    isActive!: boolean;

    constructor(data?: ISchedulerStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderId = _data["reminderId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SchedulerStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderId"] = this.reminderId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISchedulerStatus {
    reminderId: string;
    isActive: boolean;
}

export class SchedulerStatusHistoryDataIn implements ISchedulerStatusHistoryDataIn {
    pageInfo!: PageInfo;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status?: CommandStatus;
    type?: CommandMessageType;
    sorting?: SortingType;
    search?: string | undefined;

    constructor(data?: ISchedulerStatusHistoryDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): SchedulerStatusHistoryDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerStatusHistoryDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        return data;
    }
}

export interface ISchedulerStatusHistoryDataIn {
    pageInfo: PageInfo;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status?: CommandStatus;
    type?: CommandMessageType;
    sorting?: SortingType;
    search?: string | undefined;
}

export class SchedulerStatusHistoryDataOut implements ISchedulerStatusHistoryDataOut {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status!: CommandStatus;
    type!: SchedulerType;
    id!: string;

    constructor(data?: ISchedulerStatusHistoryDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SchedulerStatusHistoryDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerStatusHistoryDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ISchedulerStatusHistoryDataOut {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    status: CommandStatus;
    type: SchedulerType;
    id: string;
}

export class SchedulerStatusHistoryDataOutPaginationDataOut implements ISchedulerStatusHistoryDataOutPaginationDataOut {
    count!: number;
    data!: SchedulerStatusHistoryDataOut[] | undefined;

    constructor(data?: ISchedulerStatusHistoryDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SchedulerStatusHistoryDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulerStatusHistoryDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerStatusHistoryDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISchedulerStatusHistoryDataOutPaginationDataOut {
    count: number;
    data: SchedulerStatusHistoryDataOut[] | undefined;
}

export enum SchedulerType {
    ProfileGeneric = "ProfileGeneric",
    Alarm = "Alarm",
    Reconfiguration = "Reconfiguration",
    Pull = "Pull",
    FirmwareUpdate = "FirmwareUpdate",
    MeterActivity = "MeterActivity",
    EventLog = "EventLog",
}

export class SequentalTokenDataOut implements ISequentalTokenDataOut {
    value!: string | undefined;
    hesId!: string;
    status!: TokenStatus;
    type!: TokenType;
    executionOrder?: number | undefined;

    constructor(data?: ISequentalTokenDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hesId = _data["hesId"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.executionOrder = _data["executionOrder"];
        }
    }

    static fromJS(data: any): SequentalTokenDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new SequentalTokenDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hesId"] = this.hesId;
        data["status"] = this.status;
        data["type"] = this.type;
        data["executionOrder"] = this.executionOrder;
        return data;
    }
}

export interface ISequentalTokenDataOut {
    value: string | undefined;
    hesId: string;
    status: TokenStatus;
    type: TokenType;
    executionOrder?: number | undefined;
}

export class ServiceTypeDataIn implements IServiceTypeDataIn {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IServiceTypeDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ServiceTypeDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IServiceTypeDataIn {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ServiceTypeDataOut implements IServiceTypeDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IServiceTypeDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ServiceTypeDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IServiceTypeDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ServiceTypeDataOutPaginationDataOut implements IServiceTypeDataOutPaginationDataOut {
    count!: number;
    data!: ServiceTypeDataOut[] | undefined;

    constructor(data?: IServiceTypeDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceTypeDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceTypeDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IServiceTypeDataOutPaginationDataOut {
    count: number;
    data: ServiceTypeDataOut[] | undefined;
}

export class ServiceTypeDetailsDataOut implements IServiceTypeDetailsDataOut {
    id?: string | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IServiceTypeDetailsDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ServiceTypeDetailsDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDetailsDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IServiceTypeDetailsDataOut {
    id?: string | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ServiceTypeGetAllDataIn implements IServiceTypeGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IServiceTypeGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): ServiceTypeGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IServiceTypeGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export class SetIpSecConnectorDataIn implements ISetIpSecConnectorDataIn {
    meterNumber!: string | undefined;
    activate!: boolean;

    constructor(data?: ISetIpSecConnectorDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.activate = _data["activate"];
        }
    }

    static fromJS(data: any): SetIpSecConnectorDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new SetIpSecConnectorDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["activate"] = this.activate;
        return data;
    }
}

export interface ISetIpSecConnectorDataIn {
    meterNumber: string | undefined;
    activate: boolean;
}

export class SetupConfigurationDataIn implements ISetupConfigurationDataIn {
    attribute!: DlmsAttributes;

    constructor(data?: ISetupConfigurationDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["attribute"];
        }
    }

    static fromJS(data: any): SetupConfigurationDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new SetupConfigurationDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        return data;
    }
}

export interface ISetupConfigurationDataIn {
    attribute: DlmsAttributes;
}

export class SetupConfigurationDto implements ISetupConfigurationDto {
    id!: string;
    position!: number;
    attribute!: DlmsAttributes;

    constructor(data?: ISetupConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.position = _data["position"];
            this.attribute = _data["attribute"];
        }
    }

    static fromJS(data: any): SetupConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetupConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["position"] = this.position;
        data["attribute"] = this.attribute;
        return data;
    }
}

export interface ISetupConfigurationDto {
    id: string;
    position: number;
    attribute: DlmsAttributes;
}

export class SetupConfigurationOptionDto implements ISetupConfigurationOptionDto {
    position!: number;
    attribute!: DlmsAttributes;
    default!: boolean;

    constructor(data?: ISetupConfigurationOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.attribute = _data["attribute"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): SetupConfigurationOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetupConfigurationOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["attribute"] = this.attribute;
        data["default"] = this.default;
        return data;
    }
}

export interface ISetupConfigurationOptionDto {
    position: number;
    attribute: DlmsAttributes;
    default: boolean;
}

export class SetupConfigurationOptionsDto implements ISetupConfigurationOptionsDto {
    lpSetupConfigurationOptions!: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval1RequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval2RequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval3RequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnAlarmRequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnConnectRequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnPowerDownRequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    pushOnInstallationRequiredCaptureObjects!: SetupConfigurationOptionDto[] | undefined;
    lp1RecommendedRegisters!: RecommendedRegisterGroupDto[] | undefined;
    lp2RecommendedRegisters!: RecommendedRegisterGroupDto[] | undefined;
    lp3RecommendedRegisters!: RecommendedRegisterGroupDto[] | undefined;

    constructor(data?: ISetupConfigurationOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lpSetupConfigurationOptions"])) {
                this.lpSetupConfigurationOptions = [] as any;
                for (let item of _data["lpSetupConfigurationOptions"])
                    this.lpSetupConfigurationOptions!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnInterval1RequiredCaptureObjects"])) {
                this.pushOnInterval1RequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnInterval1RequiredCaptureObjects"])
                    this.pushOnInterval1RequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnInterval2RequiredCaptureObjects"])) {
                this.pushOnInterval2RequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnInterval2RequiredCaptureObjects"])
                    this.pushOnInterval2RequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnInterval3RequiredCaptureObjects"])) {
                this.pushOnInterval3RequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnInterval3RequiredCaptureObjects"])
                    this.pushOnInterval3RequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnAlarmRequiredCaptureObjects"])) {
                this.pushOnAlarmRequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnAlarmRequiredCaptureObjects"])
                    this.pushOnAlarmRequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnConnectRequiredCaptureObjects"])) {
                this.pushOnConnectRequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnConnectRequiredCaptureObjects"])
                    this.pushOnConnectRequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnPowerDownRequiredCaptureObjects"])) {
                this.pushOnPowerDownRequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnPowerDownRequiredCaptureObjects"])
                    this.pushOnPowerDownRequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["pushOnInstallationRequiredCaptureObjects"])) {
                this.pushOnInstallationRequiredCaptureObjects = [] as any;
                for (let item of _data["pushOnInstallationRequiredCaptureObjects"])
                    this.pushOnInstallationRequiredCaptureObjects!.push(SetupConfigurationOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["lp1RecommendedRegisters"])) {
                this.lp1RecommendedRegisters = [] as any;
                for (let item of _data["lp1RecommendedRegisters"])
                    this.lp1RecommendedRegisters!.push(RecommendedRegisterGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["lp2RecommendedRegisters"])) {
                this.lp2RecommendedRegisters = [] as any;
                for (let item of _data["lp2RecommendedRegisters"])
                    this.lp2RecommendedRegisters!.push(RecommendedRegisterGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["lp3RecommendedRegisters"])) {
                this.lp3RecommendedRegisters = [] as any;
                for (let item of _data["lp3RecommendedRegisters"])
                    this.lp3RecommendedRegisters!.push(RecommendedRegisterGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetupConfigurationOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetupConfigurationOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lpSetupConfigurationOptions)) {
            data["lpSetupConfigurationOptions"] = [];
            for (let item of this.lpSetupConfigurationOptions)
                data["lpSetupConfigurationOptions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnInterval1RequiredCaptureObjects)) {
            data["pushOnInterval1RequiredCaptureObjects"] = [];
            for (let item of this.pushOnInterval1RequiredCaptureObjects)
                data["pushOnInterval1RequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnInterval2RequiredCaptureObjects)) {
            data["pushOnInterval2RequiredCaptureObjects"] = [];
            for (let item of this.pushOnInterval2RequiredCaptureObjects)
                data["pushOnInterval2RequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnInterval3RequiredCaptureObjects)) {
            data["pushOnInterval3RequiredCaptureObjects"] = [];
            for (let item of this.pushOnInterval3RequiredCaptureObjects)
                data["pushOnInterval3RequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnAlarmRequiredCaptureObjects)) {
            data["pushOnAlarmRequiredCaptureObjects"] = [];
            for (let item of this.pushOnAlarmRequiredCaptureObjects)
                data["pushOnAlarmRequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnConnectRequiredCaptureObjects)) {
            data["pushOnConnectRequiredCaptureObjects"] = [];
            for (let item of this.pushOnConnectRequiredCaptureObjects)
                data["pushOnConnectRequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnPowerDownRequiredCaptureObjects)) {
            data["pushOnPowerDownRequiredCaptureObjects"] = [];
            for (let item of this.pushOnPowerDownRequiredCaptureObjects)
                data["pushOnPowerDownRequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pushOnInstallationRequiredCaptureObjects)) {
            data["pushOnInstallationRequiredCaptureObjects"] = [];
            for (let item of this.pushOnInstallationRequiredCaptureObjects)
                data["pushOnInstallationRequiredCaptureObjects"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lp1RecommendedRegisters)) {
            data["lp1RecommendedRegisters"] = [];
            for (let item of this.lp1RecommendedRegisters)
                data["lp1RecommendedRegisters"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lp2RecommendedRegisters)) {
            data["lp2RecommendedRegisters"] = [];
            for (let item of this.lp2RecommendedRegisters)
                data["lp2RecommendedRegisters"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lp3RecommendedRegisters)) {
            data["lp3RecommendedRegisters"] = [];
            for (let item of this.lp3RecommendedRegisters)
                data["lp3RecommendedRegisters"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISetupConfigurationOptionsDto {
    lpSetupConfigurationOptions: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval1RequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval2RequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnInterval3RequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnAlarmRequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnConnectRequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnPowerDownRequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    pushOnInstallationRequiredCaptureObjects: SetupConfigurationOptionDto[] | undefined;
    lp1RecommendedRegisters: RecommendedRegisterGroupDto[] | undefined;
    lp2RecommendedRegisters: RecommendedRegisterGroupDto[] | undefined;
    lp3RecommendedRegisters: RecommendedRegisterGroupDto[] | undefined;
}

export class SimNetworkWebhook implements ISimNetworkWebhook {
    type!: string | undefined;
    sim_id!: string | undefined;
    time!: Date;
    ipv4!: string | undefined;

    constructor(data?: ISimNetworkWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.sim_id = _data["sim_id"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.ipv4 = _data["ipv4"];
        }
    }

    static fromJS(data: any): SimNetworkWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new SimNetworkWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["sim_id"] = this.sim_id;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["ipv4"] = this.ipv4;
        return data;
    }
}

export interface ISimNetworkWebhook {
    type: string | undefined;
    sim_id: string | undefined;
    time: Date;
    ipv4: string | undefined;
}

export enum SortingType {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class StringResponseCommandSuccess implements IStringResponseCommandSuccess {
    message?: string | undefined;
    commandId!: string;

    constructor(data?: IStringResponseCommandSuccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.commandId = _data["commandId"];
        }
    }

    static fromJS(data: any): StringResponseCommandSuccess {
        data = typeof data === 'object' ? data : {};
        let result = new StringResponseCommandSuccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["commandId"] = this.commandId;
        return data;
    }
}

export interface IStringResponseCommandSuccess {
    message?: string | undefined;
    commandId: string;
}

export class TimeSyncDataOut implements ITimeSyncDataOut {
    id!: string;
    meterNumber!: string | undefined;
    meterId?: string | undefined;
    meterMakeName!: string | undefined;
    meterTimeDifference?: number | undefined;
    allowedClockOffsetInSeconds!: number;
    commandStatus?: CommandStatus;

    constructor(data?: ITimeSyncDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterNumber = _data["meterNumber"];
            this.meterId = _data["meterId"];
            this.meterMakeName = _data["meterMakeName"];
            this.meterTimeDifference = _data["meterTimeDifference"];
            this.allowedClockOffsetInSeconds = _data["allowedClockOffsetInSeconds"];
            this.commandStatus = _data["commandStatus"];
        }
    }

    static fromJS(data: any): TimeSyncDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSyncDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterNumber"] = this.meterNumber;
        data["meterId"] = this.meterId;
        data["meterMakeName"] = this.meterMakeName;
        data["meterTimeDifference"] = this.meterTimeDifference;
        data["allowedClockOffsetInSeconds"] = this.allowedClockOffsetInSeconds;
        data["commandStatus"] = this.commandStatus;
        return data;
    }
}

export interface ITimeSyncDataOut {
    id: string;
    meterNumber: string | undefined;
    meterId?: string | undefined;
    meterMakeName: string | undefined;
    meterTimeDifference?: number | undefined;
    allowedClockOffsetInSeconds: number;
    commandStatus?: CommandStatus;
}

export class TimeSyncDataOutPaginationDataOut implements ITimeSyncDataOutPaginationDataOut {
    count!: number;
    data!: TimeSyncDataOut[] | undefined;

    constructor(data?: ITimeSyncDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimeSyncDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeSyncDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSyncDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITimeSyncDataOutPaginationDataOut {
    count: number;
    data: TimeSyncDataOut[] | undefined;
}

export class TimeSyncQuery implements ITimeSyncQuery {
    pageInfo!: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: ITimeSyncQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): TimeSyncQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSyncQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface ITimeSyncQuery {
    pageInfo: PageInfo;
    /** String type field, represents a field that performs a search by meter number or service number, if it is an empty string or null, no filtering is done. */
    search?: string | undefined;
    sorting?: SortingType;
}

export enum TokenStatus {
    Pending = "Pending",
    Success = "Success",
    Failed = "Failed",
}

export enum TokenType {
    Credit = "Credit",
    ClearCredit = "ClearCredit",
    ClearTamper = "ClearTamper",
    KeyChange = "KeyChange",
}

export class UserDataIn implements IUserDataIn {
    id?: string | undefined;
    firstName!: string | undefined;
    middleName?: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    role!: string;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    image?: string | undefined;
    allRegions?: boolean | undefined;
    areas!: string[] | undefined;
    regions!: string[] | undefined;

    constructor(data?: IUserDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.image = _data["image"];
            this.allRegions = _data["allRegions"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["image"] = this.image;
        data["allRegions"] = this.allRegions;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        return data;
    }
}

export interface IUserDataIn {
    id?: string | undefined;
    firstName: string | undefined;
    middleName?: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    role: string;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    image?: string | undefined;
    allRegions?: boolean | undefined;
    areas: string[] | undefined;
    regions: string[] | undefined;
}

export class UserDataOut implements IUserDataOut {
    hesId!: string;
    firstName!: string | undefined;
    middleName?: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    roleId?: string | undefined;
    role?: string | undefined;
    roleStatus?: UserStatus;
    address!: string | undefined;
    phoneNumber?: string | undefined;
    image!: string | undefined;
    areas?: string[] | undefined;
    region?: string | undefined;
    createdTime!: Date;
    status!: UserStatus;
    createdByUserEmail!: string | undefined;
    areaNames?: string[] | undefined;
    regionName?: string | undefined;
    utilityId!: string;
    utility!: string | undefined;
    utilityStatus?: UtilityStatus;
    isAdmin!: boolean;
    timeZone?: number | undefined;
    regionIds!: string[] | undefined;
    allRegions!: boolean;

    constructor(data?: IUserDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hesId = _data["hesId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.roleId = _data["roleId"];
            this.role = _data["role"];
            this.roleStatus = _data["roleStatus"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.image = _data["image"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            this.region = _data["region"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.createdByUserEmail = _data["createdByUserEmail"];
            if (Array.isArray(_data["areaNames"])) {
                this.areaNames = [] as any;
                for (let item of _data["areaNames"])
                    this.areaNames!.push(item);
            }
            this.regionName = _data["regionName"];
            this.utilityId = _data["utilityId"];
            this.utility = _data["utility"];
            this.utilityStatus = _data["utilityStatus"];
            this.isAdmin = _data["isAdmin"];
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            this.allRegions = _data["allRegions"];
        }
    }

    static fromJS(data: any): UserDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hesId"] = this.hesId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["roleId"] = this.roleId;
        data["role"] = this.role;
        data["roleStatus"] = this.roleStatus;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["image"] = this.image;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        data["region"] = this.region;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["createdByUserEmail"] = this.createdByUserEmail;
        if (Array.isArray(this.areaNames)) {
            data["areaNames"] = [];
            for (let item of this.areaNames)
                data["areaNames"].push(item);
        }
        data["regionName"] = this.regionName;
        data["utilityId"] = this.utilityId;
        data["utility"] = this.utility;
        data["utilityStatus"] = this.utilityStatus;
        data["isAdmin"] = this.isAdmin;
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        data["allRegions"] = this.allRegions;
        return data;
    }
}

export interface IUserDataOut {
    hesId: string;
    firstName: string | undefined;
    middleName?: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    roleId?: string | undefined;
    role?: string | undefined;
    roleStatus?: UserStatus;
    address: string | undefined;
    phoneNumber?: string | undefined;
    image: string | undefined;
    areas?: string[] | undefined;
    region?: string | undefined;
    createdTime: Date;
    status: UserStatus;
    createdByUserEmail: string | undefined;
    areaNames?: string[] | undefined;
    regionName?: string | undefined;
    utilityId: string;
    utility: string | undefined;
    utilityStatus?: UtilityStatus;
    isAdmin: boolean;
    timeZone?: number | undefined;
    regionIds: string[] | undefined;
    allRegions: boolean;
}

export class UserDataOutPaginationDataOut implements IUserDataOutPaginationDataOut {
    count!: number;
    data!: UserDataOut[] | undefined;

    constructor(data?: IUserDataOutPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserDataOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDataOutPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataOutPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserDataOutPaginationDataOut {
    count: number;
    data: UserDataOut[] | undefined;
}

export class UserEditDataIn implements IUserEditDataIn {
    id?: string | undefined;
    firstName!: string | undefined;
    middleName?: string | undefined;
    lastName!: string | undefined;
    role!: string;
    address?: string | undefined;
    phoneNumber!: string | undefined;
    image?: string | undefined;

    constructor(data?: IUserEditDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UserEditDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["image"] = this.image;
        return data;
    }
}

export interface IUserEditDataIn {
    id?: string | undefined;
    firstName: string | undefined;
    middleName?: string | undefined;
    lastName: string | undefined;
    role: string;
    address?: string | undefined;
    phoneNumber: string | undefined;
    image?: string | undefined;
}

export class UserGetAllDataIn implements IUserGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;

    constructor(data?: IUserGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): UserGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IUserGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
}

export enum UserStatus {
    Inactive = "Inactive",
    Pending = "Pending",
    Active = "Active",
}

export class UserStatusUpdate implements IUserStatusUpdate {
    userId!: string;
    status!: UserStatus;

    constructor(data?: IUserStatusUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserStatusUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUserStatusUpdate {
    userId: string;
    status: UserStatus;
}

export enum UtilityCountry {
    Afghanistan = "Afghanistan",
    Albania = "Albania",
    Algeria = "Algeria",
    American_Samoa = "American_Samoa",
    Andorra = "Andorra",
    Angola = "Angola",
    Anguilla = "Anguilla",
    Antigua_and_Barbuda = "Antigua_and_Barbuda",
    Argentina = "Argentina",
    Armenia = "Armenia",
    Aruba = "Aruba",
    Australia = "Australia",
    Austria = "Austria",
    Azerbaijan = "Azerbaijan",
    Bahamas = "Bahamas",
    Bahrain = "Bahrain",
    Bangladesh = "Bangladesh",
    Barbados = "Barbados",
    Belarus = "Belarus",
    Belgium = "Belgium",
    Belize = "Belize",
    Benin = "Benin",
    Bhutan = "Bhutan",
    Bolivia = "Bolivia",
    Bosnia_and_Herzegovina = "Bosnia_and_Herzegovina",
    Botswana = "Botswana",
    Brazil = "Brazil",
    Brunei = "Brunei",
    Bulgaria = "Bulgaria",
    Burkina_Faso = "Burkina_Faso",
    Burundi = "Burundi",
    Cape_Verde = "Cape_Verde",
    Cambodia = "Cambodia",
    Cameroon = "Cameroon",
    Canada = "Canada",
    Cayman_Islands = "Cayman_Islands",
    Central_African_Republic = "Central_African_Republic",
    Chad = "Chad",
    Chile = "Chile",
    China = "China",
    Colombia = "Colombia",
    Comoros = "Comoros",
    Congo_Brazzaville = "Congo_Brazzaville",
    Congo_Kinshasa = "Congo_Kinshasa",
    Cook_Islands = "Cook_Islands",
    Costa_Rica = "Costa_Rica",
    Ivory_Coast = "Ivory_Coast",
    Croatia = "Croatia",
    Cuba = "Cuba",
    Cyprus = "Cyprus",
    Czechia = "Czechia",
    Denmark = "Denmark",
    Djibouti = "Djibouti",
    Dominica = "Dominica",
    Dominican_Republic = "Dominican_Republic",
    Ecuador = "Ecuador",
    Egypt = "Egypt",
    El_Salvador = "El_Salvador",
    Equatorial_Guinea = "Equatorial_Guinea",
    Eritrea = "Eritrea",
    Estonia = "Estonia",
    Eswatini = "Eswatini",
    Ethiopia = "Ethiopia",
    Finland = "Finland",
    France = "France",
    Gabon = "Gabon",
    Gambia = "Gambia",
    Georgia = "Georgia",
    Germany = "Germany",
    Ghana = "Ghana",
    Greece = "Greece",
    Grenada = "Grenada",
    Guatemala = "Guatemala",
    Guinea = "Guinea",
    Guinea_Bissau = "Guinea_Bissau",
    Guyana = "Guyana",
    Haiti = "Haiti",
    Honduras = "Honduras",
    Hong_Kong = "Hong_Kong",
    Hungary = "Hungary",
    Iceland = "Iceland",
    India = "India",
    Indonesia = "Indonesia",
    Iran = "Iran",
    Iraq = "Iraq",
    Ireland = "Ireland",
    Israel = "Israel",
    Italy = "Italy",
    Jamaica = "Jamaica",
    Japan = "Japan",
    Jordan = "Jordan",
    Kazakhstan = "Kazakhstan",
    Kenya = "Kenya",
    Kiribati = "Kiribati",
    North_Korea = "North_Korea",
    South_Korea = "South_Korea",
    Kuwait = "Kuwait",
    Kyrgyzstan = "Kyrgyzstan",
    Laos = "Laos",
    Latvia = "Latvia",
    Lebanon = "Lebanon",
    Lesotho = "Lesotho",
    Liberia = "Liberia",
    Libya = "Libya",
    Liechtenstein = "Liechtenstein",
    Lithuania = "Lithuania",
    Luxembourg = "Luxembourg",
    Macau = "Macau",
    North_Macedonia = "North_Macedonia",
    Madagascar = "Madagascar",
    Malawi = "Malawi",
    Malaysia = "Malaysia",
    Maldives = "Maldives",
    Mali = "Mali",
    Malta = "Malta",
    Marshall_Islands = "Marshall_Islands",
    Martinique = "Martinique",
    Mauritania = "Mauritania",
    Mauritius = "Mauritius",
    Mayotte = "Mayotte",
    Mexico = "Mexico",
    Micronesia = "Micronesia",
    Moldova = "Moldova",
    Monaco = "Monaco",
    Mongolia = "Mongolia",
    Montenegro = "Montenegro",
    Montserrat = "Montserrat",
    Morocco = "Morocco",
    Mozambique = "Mozambique",
    Myanmar = "Myanmar",
    Namibia = "Namibia",
    Nauru = "Nauru",
    Nepal = "Nepal",
    Netherlands = "Netherlands",
    New_Caledonia = "New_Caledonia",
    New_Zealand = "New_Zealand",
    Nicaragua = "Nicaragua",
    Niger = "Niger",
    Nigeria = "Nigeria",
    Niue = "Niue",
    Norfolk_Island = "Norfolk_Island",
    Norway = "Norway",
    Oman = "Oman",
    Pakistan = "Pakistan",
    Palau = "Palau",
    Palestine = "Palestine",
    Panama = "Panama",
    Papua_New_Guinea = "Papua_New_Guinea",
    Paraguay = "Paraguay",
    Peru = "Peru",
    Philippines = "Philippines",
    Pitcairn_Islands = "Pitcairn_Islands",
    Poland = "Poland",
    Portugal = "Portugal",
    Puerto_Rico = "Puerto_Rico",
    Qatar = "Qatar",
    Reunion = "Reunion",
    Romania = "Romania",
    Russia = "Russia",
    Rwanda = "Rwanda",
    Saint_Barthelemy = "Saint_Barthelemy",
    Saint_Helena = "Saint_Helena",
    Saint_Kitts_and_Nevis = "Saint_Kitts_and_Nevis",
    Saint_Lucia = "Saint_Lucia",
    Saint_Martin = "Saint_Martin",
    Saint_Pierre_and_Miquelon = "Saint_Pierre_and_Miquelon",
    Saint_Vincent_and_the_Grenadines = "Saint_Vincent_and_the_Grenadines",
    Samoa = "Samoa",
    San_Marino = "San_Marino",
    Sao_Tome_and_Principe = "Sao_Tome_and_Principe",
    Saudi_Arabia = "Saudi_Arabia",
    Senegal = "Senegal",
    Serbia = "Serbia",
    Seychelles = "Seychelles",
    Sierra_Leone = "Sierra_Leone",
    Singapore = "Singapore",
    Sint_Maarten = "Sint_Maarten",
    Slovakia = "Slovakia",
    Slovenia = "Slovenia",
    Solomon_Islands = "Solomon_Islands",
    Somalia = "Somalia",
    South_Africa = "South_Africa",
    South_Georgia_and_the_South_Sandwich_Islands = "South_Georgia_and_the_South_Sandwich_Islands",
    Spain = "Spain",
    Sri_Lanka = "Sri_Lanka",
    Sudan = "Sudan",
    Suriname = "Suriname",
    Svalbard_and_Jan_Mayen = "Svalbard_and_Jan_Mayen",
    Sweden = "Sweden",
    Switzerland = "Switzerland",
    Syria = "Syria",
    Taiwan = "Taiwan",
    Tajikistan = "Tajikistan",
    Tanzania = "Tanzania",
    Thailand = "Thailand",
    Timor_Leste = "Timor_Leste",
    Togo = "Togo",
    Tokelau = "Tokelau",
    Tonga = "Tonga",
    Trinidad_and_Tobago = "Trinidad_and_Tobago",
    Tunisia = "Tunisia",
    Turkey = "Turkey",
    Turkmenistan = "Turkmenistan",
    Turks_and_Caicos_Islands = "Turks_and_Caicos_Islands",
    Tuvalu = "Tuvalu",
    Uganda = "Uganda",
    Ukraine = "Ukraine",
    United_Arab_Emirates = "United_Arab_Emirates",
    United_Kingdom = "United_Kingdom",
    United_States = "United_States",
    Uruguay = "Uruguay",
    Uzbekistan = "Uzbekistan",
    Vanuatu = "Vanuatu",
    Vatican_City = "Vatican_City",
    Venezuela = "Venezuela",
    Vietnam = "Vietnam",
    Western_Sahara = "Western_Sahara",
    Yemen = "Yemen",
    Zambia = "Zambia",
    Zimbabwe = "Zimbabwe",
}

export class UtilityDto implements IUtilityDto {
    id?: string | undefined;
    name!: string;
    acronym!: string;
    contactPersonEmail!: string;
    contactPersonFirstName!: string;
    contactPersonLastName!: string;
    contactPerson?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    status!: UtilityStatus;
    address!: string;
    websiteAddress!: string;
    country!: UtilityCountry;
    creationDate!: Date;
    logoPath?: string | undefined;
    timeZone!: number;

    constructor(data?: IUtilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
            this.contactPersonEmail = _data["contactPersonEmail"];
            this.contactPersonFirstName = _data["contactPersonFirstName"];
            this.contactPersonLastName = _data["contactPersonLastName"];
            this.contactPerson = _data["contactPerson"];
            this.contactPersonPhoneNumber = _data["contactPersonPhoneNumber"];
            this.status = _data["status"];
            this.address = _data["address"];
            this.websiteAddress = _data["websiteAddress"];
            this.country = _data["country"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.logoPath = _data["logoPath"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UtilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        data["contactPersonEmail"] = this.contactPersonEmail;
        data["contactPersonFirstName"] = this.contactPersonFirstName;
        data["contactPersonLastName"] = this.contactPersonLastName;
        data["contactPerson"] = this.contactPerson;
        data["contactPersonPhoneNumber"] = this.contactPersonPhoneNumber;
        data["status"] = this.status;
        data["address"] = this.address;
        data["websiteAddress"] = this.websiteAddress;
        data["country"] = this.country;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["logoPath"] = this.logoPath;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUtilityDto {
    id?: string | undefined;
    name: string;
    acronym: string;
    contactPersonEmail: string;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPerson?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    status: UtilityStatus;
    address: string;
    websiteAddress: string;
    country: UtilityCountry;
    creationDate: Date;
    logoPath?: string | undefined;
    timeZone: number;
}

export class UtilityDtoPaginationDataOut implements IUtilityDtoPaginationDataOut {
    count!: number;
    data!: UtilityDto[] | undefined;

    constructor(data?: IUtilityDtoPaginationDataOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UtilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UtilityDtoPaginationDataOut {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityDtoPaginationDataOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUtilityDtoPaginationDataOut {
    count: number;
    data: UtilityDto[] | undefined;
}

export class UtilityGetAllDataIn implements IUtilityGetAllDataIn {
    pageInfo!: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: UtilityStatus;
    country?: UtilityCountry;

    constructor(data?: IUtilityGetAllDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageInfo = new PageInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageInfo = _data["pageInfo"] ? PageInfo.fromJS(_data["pageInfo"]) : new PageInfo();
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): UtilityGetAllDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityGetAllDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageInfo"] = this.pageInfo ? this.pageInfo.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["country"] = this.country;
        return data;
    }
}

export interface IUtilityGetAllDataIn {
    pageInfo: PageInfo;
    search?: string | undefined;
    sorting?: SortingType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: UtilityStatus;
    country?: UtilityCountry;
}

export enum UtilityStatus {
    Active = "Active",
    Inactive = "Inactive",
    Pending = "Pending",
}

export class UtilityStatusDataIn implements IUtilityStatusDataIn {
    utilityId!: string;
    status!: UtilityStatus;

    constructor(data?: IUtilityStatusDataIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilityId = _data["utilityId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UtilityStatusDataIn {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityStatusDataIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilityId"] = this.utilityId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUtilityStatusDataIn {
    utilityId: string;
    status: UtilityStatus;
}

export enum ExternalTokenDataInType {
    Credit = "Credit",
    ClearCredit = "ClearCredit",
    ClearTamper = "ClearTamper",
    KeyChange = "KeyChange",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}